{
 " ao(à) paciente {nome}{cpf}": " إلى المريض/المريضة {nome}{cpf}",
 " junto ao plano de saúde {c}": " لدى شركة التأمين الصحي {c}",
 " às {h}": " الساعة {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\" أو \"1 / 10\" أو \"صفحة 1 من 10\"، في الزاوية التي تريدها.",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" موجود في {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" ليس JPG ولا PNG. حوّله إلى JPG وحاول مرة أخرى.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" ليس ملف PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" في {hora} يتعارض مع: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "«{n}» أصبح الآن ملكًا للمجموعة. خلال دقيقة واحدة سيرى باقي الأعضاء كل شيء.",
 "\"{titulo}\" foi criada com os mesmos dados.": "تم إنشاء \"{titulo}\" بالبيانات نفسها.",
 "\"{titulo}\" já foi adicionado em {data}.": "تمت إضافة \"{titulo}\" بالفعل في {data}.",
 "% ao mês": "% شهريًا",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(على كمبيوتر المشرف: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(نسخة)",
 "(sem título)": "(بدون عنوان)",
 "+ Adicionar alerta": "+ إضافة تنبيه",
 "+ Adicionar outra OAB": "+ إضافة OAB أخرى",
 "+ Adicionar pausa": "+ إضافة استراحة",
 "+ Adicionar subtarefa": "+ إضافة مهمة فرعية",
 "+ Matéria em {nome}": "+ مادة في {nome}",
 "+ Perfil": "+ ملف شخصي",
 "+ Subtarefa": "+ مهمة فرعية",
 "+5 min": "+5 د",
 "+{n} acompanhante(s)": "+{n} مرافق/مرافقين",
 "+{n} páginas acima da meta": "+{n} صفحة فوق الهدف",
 ", carteirinha nº {n},": "، رقم بطاقة التأمين {n}،",
 ", pago em {d}{f}": "، مدفوع في {d}{f}",
 "1 cápsula": "1 كبسولة",
 "1 dose": "1 جرعة",
 "1 dose (30 g)": "1 جرعة (30 غ)",
 "1 pessoa": "شخص واحد",
 "1 publicação nova": "نشرة جديدة واحدة",
 "1 página": "صفحة واحدة",
 "1 tarja no documento": "شريط أسود واحد في المستند",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. ثبّت My Planner وأنشئ حسابك.  2. افتح هذا الرابط مجددًا (أو أدخل الرمز في الإعدادات › المجموعات والدعوات).",
 "1. Quais dados tratamos": "1. البيانات التي نعالجها",
 "1. Sobre o app": "1. عن التطبيق",
 "1ª dose": "الجرعة الأولى",
 "2 por folha": "2 في الورقة",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "كوبان من الدقيق\n3 بيضات\nملعقة من البيكنج باودر",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2 أو 4 أو 6 أو 9 صفحات في كل ورقة (للطباعة).",
 "2. Para que usamos": "2. لماذا نستخدمها",
 "2. Sua conta": "2. حسابك",
 "2ª dose": "الجرعة الثانية",
 "3 a 5 g": "3 إلى 5 غ",
 "3. Bases legais (LGPD)": "3. الأسس القانونية (LGPD)",
 "3. Uso correto": "3. الاستخدام الصحيح",
 "3ª dose": "الجرعة الثالثة",
 "4 por folha": "4 في الورقة",
 "4. Com quem compartilhamos": "4. مع من نشاركها",
 "4. Planos e testes": "4. الخطط والتجارب",
 "5. Limites": "5. الحدود",
 "5. Segurança": "5. الأمان",
 "6 por folha": "6 في الورقة",
 "6. Por quanto tempo": "6. مدة الاحتفاظ",
 "7. Seus direitos (art. 18 da LGPD)": "7. حقوقك (art. 18 من LGPD)",
 "8. Crianças e adolescentes": "8. الأطفال والمراهقون",
 "9 por folha": "9 في الورقة",
 "9. Mudanças": "9. التغييرات",
 "@letra-dom": "ح",
 "@letra-qua": "ر",
 "@letra-qui": "خ",
 "@letra-sab": "س",
 "@letra-seg": "ن",
 "@letra-sex": "ج",
 "@letra-ter": "ث",
 "A IA está classificando...": "الذكاء الاصطناعي يصنّف...",
 "A IA está lendo a caixa...": "الذكاء الاصطناعي يقرأ الصندوق...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "يقرأ الذكاء الاصطناعي الصفحات فيصبح ملف PDF قابلًا للبحث والنسخ.",
 "A IA lê o PDF e sugere um nome claro.": "يقرأ الذكاء الاصطناعي ملف PDF ويقترح اسمًا واضحًا.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "لم يُرجع الذكاء الاصطناعي ردًا بالتنسيق المتوقع. حاول مرة أخرى.",
 "A IA não encontrou dados para esta ficha no arquivo.": "لم يعثر الذكاء الاصطناعي على بيانات لهذه البطاقة في الملف.",
 "A IA não encontrou tarefas nesta caixa.": "لم يجد الذكاء الاصطناعي مهام في هذا الصندوق.",
 "A IA resume o PDF e responde perguntas.": "يلخّص الذكاء الاصطناعي ملف PDF ويجيب عن الأسئلة.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "تسجّل SEFAZ أنك اطّلعت على الفاتورة (دون تأكيد الشراء أو رفضه) وتتيح ملف XML الكامل في البحث التالي، خلال ساعة واحدة.",
 "A VENCER (7 DIAS)": "قريبة الاستحقاق (7 أيام)",
 "A aba inteira": "التبويب بالكامل",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "التبويب {aba} قريب من الحد الأقصى. أرشِف العناصر القديمة فيه أو احذفها.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "التبويب {aba} غير مشترك فيه. يبقى الربط محفوظًا ويعود عند الاشتراك.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "البحث عن \"{nome}\" واسع جدًا. استخدم الاسم الكامل.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "البحث عن GIF غير مفعّل في هذا التطبيق بعد. في الأثناء، استخدم الملصقات المتحركة (🎉).",
 "A cada": "كل",
 "A cada N páginas": "كل N صفحات",
 "A cada quantos dias": "كل كم يومًا",
 "A cada {n} dia(s)": "كل {n} يوم/أيام",
 "A cada {n} mês(es)": "كل {n} شهر/أشهر",
 "A cada {n} mês(es) · dia {d}": "كل {n} شهر/أشهر · يوم {d}",
 "A cada {n} semana(s)": "كل {n} أسبوع/أسابيع",
 "A cada {n} semana(s) · {dia}": "كل {n} أسبوع/أسابيع · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "الصندوق موجود في {aba}، ضمن \"الملاحظات المستلمة\".",
 "A caixa foi para {destino}.": "أُرسل الصندوق إلى {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "يُحفظ المفتاح على هذا الجهاز فقط، في خزنة النظام. على جهاز آخر، أدخله من جديد.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "يُحفظ المفتاح في هذا المتصفح فقط. استخدمه على حاسوب شخصي.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "الاتصال مشفّر. تستخدم الخزنة التشفير التام بين الطرفين (AES-256): حتى فريق الدعم لا يستطيع قراءتها. يمكن قفل التطبيق بكلمة مرور أو نمط أو بالقياسات الحيوية.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "لم يُفعَّل التأكيد عبر WhatsApp على الخادم بعد.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "الحساب وكل البيانات المحفوظة في السحابة: المهام والملاحظات والتبويبات والسجلات والرسائل والملفات المرسلة إلى التطبيق والإعدادات. تُحذف أيضًا بيانات هذا الجهاز. لا يمكن التراجع.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "يظهر اللون في الشريط والعناوين والمهام المرتبطة بهذا التبويب.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "لون My Planner هو لون التمييز في التطبيق. يمكن لكل مهمة أن يكون لها لونها الخاص في بطاقتها.",
 "A data de fim é anterior à de início.": "تاريخ الانتهاء يسبق تاريخ البدء.",
 "A data inicial precisa ser antes da final.": "يجب أن يكون تاريخ البداية قبل تاريخ النهاية.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "سيطّلع الفريق على الخطأ ويصلحه في تحديث قادم.",
 "A equipe vê e altera conforme o papel de cada um": "يرى الفريق البيانات ويعدّلها حسب دور كل شخص",
 "A fazer": "للتنفيذ",
 "A foto passa de 8 MB.": "حجم الصورة يتجاوز 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "الصورة كبيرة جدًا. ثبّت الإصدار الجديد من التطبيق لقص الصورة.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "لم يتم نشر الدالة \"nuvem\" على الخادم بعد. شغّل 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "لم يتم نشر الدالة \"nuvem\" على الخادم بعد. شغّل 9-LIGAR-DRIVE-ONEDRIVE.bat (راجع COMO RODAR، الإصدار 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "لا يزال التسجيل قيد التجهيز. حاول مرة أخرى بعد بضع دقائق.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "يُسجَّل الوقت بهذه المنطقة الزمنية. في منطقة أخرى، يعرض التطبيق الوقت المحوَّل وينبّهك عليه.",
 "A imagem original não está neste dispositivo.": "الصورة الأصلية ليست على هذا الجهاز.",
 "A pagar": "مستحق الدفع",
 "A pagar: {v}": "مستحق الدفع: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "تم سحب إذن التقويم. اسمح به مرة أخرى من إعدادات الهاتف.",
 "A pessoa sai do grupo e deixa de receber os envios.": "يغادر الشخص المجموعة ويتوقف عن تلقي المرسلات.",
 "A receber": "مستحق القبض",
 "A receber: {v}": "مستحق القبض: {v}",
 "A reunião ainda está sendo gravada.": "لا يزال الاجتماع قيد التسجيل.",
 "A senha atual não confere.": "كلمة المرور الحالية غير صحيحة.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "يجب أن تتكون كلمة مرور الخزنة من 6 أحرف أو أكثر.",
 "A senha precisa ter 8 caracteres ou mais.": "يجب أن تتكون كلمة المرور من 8 أحرف أو أكثر.",
 "A senha precisa ter pelo menos 8 caracteres.": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
 "A senha é a mesma no celular e no My Planner Web.": "كلمة المرور نفسها على الهاتف وفي My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "تتم المزامنة عند فتح التطبيق وبعد كل تغيير. تظهر 📆 على المهام المرتبطة بالتقويم.",
 "A sua equipe num lugar só": "فريقك في مكان واحد",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "لا تنتقل مهمة المنزل إلى My Planner تلقائيًا. يفتح \"إرسال إلى My Planner\" النموذج الكامل لاختيار اليوم والوقت والتكرار والاستراحات والتنبيهات.",
 "A validade não pode ser antes da emissão.": "لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ الإصدار.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "إصدار iPhone قادم قريبًا إلى App Store. في الأثناء، استخدم My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "إصدار iPhone قادم قريبًا إلى App Store. في الأثناء، استخدم My Planner Web: في Safari، اضغط على مشاركة > إضافة إلى الشاشة الرئيسية ليصبح أيقونة على هاتفك.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4 أو Letter أو A5 أو Legal، دون قص أي شيء.",
 "ADICIONAR AMIGO": "إضافة صديق",
 "AGUARDANDO RESPOSTA": "بانتظار الرد",
 "AMIGOS": "الأصدقاء",
 "ANOTAÇÕES": "الملاحظات",
 "ANOTAÇÕES RECEBIDAS · {aba}": "الملاحظات المستلمة · {aba}",
 "ATIVIDADE": "النشاط",
 "ATIVIDADE FÍSICA": "النشاط البدني",
 "ATRASADAS": "متأخرة",
 "Aba": "تبويب",
 "Aba bloqueada": "تبويب مقفل",
 "Aba {nome}": "تبويب {nome}",
 "Abas": "التبويبات",
 "Abas liberadas pelo suporte": "تبويبات فعّلها الدعم",
 "Abas para comprar": "تبويبات للشراء",
 "Abas que você já tem": "التبويبات التي لديك",
 "Abastecimento": "تعبئة وقود",
 "Abastecimentos": "تعبئات الوقود",
 "Abdominal": "تمارين البطن",
 "Abertura do prazo da declaração do IR": "بدء فترة تقديم إقرار IR (ضريبة الدخل)",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "افتح الشركة واضغط على \"البحث عن الفواتير\" لإدخال كلمة مرور الخزنة.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "افتح My Planner Anne وسجّل الدخول برقم الهوية وكلمة المرور.",
 "Abra o My Planner no celular.": "افتح My Planner على الهاتف.",
 "Abra o cofre": "افتح الخزنة",
 "Abra um PDF para começar.": "افتح ملف PDF للبدء.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "افتح مادة واضغط على \"ادرس الآن\" لتشغيل المؤقت. حدّد أهدافًا أسبوعية لكل مادة.",
 "Abraço": "حضن",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "يفتح قائمة المشاركة في الهاتف: WhatsApp والبريد الإلكتروني وGoogle Drive وOneDrive والحفظ في الملفات وغيرها.",
 "Abre o PDF para ler aqui mesmo.": "يفتح ملف PDF لقراءته هنا مباشرة.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "يفتح ماسح PDF (مع تصحيح الحواف والظلال).",
 "Abrir": "فتح",
 "Abrir Ajustes": "فتح الإعدادات",
 "Abrir PDF": "فتح PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "فتح PDF من الهاتف أو Drive أو OneDrive",
 "Abrir a aba": "فتح التبويب",
 "Abrir a cópia guardada": "فتح النسخة المحفوظة",
 "Abrir a pasta no Drive": "فتح المجلد في Drive",
 "Abrir com outro app": "فتح بتطبيق آخر",
 "Abrir configurações": "فتح الإعدادات",
 "Abrir em outro app": "فتح في تطبيق آخر",
 "Abrir no DJEN": "فتح في DJEN",
 "Abrir no modo seguro": "الفتح في الوضع الآمن",
 "Abrir normalmente": "الفتح بشكل عادي",
 "Abrir nota fiscal": "فتح الفاتورة",
 "Abrir o PDF": "فتح ملف PDF",
 "Abrir o PDF no {nome}": "فتح ملف PDF في {nome}",
 "Abrir o XML": "فتح ملف XML",
 "Abrir o app": "فتح التطبيق",
 "Abrir o app My Planner": "افتح تطبيق My Planner",
 "Abrir o cartão": "فتح البطاقة",
 "Abrir o cofre": "فتح الخزنة",
 "Abrir o cofre para ver": "افتح الخزنة للعرض",
 "Abrir o diário oficial": "فتح الجريدة الرسمية",
 "Abrir ou baixar": "فتح أو تنزيل",
 "Abrir página": "فتح الصفحة",
 "Abrir site": "فتح الموقع",
 "Abrir {nome}": "فتح {nome}",
 "Acabamento": "التشطيب",
 "Acabou": "نفد",
 "Academia": "الصالة الرياضية",
 "Aceitar": "قبول",
 "Aceitar, editar ou recusar": "قبول أو تعديل أو رفض",
 "Aceite os termos para continuar.": "وافق على الشروط للمتابعة.",
 "Aceito": "مقبول",
 "Aceito com alterações": "مقبول مع تعديلات",
 "Acerto de contas": "تسوية الحساب",
 "Acerto de contas: {v}": "تسوية الحساب: {v}",
 "Acessibilidade": "إمكانية الوصول",
 "Acesso ilimitado": "وصول غير محدود",
 "Acesso ilimitado a todas as funções, sem prazo": "وصول غير محدود إلى جميع الميزات، دون مدة",
 "Achatar": "تسطيح",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "يتابع كل شيء، بما في ذلك المصروفات، ويسجّل في اليوميات.",
 "Acompanhamento": "طبق جانبي",
 "Acompanhantes": "المرافقون",
 "Acrescentar no fim da página": "إضافة في نهاية الصفحة",
 "Adaptador de tomada": "محول قابس كهربائي",
 "Adestramento": "تدريب",
 "Adicionar": "إضافة",
 "Adicionar amigo": "إضافة صديق",
 "Adicionar amigos do app": "إضافة أصدقاء من التطبيق",
 "Adicionar ao Planner?": "إضافة إلى Planner؟",
 "Adicionar arquivo": "إضافة ملف",
 "Adicionar cômodo": "إضافة غرفة",
 "Adicionar fotos e vídeos": "إضافة صور ومقاطع فيديو",
 "Adicionar imagem": "إضافة صورة",
 "Adicionar item (ex.: 2 ovos mexidos)": "إضافة عنصر (مثال: بيضتان مخفوقتان)",
 "Adicionar na página": "إضافة إلى الصفحة",
 "Adicionar passo": "إضافة خطوة",
 "Adicionar país": "إضافة دولة",
 "Adicionar página": "إضافة صفحة",
 "Adicionar texto": "إضافة نص",
 "Adicionar {nome}": "إضافة {nome}",
 "Adicionar à equipe": "إضافة إلى الفريق",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "أضف صديقًا عبر رمزه أو أرسل رمزك إلى من تريد.",
 "Admin": "مشرف",
 "Administração": "الإدارة",
 "Adubar a cada quantos dias": "التسميد كل كم يومًا",
 "Adubar: {p}": "تسميد: {p}",
 "Adubei hoje": "سمّدتها اليوم",
 "Advogado": "محامٍ",
 "Advogados": "المحامون",
 "Afundo": "الطعنات (لانجز)",
 "Agachamento": "القرفصاء (سكوات)",
 "Agenda do Google": "تقويم Google",
 "Agenda limpa": "الأجندة نظيفة",
 "Agenda não liberada": "التقويم غير مسموح به",
 "Agenda sincronizada ✓": "تمت مزامنة التقويم ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "الأجندة والملاحظات والمالية والدراسة والرسائل وأكثر في تطبيق واحد.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "المواعيد وسجلات المرضى والمدفوعات، دون الملف الطبي.",
 "Agendado": "تمت الجدولة",
 "Agendado no My Planner": "مُجدوَل في My Planner",
 "Agendamento no pet shop": "موعد في متجر الحيوانات",
 "Agendar": "جدولة",
 "Agendar no My Planner": "جدولة في My Planner",
 "Agendar no My Planner (dias e horários)": "جدولة في My Planner (الأيام والأوقات)",
 "Agora não": "ليس الآن",
 "Agora o verso do documento.": "الآن الوجه الخلفي للمستند.",
 "Agora, {hora}": "الآن، {hora}",
 "Agora: {ml}": "الآن: {ml}",
 "Aguardando o celular · {s}s": "بانتظار الهاتف · {s} ث",
 "Aguarde": "انتظر",
 "Aguarde um pouco": "انتظر قليلًا",
 "Aguarde...": "يرجى الانتظار...",
 "Ainda a pagar no mês": "متبقٍ للدفع هذا الشهر",
 "Ainda a receber no mês": "متبقٍ للتحصيل هذا الشهر",
 "Ainda não confirmado": "لم يُؤكَّد بعد",
 "Ainda não disponível: falta configurar no servidor.": "غير متاح بعد: لم يتم الإعداد على الخادم.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "لم تدّخر شيئًا هذا الشهر بعد. ما رأيك أن تجنّب {v} (10% مما دخل) فور وصول المال؟",
 "Ainda não há feriados deste país para este ano.": "لا توجد عطلات لهذه الدولة لهذا العام بعد.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "لا يوجد شيء في هذا التبويب لمشاركته بعد. أنشئه أولًا (مثلًا: الرحلة) ثم عد إلى هنا.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "لا يوجد أشخاص آخرون في المجموعة بعد (أو لا يمكنك رؤية قائمة الأعضاء).",
 "Ainda não marcado como feito. Toque para abrir.": "لم يُعلَّم كمنجز بعد. اضغط للفتح.",
 "Ainda não sincronizado": "لم تتم المزامنة بعد",
 "Ainda sem chave neste dispositivo.": "لا يوجد مفتاح على هذا الجهاز بعد.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb أو Booking أو مباشرة: الحجوزات، التنظيف عند المغادرة، الإيرادات، المصروفات وربح الشهر",
 "Ajuda na organização": "يساعد في التنظيم",
 "Ajudante": "مساعد",
 "Ajustar": "تعديل",
 "Ajustar a data final": "تعديل تاريخ الانتهاء",
 "Ajustar a folha": "ضبط الورقة",
 "Ajustar tamanho da página": "ضبط حجم الصفحة",
 "Ajuste visual": "تعديل المظهر",
 "Ajustes": "الإعدادات",
 "Alarme dos remédios": "منبّه الأدوية",
 "Alarme que insiste até marcar como tomado": "منبّه يستمر حتى تعليم الدواء كمأخوذ",
 "Alemão": "الألمانية",
 "Alergia": "حساسية",
 "Alergias": "الحساسية",
 "Alergias e alertas": "الحساسية والتنبيهات",
 "Alertas": "التنبيهات",
 "Alertas das tarefas": "تنبيهات المهام",
 "Alertas dos compromissos": "تنبيهات المواعيد",
 "Algo deu errado, mas o app continua aberto": "حدث خطأ، لكن التطبيق ما زال مفتوحًا",
 "Alguns arquivos foram guardados em outro dispositivo.": "بعض الملفات محفوظة على جهاز آخر.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "قد لا ترسل بعض الساعات (مثل ساعات Huawei) البيانات إلى Health Connect. في هذه الحالة، أدخلها يدويًا.",
 "Alguém": "شخص ما",
 "Alguém indicou o app para você?": "هل رشّح لك أحدٌ التطبيق؟",
 "Alimentação": "الطعام",
 "Alimentação & Despensa": "الطعام والمؤونة",
 "Alimentação {semana}": "التغذية {semana}",
 "Alimento": "الطعام",
 "Alinhamento e balanceamento": "ضبط الزوايا وموازنة الإطارات",
 "Almoço": "الغداء",
 "Alongamento": "تمارين الإطالة",
 "Alta": "عالية",
 "Alterado por último por {nome}": "آخر تعديل بواسطة {nome}",
 "Alterar metadados": "تغيير البيانات الوصفية",
 "Alterar o valor pago": "تغيير المبلغ المدفوع",
 "Alterações": "التغييرات",
 "Alto-falante": "مكبر الصوت",
 "Aluga como": "نوع التأجير",
 "Alugar a casa ou um cômodo": "تأجير المنزل أو غرفة",
 "Aluguel": "الإيجار",
 "Aluguel & Hospedagem": "الإيجار والاستضافة",
 "Aluguel de carro": "استئجار سيارة",
 "Aluno": "طالب",
 "Alunos": "الطلاب",
 "Alvará ou licença": "تصريح أو رخصة",
 "Alvenaria": "أعمال البناء",
 "Alvo": "المبلغ المستهدف",
 "Alíquota do ISS (%)": "نسبة ISS (%)",
 "Alíquota do ISS deste serviço (%)": "نسبة ISS لهذه الخدمة (%)",
 "Amanhã": "غدًا",
 "Ambiente": "البيئة",
 "Ameno": "معتدل",
 "Amigos": "الأصدقاء",
 "Amor": "حب",
 "Amortização": "سداد أصل الدين",
 "Ampliar a foto": "تكبير الصورة",
 "Amém": "آمين",
 "Analisar com IA": "تحليل بالذكاء الاصطناعي",
 "Anamnese e histórico (no cofre)": "التاريخ المرضي والسوابق (في الخزنة)",
 "Anexar arquivos": "إرفاق ملفات",
 "Anexar comprovante": "إرفاق الإيصال",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "إرفاق المستندات واستيراد كشوف الحساب وحفظ التقارير وملفات PDF والنسخ الاحتياطية.",
 "Anexos": "المرفقات",
 "Anexos guardados aqui no dispositivo: {n}": "مرفقات محفوظة على هذا الجهاز: {n}",
 "Animais e natureza": "الحيوانات والطبيعة",
 "Animação": "الحركة",
 "Anime": "أنمي",
 "Aniversário": "عيد ميلاد",
 "Aniversário de Campo Grande": "ذكرى تأسيس Campo Grande",
 "Aniversário de São Paulo": "ذكرى تأسيس São Paulo",
 "Ano": "السنة",
 "Ano anterior": "السنة السابقة",
 "Ano de lançamento": "سنة الإصدار",
 "Ano de {ano}": "سنة {ano}",
 "Ano passado": "العام الماضي",
 "Anotar pela foto da página": "التدوين من صورة الصفحة",
 "Anotação": "ملاحظة",
 "Anotação de {data}": "ملاحظة بتاريخ {data}",
 "Anotação do professor": "ملاحظة المعلم",
 "Anotação à mão": "ملاحظة بخط اليد",
 "Anotações": "الملاحظات",
 "Anotações Rápidas": "ملاحظات سريعة",
 "Anotações arquivadas": "الملاحظات المؤرشفة",
 "Anotações arquivadas ({n})": "الملاحظات المؤرشفة ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "سجّل كل حجز بتواريخه ومصدره ومبالغه. يُضاف تنظيف المغادرة تلقائيًا إلى قائمة التنظيف.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "دوّن يوميات المشروع مع الصور. علّم الصور بـ«قبل» أو «بعد» لرؤية التقدم.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "سجّل ما أعرته أو استعرته، مع صورة وموعد. سينبّهك التطبيق في يوم الإرجاع.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "دوّن الأماكن التي تريد زيارتها. ابحث عنها في Google Maps أو Waze، وارسم مسارًا يمر بها جميعًا وأضفها إلى برنامج اليوم.",
 "Anteriores ({n})": "السابقة ({n})",
 "Antes": "قبل",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "قبل أن تبدأ، اطّلع على ما يستخدمه التطبيق ولماذا. يمكنك تغيير كل ذلك لاحقًا من الإعدادات > الخصوصية والشروط.",
 "Antes de uma data": "قبل تاريخ",
 "Antes do início": "قبل البدء",
 "Antes e depois": "قبل وبعد",
 "Antes: {lista}": "قبل: {lista}",
 "Antipulgas": "مضاد البراغيث",
 "Anual": "سنوي",
 "Ao ar livre": "في الهواء الطلق",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "عند الإلغاء، يصبح التبويب بالأبيض والأسود وتختفي الروابط من المهام، لكن لا يُحذف شيء.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "بإنشاء الحساب أو مواصلة استخدام التطبيق، فإنك توافق على هذه الشروط وعلى سياسة الخصوصية أدناه.",
 "Ao fechar, a página é salva.": "عند الإغلاق، تُحفظ الصفحة.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "عند الحفظ، ستنشئ كلمة مرور الخزنة. هذا الحقل مشفّر على الجهاز.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "عند النقر على \"ملف\" أو \"صورة\" في الدراسة والمستندات، يعرض منتقي الهاتف Google Drive وOneDrive وDropbox (إذا كانت التطبيقات مثبّتة). اختر الملف من هناك مباشرة.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "المس ملفًا مرفقًا ليفتح في تطبيق الهاتف الذي تختاره (في Android: \"مرة واحدة فقط\" أو \"دائمًا\"). ما تعدّله هناك يُحفظ في الملف نفسه.",
 "Apaga a conta e todos os vencimentos dela.": "يحذف الفاتورة وكل مواعيد استحقاقها.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "يحذف مواد وصفحات هذا المجلد. تبقى مهام المخطط كما هي.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "يحذف صفحات هذه المادة. يبقى وقت الدراسة في السجل.",
 "Apaga o cartão e as compras dele.": "يحذف البطاقة ومشترياتها.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "يحذف الحساب وجميع البيانات نهائيًا من السحابة ومن هذا الجهاز. لا يمكن التراجع.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "يحذف جميع مهام الأجندة، السابقة والقادمة.",
 "Apaga todas as {n} parcelas.": "يحذف جميع الأقساط الـ {n}.",
 "Apaga todos os meses desta conta.": "يحذف كل أشهر هذه الفاتورة.",
 "Apagar": "حذف",
 "Apagar \"{nome}\"?": "حذف \"{nome}\"؟",
 "Apagar a caixa?": "حذف الصندوق؟",
 "Apagar a chave": "حذف المفتاح",
 "Apagar a chave deste dispositivo?": "حذف المفتاح من هذا الجهاز؟",
 "Apagar a conta?": "حذف الحساب؟",
 "Apagar a lista de erros?": "مسح قائمة الأخطاء؟",
 "Apagar a pasta (os documentos continuam)": "حذف المجلد (تبقى المستندات)",
 "Apagar as da agenda": "حذف مهام التقويم",
 "Apagar caixa": "حذف الصندوق",
 "Apagar de verdade (as páginas com tarja viram imagem)": "حذف فعلي (الصفحات ذات الأشرطة تتحول إلى صور)",
 "Apagar de vez": "حذف نهائي",
 "Apagar desenho": "مسح الرسم",
 "Apagar envio": "حذف المُرسَل",
 "Apagar lista": "مسح القائمة",
 "Apagar minha conta": "حذف حسابي",
 "Apagar minha conta e todos os dados": "حذف حسابي وجميع البيانات",
 "Apagar o escritório": "حذف المكتب",
 "Apagar o escritório?": "حذف المكتب؟",
 "Apagar o grupo": "حذف المجموعة",
 "Apagar o grupo?": "حذف المجموعة؟",
 "Apagar o lançamento?": "حذف هذا القيد؟",
 "Apagar para todos": "حذف لدى الجميع",
 "Apagar tudo": "حذف الكل",
 "Apagar tudo antes de": "حذف كل ما قبل",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "احذف دفعة واحدة مهام اليوم أو الشهر أو فترة معينة أو حسب الاسم. قبل الحذف، يعرض التطبيق ما سيُحذف ويطلب كلمة المرور.",
 "Aparece na barra quando estiver liberada": "يظهر في الشريط عند إتاحته",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "تظهر في Planner مع أيام العطل الاختيارية (الكرنفال وأربعاء الرماد وعيد الجسد).",
 "Aplicar": "تطبيق",
 "Aponte a câmera do celular para este QR Code.": "وجّه كاميرا الهاتف نحو رمز QR هذا.",
 "Aponte para o QR Code na tela do computador": "وجّه الكاميرا نحو رمز QR على شاشة الكمبيوتر",
 "Apostila": "ملزمة",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "ملازم، تمارين، شرائح، فيديوهات، روابط وإعلانات. عبر ⋮ › إرسال إلى مجموعة، يستلمها كل طالب في تطبيقه.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "التطبيق المستخدم لزر \"المسار\" في العناوين (المهام، المواعيد، خط سير الرحلة، الأعمال الإنشائية، المدرسة...).",
 "Apple Saúde": "Apple صحتي",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: تحفظ كل شيء بالفعل في تطبيق صحتي على iPhone. لا حاجة لفعل أي شيء.",
 "Apresentação": "عرض تقديمي",
 "Aprovação": "الاعتماد",
 "Aqui": "هنا",
 "Ar-condicionado": "التكييف",
 "Arco-íris": "قوس قزح",
 "Arenoso": "رملية",
 "Armazenamento": "التخزين",
 "Armário": "خزانة",
 "Arquivadas ({n})": "المؤرشفة ({n})",
 "Arquivados ({n})": "المؤرشفة ({n})",
 "Arquivar": "أرشفة",
 "Arquivar a caixa de anotações?": "أرشفة صندوق الملاحظات؟",
 "Arquivar conversa": "أرشفة المحادثة",
 "Arquivo": "ملف",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "ملف (Drive أو OneDrive أو Dropbox أو من الجهاز)",
 "Arquivo OFX ou CSV do banco": "ملف OFX أو CSV من البنك",
 "Arquivo adicionado": "تمت إضافة الملف",
 "Arquivo menor (para WhatsApp e e-mail)": "ملف أصغر (لـ WhatsApp والبريد الإلكتروني)",
 "Arquivo menor para WhatsApp e e-mail.": "ملف أصغر لـ WhatsApp والبريد الإلكتروني.",
 "Arquivo não encontrado.": "الملف غير موجود.",
 "Arquivo ou PDF": "ملف أو PDF",
 "Arquivo ou documento": "ملف أو مستند",
 "Arquivos": "الملفات",
 "Arquivos (frente, verso, PDF)": "الملفات (الوجه، الظهر، PDF)",
 "Arquivos (importar e exportar)": "الملفات (الاستيراد والتصدير)",
 "Arquivos de {nome}": "ملفات {nome}",
 "Arquivos na nuvem e cópias de segurança": "الملفات في السحابة والنسخ الاحتياطية",
 "Arrasou!": "أبدعت!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "اسحب النقاط إلى زوايا الورقة الـ 4. يقص التطبيق الصفحة ويعدّلها.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "اسحب إصبعك فوق ما تريد إخفاءه. اضغط على شريط لإزالته.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "اسحب يمينًا للحذف، أو يسارًا للإرسال إلى تبويب آخر.",
 "Arraste para a direita para excluir.": "اسحب إلى اليمين للحذف.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "اسحب لتغيير الترتيب، ودوّر، وكرّر، واحذف، وأضف صفحات فارغة.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "اسحب لرؤية بقية اللوحة. تتوسع اللوحة إلى الأسفل وإلى اليمين.",
 "Arraste um documento para a direita para excluir.": "اسحب مستندًا إلى اليمين لحذفه.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "اسحب الصندوق إلى اليسار لأرشفته أو إلى اليمين لحذفه.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "اسحب المربع إلى اليسار للأرشفة أو إلى اليمين للحذف. اضغط مطولًا على ⋮⋮ لتغيير الترتيب.",
 "Arroz": "أرز",
 "Artes": "الفنون",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "لا يمكن للتطبيقات الأخرى استخدام اشتراكات Claude Pro وChatGPT Plus وGemini Advanced. لتفعيل الذكاء الاصطناعي هنا، أنشئ مفتاح API في حسابك (Gemini يتيح استخدامًا مجانيًا؛ أما Claude وChatGPT فيحتسبان حسب الاستخدام، ببضعة سنتات لكل تحليل).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "لم يتم تفعيل المكالمات على الخادم بعد (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "تُحذف مشترياتها أيضًا من المالية.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "تُسجَّل المشتريات بالتقسيط بكل أقساطها: تظهر الأقساط التالية مباشرة في الكشوف القادمة.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "صور هذا المستند موجودة على الجهاز الذي تم مسحه ضوئيًا عليه. يمكنك هناك تعديله ومشاركته وقراءة النص.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "تُرسل الصور فقط إلى الذكاء الاصطناعي الذي اخترته، باستخدام مفتاحك.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "تظهر عمليات التنظيف بعد المغادرة هنا تلقائيًا، مع قائمة تحقق وصور قبل وبعد.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "تظهر في هذه القائمة الفواتير الصادرة هنا والتي عُثر عليها في البحث وملفات XML المستوردة.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "تظهر الأقساط هنا. أرفق إثبات الدفع (صورة أو PDF أو لقطة شاشة PIX) بكل قسط.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "أقساط الأشهر الـ12 القادمة موجودة بالفعل في My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "يُعاد حساب الأقساط غير المدفوعة بالمبلغ والفائدة والمدة الحالية للعقد. الأقساط المدفوعة لا تتغير.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "صفحات هذا المستند موجودة على الجهاز الذي تم مسحه ضوئيًا عليه. افتحه هناك أو استخدم النسخة المحفوظة في Drive أو OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "تتحول الصفحات إلى صور أخف: ممتاز لملفات PDF الممسوحة ضوئيًا. لن يعود النص قابلًا للبحث (استخدم OCR بعد ذلك إن احتجت).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "تُرسل الصفحات فقط إلى الذكاء الاصطناعي الذي اخترته، بمفتاحك الخاص.",
 "As receitas do cardápio já têm tudo na despensa.": "كل مكونات وصفات القائمة متوفرة في المؤونة.",
 "As senhas novas não conferem.": "كلمتا المرور الجديدتان غير متطابقتين.",
 "As senhas não conferem.": "كلمتا المرور غير متطابقتين.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "ستبقى المهام في My Planner. هل تريد أيضًا حذف المهام التي جاءت من تقويم Google؟",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "تبقى مهام الغرفة في منزلي، بدون غرفة.",
 "As tarefas vinculadas continuam no My Planner.": "تبقى المهام المرتبطة في My Planner.",
 "Aspirar e passar pano": "كنس بالمكنسة الكهربائية ومسح الأرضية",
 "Assinada": "مشترَك",
 "Assinar": "توقيع",
 "Assinar (simulação de teste)": "اشتراك (محاكاة تجريبية)",
 "Assinar o documento": "توقيع المستند",
 "Assinatura": "التوقيع",
 "Assinatura do profissional": "توقيع المختص",
 "Assinatura e segurança": "التوقيع والأمان",
 "Assinaturas (simulação de teste)": "الاشتراكات (محاكاة تجريبية)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "اشترك في التبويب من الإعدادات لإرسال الملاحظات إليه.",
 "Assine a aba em Ajustes para vincular.": "اشترك في التبويب من الإعدادات للربط.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "اشترك في التبويب من الإعدادات › المشتريات لإرسال الملاحظات إليه.",
 "Assine a aba em Ajustes › Compras para vincular.": "اشترك في التبويب من الإعدادات › المشتريات للربط.",
 "Assine a aba para abrir o vínculo.": "اشترك في التبويب لفتح الرابط.",
 "Assisti mais uma aula": "شاهدت درسًا آخر",
 "Assistido": "تمت المشاهدة",
 "Assistindo": "أشاهده",
 "Assistência técnica (nome)": "مركز الصيانة (الاسم)",
 "Assistência: {nome}": "الصيانة: {nome}",
 "Assunto": "الموضوع",
 "Assunto (ex.: Reunião semanal)": "الموضوع (مثال: اجتماع أسبوعي)",
 "Atender": "رد",
 "Atendimento": "زيارة",
 "Atendimentos": "الزيارات",
 "Ativar avisos": "تشغيل الإشعارات",
 "Ativar monitor": "تفعيل المراقبة",
 "Ativas": "النشطة",
 "Atividade": "النشاط",
 "Atividade do roteiro": "نشاط في البرنامج",
 "Atividade hoje": "نشاط اليوم",
 "Atividade: {blocos}": "النشاط: {blocos}",
 "Atividades": "الأنشطة",
 "Atividades de hoje": "أنشطة اليوم",
 "Atividades e materiais": "الأنشطة والمواد",
 "Atividades físicas e saúde": "الرياضة والصحة",
 "Atrasada": "متأخرة",
 "Atrasada há {n} dia(s)": "متأخرة منذ {n} يوم/أيام",
 "Atrasadas": "متأخرة",
 "Atrasados": "المتأخرة",
 "Atuais": "الحالية",
 "Atualidades": "الشؤون الجارية",
 "Atualizar": "تحديث",
 "Atualizar agora": "التحديث الآن",
 "Atualizar alarmes no My Planner": "تحديث المنبّهات في My Planner",
 "Atualizar rega e adubo na agenda": "تحديث الري والتسميد في الجدول",
 "Atualização automática disponível no app instalado (APK).": "التحديث التلقائي متاح في التطبيق المثبّت (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "تم تنزيل التحديث. يُطبَّق عند إعادة فتح التطبيق أو عند الضغط على الإشعار.",
 "Atualização pronta": "التحديث جاهز",
 "Atualizações": "التحديثات",
 "Até": "حتى",
 "Audiência": "جلسة استماع",
 "Aula dada": "تم إعطاء الدرس",
 "Aula {a} de {n} ({p}%)": "الدرس {a} من {n} ({p}%)",
 "Aulas assistidas": "الدروس المُشاهَدة",
 "Autoajuda": "تطوير الذات",
 "Autor": "المؤلف",
 "Avaliação": "تقييم",
 "Avaliações e notas": "التقييمات والدرجات",
 "Avançado": "متقدم",
 "Aveia": "شوفان",
 "Avisar a hora de sair": "نبّهني بوقت المغادرة",
 "Avisar antes de vencer": "التنبيه قبل الانتهاء",
 "Avisar no celular quando alguém incluir algo": "نبّهني على الهاتف عندما يضيف أحدهم شيئًا",
 "Aviso": "إشعار",
 "Aviso com as tarefas do dia": "إشعار بمهام اليوم",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "أرسل الخادم إشعارًا تجريبيًا. سيصل خلال ثوانٍ؛ اخرج من التطبيق لتراه في شريط إشعارات الهاتف.",
 "Aviso enviado": "تم إرسال الإشعار",
 "Aviso {dias} dia(s) antes e no dia": "تنبيه قبل {dias} يوم/أيام وفي اليوم نفسه",
 "Avisos no celular": "إشعارات الهاتف",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "تمرّ الإشعارات على الهاتف عبر خدمات Expo وGoogle وApple.",
 "Ação": "أكشن",
 "Ações": "الأسهم",
 "BOLETO E DOCUMENTOS": "Boleto والمستندات",
 "Backup importado.": "تم استيراد النسخة الاحتياطية.",
 "Bairro": "الحي",
 "Baixa": "منخفضة",
 "Baixando atualização...": "جارٍ تنزيل التحديث...",
 "Baixar": "تنزيل",
 "Baixar a versão {v}": "تنزيل الإصدار {v}",
 "Baixar agora": "التنزيل الآن",
 "Baixar o My Planner para Android": "تنزيل My Planner لنظام Android",
 "Baixar o My Planner para Android (versão {v})": "تنزيل My Planner لنظام Android (الإصدار {v})",
 "Baixar o My Planner para iPhone": "تنزيل My Planner لـ iPhone",
 "Baixar o PDF da nota (DANFSe)": "تنزيل PDF الفاتورة (DANFSe)",
 "Baixar o PDF?": "تنزيل ملف PDF؟",
 "Baixar o XML completo (dá ciência na SEFAZ)": "تنزيل XML الكامل (يسجّل الاطلاع لدى SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "نزّل أحدث إصدار لأندرويد: {apk}",
 "Baixe aqui a versão mais recente: {link}": "نزّل أحدث إصدار من هنا: {link}",
 "Balança": "يتمايل",
 "Balanço e relatórios": "الميزانية والتقارير",
 "Banana": "موز",
 "Banco": "بنك",
 "Banco, financeira ou pessoa": "بنك أو شركة تمويل أو شخص",
 "Bandeiras": "الأعلام",
 "Banheiro": "الحمّام",
 "Banho": "استحمام",
 "Banho e tosa": "استحمام وقص شعر",
 "Barra": "الشريط",
 "Bateria": "البطارية",
 "Batimentos (média)": "نبض القلب (المتوسط)",
 "Batizado": "معمودية",
 "Bebida": "مشروب",
 "Bebê": "رضيع",
 "Beijo": "قبلة",
 "Bem": "أصل",
 "Bem clara": "فاتحة جدًا",
 "Bem-Estar": "العافية",
 "Bem-Estar · Cronograma alimentar": "العافية · خطة الوجبات",
 "Bens": "الأصول",
 "Bichos e diversão": "حيوانات وتسلية",
 "Bicicleta": "دراجة",
 "Bicicleta ergométrica": "الدراجة الثابتة",
 "Biografia": "سيرة ذاتية",
 "Biologia": "الأحياء",
 "Biometria (digital ou rosto)": "القياسات الحيوية (البصمة أو الوجه)",
 "Biometria ({tipos})": "القياسات الحيوية ({tipos})",
 "Biometria não confirmada.": "لم يتم التحقق بالبصمة.",
 "Bloqueado": "محجوب",
 "Bloquear": "حظر",
 "Bloquear agora": "القفل الآن",
 "Bloqueio": "حجب",
 "Blusas de frio": "ملابس صوفية",
 "Boa noite": "تصبح على خير",
 "Boa sorte!": "بالتوفيق!",
 "Boas-vindas ao My Planner": "مرحبًا بك في My Planner",
 "Boas-vindas pelo WhatsApp": "ترحيب عبر WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "تم إرفاق Boleto",
 "Boleto do banco {b}": "Boleto من البنك {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto والمستندات (صورة أو PDF أو ملف)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto أو فاتورة (صورة أو PDF أو ملف)",
 "Boleto por foto": "Boleto من صورة",
 "Bolinha": "دائرة",
 "Bom dia": "صباح الخير",
 "Bom dia!": "صباح الخير!",
 "Bom dia! Seu dia no My Planner": "صباح الخير! يومك في My Planner",
 "Booking": "Booking",
 "Bora!": "يلا!",
 "Borboleta": "فراشة",
 "Borracha": "ممحاة",
 "Botas para neve": "أحذية للثلج",
 "Brasil": "البرازيل",
 "Braços acima da cabeça": "الذراعان فوق الرأس",
 "Brilho": "لمعان",
 "Brinquedo ou livro para a viagem": "لعبة أو كتاب للرحلة",
 "Busca de notas": "البحث عن الفواتير",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "يبحث عن الاسم في الجرائد البلدية التي يجمعها Querido Diário (Open Knowledge Brasil). لا تشمل جميع البلديات، والجرائد الرسمية ليست جزءًا من DJEN.",
 "Buscando...": "جارٍ البحث...",
 "Buscar": "بحث",
 "Buscar GIF (ex.: parabéns, bom dia)": "ابحث عن GIF (مثل: مبروك، صباح الخير)",
 "Buscar cidade, país ou GMT": "ابحث عن مدينة أو دولة أو GMT",
 "Buscar conversa": "البحث في المحادثات",
 "Buscar documento, titular ou órgão": "ابحث عن مستند أو صاحبه أو الجهة",
 "Buscar em {nome}": "البحث في {nome}",
 "Buscar emoji (ex.: coração, risada)": "ابحث عن إيموجي (مثل: قلب، ضحك)",
 "Buscar figurinha": "ابحث عن ملصق",
 "Buscar notas": "البحث عن الفواتير",
 "Buscar ou digitar um alimento": "ابحث عن طعام أو اكتبه",
 "Buscar país": "البحث عن دولة",
 "Buscar pelo nome ou pelo texto": "البحث بالاسم أو بالنص",
 "Buscar produto, loja ou observação": "ابحث عن منتج أو متجر أو ملاحظة",
 "Buscar tarefas": "البحث في المهام",
 "Buscar: processo, parte, tribunal, palavra...": "بحث: قضية، طرف، محكمة، كلمة...",
 "CAIXA {n}": "صندوق {n}",
 "CARDS DE ANOTAÇÕES": "بطاقات الملاحظات",
 "CARTÕES": "البطاقات",
 "CEP": "CEP (الرمز البريدي)",
 "CID (se o paciente pedir na declaração)": "CID (إذا طلبه المريض في الإفادة)",
 "CID: {c}": "CID: {c}",
 "CNH": "رخصة القيادة (CNH)",
 "CNPJ (se tiver)": "CNPJ (إن وجد)",
 "CNPJ ou CPF": "CNPJ أو CPF",
 "COMPROVANTE DE PAGAMENTO": "إيصال الدفع",
 "COMPROVANTE DE RECEBIMENTO": "إيصال الاستلام",
 "COMPROVANTES ANTERIORES": "الإيصالات السابقة",
 "CONTAS DO MÊS": "فواتير الشهر",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (البرازيل)",
 "CPF de quem paga": "CPF الدافع",
 "CPF do paciente": "CPF المريض",
 "CPF do pagador": "CPF الدافع",
 "CPF inválido": "رقم CPF غير صالح",
 "CPF ou CNPJ de quem recebeu": "CPF أو CNPJ للمستلم",
 "CPF ou senha incorretos.": "رقم CPF أو كلمة المرور غير صحيحة.",
 "CRIAR CÔMODO": "إنشاء غرفة",
 "CRIAR UM GRUPO": "إنشاء مجموعة",
 "CRONOGRAMA ALIMENTAR": "الجدول الغذائي",
 "CUIDADOS PESSOAIS": "العناية الشخصية",
 "Cabeleireiro": "مصفف شعر",
 "Cabelo": "الشعر",
 "Cachorro": "كلب",
 "Cactos e suculentas": "الصبار والعصاريات",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "كل تبويب إضافي: {n} يومًا مجانًا؛ ثم {preco} سنويًا.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "يذهب كل ملف جاهز إلى {nome}. تبقى ملفات PDF المفتوحة أيضًا على هذا الجهاز، في القائمة أدناه.",
 "Cada dia da semana": "كل يوم من أيام الأسبوع",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "يذهب كل مستند جديد إلى {nome} عند خروجك منه. تبقى صور الصفحات على هذا الجهاز فقط.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "يتلقى كل عضو في الفريق الاجتماع في الواردة ويضيفه إلى Planner بلمسة واحدة مع التنبيه.",
 "Cada pessoa do grupo recebe e decide se aceita.": "يتلقاه كل شخص في المجموعة ويقرر قبوله أو لا.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "كل صفحة تحفظ ملخصًا أو درسًا أو فصلًا. ضع علامة \"تمت مراجعتها\" عند الانتهاء.",
 "Cada página vira uma imagem JPG.": "تتحول كل صفحة إلى صورة JPG.",
 "Cada refeição se repete nos dias dela": "تتكرر كل وجبة في أيامها المحددة",
 "Cadastrar": "تسجيل",
 "Cadastrar cartão de crédito": "تسجيل بطاقة ائتمان",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "التسجيل من صورة (صفحة الدورة، شهادة، منشور)",
 "Cadastrar pela foto da capa": "التسجيل من صورة الغلاف",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "املأ \"بياناتي\" لتظهر الإيصالات باسمك ونقابتك ورقمك.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "سجّل الهوية ورخصة القيادة وجواز السفر والعقود والشهادات. ينبّهك التطبيق قبل الانتهاء ويرسل المستند بلمسة واحدة.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "سجّل الشركة (أو نفسك كمهني) برقم CNPJ أو CPF والبلدية والنظام الضريبي. ثم اربط شهادة A1 لإصدار NFS-e وفق Padrão Nacional والبحث عن الفواتير الصادرة والواردة.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "أضف المشروع، وبداخله المراحل مع الميزانية، واليوميات مع الصور، والعمّال، وتوريدات المواد.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "أضف الرحلة، وبداخلها برنامج كل يوم، والحجوزات، والحقيبة. خلال الرحلة يظهر البرنامج في My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "سجّل اسمك ورقم OAB الخاص بك فقط.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "أضف الأطفال: الاختبارات والاجتماعات والمواعيد الطبية واللقاحات تُحفظ لكل طفل.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "أضف كل حيوان أليف: سجل اللقاحات ومضادات الديدان والأدوية ومتجر الحيوانات تُحفظ بداخله.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "أضف كل نبتة مع الإضاءة والتربة وعدد الأيام بين كل ري وتسميد. سيُعدّ التطبيق التقويم في الجدول.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "أضف كل مركبة. بداخلها الصيانات (مع تنبيه حسب الكيلومترات والتاريخ) ومواعيد IPVA والترخيص والتأمين.",
 "Cadastre digital ou rosto no aparelho para usar.": "سجّل البصمة أو الوجه في الجهاز لاستخدام هذه الميزة.",
 "Cadastre o cartão primeiro": "سجّل البطاقة أولًا",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "سجّل التمويل أو القرض بالمبلغ والفائدة وعدد الأقساط. يحسب التطبيق الأقساط والرصيد المتبقي وينبّهك بمواعيد الاستحقاق.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "سجّل العقار كاملًا أو كل غرفة تؤجرها. داخل كل منها الحجوزات والتنظيف والمصروفات.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "أضف الكتاب مع عدد صفحاته الكلي والهدف اليومي. اضغط ⋮ لإضافة الصفحات المقروءة.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "أضف الدواء مع مواعيده، ثم اضغط ⋮ لوضعه في الخط الزمني مع منبّه.",
 "Cadastre os alunos da turma na aba Alunos.": "أضف طلاب الفصل في تبويب «الطلاب».",
 "Cadastre os clientes para separar as horas.": "أضف العملاء لفصل الساعات.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "سجّل العملاء الذين يتلقّون فواتيرك. العنوان اختياري (إن ملأته، أدخل CEP ورمز IBGE والشارع والرقم والحي).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "سجّل الخدمات التي تصدر لها الفواتير أكثر من غيرها، مع رمز الضريبة الوطني. عند الإصدار تكفي لمسة واحدة.",
 "Cadastre primeiro em {nome}.": "أضف أولًا في {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "سجّل اسمك ونقابتك المهنية ورقم القيد. تظهر في الإيصالات والإفادات.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "سجّل عملاءك في تبويب \"متلقّو الخدمة\" للشركة لاختيارهم هنا.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "سجّل بياناتك المهنية (الاسم والنقابة والرقم) في \"بياناتي\" لتظهر في المستند.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "سجّل بياناتك المهنية (الاسم والنقابة والرقم) في \"بياناتي\" لتظهر في الإيصال.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "سجّل مرضاك. داخل كل مريض الزيارات مع تطور الحالة والوصفة والدفع والإيصال والإفادة لشركة التأمين الصحي.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "أضف نفسك وكل فرد من العائلة. لكل منهم المواعيد والفحوصات واللقاحات والأدوية. البيانات الحساسة تُحفظ في الخزنة المشفّرة.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "التسجيل بانتظار التفعيل: أوقف \"Confirm email\" في Supabase (راجع COMO RODAR).",
 "Cadastro recebido": "تم استلام التسجيل",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "التسجيل: الاسم، وCPF أو البريد الإلكتروني، وكلمة المرور (تُحفظ بصيغة محمية فقط)، وبريد التواصل.",
 "Cadastros": "السجلات",
 "Cadastros e comprovantes": "السجلات والإيصالات",
 "Cadeira extensora": "تمديد الساقين",
 "Café": "قهوة",
 "Café da manhã": "الفطور",
 "Café ou bar": "مقهى أو بار",
 "Café?": "قهوة؟",
 "Cafés": "مقاهي",
 "Caixa": "صندوق",
 "Caixa arquivada": "صندوق مؤرشف",
 "Caixa com checklist, lista ou texto livre": "مربع بقائمة تحقق أو قائمة أو نص حر",
 "Caixa {n}": "صندوق {n}",
 "Caixas": "الصناديق",
 "Caixas e cronograma da mudança.": "الصناديق وجدول الانتقال.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "صناديق حسب الغرفة مع ملصقات، ونقل الماء والكهرباء والإنترنت، والمعاينات، والجدول اليومي.",
 "Calculadora": "آلة حاسبة",
 "Calculando...": "جارٍ الحساب...",
 "Calendário": "التقويم",
 "Calendário da planta": "تقويم النبتة",
 "Calendário do imposto": "تقويم الضرائب",
 "Calendários": "التقويمات",
 "Calorias em atividade": "سعرات النشاط",
 "Calorias gastas em atividade (kcal)": "السعرات المحروقة في النشاط (kcal)",
 "Calça térmica (segunda pele)": "بنطال حراري (طبقة داخلية)",
 "Calças ou bermudas": "بناطيل أو شورتات",
 "Cama": "سرير",
 "Caminhada": "المشي",
 "Caminhão": "شاحنة",
 "Camisetas": "قمصان قصيرة",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "حقول النموذج",
 "Cancelada": "ملغاة",
 "Canceladas": "الملغاة",
 "Cancelar": "إلغاء",
 "Cancelar a NFS-e": "إلغاء NFS-e",
 "Cancelar a NFS-e {n}?": "إلغاء NFS-e رقم {n}؟",
 "Cancelar a nota": "إلغاء الفاتورة",
 "Cancelar a reunião \"{nome}\"?": "إلغاء الاجتماع \"{nome}\"؟",
 "Cancelar reunião": "إلغاء الاجتماع",
 "Caneta": "القلم",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "الالتقاط التلقائي من الخادم: كل ساعتين، من 08:00 إلى 20:00",
 "Captura automática: todos os dias às 08h e 12h": "الالتقاط التلقائي: كل يوم الساعة 08:00 و12:00",
 "Card": "بطاقة",
 "Cardápio": "القائمة",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "قائمة الأسبوع، الوصفات، قائمة تسوق تلقائية، وصلاحية المؤونة.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "قائمة طعام لهذا اليوم فقط. تبقى الأيام الأخرى على قائمة الأسبوع.",
 "Carga (kg)": "الوزن (كغ)",
 "Carimbo": "ختم",
 "Carnaval": "الكرنفال",
 "Carne magra": "لحم قليل الدهن",
 "Carregando feriados...": "جارٍ تحميل العطلات...",
 "Carregando...": "جارٍ التحميل...",
 "Carro": "سيارة",
 "Carta": "Letter",
 "Carteira": "محفظة",
 "Carteira de trabalho": "دفتر العمل",
 "Carteira profissional (OAB, CRC, CREA...)": "البطاقة المهنية (OAB, CRC, CREA...)",
 "Cartão": "بطاقة",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "بطاقة جهة الاتصال في الرسائل: الصورة والهاتف والبريد الإلكتروني والحالة التي تختار إضافتها بنفسك. لا يراها إلا من يتحدث معك وأصدقاؤك ومن يشاركك مجموعة في التطبيق.",
 "Cartão de crédito": "بطاقة ائتمان",
 "Cartão de débito": "بطاقة خصم",
 "Cartão parcelado": "بطاقة بالتقسيط",
 "Cartões": "البطاقات",
 "Cartões de visita": "بطاقات العمل",
 "Cartões e dinheiro": "البطاقات والنقود",
 "Casa": "المنزل",
 "Casa e rotina": "المنزل والروتين",
 "Casa, família e veículos": "المنزل والعائلة والمركبات",
 "Casaco leve": "معطف خفيف",
 "Casaco pesado": "معطف ثقيل",
 "Casamento": "زفاف",
 "Castanhas": "مكسرات",
 "Categoria": "الفئة",
 "Categoria de \"{d}\"": "فئة \"{d}\"",
 "Categorias": "الفئات",
 "Caução": "تأمين نقدي",
 "Ceia": "وجبة المساء",
 "Celular": "الهاتف",
 "Celular confirmado": "تم تأكيد الهاتف",
 "Celular e carregador": "الهاتف والشاحن",
 "Certidão": "شهادة رسمية",
 "Certificado digital": "شهادة رقمية",
 "Certificado digital A1": "الشهادة الرقمية A1",
 "Certificado ligado": "الشهادة مربوطة",
 "Chamada": "الحضور والغياب",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "لم يُسجَّل الحضور في هذا اليوم بعد. اضغط على من غاب أو أكّد حضور الجميع.",
 "Chamada, notas, planos de aula e materiais.": "الحضور والدرجات وخطط الدروس والمواد.",
 "Chamadas": "المكالمات",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "تمر المكالمات الصوتية ومكالمات الفيديو عبر خوادم LiveKit، أثناء المكالمة فقط ودون تسجيل.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "تمر المكالمات الصوتية ومكالمات الفيديو عبر خوادم LiveKit طوال مدة المكالمة فقط. لا يتم التسجيل إلا في اجتماعات المكتب عندما يقوم المسؤول بالتسجيل، ويُحفظ الملف مباشرة في مساحة تخزين التطبيق.",
 "Chamando...": "جارٍ الاتصال...",
 "Chapéu ou boné": "قبعة",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "لم يُسجَّل مفتاح الذكاء الاصطناعي على هذا الجهاز (الإعدادات › الذكاء الاصطناعي).",
 "Chave de acesso": "مفتاح الوصول",
 "Check-in": "تسجيل الوصول",
 "Check-in: {d} a partir das {h}": "تسجيل الوصول: {d} ابتداءً من {h}",
 "Check-in: {h} · {e}": "تسجيل الوصول: {h} · {e}",
 "Check-out": "المغادرة",
 "Check-out: {d} até as {h}": "المغادرة: {d} حتى {h}",
 "Check-out: {h} · {e}": "المغادرة: {h} · {e}",
 "Checklist": "قائمة تحقق",
 "Chinelo": "شبشب",
 "Chá de bebê": "حفل استقبال المولود",
 "Cidade": "المدينة",
 "Cidade (para a data dos recibos)": "المدينة (لتاريخ الإيصالات)",
 "Cidade de {nome}": "مدينة {nome}",
 "Cidades": "المدن",
 "Cifrão": "علامة الدولار",
 "Cinza": "رمادي",
 "Cirurgia": "عملية جراحية",
 "Ciências": "العلوم",
 "Clara": "فاتحة",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "يفتّح ملفات PDF الممسوحة: خلفية بيضاء أو رمادية أو أبيض وأسود.",
 "Claro": "فاتح",
 "Classificar categorias com IA": "تصنيف الفئات بالذكاء الاصطناعي",
 "Claude, ChatGPT ou Gemini": "Claude أو ChatGPT أو Gemini",
 "Cliente": "العميل",
 "Clientes": "العملاء",
 "Clima esperado": "الطقس المتوقع",
 "Co-anfitrião": "مضيف مشارك",
 "Cobrança": "مطالبة",
 "Cobranças": "المطالبات",
 "Coelho": "أرنب",
 "Cofre (criptografia de ponta a ponta)": "الخزنة (تشفير تام بين الطرفين)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "الخزنة مفتوحة (تُغلق تلقائيًا بعد 5 دقائق دون استخدام)",
 "Cofre ainda não criado": "لم تُنشأ الخزنة بعد",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "خزنة مشفّرة للهوية ورخصة القيادة وجواز السفر والعقود والشهادات، مع عدّ تنازلي حتى انتهاء الصلاحية وإرسال بلمسة واحدة.",
 "Cofre fechado": "الخزنة مغلقة",
 "Cofrinho": "حصّالة",
 "Cole aqui a chave ({ini}...)": "الصق المفتاح هنا ({ini}...)",
 "Cole o link (https://...)": "الصق الرابط (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "الصق الرمز الشريطي أو اكتبه (أو رمز Pix للنسخ واللصق) في حقل الرمز: يحسب التطبيق المبلغ وتاريخ الاستحقاق تلقائيًا. وعند تفعيل الذكاء الاصطناعي الخاص بك، يقرأ كل شيء من الصورة.",
 "Coloca arquivos dentro do PDF.": "يضع ملفات داخل PDF.",
 "Colocar na agenda": "إضافة إلى الجدول",
 "Colocar na linha do tempo com alarme": "وضعه في الخط الزمني مع منبّه",
 "Colocar no My Planner": "إضافة إلى My Planner",
 "Colocar rega e adubo na agenda": "إضافة الري والتسميد إلى الجدول",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "ضع قيمة الرسوم الشهرية في الفصل (تعديل) أو لدى الطالب. لا تتكرر مطالبات هذا الشهر الموجودة بالفعل.",
 "Coluna": "العمود",
 "Colágeno": "كولاجين",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "عند تفعيل القياسات الحيوية تظهر أولاً. إذا فشلت، استخدم النمط أو كلمة المرور.",
 "Com convênio": "بالتأمين",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "مع رمز الدولة ورمز المنطقة. مثال: +55 41 99999-0000",
 "Com outras pessoas": "مع أشخاص آخرين",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "مع وجود مهلة، يحسب التطبيق كم تدّخر شهريًا. المال المدّخر يُحتسب كـ \"مدّخر\" في الشهر.",
 "Com quem": "مع من",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "من دفع، والمريض، والتاريخ، ومبلغ كل زيارة مدفوعة. كشخص طبيعي، سجّل كل واحدة في تطبيق Receita Federal › Receita Saúde؛ ومع CNPJ، أصدر فاتورة الخدمة.",
 "Com valor a receber": "بمبلغ مستحق القبض",
 "Com vencimento": "بتاريخ استحقاق",
 "Combinado": "اتفقنا",
 "Combinado 👍": "اتفقنا 👍",
 "Combustível": "الوقود",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "ابدأ بتسجيل المصاريف الثابتة للشهر (الإيجار، الكهرباء، الإنترنت) وبطاقتك. سأنبّهك قبل كل موعد استحقاق.",
 "Comecei em": "تاريخ البدء",
 "Comentários": "التعليقات",
 "Começa amanhã": "يبدأ غدًا",
 "Começa às {hora} (em {m} min)": "يبدأ الساعة {hora} (بعد {m} د)",
 "Começar": "ابدأ",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "البدء بالنموذج: فطور، وجبة خفيفة، غداء، وجبة خفيفة، عشاء",
 "Começar em": "البدء من",
 "Começar o teste grátis": "ابدأ التجربة المجانية",
 "Comi outros alimentos ou quantidades": "تناولت أطعمة أو كميات أخرى",
 "Comida": "طعام",
 "Comidas e bebidas": "الطعام والشراب",
 "Comido": "ما تم تناوله",
 "Comido / alterações": "ما تم تناوله / التغييرات",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "يحتسب \"ما تم تناوله\" الوجبات المعلّمة كمنجزة (أو بها تغييرات) حتى اليوم.",
 "Comigo": "معي",
 "Comissão da plataforma": "عمولة المنصة",
 "Como apagar a sua conta e os seus dados": "كيف تحذف حسابك وبياناتك",
 "Como chegar": "كيفية الوصول",
 "Como ela está": "كيف حالها",
 "Como estou comparado ao mês passado?": "كيف وضعي مقارنةً بالشهر الماضي؟",
 "Como funciona": "كيف يعمل",
 "Como planejado": "كما هو مخطط",
 "Compartilhado no grupo": "مُشارَك في المجموعة",
 "Compartilhado no grupo · só leitura": "مُشارَك في المجموعة · للقراءة فقط",
 "Compartilhamento indisponível neste dispositivo.": "المشاركة غير متاحة على هذا الجهاز.",
 "Compartilhar": "مشاركة",
 "Compartilhar PDF": "مشاركة PDF",
 "Compartilhar a limpeza": "مشاركة التنظيف",
 "Compartilhar os dados": "مشاركة البيانات",
 "Compartilhar os dados com a equipe": "مشاركة البيانات مع الفريق",
 "Compartilhar os dados com o grupo?": "مشاركة البيانات مع المجموعة؟",
 "Compartilhar texto": "مشاركة النص",
 "Competência (mês de referência)": "فترة الاستحقاق (الشهر المرجعي)",
 "Competência {d}": "الفترة {d}",
 "Complemento": "تفاصيل إضافية",
 "Complete seus dados": "أكمل بياناتك",
 "Compra": "شراء",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "شراء وبيع العقارات والمركبات والأسهم، والإيصالات القابلة للخصم، وتقويم الضرائب.",
 "Compra feita": "تم الشراء",
 "Compra no cartão": "شراء بالبطاقة",
 "Compras": "المشتريات",
 "Compras da semana": "مشتريات الأسبوع",
 "Comprimir": "ضغط",
 "Compromisso": "موعد",
 "Compromisso da escola": "موعد مدرسي",
 "Comprovante": "إيصال",
 "Comprovante guardado": "تم حفظ الإيصال",
 "Comprovantes": "الإيصالات",
 "Computador": "الكمبيوتر",
 "Comédia": "كوميديا",
 "Concedi": "أقرضتُ",
 "Concluir": "إنهاء",
 "Concluir (esquerda)": "إنهاء (يسار)",
 "Concluída": "مكتملة",
 "Concluído": "مكتمل",
 "Concluído (%)": "المُنجَز (%)",
 "Concluído!": "اكتمل!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "أوافق على استخدام اسمي ورقم CPF وبريدي الإلكتروني فقط لتعريف حسابي، وعلى حفظ مهامي وملاحظاتي فيه. يمكنني حذف الحساب وجميع البيانات في أي وقت من الإعدادات › الأمان.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "أوافق على استخدام اسمي ورقم CPF وبريدي الإلكتروني فقط لتعريف حسابي، وعلى حفظ مهامي وملاحظاتي فيه. يمكنني حذف الحساب وجميع البيانات في أي وقت من الإعدادات.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "أوافق على استخدام اسمي ووثيقتي وبريدي الإلكتروني فقط لتعريف حسابي، وعلى حفظ مهامي وملاحظاتي فيه. يمكنني حذف الحساب وجميع البيانات في أي وقت من الإعدادات › الأمان.",
 "Concursos": "مسابقات التوظيف",
 "Condicionador": "بلسم",
 "Condomínio": "رسوم العمارة",
 "Condomínio e IPTU": "رسوم المبنى وIPTU",
 "Conectado": "متصل",
 "Conectando...": "جارٍ الاتصال...",
 "Conectar": "ربط",
 "Conectar navegador": "ربط المتصفح",
 "Conectar o {nome}": "ربط {nome}",
 "Conectar relógio ou app de saúde": "ربط ساعة أو تطبيق صحة",
 "Conectar {nome}": "ربط {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "اربط {nome} من الإعدادات › Google Drive وOneDrive.",
 "Conferindo...": "جارٍ التحقق...",
 "Conferir controles, chaves e Wi-Fi": "التحقق من أجهزة التحكم والمفاتيح وWi-Fi",
 "Conferir o prazo no sistema oficial": "تحقّق من المهلة في النظام الرسمي",
 "Confete": "قصاصات ملونة",
 "Configuração geral": "الإعدادات العامة",
 "Confira a senha da sua conta e tente de novo.": "تحقق من كلمة مرور حسابك وحاول مرة أخرى.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "راجع المواعيد الرسمية على موقع Receita Federal وعدّلها إن لزم.",
 "Confira o código. Ele tem 6 letras e números.": "تحقق من الرمز. يتكون من 6 أحرف وأرقام.",
 "Confira o e-mail ou deixe em branco.": "تحقّق من البريد الإلكتروني أو اتركه فارغًا.",
 "Confira o e-mail.": "تحقق من البريد الإلكتروني.",
 "Confira o prazo no sistema oficial.": "تحقّق من المهلة في النظام الرسمي.",
 "Confira os 11 números.": "تحقّق من الأرقام الـ11.",
 "Confira os campos antes de salvar.": "راجع الحقول قبل الحفظ.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "تأكد من أن حساب Google الخاص بك مضاف على الهاتف وأن التقويم تتم مزامنته.",
 "Confirmada": "مؤكدة",
 "Confirmado": "مؤكَّد",
 "Confirmar": "تأكيد",
 "Confirme a declaração sobre a empresa.": "أكّد الإقرار الخاص بالشركة.",
 "Confirme o seu celular": "أكّد رقم هاتفك",
 "Confirme para ativar a biometria": "أكّد لتفعيل البصمة",
 "Confirme para excluir": "أكّد للحذف",
 "Confirme sua senha para sincronizar": "أكّد كلمة المرور للمزامنة",
 "Confraternização": "حفل جماعي",
 "Confraternização Universal": "رأس السنة الميلادية",
 "Conselho": "النقابة",
 "Consignado": "قرض مخصوم من الراتب",
 "Consulta": "موعد طبي",
 "Consulta ou vacina": "موعد طبي أو لقاح",
 "Consultas": "المواعيد الطبية",
 "Consultório": "العيادة",
 "Consumo médio: {v} km/L": "متوسط الاستهلاك: {v} كم/لتر",
 "Conta": "الحساب",
 "Conta a pagar": "فاتورة مستحقة الدفع",
 "Conta a receber": "مبلغ مستحق القبض",
 "Conta de consumo ou tributo": "فاتورة خدمات أو ضريبة",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "يحسب الأيام التي كان كل عنصر مقررًا فيها (حسب أيامه في الأسبوع) والأيام التي تم تحديده فيها كمكتمل.",
 "Conta paga": "تم دفع الفاتورة",
 "Conta recebida": "تم استلام المبلغ",
 "Conta vence hoje": "فاتورة مستحقة اليوم",
 "Conta vencendo": "فاتورة قارب موعدها",
 "Contabilidade": "المحاسبة",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "يشمل المرافقين. اضغط على حالة الضيف لتغييرها.",
 "Contando: {cliente}": "يُحتسب: {cliente}",
 "Contas": "المدفوعات",
 "Contas a pagar": "فواتير مستحقة",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "الفواتير المستحقة الدفع والقبض، ومصروفات الشهر، وتنبيهات الاستحقاق، ومتابعة MEI (Mestre Achado).",
 "Contas a receber": "مبالغ مستحقة القبض",
 "Contas fixas": "المصاريف الثابتة",
 "Contato": "جهة الاتصال",
 "Contato de emergência": "جهة اتصال للطوارئ",
 "Contato do encarregado de dados:": "جهة الاتصال بمسؤول حماية البيانات:",
 "Conte a sua ideia para o app ficar melhor.": "شاركنا فكرتك لنجعل التطبيق أفضل.",
 "Conte o que está difícil ou não funciona como deveria.": "أخبرنا بما هو صعب أو لا يعمل كما ينبغي.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "أخبرنا بما فعلته وما كنت تتوقعه وما ظهر لك. إذا ظهرت رسالة خطأ، انسخها هنا.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "أخبرنا بالمشكلات والأخطاء وأفكار التحسين. تصل رسالتك مباشرة إلى فريق My Planner.",
 "Conteúdo": "المحتوى",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "المحتوى الذي تنشئه: المهام والملاحظات والمالية والمستندات والصور والمرفقات وبيانات التبويبات.",
 "Conteúdo, matéria, tarefa de casa...": "المحتوى، المادة، الواجب المنزلي...",
 "Continuar": "متابعة",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "واصل استخدام My Planner والملاحظات مقابل {preco} سنويًا. بياناتك تبقى محفوظة.",
 "Contratado": "متعاقد",
 "Contratado: {v}": "المتعاقد عليه: {v}",
 "Contrato": "عقد",
 "Conversa": "محادثة",
 "Conversa do grupo": "محادثة المجموعة",
 "Conversar": "مراسلة",
 "Conversar com o Mestre (precisa da sua IA)": "التحدث مع Mestre (يحتاج إلى ذكائك الاصطناعي)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "تحدث مع الأصدقاء والمجموعات، وأجرِ مكالمات صوتية ومكالمات فيديو.",
 "Converter de PDF": "تحويل من PDF",
 "Converter para PDF": "تحويل إلى PDF",
 "Convidado": "ضيف",
 "Convidados": "الضيوف",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "الضيوف مع تأكيد الحضور، والمورّدون، وبرنامج اليوم الكبير.",
 "Convidados e cronograma do dia, sem os valores.": "الضيوف وجدول اليوم، دون المبالغ.",
 "Convidar": "دعوة",
 "Convidar pelo WhatsApp": "دعوة عبر WhatsApp",
 "Convite": "دعوة",
 "Convite copiado. Cole onde quiser enviar.": "تم نسخ الدعوة. الصقها حيث تريد إرسالها.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "دعوة غير صالحة أو غيّرها المسؤول. اطلب رابطًا جديدًا.",
 "Convite para o My Planner": "دعوة إلى My Planner",
 "Convênio": "التأمين",
 "Copiar": "نسخ",
 "Copiar a lista para uma tarefa": "نسخ القائمة إلى مهمة",
 "Copiar o código": "نسخ الرمز",
 "Copiar para hoje": "نسخ إلى اليوم",
 "Copo de outro tamanho": "كوب بحجم آخر",
 "Copo {n}": "الكوب {n}",
 "Cor": "اللون",
 "Cor do fichário": "لون المجلد",
 "Cor do tema": "لون السمة",
 "Cor do tema de cada aba": "لون السمة لكل تبويب",
 "Coração": "قلب",
 "Corações": "قلوب",
 "Cores das abas": "ألوان التبويبات",
 "Cores das conversas": "ألوان المحادثات",
 "Cores e opções desta aba": "ألوان وخيارات هذا التبويب",
 "Corpo": "الجسم",
 "Corporativo": "حفل شركة",
 "Corpus Christi": "عيد القربان المقدس",
 "Corredor": "الممر",
 "Correia dentada": "سير التوقيت",
 "Corrida": "جري",
 "Corta as bordas em branco ou partes da página.": "يقص الحواف الفارغة أو أجزاء من الصفحة.",
 "Cortesia": "مجاني",
 "Coxa e sobrecoxa": "أفخاذ وأوراك الدجاج",
 "Cozinha": "المطبخ",
 "Creatina": "كرياتين",
 "Criada em {data}": "أُنشئت في {data}",
 "Criado com": "أُنشئ باستخدام",
 "Criado em": "تاريخ الإنشاء",
 "Criança": "طفل",
 "Crianças": "الأطفال",
 "Criar": "إنشاء",
 "Criar animada": "إنشاء متحرك",
 "Criar conta": "إنشاء حساب",
 "Criar do zero": "إنشاء من الصفر",
 "Criar documento, planilha ou apresentação": "إنشاء مستند أو جدول بيانات أو عرض تقديمي",
 "Criar em outro app": "إنشاء في تطبيق آخر",
 "Criar escritório": "إنشاء مكتب",
 "Criar fichário": "إنشاء مجلد",
 "Criar figurinha": "إنشاء ملصق",
 "Criar grupo": "إنشاء مجموعة",
 "Criar grupo e convidar pessoas": "إنشاء مجموعة ودعوة أشخاص",
 "Criar minha chave de API": "إنشاء مفتاح API الخاص بي",
 "Criar o cofre": "إنشاء الخزنة",
 "Criar o grupo e convidar": "إنشاء المجموعة والدعوة",
 "Criar os prazos do IR de {ano}": "إنشاء مواعيد IR لسنة {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "إنشاء هدف (سفر، احتياطي، سيارة...)",
 "Criar uma senha nova": "إنشاء كلمة مرور جديدة",
 "Criar {n} tarefa(s)": "إنشاء {n} مهمة",
 "Criação do Estado de MS": "ذكرى تأسيس ولاية MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "أنشئ الانتقال وسيُعدّ التطبيق قائمة النقل (الكهرباء، الماء، الإنترنت...). ثم أضف الصناديق حسب الغرفة والمعاينات والجدول اليومي.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "أنشئ مجلدًا لكل عميل، وادعُ العميل عبر الرابط (يرى مجلده فقط)، وتبادلا المستندات في الاتجاهين: فواتير، قسائم دفع، كشوف رواتب، كشوف حساب، عقود.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "أنشئ الفصل (أو مجموعة إرشاد أو تدريب أو دورة) وبداخله الطلاب والحضور والدرجات وخطط الدروس والمواد والمطالبات.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "أنشئ الفصل، وبداخله الطلاب والحضور والتقييمات مع الدرجات وخطط الدروس.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "أنشئ مهام المنزل (تنظيف الحمّام، تغيير أغطية السرير...) مع تكرارها. ينبّهك التطبيق عند تأخرها دون أن يزدحم My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "أنشئ بطاقات بقائمة مهام أو قائمة أو نص حر أو رسم لهذه المادة. اسحب لليمين للحذف ولليسار للأرشفة.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "أنشئ المكتب، وادعُ الفريق (أصدقاء من التطبيق أو دعوة عبر الرابط)، وتبادلوا الرسائل والمستندات، وحدّدوا الاجتماعات وعقدوا اجتماعات فيديو. بصفتك المشرف، يمكنك تسجيل الاجتماعات.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "أنشئ المناسبة، وبداخلها قائمة الضيوف مع تأكيد الحضور، والمورّدون، وبرنامج اليوم.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "أنشئ المجموعة وأرسل الرابط: من ينضم يتلقى التاريخ والمكان والتنبيهات وكل ما ترسله، ويمكنه القبول أو التعديل أو الرفض.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "أنشئ المجموعة وأرسل الرابط: من ينضم يرى ويشارك حسب الدور الذي تختاره. المشرفون وحدهم يضيفون الأشخاص أو يزيلونهم.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "أنشئ المجموعة وأرسل الرابط: من ينضم يرى كل ما هنا ويشارك (يضيف ويعدّل ويرفع الصور). المشرفون وحدهم يضيفون الأشخاص أو يزيلونهم.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "أنشئ حسابك. تبقى بياناتك محفوظة في السحابة وعلى هذا الجهاز.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "أنشئ مجلدًا (مثال: الدكتوراه، الإنجليزية، مسابقة توظيف) وبداخله المواد والصفحات.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "أنشئ مجموعة (فصل، مرضى، فريق، ضيوف، عملاء)، وشارك رابط الدعوة، وأرسل المواعيد والمواد والإشعارات. يقبل كل شخص ما يتلقاه أو يعدّله أو يرفضه.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "أنشئ ملفًا شخصيًا بالاسم، وإن كنت محاميًا، برقم OAB.",
 "Criptografado no cofre, só neste dispositivo": "مشفّر في الخزنة، على هذا الجهاز فقط",
 "Criptomoedas": "العملات المشفّرة",
 "Cronograma": "الجدول",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "الجدول الغذائي، والعناية الشخصية خطوة بخطوة، وماء اليوم.",
 "Cronograma do dia": "برنامج اليوم",
 "Cronograma físico-financeiro": "الجدول المادي والمالي",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "جدول مادي ومالي لكل مرحلة، ويوميات المشروع قبل وبعد، والعمّال، والتوريدات.",
 "Cronômetro de horas": "مؤقّت الساعات",
 "Crédito empresarial": "ائتمان تجاري",
 "Créditos": "الأرصدة",
 "Cuida das reservas, da limpeza e das despesas.": "يتولى الحجوزات والتنظيف والمصروفات.",
 "Cuidado": "عناية",
 "Cuidado pessoal": "عناية شخصية",
 "Cuidados": "العناية",
 "Cupom do mercado": "إيصال السوبرماركت",
 "Cupom do mercado (foto)": "إيصال السوبرماركت (صورة)",
 "Cupom lançado": "تم تسجيل الإيصال",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "دورة",
 "Cursos": "الدورات",
 "Cursos livres e certificações": "دورات حرة وشهادات",
 "Cuscuz": "كسكس الذرة",
 "CÓDIGO PARA PAGAR": "رمز الدفع",
 "CÔMODOS": "الغرف",
 "Câmera": "الكاميرا",
 "Câmera e galeria": "الكاميرا والمعرض",
 "Câmera não liberada": "لم يُسمح بالوصول إلى الكاميرا",
 "Código IBGE do município": "رمز IBGE للبلدية",
 "Código IBGE do município (7 números)": "رمز IBGE للبلدية (7 أرقام)",
 "Código NBS (9 números, opcional)": "رمز NBS (9 أرقام، اختياري)",
 "Código copiado": "تم نسخ الرمز",
 "Código da reserva (localizador)": "رمز الحجز",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "الرمز الشريطي أو السطر الرقمي أو Pix للنسخ واللصق (اختياري)",
 "Código de indicação": "رمز الإحالة",
 "Código de indicação (opcional)": "رمز الإحالة (اختياري)",
 "Código de quem convidou você": "رمز الشخص الذي دعاك",
 "Código de tributação nacional (6 números)": "رمز الضريبة الوطني (6 أرقام)",
 "Código de tributação nacional (6 números, ex.: 171901)": "رمز الضريبة الوطني (6 أرقام، مثل: 171901)",
 "Código do amigo": "رمز الصديق",
 "Código do convite": "رمز الدعوة",
 "Código do procedimento (TUSS ou do plano)": "رمز الإجراء (TUSS أو الخاص بالتأمين)",
 "Código errado. Confira e tente de novo.": "رمز خاطئ. تحقّق منه وحاول مرة أخرى.",
 "Código não encontrado. Confira as letras e os números.": "الرمز غير موجود. تحقق من الأحرف والأرقام.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "لم يتم التعرف على الرمز. تحقق من الأرقام (Boleto: ‏47 أو 48 رقمًا).",
 "Código: {c}": "الرمز: {c}",
 "Cópia automática toda semana": "نسخة تلقائية كل أسبوع",
 "Cópia criada.": "تم إنشاء نسخة.",
 "Cópia de segurança": "نسخة احتياطية",
 "Cópia feita": "تم إنشاء النسخة",
 "Cópia restaurada.": "تمت استعادة النسخة.",
 "Cômodo": "الغرفة",
 "Cômodo ou quarto": "غرفة",
 "Cômodos da casa e as tarefas de cada um.": "غرف المنزل ومهام كل غرفة.",
 "DAS de {mes} pago": "تم دفع DAS لشهر {mes}",
 "DAS de {mes}: vence dia {dia}": "DAS لشهر {mes}: يستحق يوم {dia}",
 "DAS do MEI": "DAS الخاص بـ MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "إفادة زيارة",
 "DICA DO MESTRE ACHADO": "نصيحة من Mestre Achado",
 "DPS nº {n}, série {s}": "DPS رقم {n}، سلسلة {s}",
 "Da galeria ou dos arquivos": "من المعرض أو الملفات",
 "Da meta de passos": "من هدف الخطوات",
 "Dados compartilhados": "بيانات مشتركة",
 "Dados compartilhados com o grupo": "بيانات مشتركة مع المجموعة",
 "Dados compartilhados · seu papel: {p}": "بيانات مشتركة · دورك: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "بيانات الصحة التي تسجلها بنفسك تُعالَج لك فقط ولمن تشاركها معه، بموافقتك (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "بيانات الجهاز: اللغة والبلد والمنطقة الزمنية (للتواريخ والعطل والعملة)، وطراز الجهاز، ورمز الإشعارات على الهاتف.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "لا تُستخدم بيانات الساعة والصحة للإعلانات ولا تُشارَك مع أي أحد. يمكنك فصل الربط وإلغاء الإذن في أي وقت.",
 "Dança": "الرقص",
 "Dar ciência": "تسجيل الاطلاع",
 "Dar ciência da operação?": "تسجيل الاطلاع على العملية؟",
 "Data": "التاريخ",
 "Data (embarque ou check-in)": "التاريخ (الإقلاع أو تسجيل الدخول)",
 "Data agendada": "التاريخ المحدد",
 "Data da aplicação": "تاريخ الإعطاء",
 "Data da compra": "تاريخ الشراء",
 "Data da entrega": "تاريخ التسليم",
 "Data da venda": "تاريخ البيع",
 "Data de nascimento": "تاريخ الميلاد",
 "Data do empréstimo": "تاريخ الإعارة",
 "Data do pagamento": "تاريخ الدفع",
 "Data em que foi feita": "تاريخ الإجراء",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "تاريخ مقترح بهامش يومَي عمل. تحقق منه في النظام الرسمي.",
 "De": "من",
 "De uma foto": "من صورة",
 "De {de} para {para} ({p}% menor).": "من {de} إلى {para} (أصغر بنسبة {p}%).",
 "Declaração": "إقرار",
 "Declaração de atendimento": "إفادة زيارة",
 "Declaração para reembolso (PDF)": "إفادة للاسترداد (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "أُقرّ بأن هذه الشركة ملكي أو ملك عميل أذن بالمتابعة.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "أُفيد، لأغراض الاسترداد{conv}، بأن المريض/المريضة {nome}{cpf}{cart} قد تمت معاينته/معاينتها من قِبلي في {data}{hora}، والنوع: {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "حدّد هدف الدروس يوميًا أو أسبوعيًا في تعديل.",
 "Defina a meta de páginas por dia em Editar.": "حدّد هدف الصفحات اليومي في تعديل.",
 "Defina um horário": "حدّد وقتًا",
 "Defina um horário para usar pausas.": "حدّد وقتًا لاستخدام الاستراحات.",
 "Demaquilante ou água micelar": "مزيل المكياج أو ماء ميسيلار",
 "Demolição": "الهدم",
 "Demonstração": "عرض توضيحي",
 "Dentista": "طبيب الأسنان",
 "Dependentes": "المُعالون",
 "Depois": "بعد",
 "Depois da aula": "بعد الدرس",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "بعد الحذف لا يمكن استعادة المهام. أدخل كلمة مرور حسابك للتأكيد.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "بعد التنزيل، افتح الملف واضغط على تثبيت. إذا طلب الهاتف ذلك، اسمح بتثبيت التطبيقات من هذا المصدر.",
 "Depois de criar": "بعد الإنشاء",
 "Depois de {nome}. Toque para pular.": "بعد {nome}. اضغط للتخطي.",
 "Depois é só ajustar horários e o que comer em cada um.": "بعدها عدّل الأوقات وما ستأكله في كل وجبة.",
 "Desarquivar": "إلغاء الأرشفة",
 "Desbloquear": "فتح القفل",
 "Desbloquear com": "فتح القفل باستخدام",
 "Desbloquear com biometria": "فتح القفل بالبصمة",
 "Desbloquear o My Planner": "فتح قفل My Planner",
 "Desbloqueio do app": "قفل التطبيق",
 "Descanso": "راحة",
 "Descartadas": "المستبعدة",
 "Descartar": "استبعاد",
 "Descartar este tempo?": "تجاهل هذا الوقت؟",
 "Descobrir lugares em {d}": "اكتشف أماكن في {d}",
 "Desconectar": "قطع الاتصال",
 "Desconectar o {nome}?": "قطع الاتصال بـ {nome}؟",
 "Desconto": "خصم",
 "Desconto de {v}": "خصم بقيمة {v}",
 "Descontos obtidos": "الخصومات المحصلة",
 "Descrição": "الوصف",
 "Descrição (cliente, nota fiscal...)": "الوصف (العميل، الفاتورة...)",
 "Descrição do serviço (sai na nota)": "وصف الخدمة (يظهر في الفاتورة)",
 "Descrição que sai na nota": "الوصف الذي يظهر في الفاتورة",
 "Desenhar a assinatura": "رسم التوقيع",
 "Desenhar com caneta ou dedo": "ارسم بالقلم أو بالإصبع",
 "Desenhe a assinatura e escolha a página e o lugar.": "ارسم التوقيع واختر الصفحة والمكان.",
 "Desenhe a assinatura primeiro.": "ارسم التوقيع أولًا.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "ارسم بإصبعك أو بالقلم (S Pen أو Apple Pencil أو قلم الجهاز اللوحي).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "ارسم بإصبعك أو بالقلم. لتمرير اللوحة، اضغط على نقل.",
 "Desenhe de novo para confirmar.": "ارسمه مرة أخرى للتأكيد.",
 "Desenhe o seu padrão": "ارسم نمطك",
 "Desenhe pelo menos uma tarja.": "ارسم شريطًا واحدًا على الأقل.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "ارسم نمطًا يصل بين 4 نقاط على الأقل.",
 "Desenho": "رسم",
 "Desenho com caneta ou dedo": "رسم بالقلم أو الإصبع",
 "Desenho incorreto": "نمط غير صحيح",
 "Desenho padrão": "نمط القفل",
 "Desenho padrão salvo.": "تم حفظ نمط القفل.",
 "Desenvolvimento": "ضغط الكتف",
 "Desfazer": "تراجع",
 "Desfazer amizade": "إلغاء الصداقة",
 "Desligar": "إيقاف",
 "Desligar a sincronização?": "إيقاف المزامنة؟",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "اسحب يمينًا ويسارًا لعرض أيام أخرى (حتى 60 يومًا مقدمًا). اضغط على وجبة لتخطيط قائمة ذلك اليوم فقط. اسحب إلى اليمين للحذف.",
 "Desmarcado": "أُلغي",
 "Desmarcar como recebida": "إلغاء تحديدها كمستلمة",
 "Desmarcar feita hoje": "إلغاء تعليم \"منجزة اليوم\"",
 "Desmarcar grupo": "إلغاء تحديد المجموعة",
 "Desmarcar pagamento": "إلغاء تأشير الدفع",
 "Desodorante": "مزيل العرق",
 "Despensa": "المؤن",
 "Despesa": "مصروف",
 "Despesas": "المصروفات",
 "Destino": "الوجهة",
 "Detalhes": "التفاصيل",
 "Devolver até": "الإرجاع قبل",
 "Devolver: {i} ({p})": "إرجاع: {i} ({p})",
 "Devolvido": "تم الإرجاع",
 "Devolvidos": "المُرجَعة",
 "Dia": "اليوم",
 "Dia a dia": "اليوميات",
 "Dia da mudança": "يوم الانتقال",
 "Dia de vencimento do DAS": "يوم استحقاق DAS",
 "Dia do Trabalho": "عيد العمال",
 "Dia do vencimento": "يوم الاستحقاق",
 "Dia em que a fatura fecha": "يوم إغلاق كشف البطاقة",
 "Dia planejado": "اليوم المخطط",
 "Dia {d} de {total}": "اليوم {d} من {total}",
 "Diagnóstico": "تشخيص",
 "Dias e horários": "الأيام والمواعيد",
 "Dias específicos": "أيام محددة",
 "Dias úteis": "أيام العمل",
 "Dias: {dias}": "الأيام: {dias}",
 "Dicas e observações": "نصائح وملاحظات",
 "Diesel": "ديزل",
 "Diferença": "الفرق",
 "Digitado": "يدوي",
 "Digitar": "كتابة",
 "Digitar à mão": "إدخال يدوي",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "أدخل كلمة مرور الخزنة. تُغلق تلقائيًا بعد 5 دقائق دون استخدام.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "اكتب بالدقائق (90) أو بالساعات والدقائق (1:30 أو 01:30) ثم اضغط حسنًا.",
 "Digite no formato HH:MM, por exemplo 13:30.": "اكتب بصيغة HH:MM، مثلًا 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "أدخل الرمز واحصل على 10 أيام مع فتح جميع التبويبات. إن لم يكن لديك رمز، فاتركه فارغًا.",
 "Digite o nome da tarefa.": "أدخل اسم المهمة.",
 "Dinheiro": "نقود",
 "Dinheiro e documentos": "النقود والمستندات",
 "Direita": "يمين",
 "Direito": "القانون",
 "Direito Administrativo": "القانون الإداري",
 "Direito Civil": "القانون المدني",
 "Direito Constitucional": "القانون الدستوري",
 "Direito Empresarial": "القانون التجاري",
 "Direito Penal": "القانون الجنائي",
 "Direito Tributário": "القانون الضريبي",
 "Direito do Trabalho": "قانون العمل",
 "Direto": "مباشر",
 "Disciplina": "المادة الدراسية",
 "Dispensar": "تجاهل",
 "Dispensar o aviso": "إخفاء التنبيه",
 "Dispensar todas": "إخفاء الكل",
 "Disponibilizada em": "تاريخ الإتاحة",
 "Disponível no app novo": "متاح في التطبيق الجديد",
 "Distância": "المسافة",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "قسّم الدورة إلى مواد أو وحدات. في كل منها، حدّد الدرس الذي توقفت عنده وأنشئ بطاقات ملاحظات.",
 "Dividir": "تقسيم",
 "Dividir entre (nenhum marcado = todos)": "التقسيم بين (عدم تحديد أحد = الجميع)",
 "Divisão das despesas": "تقسيم المصروفات",
 "Diária": "الليلة",
 "Diária padrão": "سعر الليلة الافتراضي",
 "Diário": "اليوميات",
 "Diários municipais": "الجرائد البلدية",
 "Do celular, do Google Drive ou do OneDrive": "من الهاتف أو Google Drive أو OneDrive",
 "Do cliente": "من العميل",
 "Do escritório": "من المكتب",
 "Doações": "التبرعات",
 "Docs": "مستندات",
 "Documento": "مستند",
 "Documento (fundo branco)": "مستند (خلفية بيضاء)",
 "Documento do veículo (CRLV)": "وثيقة المركبة (CRLV)",
 "Documento pessoal": "مستند شخصي",
 "Documento vence hoje": "مستند ينتهي اليوم",
 "Documento vencendo": "مستند قارب على الانتهاء",
 "Documento: {o}": "المستند: {o}",
 "Documentos": "المستندات",
 "Documentos (contrato, nota, recibo...)": "المستندات (عقد، فاتورة، إيصال...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "المستندات (جواز السفر، الهوية، رخصة القيادة)",
 "Documentos e autorização das crianças": "مستندات الأطفال وتصاريحهم",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "المستندات المحمية والفحوصات والتاريخ الصحي وغيرها من الحقول التي تحمل 🔒 تُشفَّر هنا على الجهاز (AES-256) بكلمة مرور الخزنة. حتى الدعم الفني لا يستطيع قراءتها. بدون كلمة المرور لا يمكن استعادة هذه البيانات.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "مستندات وإيصالات ودفاتر وألواح، بعدة صفحات",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "تُحذف المستندات والاجتماعات والتسجيلات للجميع. تبقى المحادثة في الرسائل.",
 "Documentário": "وثائقي",
 "Doenças, cirurgias e observações": "الأمراض والعمليات والملاحظات",
 "Dois dedos ou toque duplo para ampliar": "استخدم إصبعين أو انقر مرتين للتكبير",
 "Domingo": "الأحد",
 "Dono da obra": "مالك المشروع",
 "Dose": "الجرعة",
 "Dose (ex.: 1 cápsula, 5 g)": "الجرعة (مثل: 1 كبسولة، 5 غ)",
 "Dose única": "جرعة واحدة",
 "Drama": "دراما",
 "Duplicar": "تكرار",
 "Duplicar tarefa": "تكرار المهمة",
 "Duração": "المدة",
 "Duração de cada sessão": "مدة كل جلسة",
 "Duração {dur}": "المدة {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "هل يمكنني شراء شيء بـ 3 آلاف على 10 أقساط؟",
 "Débito automático": "خصم تلقائي",
 "Débito, Pix ou dinheiro": "خصم مباشر أو Pix أو نقدًا",
 "Dê um nome ao cartão.": "أعطِ البطاقة اسمًا.",
 "Dê um nome ao cuidado.": "أدخل اسمًا للعناية.",
 "Dê um nome ao cômodo.": "أدخل اسمًا للغرفة.",
 "Dê um nome ao fichário.": "أدخل اسمًا للمجلد.",
 "Dê um nome ao grupo.": "أدخل اسمًا للمجموعة.",
 "Dê um nome ao suplemento.": "أدخل اسمًا للمكمّل.",
 "Dê um nome ao treino.": "أدخل اسمًا للتمرين.",
 "Dê um nome à conta.": "أدخل اسمًا للفاتورة.",
 "Dê um nome à matéria.": "أدخل اسمًا للمادة.",
 "Dê um nome à meta.": "أعطِ الهدف اسمًا.",
 "Dê um nome à refeição.": "أدخل اسمًا للوجبة.",
 "Dê um nome à tarefa.": "أدخل اسمًا للمهمة.",
 "E-MAIL (OPCIONAL)": "البريد الإلكتروني (اختياري)",
 "E-mail": "البريد الإلكتروني",
 "E-mail (recebe a nota)": "البريد الإلكتروني (يتلقّى الفاتورة)",
 "E-mail de contato": "البريد الإلكتروني للتواصل",
 "E-mail do responsável": "بريد ولي الأمر",
 "E-mail inválido": "بريد إلكتروني غير صالح",
 "E-mail inválido.": "بريد إلكتروني غير صالح.",
 "E-mail ou WhatsApp para resposta (opcional)": "البريد الإلكتروني أو واتساب للرد (اختياري)",
 "E-mail para contato (opcional)": "بريد إلكتروني للتواصل (اختياري)",
 "E-mail salvo.": "تم حفظ البريد الإلكتروني.",
 "EM ATRASO": "متأخرة",
 "ENTRAR COM UM CÓDIGO": "الانضمام برمز",
 "ENVIADOS": "المُرسَلة",
 "ESCOLHA AS ATIVIDADES": "اختر الأنشطة",
 "ESTA SEMANA": "هذا الأسبوع",
 "EXERCÍCIO FÍSICO": "التمارين الرياضية",
 "Economia": "الاقتصاد",
 "Edita tudo": "يعدّل كل شيء",
 "Edita tudo: etapas, orçamento, diário e entregas.": "يعدّل كل شيء: المراحل والميزانية واليوميات والتسليمات.",
 "Editar": "تعديل",
 "Editar cartão": "تعديل البطاقة",
 "Editar compra": "تعديل الشراء",
 "Editar cômodo": "تعديل الغرفة",
 "Editar desenho": "تعديل الرسم",
 "Editar documento": "تعديل المستند",
 "Editar fichário": "تعديل المجلد",
 "Editar garantia": "تعديل الضمان",
 "Editar matéria": "تعديل المادة",
 "Editar meta": "تعديل الهدف",
 "Editar perfil": "تعديل الملف الشخصي",
 "Editar tarefa": "تعديل المهمة",
 "Editar {nome}": "تعديل {nome}",
 "Educação": "التعليم",
 "Educação Física": "التربية البدنية",
 "Efeito de scanner": "تأثير الماسح الضوئي",
 "Ela sai da lista e dos Recebidos da equipe.": "سيُزال من القائمة ومن الواردة لدى الفريق.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "يُحفظ أيضًا في \"ملصقاتي\" لإرساله مرة أخرى.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "تأتي من تبويب القروض والتمويلات. حدّدها هنا كمدفوعة أو افتح التبويب لرؤية العقد.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "تأتي من تبويب الفواتير الضريبية. حدّدها كمستلمة عند دخول المال.",
 "Eleitorais": "الانتخابية",
 "Eletrodoméstico": "جهاز منزلي",
 "Eletrodomésticos": "أجهزة منزلية",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "الأجهزة المنزلية والإلكترونيات والأثاث: الفاتورة، والصيانة المعتمدة، وتنبيه قبل 15 يومًا من انتهاء الضمان.",
 "Eletrônico": "جهاز إلكتروني",
 "Elétrica": "الكهرباء",
 "Elétrico": "كهربائي",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "في تعديل، الصق رابط تقويم (iCal) الإعلان. في Airbnb: التقويم › التوفر › ربط التقويمات › تصدير التقويم. في Booking: الأسعار والتوفر › مزامنة التقويمات.",
 "Em aberto": "غير مدفوعة",
 "Em alta": "الرائج",
 "Em andamento": "قيد التنفيذ",
 "Em atraso": "متأخر",
 "Em branco": "فارغة",
 "Em casa": "في المنزل",
 "Em cima": "أعلى",
 "Em construção": "قيد الإنشاء",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "محدَّث. تصل التحسينات تلقائيًا عند فتح التطبيق.",
 "Em limpeza": "قيد التنظيف",
 "Em quais páginas": "في أي صفحات",
 "Em qual agenda criar os eventos:": "التقويم الذي تُنشأ فيه الأحداث:",
 "Em qual página e onde": "في أي صفحة وأين",
 "Em tratamento": "قيد العلاج",
 "Em um horário específico": "في وقت محدد",
 "Em uso: {ia}": "قيد الاستخدام: {ia}",
 "Em {n} dia(s)": "خلال {n} يوم/أيام",
 "Embaixo": "أسفل",
 "Embaixo à esquerda": "أسفل اليسار",
 "Emissão": "الإصدار",
 "Emissão +": "الإصدار +",
 "Emissão: {data}": "الإصدار: {data}",
 "Emitida": "صادرة",
 "Emitida em {data}": "صدرت في {data}",
 "Emitida ou recebida": "صادرة أو واردة",
 "Emitidas": "الصادرة",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "الصادرة: {v} · الواردة: {r} · {n} فاتورة",
 "Emitir": "إصدار",
 "Emitir NFS-e": "إصدار NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "أصدِر NFS-e وفق Padrão Nacional بشهادة A1، وابحث عن الفواتير الصادرة والواردة، وصدّر XML وجدول بيانات وPDF.",
 "Emitir a nota de verdade?": "إصدار فاتورة حقيقية؟",
 "Emitir no ambiente de teste?": "الإصدار في بيئة الاختبار؟",
 "Emojis": "الإيموجي",
 "Emojis animados": "إيموجي متحركة",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "إيموجي متحركة: Noto من Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "الإيموجي وGIF والملصقات",
 "Empresa": "الشركة",
 "Empresa de mudança": "شركة نقل الأثاث",
 "Empresa ou pessoa": "شركة أو شخص",
 "Empresa, hotel ou voo": "شركة أو فندق أو رحلة طيران",
 "Empresas": "الشركات",
 "Emprestei": "أعرتُ",
 "Empréstimo": "إعارة",
 "Empréstimo entre pessoas": "قرض بين أشخاص",
 "Empréstimo pessoal": "قرض شخصي",
 "Empréstimos": "الإعارات",
 "Empréstimos & Financiamentos": "القروض والتمويلات",
 "Encaminhada para {nome}.": "تمت إعادة التوجيه إلى {nome}.",
 "Encaminhar": "إعادة توجيه",
 "Encaminhar para": "إعادة توجيه إلى",
 "Encerrar e salvar": "إنهاء وحفظ",
 "Encontrada para {perfil}": "عُثر عليها لـ {perfil}",
 "Endereço": "العنوان",
 "Endereço (opcional)": "العنوان (اختياري)",
 "Endereço (se for presencial)": "العنوان (إن كان حضوريًا)",
 "Endereço atual": "العنوان الحالي",
 "Endereço da escola": "عنوان المدرسة",
 "Endereço da oficina": "عنوان الورشة",
 "Endereço de quem está com o item": "عنوان من لديه الغرض",
 "Endereço do consultório": "عنوان العيادة",
 "Endereço do imóvel": "عنوان العقار",
 "Endereço do laboratório": "عنوان المختبر",
 "Endereço do veterinário": "عنوان الطبيب البيطري",
 "Endereço no trabalho e na escola": "العنوان في العمل والمدرسة",
 "Endereço nos Correios e entregas": "العنوان في البريد والتوصيل",
 "Endereço nos bancos e cartões": "العنوان في البنوك والبطاقات",
 "Endereço novo": "العنوان الجديد",
 "Endereço ou nome do lugar": "العنوان أو اسم المكان",
 "Endereço ou terminal": "العنوان أو المحطة",
 "Energia": "الطاقة",
 "Enfermeiro": "ممرض",
 "Engenharia": "الهندسة",
 "Engenheiro ou arquiteto": "مهندس أو معماري",
 "Enquadre o documento e toque no botão": "ضع المستند داخل الإطار واضغط على الزر",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "ضع وجهك داخل الإطار واضغط الزر. 🔄 يبدّل الكاميرا.",
 "Ensino Fundamental": "التعليم الأساسي",
 "Ensino Médio e ENEM": "التعليم الثانوي و ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "فهمت وأوافق على استخدام المراقبة بهذه الشروط.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "يُضاف مباشرة إلى Planner، مع الوقت والأيام وقائمة العناصر. إذا كان الوقت مشغولًا بالفعل، تختار: الاستبدال أو الإبقاء على الاثنين أو الإلغاء.",
 "Entrada": "دخل",
 "Entrada (imóvel novo)": "الدخول (المسكن الجديد)",
 "Entrada de dinheiro": "مبلغ وارد",
 "Entrando...": "جارٍ الدخول...",
 "Entrar": "دخول",
 "Entrar com CPF e senha": "الدخول برقم CPF وكلمة المرور",
 "Entrar com outra conta": "الدخول بحساب آخر",
 "Entrar de novo": "تسجيل الدخول مجددًا",
 "Entrar na chamada": "الانضمام إلى المكالمة",
 "Entrar na reunião": "الانضمام إلى الاجتماع",
 "Entrar na sala online": "دخول الغرفة الافتراضية",
 "Entrar no grupo": "الانضمام إلى المجموعة",
 "Entrar no navegador?": "الدخول من المتصفح؟",
 "Entre com seu CPF e sua senha.": "سجّل الدخول برقم CPF وكلمة المرور.",
 "Entre com seu e-mail e sua senha.": "سجّل الدخول ببريدك الإلكتروني وكلمة المرور.",
 "Entre na sua conta de novo.": "يُرجى تسجيل الدخول مرة أخرى.",
 "Entre na sua conta para usar as notas fiscais.": "سجّل الدخول إلى حسابك لاستخدام الفواتير.",
 "Entre no app com o seu e-mail e a senha nova.": "سجّل الدخول إلى التطبيق ببريدك الإلكتروني وكلمة المرور الجديدة.",
 "Entrega de material": "توريد مواد",
 "Entrega prevista": "التسليم المتوقع",
 "Entregas": "التوريدات",
 "Entregue": "تم التسليم",
 "Entrou": "دخل",
 "Entrou no total da semana.": "أُضيف إلى مجموع الأسبوع.",
 "Enviada": "مُرسلة",
 "Enviado": "تم الإرسال",
 "Enviado para o Planner": "تم الإرسال إلى Planner",
 "Enviado pelo cliente": "أرسله العميل",
 "Enviado pelo escritório": "أرسله المكتب",
 "Enviado por {quem} no grupo {g}": "أرسله {quem} في المجموعة {g}",
 "Enviando {f} de {n}...": "جارٍ إرسال {f} من {n}...",
 "Enviando...": "جارٍ الإرسال...",
 "Enviar": "إرسال",
 "Enviar \"{nome}\"": "إرسال \"{nome}\"",
 "Enviar \"{nome}\" para…": "إرسال \"{nome}\" إلى…",
 "Enviar \"{titulo}\" para": "إرسال \"{titulo}\" إلى",
 "Enviar ao grupo": "إرسال إلى المجموعة",
 "Enviar convite": "إرسال الدعوة",
 "Enviar convite para {nome}": "إرسال دعوة إلى {nome}",
 "Enviar convite pelo WhatsApp": "إرسال الدعوة عبر WhatsApp",
 "Enviar documento": "إرسال مستند",
 "Enviar instruções ao hóspede": "إرسال التعليمات إلى الضيف",
 "Enviar o convite": "إرسال الدعوة",
 "Enviar ou copiar o código": "إرسال الرمز أو نسخه",
 "Enviar ou imprimir a etiqueta": "إرسال الملصق أو طباعته",
 "Enviar para Estudos": "إرسال إلى الدراسة",
 "Enviar para My Planner": "إرسال إلى My Planner",
 "Enviar para a equipe": "إرسال إلى الفريق",
 "Enviar para o My Planner": "إرسال إلى My Planner",
 "Enviar para o Planner": "إرسال إلى Planner",
 "Enviar para o grupo": "إرسال إلى المجموعة",
 "Enviar para o grupo de estudos": "إرسال إلى مجموعة الدراسة",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "إرسال ملفات هذا الجهاز ({n}) إلى {nome}",
 "Enviar para um grupo": "إرسال إلى مجموعة",
 "Enviar para {g}": "إرسال إلى {g}",
 "Enviar para…": "إرسال إلى…",
 "Enviar por e-mail": "إرسال بالبريد الإلكتروني",
 "Enviar relatório": "إرسال التقرير",
 "Enviar relatório para a equipe": "إرسال التقرير إلى الفريق",
 "Enviar também as tarefas que já existem (de hoje em diante)": "إرسال المهام الموجودة أيضًا (من اليوم فصاعدًا)",
 "Enviar tarefas do My Planner para a agenda": "إرسال مهام My Planner إلى التقويم",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "أرسل قسائم الدفع والفواتير والتقارير إلى العميل، أو اطّلع على ما أرسله. يقبل كل مستند صورًا وملفات PDF وروابط.",
 "Enxaguante": "غسول الفم",
 "Episódio": "حلقة",
 "Equipe": "الفريق",
 "Equipe ({n})": "الفريق ({n})",
 "Equipe de limpeza": "فريق التنظيف",
 "Equipe do consultório": "فريق العيادة",
 "Equipe do imóvel (limpeza e co-anfitrião)": "فريق العقار (التنظيف والمضيف المشارك)",
 "Erro": "خطأ",
 "Erro na emissão": "خطأ في الإصدار",
 "Erro: {erro}": "خطأ: {erro}",
 "Erros registrados neste dispositivo ({n})": "الأخطاء المسجلة على هذا الجهاز ({n})",
 "Escanear documento": "مسح مستند",
 "Escanear o verso": "مسح الوجه الخلفي",
 "Escanear para PDF": "مسح ضوئي إلى PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "امسح المستندات والإيصالات والدفاتر والألواح ضوئيًا: تصحيح الحواف والظلال، عدة صفحات، بطاقة الهوية من الوجهين، التوقيع، وحفظ PDF على الهاتف أو في Google Drive أو OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "امسح ضوئيًا، واجعل الصورة أوضح، ونظّمها في مجلدات، وأرسل ملف PDF عبر WhatsApp أو البريد الإلكتروني أو Drive. عند تفعيل الذكاء الاصطناعي الخاص بك، يقرأ التطبيق النص ويلخصه ويجيب عن الأسئلة حول المستند.",
 "Escola": "المدرسة",
 "Escolha a aba:": "اختر التبويب:",
 "Escolha a data do compromisso.": "اختر تاريخ الموعد.",
 "Escolha a imagem.": "اختر الصورة.",
 "Escolha a matéria": "اختر المادة",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "اختر مجلدًا في الهاتف (مثلًا: Documents). سيحفظ التطبيق فيه تلقائيًا.",
 "Escolha a página": "اختر الصفحة",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "اختر محكمة واحدة على الأقل أو حدّد \"جميع المحاكم\".",
 "Escolha ao menos uma agenda.": "اختر تقويمًا واحدًا على الأقل.",
 "Escolha o PDF": "اختر ملف PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "اختر ملف .pfx (أو .p12) لشهادة A1 الخاصة بالشركة وأدخل كلمة مرورها. تُحفظ مشفّرة في خزنتك.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "اختر ملف .xml الخاص بـ NFS-e أو NF-e أو CT-e.",
 "Escolha o fichário": "اختر المجلد",
 "Escolha o grupo para enviar: {t}": "اختر المجموعة للإرسال: {t}",
 "Escolha os PDFs": "اختر ملفات PDF",
 "Escolha os arquivos.": "اختر الملفات.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "اختر العطلات التي تظهر في Planner وفي زر 🎉 العطلات.",
 "Escolha para quem enviar.": "اختر لمن ترسل.",
 "Escolha pelo menos um dia.": "اختر يومًا واحدًا على الأقل.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "اختر صفحة واحدة على الأقل موجودة في PDF (مثال: 1-3, 5).",
 "Escolha quem participa:": "اختر المشاركين:",
 "Escolher": "اختيار",
 "Escolher a imagem": "اختيار الصورة",
 "Escolher a pasta": "اختيار المجلد",
 "Escolher agendas": "اختيار التقويمات",
 "Escolher alimento": "اختيار طعام",
 "Escolher arquivo": "اختيار ملف",
 "Escolher arquivos": "اختيار الملفات",
 "Escolher arquivos do Drive ou do OneDrive": "اختر ملفات من Drive أو OneDrive",
 "Escolher as imagens e criar o PDF": "اختيار الصور وإنشاء PDF",
 "Escolher da galeria": "اختيار من المعرض",
 "Escolher da galeria ou arquivo (foto ou PDF)": "اختيار من المعرض أو ملف (صورة أو PDF)",
 "Escolher data": "اختيار التاريخ",
 "Escolher fuso": "اختيار المنطقة الزمنية",
 "Escolher hora": "اختيار الوقت",
 "Escolher horário": "اختيار الوقت",
 "Escolher o certificado": "اختيار الشهادة",
 "Escolher outro": "اختيار آخر",
 "Escolher pessoas": "اختيار أشخاص",
 "Escolher tribunais": "اختيار المحاكم",
 "Escolher ícone": "اختيار رمز",
 "Esconder da equipe (só administradores)": "إخفاء عن الفريق (للمشرفين فقط)",
 "Esconder detalhes": "إخفاء التفاصيل",
 "Esconder o texto completo": "إخفاء النص الكامل",
 "Escondido de {n} pessoa(s)": "مخفي عن {n} شخص",
 "Escondido de: {n}": "مخفي عن: {n}",
 "Escondidos no Planner.": "مخفية في Planner.",
 "Escova e pasta de dente": "فرشاة ومعجون أسنان",
 "Escovar os dentes": "تنظيف الأسنان بالفرشاة",
 "Escreva aqui": "اكتب هنا",
 "Escreva e dê Enter (ex.: lavar a máquina)": "اكتب واضغط Enter (مثال: تشغيل الغسالة)",
 "Escreva em uma ou em todas as páginas.": "اكتب في صفحة واحدة أو في كل الصفحات.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "اكتب السبب في \"سبب الإلغاء\" في بطاقة الفاتورة (15 حرفًا على الأقل) ثم اضغط هنا مرة أخرى.",
 "Escreva o resumo, tópicos, dúvidas...": "اكتب الملخص والنقاط والأسئلة...",
 "Escreva o texto da marca d'água.": "اكتب نص العلامة المائية.",
 "Escreva o texto.": "اكتب النص.",
 "Escreva o título.": "اكتب العنوان.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "اكتب النص أو الصقه. السطر الذي يبدأ بـ \"# \" يصبح عنوانًا.",
 "Escreva ou cole um texto e gere o PDF.": "اكتب نصًا أو الصقه وأنشئ ملف PDF.",
 "Escritório": "المكتب",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "المكتب: مستندات الفريق واجتماعاته. لا يمكن تسجيل الاجتماع إلا لمسؤول المكتب، ويرى جميع المشاركين في الاجتماع تنبيه \"جارٍ التسجيل\" طوال مدة التسجيل. يُحفظ التسجيل في مستندات المكتب، ولا يراه إلا المسؤول إلى أن يتيحه للفريق.",
 "Escuro": "داكن",
 "Espanhol": "الإسبانية",
 "Espaço": "المكان",
 "Espaço livre, dados de cada aba e anexos": "المساحة الحرة وبيانات كل تبويب والمرفقات",
 "Especialidade": "التخصص",
 "Espécie": "النوع",
 "Esquadro": "مثلث رسم",
 "Esqueci a senha": "نسيت كلمة المرور",
 "Esquerda": "يسار",
 "Esse código é o seu.": "هذا الرمز هو رمزك.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "هذا رمزك أنت. استخدم رمز الشخص الذي رشّح لك التطبيق.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "لم يستجب هذا العنوان كخادم فواتير. تحقّق منه وحاول مرة أخرى.",
 "Esta aba ainda não está no seu plano.": "هذا التبويب ليس ضمن خطتك بعد.",
 "Esta e todas as futuras": "هذه وكل ما يليها",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "تحتاج هذه الأداة إلى رؤية صفحات PDF، وهذا متاح في التطبيق الجديد (الإصدار 0.50). استخدم المتصفح أو ثبّت ملف APK الجديد.",
 "Esta imagem foi guardada em outro dispositivo.": "حُفظت هذه الصورة على جهاز آخر.",
 "Esta janela pode ser fechada.": "يمكنك إغلاق هذه النافذة.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "لم يملأ هذا الشخص بطاقة جهة الاتصال بعد.",
 "Esta semana: {a} de {m} aulas ({p}%)": "هذا الأسبوع: {a} من {m} دروس ({p}%)",
 "Esta senha é de outra conta.": "كلمة المرور هذه تخص حسابًا آخر.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "هذه المهمة بلا وقت: \"عند البداية\" و\"قبل البدء\" لا ينطبقان. استخدم \"في وقت محدد\".",
 "Esta tarefa se repete. O que excluir?": "هذه المهمة متكررة. ماذا تريد أن تحذف؟",
 "Esta tela teve um problema": "واجهت هذه الشاشة مشكلة",
 "Estado (UF) do registro": "الولاية (UF) للقيد",
 "Estado de Mato Grosso do Sul": "ولاية Mato Grosso do Sul",
 "Estado de São Paulo": "ولاية São Paulo",
 "Estado do Paraná": "ولاية Paraná",
 "Estados": "الولايات",
 "Estaduais": "محاكم الولايات",
 "Estadual": "ولائي",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "تظهر هذه التبويبات في الشريط السفلي بهذا الترتيب. My Planner والتبويبات والإعدادات تبقى دائمًا. البقية تظل هنا في شاشة التبويبات.",
 "Estatística": "الإحصاء",
 "Este CPF já tem cadastro. Use \"Entrar\".": "رقم CPF هذا مسجّل بالفعل. استخدم \"دخول\".",
 "Este PDF está no dispositivo onde foi aberto.": "ملف PDF هذا موجود على الجهاز الذي فُتح عليه.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "ملف PDF هذا موجود على الجهاز الذي فُتح عليه. افتحه هناك، أو أعد فتح النسخة المحفوظة في Drive أو OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "ملف PDF هذا محمي بكلمة مرور. أزل كلمة المرور في البرنامج الذي أُنشئ به وحاول مرة أخرى.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "لا يحتوي ملف PDF هذا على حقول نموذج. استخدم \"إضافة نص\" للكتابة عليه.",
 "Este ano": "هذا العام",
 "Este dispositivo": "هذا الجهاز",
 "Este dispositivo não consegue abrir o arquivo.": "لا يستطيع هذا الجهاز فتح الملف.",
 "Este dispositivo não consegue compartilhar arquivos.": "هذا الجهاز لا يستطيع مشاركة الملفات.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "لا يحتوي هذا الجهاز على بيانات صحية. يمكنك إدخالها يدويًا.",
 "Este arquivo foi guardado em outro dispositivo.": "حُفظ هذا الملف على جهاز آخر.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "حُفظ هذا الملف على الهاتف. افتحه من التطبيق على الهاتف.",
 "Este arquivo não é um backup do My Planner.": "هذا الملف ليس نسخة احتياطية من My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "هذا الهاتف لا يستقبل الإشعارات بعد والتطبيق مغلق. ثبّت التطبيق {v} أو أحدث (APK مع إشعارات الخادم). عندما يكون التطبيق مفتوحًا تعمل الإشعارات بالفعل.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "هذه الشهادة تخص {doc}، وهو مختلف عن CNPJ/CPF الشركة ({emp}).",
 "Este fichário ainda não tem matérias.": "لا توجد مواد في هذا المجلد بعد.",
 "Este grupo já está cheio.": "هذه المجموعة ممتلئة بالفعل.",
 "Este mês": "هذا الشهر",
 "Este mês: emitidas {e} · recebidas {r}": "هذا الشهر: الصادرة {e} · الواردة {r}",
 "Este mês: {h}": "هذا الشهر: {h}",
 "Este navegador": "هذا المتصفح",
 "Este país só tem feriados nacionais.": "لهذه الدولة عطلات وطنية فقط.",
 "Esteira": "جهاز المشي",
 "Esteticista": "خبير تجميل",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "أستخدم My Planner لتنظيم الأجندة والمالية وغير ذلك الكثير. نزّل التطبيق، وعند إنشاء حسابك استخدم رمزي {codigo} لتحصل على 10 أيام مع فتح جميع التبويبات.",
 "Estratégia": "استراتيجية",
 "Estrela": "نجمة",
 "Estudando": "جارٍ الدراسة",
 "Estudar agora": "ادرس الآن",
 "Estudar {nome}": "دراسة {nome}",
 "Estudar: {c}": "دراسة: {c}",
 "Estudo": "دراسة",
 "Estudos": "الدراسة",
 "Estudos e exatas": "الدراسة والعلوم",
 "Estudos, lazer e viagens": "الدراسة والترفيه والسفر",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "موجود في الممتلكات وضريبة الدخل › الإيصالات القابلة للخصم. افتحه هناك لإرفاق صورة الإيصال وCPF أو CNPJ المستلم.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "موجود في الصفحة \"{titulo}\" وفي \"عرض الملفات\".",
 "Etanol": "إيثانول",
 "Etapa": "المرحلة",
 "Etapa do cronograma": "مرحلة في الجدول",
 "Etapas": "المراحل",
 "Evento": "المناسبة",
 "Eventos": "المناسبات",
 "Eventos & Celebrações": "المناسبات والاحتفالات",
 "Evolução (no cofre)": "تطور الحالة (في الخزنة)",
 "Ex.: 08:00 e 20:00": "مثال: 08:00 و20:00",
 "Ex.: 08:00, 14:00 e 20:00": "مثال: 08:00 و14:00 و20:00",
 "Ex.: 09/2026": "مثال: 09/2026",
 "Ex.: 1 comprimido": "مثال: قرص واحد",
 "Ex.: 1-3, 4-10, 11-": "مثال: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "مثال: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "مثال: 171901 (استشارات)، 010101 (برمجة)",
 "Ex.: 40 sacos de cimento": "مثال: 40 كيس إسمنت",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "مثال: 4106902 (Curitiba)، 5002704 (Campo Grande)، 3550308 (São Paulo)",
 "Ex.: 8º ano B": "مثال: الصف الثامن ب",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "مثال: تمارين إطالة أسفل الظهر، حمية 1.800 سعرة",
 "Ex.: Aniversário de 30 anos da Ana": "مثال: عيد ميلاد آنا الثلاثون",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "مثال: شقة الشاطئ، جناح 1، ملحق",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "مثال: شقة في شارع X، 100 سهم PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "مثال: حصة مراجعة، موعد متابعة",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "مثال: بوفيه، دي جي، ديكور، مصوّر",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "مثال: سري، نسخة، مسودة",
 "Ex.: Cardiologista": "مثال: طبيب قلب",
 "Ex.: Consultoria mensal": "مثال: استشارة شهرية",
 "Ex.: Costela-de-adão da sala": "مثال: نبتة المونستيرا في الصالة",
 "Ex.: DAS de setembro, Extrato do Itaú": "مثال: DAS لشهر سبتمبر، كشف حساب Itaú",
 "Ex.: Desmontar os móveis do quarto": "مثال: فك أثاث غرفة النوم",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "مثال: متاح · في الحصة حتى 6 مساءً · هيا نسافر!",
 "Ex.: Eletricista, loja de material": "مثال: كهربائي، محل مواد بناء",
 "Ex.: Entrada dos noivos": "مثال: دخول العروسين",
 "Ex.: Financiamento do carro": "مثال: تمويل السيارة",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "مثال: أخصائي علاج طبيعي، أخصائي تغذية، طبيب قلب",
 "Ex.: Furadeira, livro, R$ 200": "مثال: مثقاب، كتاب، 200 R$",
 "Ex.: Hemograma": "مثال: تعداد الدم الكامل",
 "Ex.: IPVA 2027, parcela 1": "مثال: IPVA 2027، القسط 1",
 "Ex.: Lisboa, Portugal": "مثال: لشبونة، البرتغال",
 "Ex.: Mala da Ana": "مثال: حقيبة آنا",
 "Ex.: Mensalidade de outubro, material": "مثال: رسوم أكتوبر، مواد",
 "Ex.: Netflix, cinema": "مثال: Netflix، السينما",
 "Ex.: Notas de compra de setembro": "مثال: فواتير الشراء لشهر سبتمبر",
 "Ex.: Onix 2022": "مثال: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "مثال: الاختبار 1، عمل جماعي",
 "Ex.: Prova de matemática": "مثال: اختبار الرياضيات",
 "Ex.: Pôr do sol no Tejo": "مثال: غروب الشمس على نهر تاجة",
 "Ex.: Reforma da cozinha": "مثال: تجديد المطبخ",
 "Ex.: TAP TP 108": "مثال: TAP TP 108",
 "Ex.: Torre de Belém": "مثال: برج بيليم",
 "Ex.: Troca da fiação da sala": "مثال: تغيير أسلاك الصالة",
 "Ex.: V10, antirrábica": "مثال: V10، مضاد السعار",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "مثال: زيارة دير جيرونيموس",
 "Ex.: cerâmica 30 cm": "مثال: سيراميك 30 سم",
 "Ex.: kg, pacotes, latas": "مثال: كغ، علب، عبوات",
 "Ex.: seg e qua, 07:30": "مثال: الإثنين والأربعاء، 07:30",
 "Ex.: troquei o arroz por batata doce": "مثال: استبدلت الأرز بالبطاطا الحلوة",
 "Ex.: varanda, sala": "مثال: الشرفة، غرفة المعيشة",
 "Exame": "فحص",
 "Exame da OAB": "امتحان OAB",
 "Exames": "الفحوصات",
 "Excel": "Excel",
 "Excluir": "حذف",
 "Excluir \"{nome}\"?": "حذف \"{nome}\"؟",
 "Excluir \"{titulo}\"?": "حذف \"{titulo}\"؟",
 "Excluir a caixa?": "حذف الصندوق؟",
 "Excluir a compra": "حذف الشراء",
 "Excluir a compra?": "حذف الشراء؟",
 "Excluir a meta \"{m}\"?": "حذف الهدف \"{m}\"؟",
 "Excluir cartão": "حذف البطاقة",
 "Excluir conta": "حذف الفاتورة",
 "Excluir cuidado": "حذف العناية",
 "Excluir cômodo": "حذف الغرفة",
 "Excluir esta página?": "حذف هذه الصفحة؟",
 "Excluir fichário": "حذف المجلد",
 "Excluir matéria": "حذف المادة",
 "Excluir o cartão \"{c}\"?": "حذف البطاقة \"{c}\"؟",
 "Excluir o documento": "حذف المستند",
 "Excluir o fichário {nome}": "حذف المجلد {nome}",
 "Excluir página": "حذف الصفحة",
 "Excluir refeição": "حذف الوجبة",
 "Excluir suplemento": "حذف المكمّل",
 "Excluir tarefa": "حذف المهمة",
 "Excluir tarefa repetida": "حذف مهمة متكررة",
 "Excluir tarefa?": "حذف المهمة؟",
 "Excluir treino": "حذف التمرين",
 "Excluir {nome}?": "حذف {nome}؟",
 "Excluídas em definitivo 30 dias depois do descarte.": "تُحذف نهائيًا بعد 30 يومًا من تجاهلها.",
 "Executivo e profissional": "تنفيذي ومهني",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "تنفيذ العقد (art. 7º, V) لتقديم الخدمة؛ والموافقة (art. 7º, I) للكاميرا والمعرض والميكروفون والموقع؛ والوفاء بالتزام قانوني (art. 7º, II)؛ والمصلحة المشروعة (art. 7º, IX) للأمان ومنع الاحتيال.",
 "Exemplos: 13:30, 1330, 9:05": "أمثلة: 13:30، 1330، 9:05",
 "Exercício": "التمرين",
 "Exercício físico": "التمارين الرياضية",
 "Experimente grátis por {n} dias": "جرّب مجانًا لمدة {n} يومًا",
 "Explique o motivo (para cancelar)": "اشرح السبب (للإلغاء)",
 "Exportar arquivo": "تصدير ملف",
 "Exportar para o contador": "تصدير للمحاسب",
 "Extrair páginas": "استخراج صفحات",
 "Extras (pet, check-in tardio...)": "إضافات (حيوان أليف، وصول متأخر...)",
 "Extrato": "كشف الحساب",
 "Extrato bancário": "كشف حساب بنكي",
 "Extrato do banco (foto ou PDF)": "كشف الحساب البنكي (صورة أو PDF)",
 "Extrato importado": "تم استيراد كشف الحساب",
 "Extrato por foto": "كشف الحساب بالصورة",
 "FRASE": "الحالة",
 "FRÁGIL": "قابل للكسر",
 "Fabricante ou estendida: {n} meses": "ضمان الشركة المصنّعة أو الممدّد: {n} شهرًا",
 "Facultativo": "اختياري",
 "Falar com a limpeza": "التواصل مع عامل التنظيف",
 "Fale conosco": "تواصل معنا",
 "Falta": "غائب",
 "Falta XML": "XML غير موجود",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "لم يُربط خادم الفواتير بعد: على الكمبيوتر، انقر نقرًا مزدوجًا على 13-LIGAR-NOTAS.bat والصق هنا العنوان الذي يعرضه.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect غير موجود، وهو تطبيق Google الذي يجمع بيانات الساعات وتطبيقات الصحة.",
 "Faltam": "المتبقية",
 "Faltam {ml} ({n} copo(s))": "متبقٍ {ml} ({n} كوب/أكواب)",
 "Faltam {n} dia(s) do seu período grátis": "تبقّى {n} يوم من فترتك المجانية",
 "Faltam {n} dias": "متبقٍّ {n} يوم/أيام",
 "Faltou": "تغيّب",
 "Família": "العائلة",
 "Fantasia": "فانتازيا",
 "Fatura": "كشف البطاقة",
 "Fatura com vencimento em {d}.": "كشف بطاقة يستحق في {d}.",
 "Fatura de {mes}": "كشف {mes}",
 "Fatura de {mes}: vence {data}": "كشف {mes}: يستحق في {data}",
 "Fatura do cartão (foto ou PDF)": "كشف البطاقة (صورة أو PDF)",
 "Fatura importada": "تم استيراد الكشف",
 "Fatura paga (toque para desfazer)": "الكشف مدفوع (اضغط للتراجع)",
 "Fatura {c}": "كشف {c}",
 "Faturamento em {ano}: {v} de {lim}": "الإيرادات في {ano}: {v} من {lim}",
 "Faturas dos cartões": "كشوف البطاقات",
 "Fazer agora, passo a passo": "نفّذ الآن، خطوة بخطوة",
 "Fazer com este PDF": "ماذا تفعل بهذا الملف",
 "Fazer cópia agora": "إنشاء نسخة الآن",
 "Fecha dia {f} · vence dia {v}": "يُغلق يوم {f} · يستحق يوم {v}",
 "Fecha {f} · vence {v}": "الإغلاق {f} · الاستحقاق {v}",
 "Fechar": "إغلاق",
 "Fechar o cofre": "إغلاق الخزنة",
 "Feche e abra o app de novo": "أغلق التطبيق ثم افتحه مجددًا",
 "Federais": "الاتحادية",
 "Feijão": "فاصوليا",
 "Feita em {data}": "أُنجزت في {data}",
 "Feita hoje": "منجزة اليوم",
 "Feitas": "منجزة",
 "Feitas (não se repetem) · {n}": "المنجزة (غير المتكررة) · {n}",
 "Feito": "منجز",
 "Feito!": "تم!",
 "Feliz aniversário": "عيد ميلاد سعيد",
 "Feminino": "أنثوي",
 "Feminino e suave": "أنثوي وناعم",
 "Feriado escolar": "عطلة مدرسية",
 "Feriado estadual": "عطلة على مستوى الولاية",
 "Feriado estadual: {nome}": "عطلة الولاية: {nome}",
 "Feriado municipal": "عطلة بلدية",
 "Feriado municipal: {nome}": "عطلة بلدية: {nome}",
 "Feriado nacional": "عطلة وطنية",
 "Feriado nacional: {nome}": "عطلة وطنية: {nome}",
 "Feriado regional": "عطلة إقليمية",
 "Feriado regional: {nome}": "عطلة إقليمية: {nome}",
 "Feriados": "العطلات",
 "Feriados nacionais": "العطلات الوطنية",
 "Feriados no planner": "العطلات في المخطط",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "قد تحتوي العطل وأسعار الصرف واقتراحات الذكاء الاصطناعي والقراءة التلقائية للفواتير والإيصالات على أخطاء. تحقق منها قبل الاستخدام.",
 "Ferramenta": "أداة",
 "Ferramentas": "أدوات",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "بطاقة لكل نبتة، وإعادة الزراعة، وتقويم الري والتسميد في الجدول.",
 "Ficha preenchida": "تم ملء البطاقة",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "المجلدات والمواد والصفحات، ومؤقت الدراسة، والأهداف الأسبوعية.",
 "Ficção": "خيال أدبي",
 "Figurinha": "ملصق",
 "Figurinhas": "الملصقات",
 "Filme": "فيلم",
 "Filme ou série": "فيلم أو مسلسل",
 "Filmes e séries": "الأفلام والمسلسلات",
 "Filosofia": "الفلسفة",
 "Filtros": "الفلاتر",
 "Fim": "النهاية",
 "Fim (vazio = uso contínuo)": "النهاية (فارغ = استخدام مستمر)",
 "Fim da garantia": "نهاية الضمان",
 "Fim da garantia:": "انتهاء الضمان:",
 "Fim da pausa. Continue: {tarefa}": "انتهت الاستراحة. تابع: {tarefa}",
 "Fim de semana": "عطلة نهاية الأسبوع",
 "Fim previsto": "النهاية المتوقعة",
 "Fina": "رفيع",
 "Finados": "يوم الموتى",
 "Finalizador": "منتج التصفيف",
 "Financeiro": "المالية",
 "Financeiro: {gasto} de {orcado} ({p}%)": "المالي: {gasto} من {orcado} ({p}%)",
 "Financiamento": "التمويل",
 "Financiamento de veículo": "تمويل مركبة",
 "Financiamento imobiliário": "تمويل عقاري",
 "Financiamentos": "التمويلات",
 "Financiamentos e empréstimos": "التمويلات والقروض",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "التمويلات والقروض مع الأقساط والفوائد والرصيد المتبقي وإثباتات الدفع؛ والأغراض المُعارة مع صورة وتذكير بالإرجاع.",
 "Finanças": "المالية",
 "Finanças {p}": "المالية {p}",
 "Finanças · {p}": "المالية · {p}",
 "Fins de semana": "عطلات نهاية الأسبوع",
 "Fio dental": "خيط الأسنان",
 "Flex": "مرن (Flex)",
 "Flexão de braço": "تمرين الضغط",
 "Flor": "زهرة",
 "Flutua": "يطفو",
 "Foguete": "صاروخ",
 "Fogão": "موقد",
 "Foi no cartão de crédito? Lançar como compra no cartão": "هل دفعت ببطاقة الائتمان؟ سجّله كشراء بالبطاقة",
 "Foi para {destino}.": "أُرسل إلى {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "أُرسل إلى {destino}. هل تريد إزالته من هنا؟",
 "Folha de pagamento": "كشف الرواتب",
 "Fone": "سماعة الأذن",
 "Fone de ouvido": "سماعات الأذن",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "المصادر: البرازيل، تُحسب في التطبيق استنادًا إلى المرسوم الاتحادي للعطلات وقوانين كل ولاية. الدول الأخرى: قاعدة البيانات العامة Nager.Date (date.nager.at)، تُنزَّل من الإنترنت وتُحفظ على الجهاز.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "المصادر: البرازيل، تُحسب في التطبيق استنادًا إلى القرار الاتحادي الخاص بالعطل وقوانين كل ولاية والتقاويم الرسمية للعواصم. الدول الأخرى: قاعدة البيانات العامة Nager.Date (date.nager.at)، تُنزَّل من الإنترنت وتُحفظ على الجهاز.",
 "Forma": "الطريقة",
 "Forma das parcelas": "نظام الأقساط",
 "Forma de pagamento": "طريقة الدفع",
 "Forma de pagamento: {f}.": "طريقة الدفع: {f}.",
 "Formas": "أشكال",
 "Formato": "التنسيق",
 "Formatos": "أشكال",
 "Formatura": "حفل تخرج",
 "Fornecedor": "المورّد",
 "Fornecedores": "المورّدون",
 "Forte": "قوية",
 "Foto": "صورة",
 "Foto da galeria": "صورة من المعرض",
 "Foto do contato": "صورة جهة الاتصال",
 "Foto inteira": "الصورة كاملة",
 "Foto ou PDF (lido pela sua IA)": "صورة أو PDF (يقرؤه ذكاؤك الاصطناعي)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "صوّر كل غرفة في معاينة الخروج والدخول. تحميك الصور عند تسليم العقار.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "صوّر كل إيصال من الطبيب وطبيب الأسنان والمدرسة والتقاعد الخاص فور الدفع. في نهاية العام يكون كل شيء جاهزًا.",
 "Fotos": "الصور",
 "Fotos JPG, PNG e outras viram um PDF.": "تتحول صور JPG وPNG وغيرها إلى ملف PDF.",
 "Fotos de {d}": "صور {d}",
 "Fotos do espaço pronto": "صور المكان جاهزًا",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "تُحفظ صور وملفات هذا السجل أيضًا في مجلد المجموعة ليتمكن المشاركون من فتحها.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "تُحفظ الصور والملفات على هذا الجهاز فقط. أما بيانات المستند فتُحفظ في حسابك بشكل محمي.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "تُحفظ الصور والملفات على هذا الجهاز (وفي Drive أو OneDrive إن كان مفعّلًا في الإعدادات).",
 "Fotos e notas": "الصور والملاحظات",
 "Fotos e vídeos": "الصور والفيديو",
 "Fotos, arquivos e links": "الصور والملفات والروابط",
 "Fraldas e lenços": "الحفاضات والمناديل",
 "Francês": "الفرنسية",
 "Frango com osso": "دجاج بالعظم",
 "Frango sem osso": "دجاج بدون عظم",
 "Frase (opcional, ex.: Bom dia!)": "عبارة (اختياري، مثل: صباح الخير!)",
 "Freelancer & Projetos": "العمل الحر والمشاريع",
 "Freezer": "الفريزر",
 "Freios": "الفرامل",
 "Frente": "الوجه الأمامي",
 "Frente do documento": "الوجه الأمامي للمستند",
 "Frente e verso na mesma folha": "الوجهان في الورقة نفسها",
 "Frente pronta": "الوجه الأمامي جاهز",
 "Frequência": "التكرار",
 "Frio": "بارد",
 "Fruta": "فاكهة",
 "Frágil": "قابل للكسر",
 "Fundação e estrutura": "الأساسات والهيكل",
 "Fundo": "الخلفية",
 "Fundos e renda fixa": "الصناديق والدخل الثابت",
 "Fuso": "المنطقة",
 "Fuso horário": "المنطقة الزمنية",
 "Fuso horário do destino": "المنطقة الزمنية للوجهة",
 "Futebol": "كرة القدم",
 "Física": "الفيزياء",
 "Físico (obra pronta): {p}%": "الإنجاز الفعلي: {p}%",
 "GASTOS POR CATEGORIA": "المصروفات حسب الفئة",
 "GIF guardado nos seus GIFs.": "تم حفظ GIF في صور GIF الخاصة بك.",
 "Garagem": "المرآب",
 "Garantia": "الضمان",
 "Garantia até {data}.": "الضمان حتى {data}.",
 "Garantia legal": "الضمان القانوني",
 "Garantia vencendo": "ضمان على وشك الانتهاء",
 "Garantias": "الضمانات",
 "Garrafa de água": "قارورة ماء",
 "Gasolina": "بنزين",
 "Gasto": "مصروف",
 "Gasto até agora": "المصروف حتى الآن",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "تم تسجيل مصروف بقيمة {v}. تم حفظ {n} سعر لقائمة التسوق.",
 "Gasto neste mês: {v}": "المصروف هذا الشهر: {v}",
 "Gasto: {v}": "المصروف: {v}",
 "Gastos": "المصروفات",
 "Gastos por categoria": "المصروفات حسب الفئة",
 "Gato": "قطة",
 "Geladeira": "الثلاجة",
 "Geografia": "الجغرافيا",
 "Gerado por": "أُنتج بواسطة",
 "Gerando QR Code...": "جارٍ إنشاء رمز QR...",
 "Gerar PDF": "إنشاء PDF",
 "Gerar as cobranças do mês": "إنشاء مطالبات الشهر",
 "Gerar as parcelas": "إنشاء الأقساط",
 "Gerar lista da mala": "إنشاء قائمة الحقيبة",
 "Gerar pelo cardápio e pela despensa": "إنشاء من القائمة والمؤونة",
 "Gesso e forro": "الجبس والأسقف",
 "Gira todas as páginas ou só as escolhidas.": "يدوّر كل الصفحات أو المختارة فقط.",
 "Girar": "تدوير",
 "Google Drive e OneDrive": "Google Drive وOneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive وOneDrive وتقويم Google: فقط إذا ربطتها، وفقط لحفظ ملفاتك وأحداثك.",
 "Gorro, cachecol e luvas": "قبعة صوفية ووشاح وقفازات",
 "Gota": "قطرة",
 "Graduação e Pós": "الجامعة والدراسات العليا",
 "Grande": "كبير",
 "Gravando": "جارٍ التسجيل",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "تسجيل التذكيرات والملاحظات صوتيًا عندما تطلب ذلك. لا يعمل الميكروفون إلا بلمستك.",
 "Gravar reunião": "تسجيل الاجتماع",
 "Gravação de áudio": "تسجيل الصوت",
 "Gravações das reuniões": "تسجيلات الاجتماعات",
 "Grossa": "عريض",
 "Grupo": "المجموعة",
 "Grupo com convite (turma, equipe, convidados)": "مجموعة بالدعوة (فصل، فريق، ضيوف)",
 "Grupo criado": "تم إنشاء المجموعة",
 "Grupo da família": "مجموعة العائلة",
 "Grupo da mudança (família e ajudantes)": "مجموعة الانتقال (العائلة والمساعدون)",
 "Grupo da obra (equipe)": "مجموعة الأعمال (الفريق)",
 "Grupo da turma (convidar alunos)": "مجموعة الفصل (دعوة الطلاب)",
 "Grupo da viagem (convidar quem vai)": "مجموعة الرحلة (دعوة المرافقين)",
 "Grupo de cuidado (família ou profissional)": "مجموعة الرعاية (العائلة أو مختص)",
 "Grupo de estudos (convidar colegas)": "مجموعة الدراسة (دعوة الزملاء)",
 "Grupo de leitura (convidar)": "مجموعة القراءة (دعوة)",
 "Grupo do cliente": "مجموعة العميل",
 "Grupo do evento (convidar)": "مجموعة الفعالية (دعوة)",
 "Grupos": "المجموعات",
 "Grupos de estudo": "مجموعات الدراسة",
 "Grupos de {aba}": "مجموعات {aba}",
 "Grupos desta aba: {n}": "مجموعات هذا التبويب: {n}",
 "Grupos e convites": "المجموعات والدعوات",
 "Grátis no lançamento": "مجاني عند الإطلاق",
 "Guarda-chuva": "مظلة",
 "Guardada nas suas figurinhas.": "تم الحفظ في ملصقاتك.",
 "Guardado": "المدّخر",
 "Guardado até agora: {v}": "المدّخر حتى الآن: {v}",
 "Guardado em outro dispositivo": "محفوظ على جهاز آخر",
 "Guardado na pasta \"{pasta}\" do celular.": "حُفظ في مجلد \"{pasta}\" على الهاتف.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "محفوظ في الخزنة بتشفير تام بين الطرفين.",
 "Guardado no {nome}.": "حُفظ في {nome}.",
 "Guardado {onde} em {quando}": "تم الحفظ {onde} في {quando}",
 "Guardando...": "جارٍ الحفظ...",
 "Guardar": "ادّخار",
 "Guardar como recibo do IR": "حفظ كإيصال لـ IR",
 "Guardar dinheiro": "ادّخار المال",
 "Guardar e enviar": "حفظ وإرسال",
 "Guardar na meta": "الادّخار للهدف",
 "Guardar nas minhas figurinhas": "حفظ في ملصقاتي",
 "Guardar nos meus GIFs": "حفظ في صور GIF الخاصة بي",
 "Guardar o PDF {onde}": "حفظ ملف PDF {onde}",
 "Guardar os PDFs em": "حفظ ملفات PDF في",
 "Guardar os arquivos prontos em": "حفظ الملفات الجاهزة في",
 "Guardar sozinho cada arquivo pronto": "حفظ كل ملف جاهز تلقائيًا",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "احفظ الوصفات والتعليمات التي تستخدمها دائمًا. في الزيارة، اضغط ⋮ › استخدام قالب.",
 "Guarde seus documentos num lugar só": "احفظ مستنداتك في مكان واحد",
 "Guarde {v} por mês até {d}": "ادّخر {v} شهريًا حتى {d}",
 "Guardou": "مدّخر",
 "Guia de imposto": "قسيمة دفع الضريبة",
 "Gás": "الغاز",
 "Gênero ou categoria": "النوع أو الفئة",
 "HISTÓRICO DOS DADOS": "سجل البيانات",
 "HOJE": "اليوم",
 "Hall de entrada": "مدخل المنزل",
 "Halteres": "دمبلز",
 "Hexágono": "سداسي",
 "Hidratante": "مرطّب",
 "Hidratante labial": "مرطب الشفاه",
 "Hidráulica": "السباكة",
 "Higiene bucal": "العناية بالفم",
 "Higienizar": "تنظيف",
 "História": "التاريخ",
 "Histórico": "السجل",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "التاريخ الصحي للعائلة، والفحوصات المحمية، واللقاحات، والمواعيد، ومنبّه الأدوية في الخط الزمني.",
 "Hmm...": "همم...",
 "Hoje": "اليوم",
 "Hoje: {a} de {m} aulas ({p}%)": "اليوم: {a} من {m} دروس ({p}%)",
 "Hoje: {n} página(s)": "اليوم: {n} صفحة",
 "Hora": "الوقت",
 "Hora da pausa": "وقت الاستراحة",
 "Hora de voltar": "وقت العودة",
 "Hora de voltar!": "حان وقت العودة!",
 "Hora do check-in": "وقت الوصول",
 "Hora do check-out": "وقت المغادرة",
 "Horas": "الساعات",
 "Horas de sono": "ساعات النوم",
 "Horário": "الوقت",
 "Horário de check-in": "موعد الوصول",
 "Horário de check-out": "موعد المغادرة",
 "Horário do lembrete": "وقت التذكير",
 "Horário inválido": "وقت غير صالح",
 "Horário ocupado": "الوقت مشغول",
 "Horários": "المواعيد",
 "Horários (remédio diário)": "المواعيد (دواء يومي)",
 "Hospedados agora": "المقيمون الآن",
 "Hospedagem": "الإقامة",
 "Hospital ou pronto-socorro de referência": "المستشفى أو الطوارئ المعتمدة",
 "Hotel": "فندق",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "يتوفر إصدار جديد من My Planner Web. أعد التحميل لاستخدامه.",
 "Híbrido": "هجين",
 "Hóspede": "الضيف",
 "Hóspede ({c})": "ضيف ({c})",
 "Hóspedes (máximo)": "الضيوف (الحد الأقصى)",
 "IA ligada": "الذكاء الاصطناعي مفعّل",
 "IA não ligada": "الذكاء الاصطناعي غير مفعّل",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "الذكاء الاصطناعي غير مفعّل. فعّله من الإعدادات › الذكاء الاصطناعي.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS محتجز من متلقّي الخدمة",
 "Ida": "الذهاب",
 "Identidade": "بطاقة الهوية",
 "Idioma": "اللغة",
 "Idiomas": "اللغات",
 "Ilimitados": "غير محدودة",
 "Imagem": "صورة",
 "Imagem escolhida (trocar)": "تم اختيار الصورة (تغيير)",
 "Imagem guardada no {nome}. Toque para abrir.": "تم حفظ الصورة في {nome}. انقر للفتح.",
 "Imagens para PDF": "صور إلى PDF",
 "Imagens {data}": "صور {data}",
 "Imperdíveis": "لا تفوّتها",
 "Imperdível": "لا يُفوَّت",
 "Importar": "استيراد",
 "Importar XML de nota": "استيراد XML فاتورة",
 "Importar arquivo": "استيراد ملف",
 "Importar backup?": "استيراد النسخة الاحتياطية؟",
 "Importar extrato": "استيراد كشف حساب",
 "Importar extrato do banco (OFX ou CSV)": "استيراد كشف حساب بنكي (OFX أو CSV)",
 "Importar fatura": "استيراد كشف البطاقة",
 "Importar fotos": "استيراد صور",
 "Importar reservas do Airbnb, Booking...": "استيراد الحجوزات من Airbnb وBooking...",
 "Importar {n} lançamento(s)": "استيراد {n} من القيود",
 "Imóveis e espaços": "العقارات والأماكن",
 "Imóvel": "عقار",
 "Imóvel inteiro": "العقار كاملًا",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "العقار كاملًا أو بالغرفة: حجوزات Airbnb أو Booking أو مباشرة، التنظيف عند المغادرة، المصروفات، الإشغال وربح الشهر.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "يشمل {v} من الفواتير الصادرة في تبويب الفواتير الضريبية.",
 "Independência do Brasil": "عيد استقلال البرازيل",
 "Indicação": "توصية",
 "Indique e ganhe": "ادعُ واربح",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "رشّح My Planner لأصدقائك وعائلتك. من ينشئ حسابًا برمزك يحصل على 10 أيام مع فتح جميع التبويبات.",
 "Infantil": "أطفال",
 "Informações do PDF": "معلومات PDF",
 "Informe a descrição e o valor.": "أدخل الوصف والمبلغ.",
 "Informe de quantos em quantos dias regar ou adubar.": "حدد كل كم يومًا يكون الري أو التسميد.",
 "Informe o nome do produto.": "أدخل اسم المنتج.",
 "Informe o rótulo e o nome.": "أدخل التسمية والاسم.",
 "Informe o total de aulas da matéria em Editar.": "أدخل إجمالي دروس المادة في تعديل.",
 "Informe o valor.": "أدخل المبلغ.",
 "Informe os horários": "أدخل المواعيد",
 "Informe quanto quer juntar.": "أدخل المبلغ الذي تريد جمعه.",
 "Informe seu nome.": "أدخل اسمك.",
 "Informática": "الحاسوب",
 "Inglês": "الإنجليزية",
 "Ingredientes (um por linha)": "المكونات (واحد في كل سطر)",
 "Inscrição municipal (se tiver)": "رقم التسجيل البلدي (إن وُجد)",
 "Inspeção": "الفحص الدوري",
 "Instalar ou atualizar o Health Connect": "تثبيت Health Connect أو تحديثه",
 "Instruções, receita, observações...": "تعليمات، وصفة، ملاحظات...",
 "Insumos (papel, sabonete, café)": "المستلزمات (ورق، صابون، قهوة)",
 "Inteligência artificial": "الذكاء الاصطناعي",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "الذكاء الاصطناعي (Claude أو ChatGPT أو Gemini): فقط إذا فعّلته، بمفتاحك الخاص الذي يبقى على الجهاز فقط. يُرسل نص السؤال مباشرة إلى الخدمة المختارة.",
 "Intensidade": "الشدة",
 "Internação": "دخول المستشفى",
 "Internet": "الإنترنت",
 "Intimação": "إخطار قضائي",
 "Intimação com prazo": "إخطار قضائي بمهلة",
 "Investimento": "استثمار",
 "Investimentos": "الاستثمار",
 "Início": "البداية",
 "Início {ini} · Fim {fim} · Duração {dur}": "البداية {ini} · النهاية {fim} · المدة {dur}",
 "Iogurte": "زبادي",
 "Ir para Ajustes (exportar meus dados)": "الانتقال إلى الإعدادات (تصدير بياناتي)",
 "Ir para hoje": "الانتقال إلى اليوم",
 "Ir para o My Planner Web": "الانتقال إلى My Planner Web",
 "Italiano": "الإيطالية",
 "Item": "عنصر",
 "Item da despensa": "صنف في المؤونة",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "عنصر محمي: الصور والملفات مشفّرة في الخزنة وعلى هذا الجهاز فقط (لا تُرسل إلى Drive أو OneDrive).",
 "Itens": "الأغراض",
 "Itens de higiene (xampu, sabonete)": "أدوات النظافة (شامبو، صابون)",
 "Jantar": "العشاء",
 "Japonês": "اليابانية",
 "Jaqueta impermeável": "سترة مقاومة للماء",
 "Jogo": "لعبة",
 "Jovem e divertido": "شبابي ومرح",
 "Juntar PDFs": "دمج ملفات PDF",
 "Juros": "الفوائد",
 "Juros ainda por vir: {v}": "فوائد لم تُستحق بعد: {v}",
 "Juros ao mês": "الفائدة الشهرية",
 "JÁ RESPONDIDOS": "تم الرد عليها",
 "Já aberta na casa nova": "فُتح بالفعل في المنزل الجديد",
 "Já enviado para a turma": "أُرسل إلى الفصل بالفعل",
 "Já está compacto": "مضغوط بالفعل",
 "Já está no Planner": "موجود بالفعل في Planner",
 "Já está pago": "مدفوع بالفعل",
 "Já há horários deste item no My Planner": "توجد أوقات لهذا العنصر بالفعل في My Planner",
 "Já pago: {v}": "المدفوع حتى الآن: {v}",
 "Já tenho o app: abrir nele": "لدي التطبيق: افتحه فيه",
 "Já tenho o app: abrir o convite nele": "لديّ التطبيق: افتح الدعوة فيه",
 "Já visitei": "زرته",
 "Kit de primeiros socorros": "حقيبة إسعافات أولية",
 "Kkkk": "ههه",
 "Kkkkk": "هههههه",
 "Km de hoje no painel": "عدد الكيلومترات اليوم في العدّاد",
 "Km no dia": "الكيلومترات في ذلك اليوم",
 "Km no painel": "الكيلومترات في العدّاد",
 "LANÇAMENTOS": "القيود",
 "LINHA DO TEMPO": "الخط الزمني",
 "Laboratório": "المختبر",
 "Lanche": "وجبة خفيفة",
 "Lanche da manhã": "وجبة خفيفة صباحية",
 "Lanche da tarde": "وجبة خفيفة مسائية",
 "Lanches e água": "وجبات خفيفة وماء",
 "Lançamentos": "الحركات",
 "Lavanderia": "غرفة الغسيل",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "المغسلة والمستلزمات والصيانة والفواتير والرسوم. تُحتسب في ربح الشهر.",
 "Lavar o rosto com sabonete facial": "غسل الوجه بغسول الوجه",
 "Lazer": "الترفيه",
 "Leg press": "ضغط الأرجل",
 "Legenda": "التعليق",
 "Legislação Específica": "تشريعات خاصة",
 "Legumes": "خضروات",
 "Leia hoje para começar uma sequência": "اقرأ اليوم لتبدأ سلسلة",
 "Leite": "حليب",
 "Leitura": "القراءة",
 "Leitura automática do texto": "قراءة تلقائية للنص",
 "Leitura da IA": "قراءة الذكاء الاصطناعي",
 "Leitura, Cursos & Mídia": "القراءة والدورات والوسائط",
 "Lembrete": "تذكير",
 "Lembrete de hoje": "تذكير اليوم",
 "Lembrete de renovação no Planner": "تذكير بالتجديد في Planner",
 "Lembrete no Planner": "تذكير في Planner",
 "Lembrete no planner": "تذكير في المخطط",
 "Lembrete pelo WhatsApp": "تذكير عبر WhatsApp",
 "Lembrete: começa às {hora}": "تذكير: يبدأ الساعة {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "نقرأ جميع الرسائل. وإذا لزم الأمر، نرد عبر بريدك الإلكتروني.",
 "Lendo": "أقرؤه",
 "Lendo a fatura...": "جارٍ قراءة الكشف...",
 "Lendo a página": "جارٍ قراءة الصفحة",
 "Lendo o boleto...": "جارٍ قراءة Boleto...",
 "Lendo o cupom...": "جارٍ قراءة الإيصال...",
 "Lendo o documento...": "جارٍ قراءة المستند...",
 "Lendo o extrato...": "جارٍ قراءة كشف الحساب...",
 "Lendo o relógio...": "جارٍ قراءة الساعة...",
 "Lendo o texto": "جارٍ قراءة النص",
 "Ler a fatura": "قراءة الكشف",
 "Ler a publicação inteira": "قراءة النشرة كاملة",
 "Ler com a minha IA": "القراءة بالذكاء الاصطناعي الخاص بي",
 "Ler de novo": "إعادة القراءة",
 "Ler de novo agora": "إعادة القراءة الآن",
 "Ler o texto": "قراءة النص",
 "Ler o texto completo": "قراءة النص الكامل",
 "Ler publicação inteira": "قراءة النشرة كاملة",
 "Ler sozinho as publicações novas": "قراءة النشرات الجديدة تلقائيًا",
 "Leve": "خفيفة",
 "Leve (sem perder qualidade)": "خفيف (دون فقدان الجودة)",
 "Li e aceito os termos e a política de privacidade": "قرأت الشروط وسياسة الخصوصية وأوافق عليها",
 "Li mais {n} páginas": "قرأت {n} صفحة أخرى",
 "Liberada pelo suporte": "فعّلها الدعم",
 "Liberar para a equipe": "إتاحة للفريق",
 "Liberar para a turma em": "إتاحته للفصل في",
 "Liberar para o grupo": "إتاحة للمجموعة",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "التفعيلات والأرصدة مرتبطة برقم CPF الخاص بك. تتحدّث عند المزامنة.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "اسمح لـ My Planner باستخدام الكاميرا من إعدادات الهاتف لقراءة رمز QR.",
 "Libere a câmera para o My Planner nas configurações do celular.": "اسمح لتطبيق My Planner باستخدام الكاميرا من إعدادات الهاتف.",
 "Libere outras abas em Ajustes › Compras.": "افتح تبويبات أخرى من الإعدادات › المشتريات.",
 "Licenciamento": "الترخيص",
 "Lidas hoje": "قُرئت اليوم",
 "Lido": "مقروء",
 "Ligando. Toque para atender.": "مكالمة واردة. اضغط للرد.",
 "Ligar": "اتصال",
 "Ligar certificado": "ربط الشهادة",
 "Ligar para a assistência": "الاتصال بمركز الصيانة",
 "Ligar para {nome}": "الاتصال بـ {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "فعّل الذكاء الاصطناعي في الإعدادات › الذكاء الاصطناعي (Claude أو ChatGPT أو Gemini) لاستخدام هذه الأداة.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "فعّل الذكاء الاصطناعي الخاص بك من الإعدادات › الذكاء الاصطناعي لقراءة النص وتلخيصه وطرح الأسئلة حول المستند.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "فعّل الذكاء الاصطناعي الخاص بك من الإعدادات › الذكاء الاصطناعي.",
 "Ligue o certificado A1 da empresa primeiro.": "اربط شهادة A1 الخاصة بالشركة أولًا.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "اربط Google Drive أو OneDrive لحفظ الصور والملفات (لتُفتح على أي جهاز) وللحصول على نسخ احتياطية كاملة.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "فعّل هذا لتعمل المجموعة على البيانات نفسها (مشروع بناء، رحلة، فصل، عقار، عيادة)، لكل شخص دوره.",
 "Ligue pelo menos 4 pontos.": "صل بين 4 نقاط على الأقل.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "يمكن تعديل الحد السنوي من الإعدادات › التبويبات › تبويب المالية. تحقق دائمًا مع محاسبك.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "تم بلوغ حد الاستعلامات. حاول مرة أخرى بعد دقيقة.",
 "Limite de energia por dia": "حد الطاقة اليومي",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "الحد السنوي لإيرادات MEI (تحقق من القيمة السارية مع محاسبك).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "تم بلوغ حد الرسائل لهذا اليوم. حاول غدًا.",
 "Limite diário": "الحد اليومي",
 "Limite livre: {v} de {l}": "الحد المتاح: {v} من {l}",
 "Limite total (opcional)": "الحد الإجمالي (اختياري)",
 "Limpar": "مسح",
 "Limpar a agenda": "تنظيف الأجندة",
 "Limpar banheiro": "تنظيف الحمّام",
 "Limpar cozinha e louça": "تنظيف المطبخ والأطباق",
 "Limpar feitos": "مسح المنجز",
 "Limpeza": "التنظيف",
 "Limpeza após {h}": "التنظيف بعد {h}",
 "Limpeza final": "التنظيف النهائي",
 "Limpeza · {e}": "التنظيف · {e}",
 "Limpeza: {e}": "التنظيف: {e}",
 "Limpezas": "عمليات التنظيف",
 "Linha do tempo, tarefas, energia e alertas.": "الخط الزمني والمهام والطاقة والتنبيهات.",
 "Link": "رابط",
 "Link (Drive, OneDrive, Dropbox)": "رابط (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "تم نسخ الرابط. الصقه حيث تريد إرساله.",
 "Link da aula ou reunião online (opcional)": "رابط الحصة أو الاجتماع عبر الإنترنت (اختياري)",
 "Link da nota fiscal (Drive ou OneDrive)": "رابط الفاتورة (Drive أو OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "رابط المجلد في Drive أو OneDrive (اختياري)",
 "Link da reserva": "رابط الحجز",
 "Link da sala online (Meet, Zoom...)": "رابط الغرفة الافتراضية (Meet، Zoom...)",
 "Link de outro calendário (iCal)": "رابط تقويم آخر (iCal)",
 "Link do calendário do Airbnb (iCal)": "رابط تقويم Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "رابط تقويم Booking (iCal)",
 "Link inválido": "رابط غير صالح",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "روابط المواد (Drive، فيديوهات، PDF)، رابط في كل سطر",
 "Links: {n}": "الروابط: {n}",
 "Lista": "قائمة",
 "Lista da mala": "قائمة الحقيبة",
 "Lista de compras": "قائمة التسوق",
 "Lista de exercícios": "قائمة تمارين",
 "Lista rápida": "قائمة سريعة",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "قوائم سريعة وصناديق تتحول إلى مهام أو تُرسل إلى تبويب آخر.",
 "Literatura": "الأدب",
 "Litros": "اللترات",
 "Livre": "متاح",
 "Livro": "كتاب",
 "Livros": "الكتب",
 "Local": "المكان",
 "Local ou endereço": "المكان أو العنوان",
 "Local: {l}": "المكان: {l}",
 "Localização (país e fuso horário)": "الموقع (البلد والمنطقة الزمنية)",
 "Logo, foto ou rubrica nas páginas.": "شعار أو صورة أو توقيع مختصر على الصفحات.",
 "Loja (opcional)": "المتجر (اختياري)",
 "Lote": "رقم التشغيلة",
 "Lua": "قمر",
 "Lugar": "المكان",
 "Lugar para visitar": "مكان للزيارة",
 "Lugares": "الأماكن",
 "Luz": "الكهرباء",
 "Luz indireta": "ضوء غير مباشر",
 "Luz, água, gás e internet": "الكهرباء والماء والغاز والإنترنت",
 "Lápis": "قلم رصاص",
 "Língua Portuguesa": "اللغة البرتغالية",
 "MAIS ADIANTE": "لاحقًا",
 "MAIS USADOS": "الأكثر استخدامًا",
 "ME ou EPP do Simples": "ME أو EPP ضمن Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: إيرادات {ano} بقيمة {v} (الحد {l}).",
 "MEMBROS ({n})": "الأعضاء ({n})",
 "METAS": "الأهداف",
 "MS": "MS",
 "Mais": "المزيد",
 "Mais abas": "المزيد من التبويبات",
 "Mais cidades entram nas próximas versões.": "ستُضاف مدن أخرى في الإصدارات القادمة.",
 "Mais emojis": "المزيد من الرموز التعبيرية",
 "Mais ferramentas": "مزيد من الأدوات",
 "Mais figurinhas animadas (KLIPY)": "مزيد من الملصقات المتحركة (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "ستتوفر خيارات أخرى لهذا التبويب في الإصدارات القادمة.",
 "Mais uma": "واحدة أخرى",
 "Mala": "الحقيبة",
 "Mala ({clima}, {n} dias)": "الحقيبة ({clima}، {n} يوم/أيام)",
 "Mamadeiras e leite": "زجاجات الرضاعة والحليب",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "أرسلنا رمزًا من 6 أرقام إلى WhatsApp الخاص بالرقم {tel}.",
 "Mandar as orientações pelo WhatsApp": "إرسال التعليمات عبر WhatsApp",
 "Mandar de novo": "إعادة الإرسال",
 "Mandar e-mail": "إرسال بريد إلكتروني",
 "Mandar lembrete": "إرسال تذكير",
 "Mandar meu código": "إرسال رمزي",
 "Mandar o acerto para o grupo": "إرسال التسوية إلى المجموعة",
 "Mandar para quem limpa (WhatsApp)": "إرسال إلى عامل التنظيف (WhatsApp)",
 "Mandarim": "الصينية الماندرينية",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "أرسل بريدًا إلكترونيًا تطلب فيه الحذف مع رقم هوية الحساب. نرد خلال 15 يومًا.",
 "Manter": "إبقاء",
 "Manter ambas": "الإبقاء على الاثنين",
 "Manter ambos": "الإبقاء على الاثنين",
 "Manter aqui também": "الإبقاء هنا أيضًا",
 "Manter tarefas": "الاحتفاظ بالمهام",
 "Manutenção": "صيانة",
 "Manutenções": "الصيانات",
 "Mapas (Apple)": "خرائط Apple",
 "Marca d'água": "علامة مائية",
 "Marca-texto": "قلم تمييز",
 "Marcado": "محدد",
 "Marcado como feito hoje.": "تم وضع علامة \"منجز\" اليوم.",
 "Marcar como concluída ({dia})": "تحديد كمكتملة ({dia})",
 "Marcar como devolvido": "تعليم كمُرجَع",
 "Marcar como feita hoje": "تعليم كمنجزة اليوم",
 "Marcar como lido": "تعليم كمقروءة",
 "Marcar como paga": "تأشير كمدفوعة",
 "Marcar como pago": "تحديد كمدفوع",
 "Marcar como quitado": "تحديد كمسدَّد",
 "Marcar como recebida": "تأشير كمحصَّلة",
 "Marcar como recebida?": "تأشيرها كمحصَّلة؟",
 "Marcar como recebido": "تحديد كمستلَم",
 "Marcar como visto": "وضع علامة كمقروء",
 "Marcar e avisar a equipe": "تحديد وإبلاغ الفريق",
 "Marcar esta conta como paga?": "تأشير هذه الفاتورة كمدفوعة؟",
 "Marcar fatura como paga": "تحديد الكشف كمدفوع",
 "Marcar grupo": "تحديد المجموعة",
 "Marcar reunião": "تحديد اجتماع",
 "Marcenaria": "النجارة",
 "Margem": "الهامش",
 "Marketing": "التسويق",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "علّم صور اليوميات بـ«قبل» أو «بعد» لإنشاء المعرض.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "حدّد الأيام التي تدرس فيها ووقت كل يوم. يصبح كل يوم مهمة تتكرر كل أسبوع، مرتبطة بهذا العنصر.",
 "Marque um ou mais estados.": "حدد ولاية واحدة أو أكثر.",
 "Martelo": "مطرقة",
 "Masculino": "ذكوري",
 "Masculino e minimalista": "ذكوري وبسيط",
 "Matemática": "الرياضيات",
 "Materiais": "المواد",
 "Material": "المادة",
 "Matrícula, placa, código ou CNPJ": "رقم التسجيل أو اللوحة أو الرمز أو CNPJ",
 "Matéria ou material": "مادة أو محتوى",
 "Matéria ou módulo": "مادة أو وحدة",
 "Matérias": "المواد",
 "Meia-sombra": "ظل جزئي",
 "Melhorando a imagem...": "جارٍ تحسين الصورة...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "تم تنزيل تحسينات جديدة. يستغرق الأمر بضع ثوانٍ فقط وتبقى بياناتك كما هي.",
 "Membros": "الأعضاء",
 "Menos de 1 minuto": "أقل من دقيقة",
 "Mensagem": "رسالة",
 "Mensagem apagada": "تم حذف الرسالة",
 "Mensagem enviada. Obrigado!": "تم إرسال الرسالة. شكرًا لك!",
 "Mensagem ou observações": "رسالة أو ملاحظات",
 "Mensagens": "الرسائل",
 "Mensagens que você envia em Fale conosco.": "الرسائل التي ترسلها عبر تواصل معنا.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "الرسائل: قائمة أصدقائك والمحادثات والصور والملفات المرسلة تُحفظ على الخادم لتصل إلى أجهزتك الأخرى. لا يتم تسجيل المكالمات الصوتية ومكالمات الفيديو.",
 "Mensalidade de {m}": "رسوم {m}",
 "Mensalidade ou valor por aluno": "الرسوم الشهرية أو المبلغ لكل طالب",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "الرسوم الشهرية والدروس المنفردة والمواد. في ⋮ الخاصة بالفصل، ينشئ \"إنشاء مطالبات الشهر\" مطالبة لكل طالب.",
 "Mercado": "البقالة",
 "Mesa flexora": "ثني الساقين",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "رئيس العمال",
 "Meta": "الهدف",
 "Meta 100% batida": "تحقق الهدف 100%",
 "Meta atingida": "تم بلوغ الهدف",
 "Meta atingida!": "تم بلوغ الهدف!",
 "Meta da semana: {dur}": "هدف الأسبوع: {dur}",
 "Meta de aulas": "هدف الدروس",
 "Meta de aulas batida": "تحقق هدف الدروس",
 "Meta de copos por dia": "هدف الأكواب يوميًا",
 "Meta de páginas por dia": "هدف الصفحات اليومي",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "هدف الصفحات والتقدم وملخصات الكتب والأفلام والمسلسلات للمشاهدة ودروس الدورات.",
 "Meta diária": "الهدف اليومي",
 "Meta por dia": "الهدف اليومي",
 "Meta por semana:": "الهدف الأسبوعي:",
 "Meta {meta} · copo de {copo} · {n} copos": "الهدف {meta} · كوب {copo} · {n} أكواب",
 "Metas": "الأهداف",
 "Metodologia Científica": "منهجية البحث العلمي",
 "Meu caderno": "دفتري",
 "Meu cartão de contato": "بطاقة جهة الاتصال الخاصة بي",
 "Meu plano": "خطتي",
 "Meus GIFs ({n})": "صور GIF الخاصة بي ({n})",
 "Meus PDFs": "ملفات PDF الخاصة بي",
 "Meus dados": "بياناتي",
 "Meus dados profissionais": "بياناتي المهنية",
 "Microchip": "شريحة إلكترونية",
 "Microfone": "الميكروفون",
 "Microscópio": "مجهر",
 "Militares estaduais": "العسكرية للولايات",
 "Minha Casa": "منزلي",
 "Minha conta": "حسابي",
 "Minhas anotações do livro": "ملاحظاتي عن الكتاب",
 "Minhas figurinhas": "ملصقاتي",
 "Minutos": "الدقائق",
 "Minutos de exercício": "دقائق التمرين",
 "Mirante": "نقطة مشاهدة",
 "Mirantes": "نقاط مشاهدة",
 "Modelo": "النموذج",
 "Modelo de prescrição": "قالب وصفة",
 "Modelos": "القوالب",
 "Modificado em": "تاريخ التعديل",
 "Modo": "الوضع",
 "Modo de preparo": "طريقة التحضير",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "الوضع الآمن: المهام التلقائية متوقفة حتى تفتح التطبيق مجددًا",
 "Moeda": "العملة",
 "Moeda: {m}": "العملة: {m}",
 "Moedas": "عملات معدنية",
 "Momento do evento": "فقرة المناسبة",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "مراقبة الجريدة القضائية الإلكترونية (DJEN) بالاسم ورقم OAB.",
 "Monitor ou co-professor": "مساعد تدريس أو معلم مشارك",
 "Montando o PDF: página {n} de {total}...": "جارٍ إنشاء PDF: الصفحة {n} من {total}...",
 "Montar a mala pelo clima ({n} dias)": "تجهيز الحقيبة حسب الطقس ({n} يوم/أيام)",
 "Monte o cronograma alimentar para ver o relatório.": "أنشئ الجدول الغذائي لعرض التقرير.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "أعدّ البرنامج يومًا بيوم. خلال فترة الرحلة يظهر في الخط الزمني لـ My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "أنشئ جدولك الغذائي وروتين العناية أدناه. ما يخص اليوم يظهر هنا لتضع عليه علامة.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "أنشئ جدولك الغذائي والعناية والتمارين والمكمّلات أدناه. ما يخص اليوم يظهر هنا لتعليمه.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "أنشئ تمارينك من أنشطة جاهزة: أجهزة الصالة الرياضية، تمارين منزلية، المشي، الجري، اليوغا، البيلاتس...",
 "Mostrando as 120 mais recentes.": "يتم عرض أحدث 120.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "يُعرض البرنامج فقط. {n} مهمة/مهام لليوم مخفية.",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "عرض التواريخ والأوقات والعملة والعطل الصحيحة لمكانك. لا نستخدم GPS.",
 "Mostrar menos": "عرض أقل",
 "Mostrar só o roteiro durante a viagem": "عرض البرنامج فقط أثناء الرحلة",
 "Motivo do cancelamento": "سبب الإلغاء",
 "Moto": "دراجة نارية",
 "Mover": "نقل",
 "Mover para hoje": "نقل إلى اليوم",
 "Mudança": "الانتقال",
 "Mudança: {para}": "الانتقال: {para}",
 "Mudanças": "الانتقالات",
 "Mudar e-mail": "تغيير البريد الإلكتروني",
 "Mudar o nome": "إعادة التسمية",
 "Mudar senha": "تغيير كلمة المرور",
 "Mudo": "كتم",
 "Muitas tentativas": "محاولات كثيرة جدًا",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "محاولات خاطئة كثيرة. حاول مرة أخرى بعد {s} ثانية.",
 "Muitas tentativas. Aguarde alguns minutos.": "محاولات كثيرة. انتظر بضع دقائق.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "أحسنت: ادّخرت {v} هذا الشهر بالفعل. الانتظام أهم من المبلغ الكبير.",
 "Multa": "مخالفة",
 "Multa e juros": "غرامة التأخير والفوائد",
 "Multa e juros de {v}": "غرامة التأخير والفوائد بقيمة {v}",
 "Multa e juros estimados: {v}": "الغرامة والفوائد التقديرية: {v}",
 "Multas e juros pagos": "غرامات التأخير والفوائد المدفوعة",
 "Mundo": "العالم",
 "Municipal": "بلدي",
 "Município da prestação (IBGE), se for outro": "بلدية تقديم الخدمة (IBGE)، إن كانت مختلفة",
 "Município da prestação (código IBGE, 7 números)": "بلدية تقديم الخدمة (رمز IBGE، 7 أرقام)",
 "Mural": "لوحة الإعلانات",
 "Museu": "متحف",
 "Museus": "متاحف",
 "My Planner (vira tarefa)": "My Planner (يتحول إلى مهمة)",
 "My Planner bloqueado": "My Planner مقفل",
 "Máxima": "قصوى",
 "Média": "متوسطة",
 "Média para aprovação": "المعدل المطلوب للنجاح",
 "Média · repouso {n}": "المتوسط · الراحة {n}",
 "Médico": "طبيب",
 "Médico ou clínica": "الطبيب أو العيادة",
 "Médio": "متوسط",
 "Mês": "الشهر",
 "Mês a mês": "شهرًا بشهر",
 "Mês atual": "الشهر الحالي",
 "Mês passado": "الشهر الماضي",
 "Móveis e enxoval": "الأثاث والمفروشات",
 "Móvel": "أثاث",
 "Música": "الموسيقى",
 "NAS ABAS": "في التبويبات",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: تشترط SEFAZ ساعة واحدة بين عمليات البحث. البحث التالي بدءًا من {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: أدخل الولاية (UF) الخاصة بالشركة للبحث عن فواتير المنتجات.",
 "NFS-e emitida": "تم إصدار NFS-e",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "في يوم (اختياري):",
 "Na agenda": "في الجدول",
 "Na agenda em {data}": "في الجدول بتاريخ {data}",
 "Na barra": "في الشريط",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "لا يوجد خادم فواتير في النسخة التجريبية. استخدم التطبيق بحسابك.",
 "Na hora": "فورًا",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "عند وقت الاستراحة يظهر تنبيه كبير على الشاشة مع عدّ تنازلي.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "في الخط الزمني، الضغط على المؤقت يفتح هذه الصفحة أيضًا.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "في مجلد \"{pasta}\" على الهاتف. يذهب كل ملف جاهز إلى هناك.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "في المجلد \"{pasta}\" على الهاتف. يذهب كل مستند جديد إليه عند خروجك منه.",
 "Na prévia de demonstração não há chamadas de verdade.": "لا توجد مكالمات حقيقية في المعاينة التجريبية.",
 "Na prévia de demonstração não há gravação de verdade.": "لا يوجد تسجيل حقيقي في المعاينة التجريبية.",
 "Na prévia de demonstração os arquivos não abrem.": "لا تُفتح الملفات في المعاينة التجريبية.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "في نسخة المتاجر، سيتم الشراء عبر Google Play أو App Store. حاليًا يحاكي المفتاح الاشتراك لأغراض الاختبار.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "في نسخة المتاجر، يفتح هذا الزر الشراء عبر Google Play أو App Store.",
 "Nacional": "وطني",
 "Nada a gerar": "لا شيء لإنشائه",
 "Nada encontrado.": "لم يُعثر على شيء.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "لا يدخل شيء في جدول أي أحد دون إذن: كل شخص يقبل أو يعدّل أو يرفض.",
 "Nada foi registrado.": "لم يُسجَّل شيء.",
 "Nada lançado neste mês.": "لا قيود في هذا الشهر.",
 "Nada no mês": "لا شيء هذا الشهر",
 "Nada no roteiro deste dia.": "لا شيء في برنامج هذا اليوم.",
 "Nada para apagar com esse filtro.": "لا يوجد ما يُحذف بهذا الفلتر.",
 "Nada para comprar": "لا شيء للشراء",
 "Nada para enviar.": "لا يوجد شيء لإرساله.",
 "Nada planejado para este dia": "لا شيء مخطط لهذا اليوم",
 "Nada planejado para hoje. Bom dia!": "لا شيء مخطط لليوم. صباح الخير!",
 "Nada por aqui.": "لا شيء هنا.",
 "Nada recebido ainda.": "لم يصل شيء بعد.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "في المحادثات، يرى كل شخص اسمك وما ترسله فيها. يمكنك حذف رسالة لدى الجميع أو مغادرة مجموعة أو حظر شخص ما.",
 "Nascimento": "الميلاد",
 "Natal": "عيد الميلاد",
 "Natação": "سباحة",
 "Navegador conectado": "المتصفح مرتبط",
 "Negrito": "عريض",
 "Negócios": "أعمال",
 "Nenhum": "لا شيء",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "لا يوجد XML في هذه الفترة (أو حُفظت على جهاز آخر).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "لا يوجد أصدقاء لإضافتهم. ادعُ عبر WhatsApp أو أضف أصدقاء في الرسائل (رمز الصديق).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "لا توجد ملفات أو صور أو روابط في صفحات هذه المادة.",
 "Nenhum arquivo.": "لا توجد ملفات.",
 "Nenhum atendimento pago neste mês.": "لا توجد زيارات مدفوعة هذا الشهر.",
 "Nenhum cartão": "لا توجد بطاقات",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "لا توجد إيصالات محفوظة بعد. عند دفع فاتورة، اضغط عليها وأرفق صورة الإيصال أو ملف PDF أو لقطة شاشة له.",
 "Nenhum cômodo ainda": "لا توجد غرف بعد",
 "Nenhum dia": "لا يوجد يوم",
 "Nenhum documento ainda.": "لا توجد مستندات بعد.",
 "Nenhum documento neste filtro.": "لا توجد مستندات في هذا الفلتر.",
 "Nenhum e-mail cadastrado": "لا يوجد بريد إلكتروني مسجل",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "لا توجد أخطاء مسجلة. إذا أُغلق التطبيق وحده أو واجهت شاشة مشكلة، يظهر الخطأ هنا لترسله إلى الفريق.",
 "Nenhum feriado neste ano.": "لا توجد عطلات هذا العام.",
 "Nenhum fichário ainda": "لا توجد مجلدات بعد",
 "Nenhum grupo ainda.": "لا توجد مجموعات بعد.",
 "Nenhum item em {nome}": "لا عناصر في {nome}",
 "Nenhum lançamento encontrado": "لم يتم العثور على قيود",
 "Nenhum país encontrado.": "لم يتم العثور على أي دولة.",
 "Nenhum selecionado": "لم يتم تحديد شيء",
 "Nenhuma (plano gratuito)": "لا شيء (الخطة المجانية)",
 "Nenhuma aba encontrada.": "لم يُعثر على أي تبويب.",
 "Nenhuma aba fixada além do My Planner.": "لا توجد تبويبات مثبّتة غير My Planner.",
 "Nenhuma aba liberada para receber": "لا يوجد تبويب مفتوح يمكنه الاستلام",
 "Nenhuma agenda encontrada": "لم يتم العثور على أي تقويم",
 "Nenhuma agenda para trazer": "لا يوجد تقويم لاستيراده",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "لم يُعثر على جلسة استماع أو مهلة في هذه النشرة.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "لا توجد صناديق مؤرشفة. اسحب الصندوق إلى اليسار لأرشفته.",
 "Nenhuma compra encontrada": "لم يُعثر على مشتريات",
 "Nenhuma compra nesta fatura.": "لا توجد مشتريات في هذا الكشف.",
 "Nenhuma conta a pagar cadastrada.": "لا توجد فواتير مستحقة مسجّلة.",
 "Nenhuma conta a receber cadastrada.": "لا توجد مبالغ مستحقة القبض مسجّلة.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "لا فواتير في هذا الشهر. اضغط + للإضافة (الإيجار، الكهرباء، البطاقة...).",
 "Nenhuma cópia de segurança ainda.": "لا توجد نسخة احتياطية بعد.",
 "Nenhuma cópia encontrada.": "لم يتم العثور على أي نسخة.",
 "Nenhuma garantia ativa. Cadastre com o +.": "لا يوجد ضمان نشط. أضف ضمانًا بالزر +.",
 "Nenhuma garantia vencida.": "لا يوجد ضمان منتهٍ.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "لا توجد رسائل بعد. قل مرحبًا! 👋",
 "Nenhuma nota neste período.": "لا توجد فواتير في هذه الفترة.",
 "Nenhuma opção ainda.": "لا توجد خيارات بعد.",
 "Nenhuma publicação nova.": "لا توجد نشرات جديدة.",
 "Nenhuma refeição neste dia.": "لا توجد وجبات في هذا اليوم.",
 "Nenhuma reunião marcada.": "لا توجد اجتماعات محددة.",
 "Nesse ritmo, termina em {d}": "بهذه الوتيرة تنتهي في {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "في مرحلة الإطلاق هذه، كل التبويبات مفتوحة ومجانية.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "في مرحلة الاختبار هذه، يعيد الدعم تعيين كلمة المرور. راسل {email} مع ذكر CPF أو بريدك الإلكتروني.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "في مرحلة الاختبار هذه، يعيد الدعم تعيين كلمة المرور. راسل {email} مع ذكر رقم CPF الخاص بك.",
 "Neve": "ثلج",
 "Ninguém deve nada a ninguém.": "لا أحد مدين لأحد.",
 "Ninguém entrou ainda. Envie o convite.": "لم ينضم أحد بعد. أرسل الدعوة.",
 "Ninguém usou o seu código ainda.": "لم يستخدم أحد رمزك بعد.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "في Android يحتفظ التطبيق باختصار للملف المختار فقط: يبقى الملف في مكانه (Drive أو OneDrive أو التنزيلات) ويُفتح في تطبيق الهاتف. لا يُنسخ أي شيء. ينطبق هذا الخيار على الصور الملتقطة بالكاميرا.",
 "No Google Drive ou OneDrive: {n}": "على Google Drive أو OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "في Google Drive، لا يرى التطبيق إلا الملفات التي أنشأها بنفسه في مجلد My Planner. ويخضع استخدام المعلومات الواردة من واجهات Google API لسياسة بيانات المستخدمين في خدمات Google API، بما في ذلك متطلبات الاستخدام المحدود: لا يُباع أي شيء ولا يُستخدم للإعلانات ولا يطّلع عليه أشخاص، إلا بإذنك أو بموجب التزام قانوني.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "في تطبيق ساعتك (Samsung Health، Garmin Connect، Mi Fitness، Zepp، Fitbit، Amazfit، Google Fit...)، فعّل خيار \"Health Connect\" أو \"المزامنة مع Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "في التطبيق الجديد (الإصدار 0.49)، يكتشف الهاتف حواف الورقة تلقائيًا. في هذا الإصدار، اضبط الزوايا الـ 4 بإصبعك.",
 "No centro": "في الوسط",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "على الكمبيوتر، افتح {url}، واضغط على الزر أعلاه، ووجّه الكاميرا نحو رمز QR على الشاشة.",
 "No dia (opcional):": "في تاريخ (اختياري):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "على iPhone، يفتح التطبيق \"حفظ في الملفات\" لتختار المجلد (يمكن أن يكون iCloud Drive).",
 "No início": "عند البداية",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "في الوضع الآمن يُفتح التطبيق دون المهام التلقائية (التنبيهات وتقويم Google والمنشورات والرسائل والساعة). لا تتغير بياناتك ويعود كل شيء طبيعيًا عند الفتح التالي.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "في المتصفح، تبقى الصفحات فقط ما دامت هذه الصفحة مفتوحة.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "في المتصفح، الصق رابط الملف من Drive أو OneDrive أو Dropbox (في الدراسة أو المستندات، خيار رابط). على الهاتف، يعرض زر الملف Drive وOneDrive بالفعل.",
 "No navegador, o PDF é baixado para o computador.": "في المتصفح، يتم تنزيل ملف PDF إلى الكمبيوتر.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "في المتصفح، يمكن حفظ الصور الصغيرة فقط (حتى 200 KB). للملفات الأخرى، أضف رابطًا من Drive أو OneDrive أو Dropbox، أو استخدم التطبيق على الهاتف.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "في التطبيق الآخر، انسخ رابط الملف (مشاركة › نسخ الرابط) والصقه في كتلة الرابط الموجودة في هذه الصفحة.",
 "No ritmo atual, o ano fecha em {v}.": "بالوتيرة الحالية، ستُغلق السنة عند {v}.",
 "No seu fuso: {hora}{dia}": "في منطقتك الزمنية: {hora}{dia}",
 "Nome": "الاسم",
 "Nome (cliente ou fornecedor)": "الاسم (عميل أو مورّد)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "الاسم (مثال: الصف الثامن ب، مرضى العيادة، عيد ميلاد آنا)",
 "Nome (ex.: Almoço)": "الاسم (مثال: الغداء)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "الاسم (مثل: إيجار مُستلَم، العميل X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "الاسم (مثل: الإيجار، الكهرباء، الإنترنت)",
 "Nome (ex.: Doutorado UFPR)": "الاسم (مثال: دكتوراه UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "الاسم (مثال: Nubank، Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "الاسم (مثال: العناية بالبشرة ليلًا)",
 "Nome (ex.: Treino A)": "الاسم (مثل: تمرين A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "الاسم (مثال: رحلة العطلة، صندوق الطوارئ)",
 "Nome (ex.: Vitamina C)": "الاسم (مثل: فيتامين سي)",
 "Nome (opcional)": "الاسم (اختياري)",
 "Nome (opcional, ex.: CNH do Walter)": "الاسم (اختياري، مثال: CNH الخاصة بـ Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "الاسم (يمكن تعديله، مثل: \"عصير عنب\")",
 "Nome completo": "الاسم الكامل",
 "Nome curto": "اسم مختصر",
 "Nome da lista": "اسم القائمة",
 "Nome da matéria": "اسم المادة",
 "Nome da obra": "اسم المشروع",
 "Nome da pasta (ex.: Recibos, Contratos)": "اسم المجلد (مثلًا: إيصالات، عقود)",
 "Nome da tarefa": "اسم المهمة",
 "Nome da tarefa (ex.: Academia)": "اسم المهمة (مثال: النادي الرياضي)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "اسم المهمة (مثل: تنظيف الحمّام)",
 "Nome do PDF (opcional)": "اسم ملف PDF (اختياري)",
 "Nome do conselho": "اسم النقابة",
 "Nome do cômodo": "اسم الغرفة",
 "Nome do documento": "اسم المستند",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "اسم المكتب (مثال: Ravasco Contabilidade)",
 "Nome do evento": "اسم المناسبة",
 "Nome do grupo (ex.: Família)": "اسم المجموعة (مثال: العائلة)",
 "Nome do modelo": "اسم القالب",
 "Nome ou modelo": "الاسم أو الطراز",
 "Nome ou razão social": "الاسم أو الاسم التجاري",
 "Nome, subtarefa ou anotação": "الاسم أو المهمة الفرعية أو الملاحظة",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "في المجموعات، كل شخص مسؤول عمّا يضيفه. ومشرف المجموعة يقرر من يشارك فيها.",
 "Nossa Senhora Aparecida": "سيدة أباريسيدا",
 "Nossa Senhora da Luz dos Pinhais": "سيدة النور في Pinhais",
 "Nota cancelada": "تم إلغاء الفاتورة",
 "Nota fiscal": "فاتورة",
 "Nota fiscal emitida": "صدرت فاتورة ضريبية",
 "Nota fiscal, certificado de garantia e fotos": "الفاتورة وشهادة الضمان والصور",
 "Nota importada": "تم استيراد الفاتورة",
 "Notas": "الفواتير",
 "Notas Fiscais": "الفواتير الضريبية",
 "Notebook e carregador": "الحاسوب المحمول والشاحن",
 "Nova avaliação": "تقييم جديد",
 "Nova caixa (ex.: Compras, Ideias)": "صندوق جديد (مثال: مشتريات، أفكار)",
 "Nova conversa": "محادثة جديدة",
 "Nova garantia": "ضمان جديد",
 "Nova matéria": "مادة جديدة",
 "Nova meta": "هدف جديد",
 "Nova pasta": "مجلد جديد",
 "Nova página": "صفحة جديدة",
 "Nova página com esta caixa": "صفحة جديدة بهذا الصندوق",
 "Nova refeição": "وجبة جديدة",
 "Nova tarefa": "مهمة جديدة",
 "Nova tarefa da casa": "مهمة منزلية جديدة",
 "Nova tarefa neste cômodo": "مهمة جديدة في هذه الغرفة",
 "Novas": "الجديدة",
 "Novo": "جديد",
 "Novo alerta:": "تنبيه جديد:",
 "Novo cartão": "بطاقة جديدة",
 "Novo cartão de crédito": "بطاقة ائتمان جديدة",
 "Novo cuidado": "عناية جديدة",
 "Novo documento": "مستند جديد",
 "Novo e-mail": "البريد الإلكتروني الجديد",
 "Novo fichário": "مجلد جديد",
 "Novo grupo": "مجموعة جديدة",
 "Novo item": "عنصر جديد",
 "Novo perfil": "ملف شخصي جديد",
 "Novo suplemento": "مكمّل جديد",
 "Novo treino": "تمرين جديد",
 "Novo: {nome}": "جديد: {nome}",
 "Novos": "جديدة",
 "Num período": "خلال فترة",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "رقّم كل صندوق واذكر الغرفة والمحتوى. استخدم البحث لمعرفة مكان كل شيء.",
 "Nº": "رقم",
 "Não": "لا",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "لم أجد الإجمالي في الإيصال. جرّب صورة أوضح.",
 "Não consegue entrar?": "لا تستطيع الدخول؟",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "تعذّر فتح \"{nome}\". جرّب أداة إصلاح PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "تعذّر الاتصال بالمكالمة. تحقق من الإنترنت وحاول مرة أخرى.",
 "Não deu certo: {msg}": "لم ينجح الأمر: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "تعذّر تصغير ملف PDF هذا أكثر ({tam}).",
 "Não dá para tirar todas as páginas.": "لا يمكن حذف كل الصفحات.",
 "Não encontrei texto neste PDF.": "لم يُعثر على نص في ملف PDF هذا.",
 "Não encontrei texto neste documento.": "لم أجد نصًا في هذا المستند.",
 "Não foi possível": "تعذّر ذلك",
 "Não foi possível abrir": "تعذّر الفتح",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "تعذّر فتح الشهادة المحفوظة. اربط الشهادة مرة أخرى.",
 "Não foi possível abrir.": "تعذّر الفتح.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "تعذر تنزيل عطلات هذه الدولة. تحقق من اتصال الإنترنت.",
 "Não foi possível conectar": "تعذّر الاتصال",
 "Não foi possível conectar o {nome}": "تعذّر ربط {nome}",
 "Não foi possível consultar o DJEN agora.": "تعذّر الاستعلام من DJEN الآن.",
 "Não foi possível continuar": "تعذّرت المتابعة",
 "Não foi possível criar um evento na agenda: {msg}": "تعذّر إنشاء حدث في التقويم: {msg}",
 "Não foi possível entrar.": "تعذّر تسجيل الدخول.",
 "Não foi possível enviar": "تعذر الإرسال",
 "Não foi possível enviar.": "تعذّر الإرسال.",
 "Não foi possível guardar: {erro}": "تعذّر الحفظ: {erro}",
 "Não foi possível ler o arquivo.": "تعذرت قراءة الملف.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "تعذّرت قراءة التقويم. تحقق من الرابط في تعديل.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "تعذّر البحث الآن. ستتم المحاولة تلقائيًا لاحقًا.",
 "Não foi possível reiniciar sozinho.": "تعذّر إعادة التشغيل تلقائيًا.",
 "Não foi possível sincronizar com a agenda: {msg}": "تعذّرت المزامنة مع التقويم: {msg}",
 "Não foi possível trocar a foto": "تعذّر تغيير الصورة",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "لا يوجد ضمان لوصول الإشعار والتطبيق مغلق. يتم التحقق عند فتح التطبيق (كل 6 ساعات) أو عبر \"تحقّق الآن\".",
 "Não identificado": "غير معروف",
 "Não marcada como feita": "غير معلّمة كمنجزة",
 "Não optante pelo Simples": "غير مشترك في Simples",
 "Não se repete": "لا يتكرر",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "لا تستخدم التطبيق في أنشطة غير قانونية، أو لحفظ محتوى الغير دون إذن، أو لمحاولة الوصول إلى بيانات أشخاص آخرين.",
 "Não vai": "لن يحضر",
 "Não vence": "لا ينتهي",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "لا نبيع بياناتك ولا نستخدم محتواك في الإعلانات.",
 "Não é possível adicionar esta pessoa.": "لا يمكن إضافة هذا الشخص.",
 "Não é um XML de nota fiscal": "ليس ملف XML لفاتورة",
 "Número": "الرقم",
 "Número (opcional)": "الرقم (اختياري)",
 "Número da OAB": "رقم OAB",
 "Número da caixa": "رقم الصندوق",
 "Número da carteirinha": "رقم البطاقة",
 "Número da guia do convênio": "رقم موافقة التأمين",
 "Número da parcela": "رقم القسط",
 "Número de hóspedes": "عدد الضيوف",
 "Número de parcelas": "عدد الأقساط",
 "Número do contrato": "رقم العقد",
 "Número do registro": "رقم القيد",
 "Número na chamada": "الرقم في كشف الحضور",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "الرقم {n}. حُفظ ملف XML في الفاتورة. اضغط عليها لعرض PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "يُشفَّر الرقم وجهة الإصدار والملاحظات (AES-256) على الجهاز قبل إرسالها إلى السحابة.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "الرقم وجهة الإصدار والملاحظات والصور وملفات PDF مشفّرة (AES-256) على الجهاز. تبقى الملفات المحمية على هذا الجهاز فقط.",
 "Número: {n}": "الرقم: {n}",
 "Números de página": "أرقام الصفحات",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT لا يقرأ ملفات PDF هنا. التقط صورة أو لقطة شاشة للصفحة، أو استخدم Claude أو Gemini من الإعدادات › الذكاء الاصطناعي.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "يستحق DAS يوم {dia}. أشّر عليه كمدفوع في المالية.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "لم يتم تفعيل المكتب على الخادم بعد. على الكمبيوتر، شغّل 29-SERVIDOR-0.45.bat (مرة واحدة فقط).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "يعتني Mestre Achado بأموالك: المدفوعات، البطاقات والكشوف، الميزانية حسب الفئة، الأهداف، كشف الحساب والإيصال بالصورة، التقرير وMEI.",
 "O Mestre está pensando...": "Mestre يفكّر...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "ينشئ My Planner مجلد \"My Planner\" في Drive الخاص بك ولا يرى إلا ما حفظه فيه بنفسه.",
 "O My Planner já abriu no computador, com os seus dados.": "تم فتح My Planner على الكمبيوتر ببياناتك.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "يقرأ My Planner بيانات الساعة عبر {fonte}، حيث تحفظ الساعة وتطبيقات الصحة والرياضة كل شيء.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "ينظّم My Planner أجندتك ومهامك وماليتك ومستنداتك وجوانب أخرى من حياتك. يقدّمه Walter Ravasco da Costa، وهو المتحكم في البيانات الشخصية التي تُعالَج في التطبيق.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "يستخدم My Planner فقط مجلد التطبيقات › My Planner في OneDrive الخاص بك.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "سيتم حذف ملف PDF والصور من هذا الجهاز ومن السحابة.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "تجاوز ملف PDF حجم 15 MB. إذا رفضه WhatsApp أو البريد الإلكتروني، فعّل \"ملف أصغر\".",
 "O QUE COMER": "ماذا آكل",
 "O QUE OS MEMBROS PODEM": "ما يمكن للأعضاء فعله",
 "O QUE VOCÊ MANDA": "ما ترسله",
 "O QUE VOCÊ RECEBE": "ما تستلمه",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "يظل الدخول عبر رقم CPF. يُستخدم البريد الإلكتروني ليتواصل معك الدعم.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "سيتمكن مسؤول المجموعة من إرسال المواعيد والمواد والإشعارات. لا يدخل شيء في جدولك دون موافقتك.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "يرنّ المنبّه مجددًا كل دقيقتين (حتى 4 مرات) ما دام الدواء لم يُعلَّم كمأخوذ.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "يساعدك التطبيق على التنظيم، لكنه لا يغني عن استشارة الأطباء أو المحامين أو المحاسبين أو غيرهم من المختصين. تحقق من المواعيد النهائية والمبالغ والتواريخ المهمة.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "ينبّهك التطبيق قبل 3 أيام وفي يوم الاستحقاق، الساعة 9 صباحًا.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "يستعلم التطبيق من الخدمة العامة لـ CNJ (DJEN) بالأسماء ورقم OAB التي تسجّلها. تُرسل هذه البيانات إلى تلك الخدمة في كل عملية تحقق.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "يستعلم تطبيق My Planner وخادمه من الخدمة العامة لـ CNJ (DJEN) بالأسماء وأرقام OAB التي تسجلها، وإذا حدّدت ذلك، من Querido Diário (الجرائد الرسمية البلدية). تُرسل هذه البيانات إلى هذه الخدمات عند كل فحص.",
 "O app fechou sozinho {n} vezes seguidas": "أُغلق التطبيق وحده {n} مرات متتالية",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "التطبيق المثبت على هذا الجهاز هو الإصدار {v}. لإجراء المكالمات الصوتية والمرئية، ثبّت التطبيق 0.35 أو أحدث (APK جديد). الرسائل تعمل بالفعل.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "لم يُغلق التطبيق وبياناتك ما زالت محفوظة. حاول مرة أخرى أو أرسل التقرير ليصلحه الفريق.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "يطلب التطبيق فتح القفل عند فتحه وعند العودة من الخلفية.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "يطلب التطبيق إلغاء القفل عند فتحه. التنقل السريع بين التطبيقات أو الشاشات لا يطلبه مجددًا؛ أما إذا قُفل الهاتف أو بقي التطبيق خارج الشاشة مدة أطول من المهلة أدناه، فسيُطلب.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "التطبيق يقرأ فقط (الخطوات، المسافة، السعرات، التمرين، نبض القلب والنوم) ولا يغيّر بياناتك الصحية أبدًا. تُحفظ إجماليات كل يوم في حسابك لتظهر أيضًا على الموقع وعلى الهاتف الآخر.",
 "O app volta a pedir a senha para desbloquear.": "سيعود التطبيق إلى طلب كلمة المرور لفتح القفل.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "التطبيق مخصص لمن تجاوزوا 18 عامًا. لا يجوز تسجيل بيانات الأطفال إلا من قِبل الوالدين أو الأوصياء.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "بقي الملف على هذا الجهاز فقط. تعذّر الحفظ في {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "لم يعد الملف في ذلك المكان (حُذف أو نُقل).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "لم يعد الملف في ذلك المكان (حُذف أو نُقل أو سحب تطبيقه الإذن). أرفقه من جديد.",
 "O arquivo passa de 15 MB.": "حجم الملف يتجاوز 15 ميغابايت.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "يتجاوز الملف 15 MB. فعّل \"ملف أصغر\" وحاول مرة أخرى.",
 "O arquivo passa de 25 MB.": "حجم الملف يتجاوز 25 MB.",
 "O arquivo passa de 50 MB.": "الملف أكبر من 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "سيُحذف الملف من هذا الهاتف. النسخ التي حفظتها في Drive أو OneDrive أو أرسلتها تبقى هناك.",
 "O arquivo sai do escritório para todos.": "سيُزال الملف من المكتب للجميع.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "يصل التنبيه الساعة 9 صباحًا، ومرة أخرى يوم الانتهاء.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "قاعدة البيانات غير مُعدّة بعد. شغّل الملف supabase/schema.sql في Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "البطاقة {c} مستخدمة بنسبة {p}% من حدّها. تجنّب التقسيط الجديد عليها حاليًا.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "لا يُبلغ الهاتف التطبيق عند قفل الشاشة، لذلك يحسب التطبيق الوقت الذي يقضيه خارجها. مع دقيقة واحدة، قفل الهاتف والعودة لاحقًا يطلب القياسات الحيوية؛ أما الرد السريع على رسالة فلا.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "يُستخدم الهاتف فقط لتأكيد أن الحساب لك (رمز عبر WhatsApp عند التسجيل وعند تغيير الرقم). رقم واحد لكل حساب.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "لم يتم تفعيل المشاركة على الخادم بعد. على الكمبيوتر، افتح المجلد C:\\MyPlanner وانقر نقرًا مزدوجًا على 12-LIGAR-COMPARTILHAMENTO.bat (مرة واحدة فقط).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "سيفتح الكمبيوتر My Planner بحسابك. افعل ذلك فقط على أجهزة كمبيوتر موثوقة.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "تتضمن الدعوة رابط التطبيق وأحدث APK. من يدخل عبر الرابط ينتقل مباشرة إلى المكتب.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "رمز الإحالة صالح فقط خلال أول 30 يومًا من الحساب.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "يُحفظ النمط على هذا الجهاز فقط وبشكل محمي. تبقى كلمة المرور صالحة إذا نسيت النمط.",
 "O dinheiro gasto está à frente do andamento da obra.": "المال المصروف يسبق تقدّم أعمال المشروع.",
 "O documento não tem páginas.": "لا يحتوي المستند على صفحات.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "تتم قراءة كشف الحساب هنا على الجهاز. الفواتير المستحقة بنفس المبلغ وتاريخ قريب تُسجَّل كمدفوعة تلقائيًا.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "يُقرأ كشف الحساب هنا على الجهاز. المدفوعات المستحقة بنفس المبلغ وتاريخ قريب تُسدَّد تلقائيًا. دفع كشف البطاقة لا يُحتسب مرتين.",
 "O governo recusou a nota": "رفضت الجهات الحكومية الفاتورة",
 "O governo recusou a nota.": "رفضت الجهات الحكومية الفاتورة.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "اللغة تخص هذا الجهاز. البيانات التي أدخلتها لا تُترجم.",
 "O item vinculado foi apagado ou movido.": "تم حذف العنصر المرتبط أو نقله.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "تم حذف العنصر المرتبط أو نقله. عدّل المهمة لاختيار عنصر آخر.",
 "O link antigo deixa de funcionar.": "سيتوقف الرابط القديم عن العمل.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "يتوقف الرابط القديم عن العمل. من هو في المجموعة يبقى فيها.",
 "O link deve começar com https://": "يجب أن يبدأ الرابط بـ https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "المتصفح لا يسمح بقراءة تقويمات المنصات. استورد عبر التطبيق على الهاتف.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "تخضع الخطة الأساسية وفترات تجربة التبويبات للقواعد الموضحة في الإعدادات > المشتريات. مزايا الإحالة تُمنح مرة واحدة لكل حساب.",
 "O que acontece": "ما يحدث",
 "O que apagar": "ما الذي يُحذف",
 "O que comprou": "ما الذي اشتريته",
 "O que fazer": "ما يجب فعله",
 "O que foi comido:": "ما تم تناوله:",
 "O que foi feito": "ما تم إنجازه",
 "O que foi visto": "ما تم شرحه",
 "O que funcionou, o que ajustar, metodologias, resumos...": "ما نجح، وما يحتاج تعديلًا، والمنهجيات، والملخصات...",
 "O que já foi guardado continua nos lançamentos como investimento.": "ما تم ادّخاره يبقى في الحركات كاستثمار.",
 "O que levar ou estudar": "ما يجب إحضاره أو مذاكرته",
 "O que o app pode usar": "ما الذي يمكن للتطبيق استخدامه",
 "O que o médico disse": "ما قاله الطبيب",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "ما أرسلته مجموعاتك. المواعيد المقبولة تذهب إلى My Planner؛ والمواد والإشعارات تذهب إلى الملاحظات.",
 "O que precisa": "المطلوب",
 "O que tem dentro": "ما بداخله",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "ما أعرته أو استعرته: صورة، ومع من هو، وتنبيه الإرجاع.",
 "O que é apagado": "ما الذي يُحذف",
 "O quê": "ماذا",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "يعرض المنتقي Google Drive وOneDrive وDropbox عند تثبيت هذه التطبيقات على الهاتف. يحتفظ التطبيق بالاختصار فقط: يبقى الملف في مكانه ويُفتح في تطبيق الهاتف.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "تعرض أداة الاختيار Google Drive وOneDrive وDropbox عندما تكون هذه التطبيقات مثبتة على الهاتف. يُحفظ الملف المختار على هذا الجهاز.",
 "O servidor ainda não buscou para os seus perfis.": "لم يبحث الخادم بعد لملفاتك الشخصية.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "الخادم غير جاهز للرسائل بعد. شغّل 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "الخادم غير جاهز للإحالات بعد. حاول مرة أخرى لاحقًا.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "الخادم غير مهيأ بعد لبطاقة جهة الاتصال. شغّل 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "لم يُجهَّز الخادم بعد للبيانات المشتركة. على الكمبيوتر، افتح المجلد C:\\MyPlanner وانقر نقرًا مزدوجًا على 15-LIGAR-GRUPOS-COLABORATIVOS.bat (مرة واحدة فقط).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "لم يتم تجهيز الخادم بعد لـ Drive وOneDrive (راجع COMO RODAR، الإصدار 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "الخادم غير مُعدّ بعد للوصول عبر الويب (شغّل supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "لا يحتوي الخادم بعد على الدالة \"qr-login\". راجع خطوة الإصدار 0.6 في COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "رفض خادم المكالمات مفتاح LiveKit. على كمبيوتر المشرف، شغّل 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "ردّ خادم الفواتير بشكل غير متوقع (HTTP {s}). تحقّق من العنوان.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "يقوم الخادم بالالتقاط التلقائي كل ساعتين، من 08:00 إلى 20:00 (بتوقيت برازيليا)، حتى عندما يكون التطبيق مغلقًا. تظهر المنشورات الملتقطة عند فتح التطبيق. يمكنك أيضًا استخدام \"تحقّق الآن\".",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "يجري الخادم الالتقاط التلقائي كل يوم الساعة 08:00 و12:00 (بتوقيت برازيليا)، حتى عندما يكون التطبيق مغلقًا. تظهر النشرات الملتقطة عند فتح التطبيق. يمكنك أيضًا استخدام \"تحقّق الآن\".",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "رفض الخادم الوصول: في الدالة \"nuvem\" على Supabase، أوقف \"Verify JWT\" (يقوم 32-LIGAR-DRIVE-ONEDRIVE.bat بذلك بالفعل).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "رفض الخادم الوصول: في الدالة \"nuvem\" في Supabase، أوقف \"Verify JWT\" (الملف 9-LIGAR-DRIVE-ONEDRIVE.bat يقوم بذلك).",
 "O seu papel no grupo não permite incluir aqui.": "دورك في المجموعة لا يسمح بالإضافة هنا.",
 "O site deve começar com https://": "يجب أن يبدأ الموقع بـ https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "يُغيَّر حجم الكوب الافتراضي ({copo}) من \"تعديل\" في بطاقة الماء.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "يغيّر السمة ألوان التبويبات (تبقى الأيقونات كما هي) ويسري في الوضعين الفاتح والداكن. ويمكنك بعد ذلك تغيير لون أي تبويب من الإعدادات > التبويبات.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "يمتلئ المؤقت باللون مع مرور وقت المهمة. الضغط عليه يفتح رابط المهمة.",
 "O teste grátis terminou": "انتهت التجربة المجانية",
 "O texto": "النص",
 "O texto do PDF num arquivo .docx para editar.": "نص PDF في ملف .docx قابل للتعديل.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "النص مضمّن أيضًا بشكل مخفي داخل ملف PDF: يمكنك البحث عنه ونسخه في قارئ PDF.",
 "O tom escolhido fica para os próximos emojis.": "يُستخدم لون البشرة المختار للإيموجي التالية.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "يظهر المجموع أعلى My Planner. إذا تجاوز الحد، يصبح البرق أحمر. مهام \"استرخاء\" قيمتها 0.",
 "OAB (opcional, para advogados)": "OAB (اختياري، للمحامين)",
 "OBS": "ملاحظات",
 "OCR: texto pesquisável": "OCR: نص قابل للبحث",
 "OK": "حسنًا",
 "OU ESCOLHER CÔMODO…": "أو اختر غرفة…",
 "Objetivos": "الأهداف",
 "Objeto": "غرض",
 "Objetos": "الأشياء",
 "Objetos e valores": "الأغراض والأموال",
 "Obra": "المشروع",
 "Obras": "المشاريع",
 "Obras & Reformas": "البناء والتجديد",
 "Obrigado": "شكرًا",
 "Obrigado!": "شكرًا!",
 "Observações": "ملاحظات",
 "Observações (alergias, ração...)": "ملاحظات (حساسية، طعام...)",
 "Observações (chave Pix, conta para depósito...)": "ملاحظات (مفتاح Pix، حساب الإيداع...)",
 "Observações (código de barras, chave Pix...)": "ملاحظات (الرمز الشريطي، مفتاح Pix...)",
 "Observações (dados bancários, PIX...)": "ملاحظات (بيانات بنكية، PIX...)",
 "Observações (estado do item...)": "ملاحظات (حالة الغرض...)",
 "Observações (garantia, seguro, CET...)": "ملاحظات (ضمان، تأمين، التكلفة الفعلية...)",
 "Observações (nº de série, modelo...)": "ملاحظات (الرقم التسلسلي، الطراز...)",
 "Observações (onde está o original, categoria da CNH...)": "ملاحظات (مكان النسخة الأصلية، فئة رخصة القيادة...)",
 "Observações (recibo de entrega, número...)": "ملاحظات (إيصال التسليم، رقم...)",
 "Observações (restrição alimentar...)": "ملاحظات (قيود غذائية...)",
 "Ocultar texto (tarja)": "إخفاء النص (شريط أسود)",
 "Ocupado": "مشغول",
 "Oficina": "ورشة السيارات",
 "Ofício": "Legal",
 "Oi!": "أهلًا!",
 "Oi! Tudo certo para sábado?": "مرحبًا! هل كل شيء جاهز ليوم السبت؟",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "مرحبًا {pessoa}! ما زال {coisa} الذي أعرتني إياه عندي. متى يناسبك أن أعيده؟",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "مرحبًا {pessoa}! كيف حالك؟ أردت تذكيرك بـ{coisa} الذي أعرتك إياه في {data}. هل يمكنك إعادته {quando}؟",
 "Oi?!": "نعم؟!",
 "Olá!": "مرحبًا!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "مرحبًا! أنا Mestre Achado. اسألني عن مصروفاتك ومدفوعاتك وبطاقاتك وأهدافك: أجيبك بأرقامك.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "مرحبًا! أذكّرك بدفع {ref} ({v})، المستحق في {d}. شكرًا!",
 "Olá! Preciso de assistência técnica para: {item}": "مرحبًا! أحتاج إلى خدمة الصيانة من أجل: {item}",
 "Olá, {nome}!": "مرحبًا {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "مرحبًا {nome}! أهلًا وسهلًا.",
 "Ombros: girar para trás": "الكتفان: تدوير للخلف",
 "Omelete": "أومليت",
 "Onde": "أين",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "أين يساعد الذكاء الاصطناعي: النشرات القضائية (جلسات الاستماع والمهل)، والمستندات (ملء البطاقة من الصورة)، والملاحظات (تحويل صندوق إلى مهام).",
 "Onde assistir": "أين تشاهده",
 "Onde eu mais gastei este mês?": "أين أنفقت أكثر هذا الشهر؟",
 "Onde fica": "أين يقع",
 "Onde guardar fotos e arquivos novos": "مكان حفظ الصور والملفات الجديدة",
 "Onde na página": "المكان في الصفحة",
 "Ontem": "أمس",
 "Organizar": "تنظيم",
 "Organizar barra": "تنظيم الشريط",
 "Organizar com IA": "تنظيم بالذكاء الاصطناعي",
 "Organizar com IA (vira tarefas)": "تنظيم بالذكاء الاصطناعي (يتحول إلى مهام)",
 "Organizar páginas": "تنظيم الصفحات",
 "Orgulho e vibrante": "فخر وحيوية",
 "Origem": "المصدر",
 "Origem da reserva": "مصدر الحجز",
 "Original": "الأصلي",
 "Orquídeas": "الأوركيد",
 "Orçado": "المُقدَّر",
 "Orçamento": "الميزانية",
 "Orçamento do mês": "ميزانية الشهر",
 "Orçamento por categoria": "الميزانية حسب الفئة",
 "Orçamento total": "الميزانية الإجمالية",
 "Orçamento: {v}": "الميزانية: {v}",
 "Os alertas precisam de um horário.": "التنبيهات تحتاج إلى وقت محدد.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "المرفقات المحفوظة على الجهاز فقط لا تظهر على الأجهزة الأخرى وتضيع عند تغيير الهاتف. اربط Google Drive أو OneDrive في الإعدادات لحفظ نسخة.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "الملفات والنسخ الموجودة هناك تبقى كما هي. يتوقف My Planner فقط عن حفظ أي شيء جديد.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "سيتم أيضًا حذف الملفات المحفوظة على هذا الجهاز.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "الملفات الموجودة في Google Drive أو OneDrive أو على هاتفك تبقى معك. السجلات التي يلزم القانون بحفظها (مثل سجلات الدخول) قد تُحفظ للمدة القانونية ثم تُحذف.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "لم تُفعَّل تنبيهات المجموعة على الخادم بعد. على الكمبيوتر، انقر نقرًا مزدوجًا على 15-LIGAR-GRUPOS-COLABORATIVOS.bat (مرة واحدة فقط).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "الإشعارات متوقفة لتطبيق My Planner. اضغط على فتح الإعدادات وفعّل الإشعارات.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "تعمل إشعارات الهاتف في التطبيق المثبّت (Android أو iPhone).",
 "Os campos do formulário viram parte da página.": "تصبح حقول النموذج جزءًا من الصفحة.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "ستُستبدل البيانات الحالية ببيانات الملف، هنا وفي السحابة.",
 "Os dados continuam salvos na nuvem.": "تبقى البيانات محفوظة في السحابة.",
 "Os dados da aba ainda são só seus": "بيانات التبويب لا تزال لك وحدك",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "ستصبح بيانات التبويب {aba} مرئية للفريق، كل شخص حسب الدور الذي تختاره.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "لم تُتَح بيانات هذه المجموعة بعد. اطلب ممن أنشأ المجموعة فتح My Planner المحدَّث: سيتيحها التطبيق تلقائيًا.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "لم تُتَح بيانات هذه المجموعة بعد. اطلب ممن أنشأ المجموعة تحديث My Planner وفتح المجموعة: سيظهر هناك زر الإتاحة.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "تُشفَّر بيانات الخزنة هنا على الجهاز (AES-256) قبل إرسالها إلى السحابة. حتى الدعم الفني لا يستطيع قراءتها. إذا نسيت كلمة مرور الخزنة فلا يمكن استعادة هذه البيانات.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "تُحفظ البيانات ما دام الحساب موجودًا. وعند حذف الحساب تُحذف البيانات، باستثناء ما يُلزم القانون بالاحتفاظ به.",
 "Os desenhos não conferem. Comece de novo.": "النمطان غير متطابقين. ابدأ من جديد.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "الأيام موجودة في التطبيق أو في كشف البنك. المشتريات بعد الإغلاق تدخل في الكشف التالي.",
 "Os emojis que você usar aparecem aqui.": "تظهر هنا الإيموجي التي تستخدمها.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "لم تُفعَّل المجموعات على الخادم بعد. على الحاسوب، افتح المجلد C:\\MyPlanner وانقر نقرًا مزدوجًا على 11-LIGAR-GRUPOS.bat (مرة واحدة فقط).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "لم يتم تفعيل المجموعات على الخادم بعد. شغّل supabase\\migracao-0.21.sql في Supabase (راجع COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "تُفتح الأماكن في Google Maps أو Waze أو الخرائط، حسب اختيارك في الإعدادات.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "يرى الأعضاء المسؤولين دائمًا ولا يتلقون إلا ما أُرسل إليهم.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "لن يرى الأعضاء الآخرون البيانات بعد الآن (تُحذف النسخة من أجهزتهم). يبقى كل شيء لديك.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "تبقى الملفات الشخصية والنتائج في حسابك على My Planner.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "توجد الملفات الشخصية وأرقام OAB والمحاكم داخل تبويب النشرات القضائية. يعمل البحث التلقائي على الخادم الساعة 08:00 و12:00 (بتوقيت برازيليا).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "تُحفظ الأسعار وتظهر في قائمة التسوق في تبويب الطعام والمؤونة كسعر آخر شراء.",
 "Os resultados deste perfil também serão apagados.": "ستُحذف نتائج هذا الملف الشخصي أيضًا.",
 "Os termos foram atualizados": "تم تحديث الشروط",
 "Ou digite (ex.: 2 ovos mexidos)": "أو اكتب (مثل: 2 بيض مخفوق)",
 "Ou escreva o prato": "أو اكتب الطبق",
 "Ou escreva o seu": "أو اكتب نصك",
 "Outra": "أخرى",
 "Outra aba…": "تبويب آخر…",
 "Outra atividade (digite e dê Enter)": "نشاط آخر (اكتبه واضغط Enter)",
 "Outro": "أخرى",
 "Outro (ml)": "آخر (مل)",
 "Outro valor": "مبلغ آخر",
 "Outros": "أخرى",
 "Outros países": "دول أخرى",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "ساعات أخرى (Garmin، Samsung، Xiaomi، Amazfit...): في تطبيق الساعة، فعّل خيار إرسال البيانات إلى تطبيق صحتي (Apple صحتي).",
 "Ovo": "بيض",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "مدفوع، مستلم، سري، معتمد أو نصك الخاص، مع التاريخ.",
 "PARA ACERTAR": "للتسوية",
 "PARA QUEM": "إلى من",
 "PARA {refeicao}": "لـ {refeicao}",
 "PASSO A PASSO": "خطوة بخطوة",
 "PASSO {n}": "الخطوة {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF بنص رقمي: يجهز فورًا في المتصفح. PDF ممسوح (صورة): يقرأ الذكاء الاصطناعي كل صفحة.",
 "PDF grande": "ملف PDF كبير",
 "PDF guardado na pasta \"{pasta}\" do celular.": "تم حفظ ملف PDF في المجلد \"{pasta}\" على الهاتف.",
 "PDF guardado no {nome}.": "تم حفظ ملف PDF في {nome}.",
 "PDF numa página só": "PDF في صفحة واحدة",
 "PDF para Word": "PDF إلى Word",
 "PDF para imagens": "PDF إلى صور",
 "PDF para texto": "PDF إلى نص",
 "PDFs arquivados ({n})": "ملفات PDF المؤرشفة ({n})",
 "PDFs juntados {data}": "ملفات PDF مدمجة {data}",
 "PEDIDOS RECEBIDOS": "الطلبات الواردة",
 "PIX": "PIX",
 "PIX COPIA E COLA": "Pix للنسخ واللصق",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "الكشوف القادمة (ملتزم بها مسبقًا)",
 "Paciente": "المريض",
 "Paciente ou aluno": "المريض أو الطالب",
 "Pacientes": "المرضى",
 "Padrão": "افتراضي",
 "Padrão da aba": "افتراضي التبويب",
 "Paga": "مدفوع",
 "Paga (toque para desfazer)": "مدفوعة (اضغط للتراجع)",
 "Pagador": "الدافع",
 "Pagamento já contado": "دفعة محتسبة مسبقًا",
 "Pagar": "دفع",
 "Pagar parcela {n}/{t} · {c}": "دفع القسط {n}/{t} · {c}",
 "Pagas": "المدفوعة",
 "Pago": "مدفوع",
 "Pago com": "طريقة الدفع",
 "Pago: {p} · Falta pagar: {f}": "المدفوع: {p} · المتبقي: {f}",
 "Pagos": "المدفوعة",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "هل دفعت {v}؟ إذا حصلت على خصم أو دفعت غرامة أو فوائد، أدخل المبلغ المدفوع. هل تريد حفظ الإيصال الآن؟",
 "Paguei outro valor (desconto, multa ou juros)": "دفعت مبلغًا آخر (خصم أو غرامة أو فوائد)",
 "Paixão de Cristo": "الجمعة العظيمة",
 "Palavras-chave (separe com vírgula)": "الكلمات المفتاحية (افصل بينها بفاصلة)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "ليبلغ الهدف \"{m}\" في موعده، يلزم {v} شهريًا. الأفضل تمديد المهلة أو البدء بمبلغ أصغر.",
 "Para clareza, firmo o presente.": "وهذا إقرار مني بذلك.",
 "Para comprar": "للشراء",
 "Para continuar, digite a senha do app.": "للمتابعة، أدخل كلمة مرور التطبيق.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "للمحادثة، فعّل ذكاءك الاصطناعي من الإعدادات › الذكاء الاصطناعي (Claude أو ChatGPT أو Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "لتقسيم المصروفات، اكتب في \"من سيذهب\" الأسماء مفصولة بفواصل (عدّل الرحلة).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "لإصدار الفواتير والبحث عنها، اربط خادم الفواتير مرة واحدة: على الكمبيوتر، انقر نقرًا مزدوجًا على 13-LIGAR-NOTAS.bat والصق هنا العنوان الذي يعرضه (ينتهي بـ .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "لممارسة حقوقك، استخدم تواصل معنا في التطبيق أو راسلنا على البريد الإلكتروني أدناه. نرد خلال 15 يومًا.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "لإجراء مكالمات صوتية ومكالمات فيديو، ثبّت الإصدار الجديد من التطبيق (0.35). الرسائل تعمل بالفعل.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "لتشغيل التطبيق: حفظ بياناتك ومزامنتها بين الأجهزة، وإرسال التنبيهات، والمشاركة مع المجموعات التي تختارها، وتقديم الدعم.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "لحفظ ملفات PDF في {nome}، اربط حسابك من الإعدادات › Google Drive وOneDrive.",
 "Para hoje": "إلى اليوم",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "لقراءة الصور أو PDF، فعّل ذكاءك الاصطناعي من الإعدادات › الذكاء الاصطناعي (Claude أو ChatGPT أو Gemini). كشف الحساب بصيغة OFX أو CSV يعمل دون ذكاء اصطناعي.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "لقراءة الساعة تلقائيًا، ثبّت الإصدار الجديد من التطبيق (0.33). وحتى ذلك الحين، يمكنك الإدخال يدويًا.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "لقراءة الساعة، اربطها من التطبيق على الهاتف. ستظهر الأرقام هنا أيضًا.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "لقراءة الساعة، اسمح لـ My Planner بالوصول إلى بيانات النشاط.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "لقراءة النص وتلخيصه وطرح الأسئلة، فعّل الذكاء الاصطناعي الخاص بك من الإعدادات › الذكاء الاصطناعي (Claude أو ChatGPT أو Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "للتشغيل، استخدم التطبيق على الهاتف (الإعدادات > تقويم Google). بعد ذلك سيظهر كل شيء هنا أيضًا.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "للتفعيل، استخدم التطبيق على الهاتف (الإعدادات › الإعدادات العامة › تقويم Google). بعد ذلك سيظهر كل شيء هنا أيضًا.",
 "Para monitorar a OAB, informe o número e a UF.": "لمراقبة OAB، أدخل الرقم والولاية.",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "لعدم السؤال مجددًا، اختر التطبيق من الإعدادات › الإعدادات العامة.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "للمختصين الصحيين: المرضى، تطور الحالة في الخزنة، وصفات بالقوالب، المالية، إيصال وإفادة للاسترداد بصيغة PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "للمختصين الصحيين: المرضى، تطور الحالة، وصفات بالقوالب، المالية مع التأمين، إيصال وإفادة للاسترداد.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "لحماية حسابك، نؤكّد هاتفك مرة واحدة برمز عبر WhatsApp. ولا يُطلب مرة أخرى إلا إذا غيّرت رقمك.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "لمن يؤجر عقارًا أو غرفة لفترات قصيرة (Airbnb أو Booking أو مباشرة): الحجوزات والتنظيف والمصروفات وربح كل شهر.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "لتلقي جدول الحدث ومكانه وتنبيهاته على هاتفك، انضم إلى المجموعة: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "للمزامنة، اسمح لـ My Planner بالوصول إلى التقويم من إعدادات الهاتف.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "لإلغاء إذن سبق أن منحته للنظام (الكاميرا، الصور، الميكروفون)، استخدم أيضًا إعدادات الهاتف.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "لقراءة أشمل، فعّل الذكاء الاصطناعي الخاص بك من الإعدادات › الذكاء الاصطناعي.",
 "Parabéns": "مبروك",
 "Parabéns!": "مبروك!",
 "Parada": "ثابت",
 "Parar": "إيقاف",
 "Parar de compartilhar?": "إيقاف المشاركة؟",
 "Parar e salvar": "إيقاف وحفظ",
 "Parar gravação": "إيقاف التسجيل",
 "Parcela": "قسط",
 "Parcela de financiamento": "قسط تمويل",
 "Parcela {n}/{t}": "القسط {n}/{t}",
 "Parcela {n}/{t} · {c}": "القسط {n}/{t} · {c}",
 "Parcelas": "الأقساط",
 "Parcelas a pagar nos próximos meses": "الأقساط المستحقة في الأشهر القادمة",
 "Parcelas recalculadas": "أُعيد حساب الأقساط",
 "Parece que foi impresso e escaneado.": "يبدو كأنه طُبع ثم مُسح ضوئيًا.",
 "Parei": "توقفت",
 "Parei na aula": "توقفت عند الدرس",
 "Parei na aula...": "توقفت عند الدرس...",
 "Pares de meia": "أزواج جوارب",
 "Parque ou natureza": "حديقة أو طبيعة",
 "Parques": "حدائق",
 "Parte": "طرف",
 "Partes": "الأطراف",
 "Participa": "مشارك",
 "Participantes": "المشاركون",
 "Participação em empresa": "حصة في شركة",
 "Passa do limite do MEI: fale com seu contador.": "يتجاوز حد MEI: تحدّث مع محاسبك.",
 "Passaporte": "جواز السفر",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "مرّر إصبعك على الرسم لمسح ذلك الجزء فقط.",
 "Passeio": "جولة",
 "Passeios": "الجولات",
 "Passo a passo": "خطوة بخطوة",
 "Passos": "الخطوات",
 "Passos, exercício, calorias, batimentos e sono": "الخطوات، التمرين، السعرات، نبض القلب والنوم",
 "Passou do orçamento": "تجاوز الميزانية",
 "Passou do orçamento em {v}": "تجاوز الميزانية بمقدار {v}",
 "Pasta": "مجلد",
 "Patrimônio": "الممتلكات",
 "Patrimônio & Imposto de Renda": "الممتلكات وضريبة الدخل",
 "Patrimônio pelo valor de compra: {v}": "الممتلكات بسعر الشراء: {v}",
 "Pausa (s)": "الراحة (ث)",
 "Pausa de {m} min": "استراحة {m} د",
 "Pausado": "متوقف مؤقتًا",
 "Pausar": "إيقاف مؤقت",
 "Pausas": "الاستراحات",
 "Pausas de estudo": "استراحات الدراسة",
 "Pauta (opcional)": "جدول الأعمال (اختياري)",
 "Paz": "سلام",
 "Pediatra": "طبيب الأطفال",
 "Pedido": "طلب",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "تم إرسال الطلب إلى {nome}. عند القبول يمكنكما التحدث.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "تم إرسال الطلب. عندما يقبل الشخص يمكنكما التحدث.",
 "Pedidos de documentos": "طلبات المستندات",
 "Pedir de novo depois de": "الطلب مجددًا بعد",
 "Peguei emprestado": "استعرتُ",
 "Peito de frango": "صدر الدجاج",
 "Peixe": "سمكة",
 "Pela última compra: cerca de {v}": "حسب آخر شراء: حوالي {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "بحسب المدفوعات المتبقية هذا الشهر، سينقصك {v}. انظر ما يمكن تأجيله أو تقليصه قبل أي مصروف جديد.",
 "Pendente": "بانتظار الرد",
 "Pensão alimentícia": "النفقة",
 "Pequena": "صغيرة",
 "Pequeno": "صغير",
 "Percentual de tributos do Simples (para sair na nota)": "نسبة ضرائب Simples (لتظهر في الفاتورة)",
 "Perguntar ao Mestre": "اسأل Mestre",
 "Perguntar sempre": "السؤال دائمًا",
 "Pergunte ao Mestre...": "اسأل Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "اسأل عن المستند (مثلًا: ما هو الموعد النهائي؟)",
 "Permissões": "الأذونات",
 "Personalizado": "مخصص",
 "Perto do limite do orçamento": "قريب من حد الميزانية",
 "Período": "الفترة",
 "Período da meta": "مدة الهدف",
 "Pescoço: inclinar para os lados": "الرقبة: إمالة إلى الجانبين",
 "Peso": "الوزن",
 "Peso na média": "الوزن في المعدل",
 "Pesquisar no mapa": "البحث في الخريطة",
 "Pessoa": "شخص",
 "Pessoa de contato": "الشخص المسؤول للتواصل",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "يرى أعضاء مجموعاتك فقط ما تتم مشاركته في المجموعة.",
 "Pet": "حيوان أليف",
 "Pet & Família": "الحيوانات الأليفة والعائلة",
 "Pet shop": "متجر الحيوانات",
 "Pet shop ou clínica": "متجر الحيوانات أو العيادة",
 "Pets": "الحيوانات الأليفة",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "اطلب مستندات من العميل مع موعد نهائي. يتلقّى الطلب ويرفق الملف ويضع علامة التسليم.",
 "Pijamas": "ملابس النوم",
 "Pilates": "بيلاتس",
 "Pintura": "الدهان",
 "Pix copia e cola": "Pix للنسخ واللصق",
 "Placa": "اللوحة",
 "Planejado": "المخطط",
 "Planejado e comido": "المخطط وما تم تناوله",
 "Planilha": "جدول بيانات",
 "Planilha (Excel)": "جدول بيانات (Excel)",
 "Planilha do mês para o Receita Saúde": "جدول الشهر لـ Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "الخطة الأساسية: My Planner + الملاحظات",
 "Plano de aula": "خطة الدرس",
 "Plano de saúde": "التأمين الصحي",
 "Planos de aula": "خطط الدروس",
 "Planta": "نبتة",
 "Plantas": "النباتات",
 "Plantas & Jardim": "النباتات والحديقة",
 "Plataforma ou escola": "المنصة أو المدرسة",
 "Pneus novos": "إطارات جديدة",
 "Podcast": "بودكاست",
 "Pode confirmar sua presença respondendo esta mensagem?": "هل يمكنك تأكيد حضورك بالرد على هذه الرسالة؟",
 "Polichinelo": "القفز المفتوح",
 "Polo ativo": "الطرف المدّعي",
 "Polo passivo": "الطرف المدّعى عليه",
 "Política de privacidade (LGPD)": "سياسة الخصوصية (LGPD)",
 "Política de privacidade, LGPD e permissões": "سياسة الخصوصية وLGPD والأذونات",
 "Política de privacidade, LGPD e termos": "سياسة الخصوصية وLGPD والشروط",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "ضع هنا صور الرحلة ومقاطع الفيديو. في المجموعة يراها الجميع ويمكن للجميع إضافة صورهم.",
 "Ponte de glúteos": "جسر الأرداف",
 "Ponto facultativo": "عطلة اختيارية",
 "Ponto facultativo: {nome}": "عطلة اختيارية: {nome}",
 "Ponto turístico": "معلم سياحي",
 "Pontos turísticos": "معالم سياحية",
 "Por dia": "يوميًا",
 "Por faixas": "حسب النطاقات",
 "Por mês": "شهريًا",
 "Por nome": "حسب الاسم",
 "Por semana": "أسبوعيًا",
 "Portal": "البوابة",
 "Portal do Cliente": "بوابة العميل",
 "Portal do cliente (convidar o cliente)": "بوابة العميل (دعوة العميل)",
 "Português": "البرتغالية",
 "Porão": "القبو",
 "Porções": "الحصص",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "مساحة حرة قليلة: قد لا تُحفظ الصور والمرفقات الجديدة. حرّر مساحة أو احفظ المرفقات على Google Drive أو OneDrive.",
 "Praia": "شاطئ",
 "Prancha": "البلانك",
 "Prato do cardápio": "طبق من القائمة",
 "Prato principal": "الطبق الرئيسي",
 "Prazo": "مهلة",
 "Prazo (pagamento ou entrega)": "الموعد النهائي (دفع أو تسليم)",
 "Prazo até {fim} · fazer em {dia}": "المهلة حتى {fim} · أنجزها في {dia}",
 "Prazo final: {fim}": "نهاية المهلة: {fim}",
 "Prazo: {d}": "المهلة: {d}",
 "Prazo: {t}": "الموعد النهائي: {t}",
 "Prazos criados": "تم إنشاء المواعيد",
 "Precisa da sua IA": "يحتاج إلى ذكائك الاصطناعي",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "املأ الوصف ورمز الضريبة الوطني (6 أرقام) والقيمة.",
 "Preenche os campos do PDF e, se quiser, trava.": "يملأ حقول PDF ويقفلها إن أردت.",
 "Preencher formulário": "ملء النموذج",
 "Preencher pela foto com a minha IA": "الملء من الصورة بالذكاء الاصطناعي الخاص بي",
 "Preencher pela nota fiscal com a minha IA": "املأ من الفاتورة باستخدام ذكائي الاصطناعي",
 "Preparando a conversa da equipe...": "جارٍ تجهيز محادثة الفريق...",
 "Preparando a página {n} de {total}...": "جارٍ تجهيز الصفحة {n} من {total}...",
 "Preparando o arquivo": "جارٍ تجهيز الملف",
 "Prescrição, conduta e orientações": "الوصفة والإجراء والتعليمات",
 "Presente": "حاضر",
 "Presença": "الحضور",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "اضغط مطولًا على الرمز لنسخه، أو اضغط إرسال واختر \"نسخ\".",
 "Pressione e segure o código para copiar.": "اضغط مطولًا على الرمز لنسخه.",
 "Pressione e segure um lançamento para apagar.": "اضغط مطولًا على قيد لحذفه.",
 "Pressione e segure um perfil para removê-lo.": "اضغط مطولًا على ملف شخصي لإزالته.",
 "Preto e branco": "أبيض وأسود",
 "Previdência privada": "التقاعد الخاص",
 "Preço ou ingresso": "السعر أو التذكرة",
 "Price": "أقساط متساوية (Price)",
 "Primeira": "الأولى",
 "Primeira cota ou cota única do IR": "القسط الأول أو الدفعة الواحدة لـ IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "القسط الأول في كشف {mes}، المستحق في {data}.",
 "Prioridade": "الأولوية",
 "Privacidade": "الخصوصية",
 "Privacidade e termos": "الخصوصية والشروط",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "الخصوصية: يُرسَل النص أو الصورة المحلَّلة مباشرة من هذا الجهاز إلى شركة الذكاء الاصطناعي المختارة، بمفتاحك. لا يحتفظ My Planner بأي نسخة.",
 "Problema": "مشكلة",
 "Problemas, erros e sugestões": "المشكلات والأخطاء والاقتراحات",
 "Procedimento": "إجراء",
 "Procedimento: {c}": "الإجراء: {c}",
 "Processo": "الدعوى",
 "Processo Civil": "الإجراءات المدنية",
 "Processo Penal": "الإجراءات الجنائية",
 "Processo do Trabalho": "الإجراءات العمالية",
 "Processo não informado": "رقم الدعوى غير مذكور",
 "Proclamação da República": "ذكرى إعلان الجمهورية",
 "Procurando a folha...": "جارٍ البحث عن الورقة...",
 "Procurando atualização...": "جارٍ البحث عن تحديث...",
 "Procurar aba": "البحث عن تبويب",
 "Procurar atualização agora": "البحث عن تحديث الآن",
 "Procurar documento": "البحث عن مستند",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "ابحث عن أداة (مثال: دمج، توقيع، ضغط)",
 "Produto": "المنتج",
 "Produto (ex.: Geladeira)": "المنتج (مثال: ثلاجة)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "المنتجات، والفواتير، ومراكز الصيانة، وتنبيه قبل انتهاء الضمان.",
 "Produção (vale de verdade)": "الإنتاج (سارية فعليًا)",
 "Produção restrita (teste)": "الإنتاج المقيّد (اختبار)",
 "Produção restrita (teste, não vale)": "الإنتاج المقيّد (اختبار، غير سارية)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "الإنتاج المقيّد: بيئة الاختبار الحكومية. الفواتير غير سارية. اختبر كل شيء هنا قبل التحويل إلى الإنتاج (من تعديل).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "الإنتاج: الفواتير الصادرة سارية فعليًا وتُرسل إلى البلدية وإلى Receita.",
 "Produção: vale de verdade": "الإنتاج: سارية فعليًا",
 "Professor": "المعلم",
 "Professor & Mentoria": "المعلم والإرشاد",
 "Professor(a)": "المعلم/المعلمة",
 "Profissionais": "العمّال",
 "Profissional": "عامل/فني",
 "Profissional assistente": "أخصائي مساعد",
 "Profissional ou fornecedor": "فني أو مورّد",
 "Profissional ou local": "مختص أو مكان",
 "Profissão ou especialidade": "المهنة أو التخصص",
 "Profissões": "المهن",
 "Programação": "البرمجة",
 "Progresso geral": "التقدم العام",
 "Projeto e licenças": "التصميم والتراخيص",
 "Projetos": "المشاريع",
 "Prontas": "جاهزة",
 "Pronto": "تم",
 "Pronto! Todas as abas estão liberadas até {data}.": "تم! جميع التبويبات مفتوحة حتى {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "تم. اقفل الشاشة وانتظر دقيقة واحدة: يجب أن يظهر التنبيه مع صوت.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "الملف الطبي والتطور والوصفات، دون الجانب المالي.",
 "Protegendo a chave...": "جارٍ حماية المفتاح...",
 "Proteger no cofre": "حماية في الخزنة",
 "Protegido": "محمي",
 "Protegido no cofre": "محمي في الخزنة",
 "Protegidos pelo cofre: {n}": "محمية بالخزنة: {n}",
 "Protetor solar": "واقي الشمس",
 "Protocolo": "رقم البروتوكول",
 "Prova": "اختبار",
 "Próxima": "التالي",
 "Próxima até a data": "التالية بحلول تاريخ",
 "Próxima com quantos km": "التالية عند كم كيلومتر",
 "Próxima dose": "الجرعة التالية",
 "Próxima: {data}": "التالية: {data}",
 "Próxima: {d} · {v}": "القادم: {d} · {v}",
 "Próximas": "القادمة",
 "Próximo": "التالي",
 "Próximo ano": "السنة التالية",
 "Próximo número da DPS": "رقم DPS التالي",
 "Próximos 7 dias": "الأيام الـ7 القادمة",
 "Próximos vencimentos ({n})": "المواعيد القادمة ({n})",
 "Publicação": "نشرة قضائية",
 "Publicações": "النشرات القضائية",
 "Pula": "يقفز",
 "Pulsa": "ينبض",
 "Punho": "قبضة",
 "Puxada frontal": "السحب الأمامي",
 "PÁGINAS": "الصفحات",
 "PÔR NA BARRA": "ضعه في الشريط",
 "Pág. {n}": "ص {n}",
 "Página": "صفحة",
 "Página 1": "صفحة 1",
 "Página 1 de 10": "صفحة 1 من 10",
 "Página em branco no fim": "صفحة فارغة في النهاية",
 "Página em que estou": "الصفحة التي وصلت إليها",
 "Página escaneada": "تم مسح الصفحة",
 "Página inteira": "صفحة كاملة",
 "Página {a} de {n}": "الصفحة {a} من {n}",
 "Página {n}": "الصفحة {n}",
 "Página {n} de {total}": "الصفحة {n} من {total}",
 "Página: {titulo}": "الصفحة: {titulo}",
 "Páginas": "الصفحات",
 "Páginas, tamanho, autor, datas e campos.": "الصفحات والحجم والمؤلف والتواريخ والحقول.",
 "Pássaro": "طائر",
 "Pão francês": "خبز فرنسي صغير",
 "Pão integral": "خبز أسمر",
 "Pôr a data de hoje": "إضافة تاريخ اليوم",
 "Pôr as parcelas no My Planner": "إضافة الأقساط إلى My Planner",
 "Pôr na barra": "ضعه في الشريط",
 "Pôr no roteiro da viagem": "إضافة إلى برنامج الرحلة",
 "Pôr uma foto": "إضافة صورة",
 "Quadro": "اللوحة",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "لوحة Kanban، ومؤقّت الساعات لكل عميل، والمواعيد النهائية في My Planner.",
 "Quais contas vencem nos próximos dias?": "ما المدفوعات المستحقة في الأيام القادمة؟",
 "Quais páginas ficam no PDF novo": "الصفحات التي تبقى في PDF الجديد",
 "Quais páginas sair": "الصفحات المراد حذفها",
 "Qual IA": "أي ذكاء اصطناعي",
 "Qualidade alta": "جودة عالية",
 "Qualidade boa (menor)": "جودة جيدة (أصغر)",
 "Quantidade": "الكمية",
 "Quanto cortar de cada lado (% da página)": "مقدار القص من كل جانب (% من الصفحة)",
 "Quanto já tem guardado (opcional)": "المدّخر حاليًا (اختياري)",
 "Quanto paga por limpeza": "الأجر لكل تنظيف",
 "Quanto preciso guardar por mês para as minhas metas?": "كم أحتاج أن أدّخر شهريًا لأهدافي؟",
 "Quanto quer juntar": "المبلغ الذي تريد جمعه",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "أقصى ما تريد إنفاقه في كل فئة شهريًا. اتركه فارغًا لعدم المراقبة.",
 "Quarta": "الأربعاء",
 "Quarta-feira de Cinzas (até 14h)": "أربعاء الرماد (حتى 14:00)",
 "Quarto": "غرفة النوم",
 "Quarto das crianças": "غرفة الأطفال",
 "Quarto de casal": "غرفة النوم الرئيسية",
 "Quarto de hóspedes": "غرفة الضيوف",
 "Quarto infantil": "غرفة الأطفال",
 "Queijo": "جبن",
 "Queixa principal": "الشكوى الرئيسية",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "من يفتح الرابط ينزّل My Planner (أو يستخدمه في المتصفح)، ويسجّل الدخول، وينضم إلى المجموعة.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "من ينشئ حسابًا باستخدام رمزك يصبح صديقك هنا مباشرةً دون الحاجة إلى طلب.",
 "Quem enviou": "المُرسِل",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "من يشاركك مجموعة في التطبيق (فصل، عائلة، رحلة...) يمكنه التحدث معك دون أن يكون صديقًا. اضغط مطولًا على صديق لإلغاء الصداقة أو الحظر.",
 "Quem faz a limpeza": "من يقوم بالتنظيف",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "من يدفع إن لم يكن المريض (الأم، الأب، ولي الأمر)",
 "Quem pagou": "من دفع",
 "Quem recebeu (médico, escola...)": "المستلم (طبيب، مدرسة...)",
 "Quem vai": "من سيذهب",
 "Quem vai limpar": "من سينظّف",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "من يراها: فقط من يتحدث معك وأصدقاؤك ومن هو في مجموعة في التطبيق معك. اترك فارغًا ما لا تريد إظهاره.",
 "Quente": "حار",
 "Quer escanear mais uma página?": "هل تريد مسح صفحة أخرى؟",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "هل تريد حفظ الإيصال الآن؟ صورة أو PDF أو لقطة شاشة لـ Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "تريد إرسال لقطة شاشة؟ أرسلها بالبريد الإلكتروني وأرفق الصورة.",
 "Quer trocar pelos novos ou manter os dois?": "هل تريد استبدالها بالجديدة أم الإبقاء على الاثنين؟",
 "Quero assistir": "أريد مشاهدته",
 "Quero ir": "أريد الذهاب",
 "Quero ler": "أريد قراءته",
 "Quero ver": "أريد مشاهدته",
 "Quilometragem atual": "عدد الكيلومترات الحالي",
 "Quilometragem: {km}": "الكيلومترات: {km}",
 "Quinta": "الخميس",
 "Quintal": "الفناء الخلفي",
 "Quitado": "مسدَّد",
 "Quitados": "المسدَّدة",
 "Química": "الكيمياء",
 "RECIBO": "إيصال",
 "RG / Carteira de identidade": "بطاقة الهوية (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "الهوية ورخصة القيادة وجواز السفر والعقود والشهادات، مع تنبيه قبل الانتهاء وإرسال بلمسة واحدة.",
 "Raciocínio Lógico": "الاستدلال المنطقي",
 "Razão social ou nome": "الاسم التجاري أو الاسم",
 "Razão social ou nome do consultório": "الاسم التجاري أو اسم العيادة",
 "Razão social ou nome fantasia": "الاسم القانوني أو الاسم التجاري",
 "Raça": "السلالة",
 "Realizado": "تمت",
 "Recado": "رسالة",
 "Recalcular": "إعادة الحساب",
 "Recalcular as parcelas em aberto": "إعادة حساب الأقساط غير المدفوعة",
 "Recalcular as parcelas?": "إعادة حساب الأقساط؟",
 "Receber": "تحصيل",
 "Receber de volta: {i} ({p})": "استرداد: {i} ({p})",
 "Receber o código no WhatsApp": "استلام الرمز عبر WhatsApp",
 "Receber parcela {n}/{t} · {c}": "استلام القسط {n}/{t} · {c}",
 "Recebeu um convite?": "هل تلقيت دعوة؟",
 "Recebeu um código?": "هل حصلت على رمز؟",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "استلمتُ من {pagador}{doc} مبلغ {valor}{extenso}، مقابل {tipo} تمت في {data}{paciente}.",
 "Recebi outro valor": "استلمت مبلغًا آخر",
 "Recebida": "واردة",
 "Recebida (toque para desfazer)": "محصَّلة (اضغط للتراجع)",
 "Recebidas": "المستلَمة",
 "Recebido": "تم الاستلام",
 "Recebido: {v}": "المستلَم: {v}",
 "Recebidos": "الواردة",
 "Recebidos dos grupos": "الواردة من المجموعات",
 "Recebimento": "تحصيل",
 "Receita": "وصفة",
 "Receitas": "الوصفات",
 "Recibo": "إيصال",
 "Recibo em PDF": "إيصال PDF",
 "Recibo emitido": "صدر الإيصال",
 "Recibo guardado": "تم حفظ الإيصال",
 "Recibos dedutíveis": "الإيصالات القابلة للخصم",
 "Recomendada": "موصى بها",
 "Recomeçar": "البدء من جديد",
 "Recortar": "قص",
 "Recortar margens": "قص الهوامش",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "القص والتدوير والفلاتر قادمة مع التطبيق الجديد (الإصدار 0.49).",
 "Recusada": "مرفوضة",
 "Recusado": "مرفوض",
 "Recusar": "رفض",
 "Redação": "التعبير الكتابي",
 "Refazer": "إعادة",
 "Refeição": "وجبة",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "الوجبات والتمارين والعناية والمكملات المقررة لليوم",
 "Referente a": "بخصوص",
 "Referência": "مرجع",
 "Reforço": "جرعة معزِّزة",
 "Regar a cada quantos dias": "الري كل كم يومًا",
 "Regar hoje": "اسقِها اليوم",
 "Regar: {p}": "ري: {p}",
 "Regional": "إقليمي",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "يسجّل اليوميات والمراحل والتسليمات، دون رؤية المبالغ.",
 "Registrar venda/serviço do MEI": "تسجيل بيع/خدمة MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "سجّل كل زيارة: يُحفظ تطور الحالة في الخزنة مشفّرًا. يمكن أخذ الوصفة من قالب.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "سجّل عمليات شراء وبيع العقارات والمركبات والاستثمارات مع الإثباتات. يفيد كثيرًا عند الإقرار الضريبي.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "سجّل ما اختلف عن الجدول (استبدلت طعامًا، غيّرت الوجبة). يُضاف إلى تقرير الأسبوع.",
 "Registro": "سجل",
 "Registro clínico": "سجل طبي",
 "Registro de horas": "سجل الساعات",
 "Registro do diário": "سجل اليوميات",
 "Regiões com feriado próprio (marque as suas):": "مناطق لها عطلات خاصة (حدد مناطقك):",
 "Regras da casa": "قواعد المنزل",
 "Regras da casa:": "قواعد المنزل:",
 "Reguei": "سقيتها",
 "Reguei hoje": "سقيتها اليوم",
 "Reiniciar": "إعادة التشغيل",
 "Reiniciar o app": "إعادة تشغيل التطبيق",
 "Relatório": "التقرير",
 "Relatório da semana": "تقرير الأسبوع",
 "Relatório em PDF ou Excel": "تقرير PDF أو Excel",
 "Relatório enviado. Obrigado!": "تم إرسال التقرير. شكرًا!",
 "Relatórios": "التقارير",
 "Relatórios do Bem-Estar": "تقارير العافية",
 "Relatórios gerados ({n})": "التقارير المُنشأة ({n})",
 "Relaxar": "استرخاء",
 "Religião": "دين",
 "Relógio": "الساعة",
 "Relógio e apps de saúde": "الساعة وتطبيقات الصحة",
 "Remada baixa": "التجديف السفلي",
 "Remover": "إزالة",
 "Remover \"{nome}\"?": "إزالة \"{nome}\"؟",
 "Remover anotações": "إزالة التعليقات التوضيحية",
 "Remover este bloco?": "إزالة هذه الكتلة؟",
 "Remover páginas": "حذف صفحات",
 "Remover vínculo": "إزالة الربط",
 "Remover {nome}?": "إزالة {nome}؟",
 "Remédio": "دواء",
 "Remédio contínuo": "دواء مستمر",
 "Remédio na linha do tempo": "الدواء في الخط الزمني",
 "Remédios": "الأدوية",
 "Remédios de uso contínuo": "الأدوية المستمرة",
 "Renavam ou chassi": "Renavam أو رقم الهيكل",
 "Renegociado": "أُعيدت جدولته",
 "Renomear": "إعادة التسمية",
 "Renomear com IA": "إعادة التسمية بالذكاء الاصطناعي",
 "Renomear ou trocar ícone": "إعادة التسمية أو تغيير الرمز",
 "Renomear pasta": "إعادة تسمية المجلد",
 "Renomear, ícone ou cor": "إعادة التسمية أو الرمز أو اللون",
 "Renovar: {nome}": "تجديد: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "يعيد ترتيب الملف من الداخل. فائدته قليلة مع ملفات PDF التي تحتوي على صور.",
 "Reparar PDF": "إصلاح PDF",
 "Repelente": "طارد الحشرات",
 "Repete": "التكرار",
 "Repetir a cada quantos dias": "التكرار كل كم يومًا",
 "Repetições": "التكرارات",
 "Repita a senha": "أعد كتابة كلمة المرور",
 "Repita a senha do cofre": "أعد كتابة كلمة مرور الخزنة",
 "Repita a senha nova": "أعد كتابة كلمة المرور الجديدة",
 "Replantio": "إعادة الزراعة",
 "Replantios": "إعادات الزراعة",
 "Repor papel higiênico, sabonete e café": "إعادة تعبئة ورق الحمّام والصابون والقهوة",
 "Representatividade": "التنوع والتمثيل",
 "Reserva": "حجز",
 "Reservas": "الحجوزات",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "الحجوزات والتنظيف والإيرادات والمصروفات في تبويب الإيجار والاستضافة",
 "Respirar fundo 5 vezes": "تنفّس بعمق 5 مرات",
 "Respondendo a {nome}": "الرد على {nome}",
 "Responder": "رد",
 "Responsável": "المسؤول",
 "Responsável (imobiliária, vistoriador)": "المسؤول (الوكالة العقارية، المعاين)",
 "Resposta da SEFAZ": "ردّ SEFAZ",
 "Resta {tempo}": "متبقٍ {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "المتبقي {ml} = {n} كوب/أكواب من {copo}",
 "Restaurante": "مطعم",
 "Restaurantes": "مطاعم",
 "Restaurar": "استعادة",
 "Restaurar esta cópia?": "استعادة هذه النسخة؟",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "الاستعادة تستبدل جميع البيانات الحالية ببيانات النسخة، هنا وفي حسابك.",
 "Restaurar uma cópia": "استعادة نسخة",
 "Resultado": "النتيجة",
 "Resultado nas vendas: {v}": "نتيجة المبيعات: {v}",
 "Resumir": "تلخيص",
 "Resumir e perguntar": "تلخيص وسؤال",
 "Resumo": "الملخص",
 "Resumo (falta o XML completo)": "ملخّص (XML الكامل غير موجود)",
 "Resumo da manhã": "ملخص الصباح",
 "Resumo da pasta": "ملخّص المجلد",
 "Resumo e opinião": "الملخص والرأي",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "الملخص، المصروفات حسب الفئة، المدفوعات، الكشوف، الأهداف وكل الحركات. مناسب لإرساله إلى المحاسب أو حفظه لـ IR.",
 "Retirar": "سحب",
 "Retirar da meta": "سحب من الهدف",
 "Retorno": "موعد المتابعة",
 "Reunião": "اجتماع",
 "Reunião agora": "اجتماع الآن",
 "Reunião de equipe": "اجتماع الفريق",
 "Reuniões": "الاجتماعات",
 "Revestimento e pisos": "التكسيات والأرضيات",
 "Revisão": "الصيانة الدورية",
 "Revolução Constitucionalista": "ذكرى الثورة الدستورية",
 "Rico em matéria orgânica": "غنية بالمواد العضوية",
 "Rodízio de pneus": "تدوير الإطارات",
 "Roedor": "قارض",
 "Romance": "رومانسي",
 "Rosca direta": "ثني الذراعين بالبار",
 "Rota": "المسار",
 "Rota passando pelos {n} lugares que faltam": "مسار يمر بالأماكن الـ {n} المتبقية",
 "Rotas e mapas": "المسارات والخرائط",
 "Roteiro": "البرنامج",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "برنامج يومي يدخل الخط الزمني أثناء الرحلة، وحقيبة حسب الطقس، والحجوزات، والمناطق الزمنية.",
 "Rotina": "روتين",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "روتين خطوة بخطوة: العناية بالبشرة، الإطالة، الشعر... اضغط على \"+ عناية\" لاختيار نموذج أو إنشاء روتينك.",
 "Roupa": "ملابس",
 "Roupa social": "ملابس رسمية",
 "Roupas de banho": "ملابس السباحة",
 "Roupas extras das crianças": "ملابس إضافية للأطفال",
 "Roupas íntimas": "الملابس الداخلية",
 "Rua": "الشارع",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "الشارع، الرقم، الحي، المدينة (أو اسم المكان)",
 "Régua": "مسطرة",
 "Réptil": "زاحف",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "التسمية (مثال: اسمي، شركة العميل)",
 "SAC": "أصل ثابت (SAC)",
 "SEM HORÁRIO": "بدون وقت",
 "SEU MÊS EM NÚMEROS": "شهرك بالأرقام",
 "SEU TREINO": "تمرينك",
 "SEUS GRUPOS DO APP": "مجموعاتك في التطبيق",
 "SP": "SP",
 "SUBTAREFA": "مهمة فرعية",
 "SUBTAREFAS": "المهام الفرعية",
 "SUPLEMENTAÇÃO": "المكمّلات",
 "Sabonete facial": "غسول الوجه",
 "Sabão para lavar roupa": "مسحوق الغسيل",
 "Sacada": "الشرفة",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "يُزال فقط من قائمة هذا التطبيق. تبقى النسخة المحفوظة في Drive أو OneDrive أو مجلد الهاتف كما هي.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "يُزال من القائمة فقط. يبقى الملف حيث حُفظ.",
 "Sair": "تسجيل الخروج",
 "Sair da conta?": "تسجيل الخروج من الحساب؟",
 "Sair do escritório": "مغادرة المكتب",
 "Sair do escritório?": "مغادرة المكتب؟",
 "Sair do grupo": "مغادرة المجموعة",
 "Sair do grupo?": "مغادرة المجموعة؟",
 "Sair sem baixar": "الخروج دون تنزيل",
 "Saiu": "خرج",
 "Sala": "الصالة",
 "Sala de estar": "غرفة المعيشة",
 "Sala de jantar": "غرفة الطعام",
 "Sala virtual": "قاعة افتراضية",
 "Salada": "سلطة",
 "Saldo": "الرصيد",
 "Saldo depois desta parcela": "الرصيد بعد هذا القسط",
 "Saldo devedor: {v}": "الرصيد المتبقي: {v}",
 "Saldo do mês": "رصيد الشهر",
 "Salvar": "حفظ",
 "Salvar backup do My Planner": "حفظ نسخة احتياطية من My Planner",
 "Salvar cuidado": "حفظ العناية",
 "Salvar cômodo": "حفظ الغرفة",
 "Salvar e colocar no My Planner": "حفظ وإضافة إلى My Planner",
 "Salvar e sincronizar": "حفظ ومزامنة",
 "Salvar e testar": "حفظ واختبار",
 "Salvar endereço": "حفظ العنوان",
 "Salvar no My Planner": "حفظ في My Planner",
 "Salvar refeição": "حفظ الوجبة",
 "Salvar suplemento": "حفظ المكمّل",
 "Salvar tarefa": "حفظ المهمة",
 "Salvar treino": "حفظ التمرين",
 "Sanduíche natural": "ساندويتش صحي",
 "Santo Antônio": "القديس أنطونيوس",
 "Sapato confortável": "حذاء مريح",
 "Saudade": "اشتقت لك",
 "Saída (imóvel antigo)": "الخروج (المسكن القديم)",
 "Saída de praia": "رداء الشاطئ",
 "Saúde": "الصحة",
 "Saúde & Prontuário": "الصحة والملف الطبي",
 "Saúde (médicos, dentistas, exames, plano)": "الصحة (الأطباء، أطباء الأسنان، الفحوصات، التأمين الصحي)",
 "Saúde e bem-estar": "الصحة والعافية",
 "Scanner": "الماسح",
 "Scanner PDF": "ماسح PDF",
 "Sci-Fi": "خيال علمي",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "إذا لم يستجب شيء، أعد تشغيل التطبيق. بياناتك محفوظة.",
 "Se der tempo": "إن سمح الوقت",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "إذا تغيرت هذه السياسة تغييرًا مهمًا، فسيُعلمك التطبيق ويطلب موافقتك مجددًا.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "إذا ظهر هذا التنبيه، فإن تنبيهات المواعيد تعمل.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "إذا كان هناك حساب مرتبط بـ {email}، فقد أرسلنا رابطًا لإنشاء كلمة مرور جديدة. تحقق أيضًا من مجلد الرسائل غير المرغوب فيها.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "إذا تأخّر التنبيه أو لم يظهر: في إعدادات التطبيق، أبقِ الإشعارات مفعّلة، واجعل البطارية \"غير مقيّد\"، واسمح بـ\"المنبّهات والتذكيرات\".",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "إذا كانت الساعة مربوطة، تحلّ أرقامها محل الأرقام المُدخلة يدويًا عندما تتوفر لديها البيانات.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "إذا ربطت الساعة: إجماليات يومية للخطوات والمسافة والسعرات والتمرين ونبض القلب والنوم، تُقرأ من Health Connect (Android) أو من تطبيق صحتي (iPhone). التطبيق يقرأ فقط ولا يغيّر هذه البيانات أبدًا.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "إذا كنت قد استخدمت هذا التبويب من قبل، فلم يُحذف شيء: يعود كل شيء كما كان عند الاشتراك.",
 "Secretária ou recepção": "سكرتارية أو استقبال",
 "Seg a sex": "الإثنين–الجمعة",
 "Seguir": "متابعة",
 "Segunda": "الإثنين",
 "Segurança": "الأمان",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "اضغط مطولًا واسحب لتغيير الترتيب. ↻ يدوّر، ⧉ يكرّر و✕ يحذف الصفحة.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "اضغط مطولًا على GIF في محادثة ثم اضغط على \"حفظ\" ليظهر هنا.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "اضغط مطولًا على غرفة لتغيير مكانها. وعند فتح الغرفة، اضغط مطولًا على مهمة وأفلتها في غرفة أخرى لنقلها.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "اضغط مطولًا على مجلد أو مادة أو صفحة لتغيير الترتيب. أفلت مادة في مجلد آخر لنقلها إليه.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "اضغط مطوّلًا على محادثة لكتمها أو أرشفتها. المحادثة المؤرشفة تظل تستقبل وترسل، لكن دون إشعار.",
 "Seguro": "تأمين",
 "Seguro da casa": "تأمين المنزل",
 "Seguro viagem": "تأمين السفر",
 "Selecionar": "تحديد",
 "Sem": "بدون",
 "Sem alerta": "بدون تنبيه",
 "Sem categoria": "بدون فئة",
 "Sem comprovante": "بدون إثبات دفع",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "لا يوجد اتصال بخادم الفواتير. تحقّق من الإنترنت وعنوان الخادم.",
 "Sem conexão com o servidor. Confira a internet.": "لا يوجد اتصال بالخادم. تحقّق من الإنترنت.",
 "Sem conexão com os GIFs agora.": "لا يوجد اتصال بصور GIF الآن.",
 "Sem cômodo": "بدون غرفة",
 "Sem data de fim": "بدون تاريخ انتهاء",
 "Sem exercícios": "لا توجد تمارين",
 "Sem fatura em {mes}": "لا يوجد كشف في {mes}",
 "Sem fim": "بلا نهاية",
 "Sem horário": "بدون وقت",
 "Sem internet ou servidor ainda não preparado.": "لا يوجد إنترنت أو الخادم غير جاهز بعد.",
 "Sem internet. Envia quando voltar.": "لا يوجد إنترنت. سيُرسل عند عودة الاتصال.",
 "Sem internet. Tente de novo.": "لا يوجد اتصال بالإنترنت. حاول مرة أخرى.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "بدون هذا، يغطي الشريط فقط: يبقى النص تحته في الملف ويمكن نسخه.",
 "Sem itens": "لا توجد عناصر",
 "Sem juros": "بدون فوائد",
 "Sem limite": "بلا حد",
 "Sem link de calendário": "لا يوجد رابط تقويم",
 "Sem margem": "بلا هامش",
 "Sem nome": "بلا اسم",
 "Sem número na primeira página (capa)": "بلا رقم في الصفحة الأولى (الغلاف)",
 "Sem pasta": "بدون مجلد",
 "Sem pausas": "بدون استراحات",
 "Sem permissão": "لا يوجد إذن",
 "Sem prazo": "بلا مهلة",
 "Sem recibo": "بدون إيصال",
 "Sem tarefas": "لا توجد مهام",
 "Sem texto.": "لا يوجد نص.",
 "Sem tomador identificado": "لم يُحدَّد متلقّي الخدمة",
 "Sem título": "بدون عنوان",
 "Sem validade": "بلا صلاحية",
 "Semana": "الأسبوع",
 "Semana completa": "الأسبوع كاملًا",
 "Semana de {de} a {ate}": "الأسبوع من {de} إلى {ate}",
 "Semanal": "أسبوعي",
 "Semanal · dias úteis": "أسبوعي · أيام العمل",
 "Semanal · todos os dias": "أسبوعي · كل الأيام",
 "Semanal · {dias}": "أسبوعي · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "تظهر دائمًا، مع العطلات الاختيارية (الكرنفال وأربعاء الرماد وعيد جسد المسيح).",
 "Senha": "كلمة المرور",
 "Senha (8 caracteres ou mais)": "كلمة المرور (8 أحرف أو أكثر)",
 "Senha alterada.": "تم تغيير كلمة المرور.",
 "Senha atual": "كلمة المرور الحالية",
 "Senha atual do cofre": "كلمة مرور الخزنة الحالية",
 "Senha da conta": "كلمة مرور الحساب",
 "Senha do certificado": "كلمة مرور الشهادة",
 "Senha do cofre": "كلمة مرور الخزنة",
 "Senha do cofre alterada.": "تم تغيير كلمة مرور الخزنة.",
 "Senha do cofre incorreta.": "كلمة مرور الخزنة غير صحيحة.",
 "Senha incorreta": "كلمة مرور غير صحيحة",
 "Senha incorreta.": "كلمة المرور غير صحيحة.",
 "Senha nova (8 caracteres ou mais)": "كلمة المرور الجديدة (8 أحرف أو أكثر)",
 "Senha nova do cofre (6 caracteres ou mais)": "كلمة مرور جديدة للخزنة (6 أحرف أو أكثر)",
 "Senha, biometria, bloqueio e privacidade": "كلمة المرور والقياسات الحيوية والقفل والخصوصية",
 "Senha, e-mail e formas de desbloquear": "كلمة المرور والبريد الإلكتروني وطرق فتح القفل",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "تجهيز بيانات الدخل (البنوك، صاحب العمل، شركات الوساطة)",
 "Servidor de notas": "خادم الفواتير",
 "Servidor não configurado (lib/config.ts).": "الخادم غير مُهيّأ (lib/config.ts).",
 "Servidor não configurado.": "الخادم غير مُهيّأ.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "الخادم غير مُهيّأ: بيانات Supabase مفقودة في lib/config.ts.",
 "Serviço": "الخدمة",
 "Serviço não prestado": "لم تُقدَّم الخدمة",
 "Serviços": "الخدمات",
 "Será excluída em 1 dia": "سيتم الحذف خلال يوم واحد",
 "Será excluída em {n} dias": "سيتم الحذف خلال {n} يوم",
 "Será excluída hoje": "سيتم الحذف اليوم",
 "Sessão": "جلسة",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "ما زال وصولك بحاجة إلى تفعيل. حاول الدخول بعد قليل.",
 "Seu código": "رمزك",
 "Seu código de amigo": "رمز الصديق الخاص بك",
 "Seu código para amigos ganharem 10 dias com todas as abas": "رمزك ليحصل أصدقاؤك على 10 أيام مع جميع التبويبات",
 "Seu nome": "اسمك",
 "Seu papel: {p}": "دورك: {p}",
 "Seu papel: {p}. {d}": "دورك: {p}. {d}",
 "Seu scanner de bolso": "ماسحك الضوئي في جيبك",
 "Seus dados continuam salvos na nuvem.": "تبقى بياناتك محفوظة في السحابة.",
 "Seus dados na nuvem do My Planner": "بياناتك في سحابة My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "بياناتك ملكك: لا نبيعها ولا نستخدمها في الإعلانات. يمكنك تصدير كل شيء أو حذفه متى شئت.",
 "Seus {n} meses grátis terminaram": "انتهت أشهرك المجانية ({n})",
 "Sexta": "الجمعة",
 "Sextou": "الويكند",
 "Sextou!": "أخيرًا الويكند!",
 "Shampoo": "شامبو",
 "Show ou passeio": "عرض أو جولة",
 "Silenciar avisos": "كتم الإشعارات",
 "Sim": "نعم",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "تمت المزامنة في {data}",
 "Sincronizando pelo dispositivo {nome}": "تتم المزامنة عبر الجهاز {nome}",
 "Sincronizando...": "جارٍ المزامنة...",
 "Sincronizar agora": "المزامنة الآن",
 "Sincronização parada: confirme sua senha. Nada se perde.": "المزامنة متوقفة: أكّد كلمة المرور. لن يضيع شيء.",
 "Site da assistência": "موقع مركز الصيانة",
 "Site da assistência (https://...)": "موقع مركز الصيانة (https://...)",
 "Site ou ingresso online": "موقع أو تذكرة عبر الإنترنت",
 "Situação": "الحالة",
 "Situação agora": "الحالة الآن",
 "Skincare da manhã": "العناية بالبشرة صباحًا",
 "Skincare da noite": "العناية بالبشرة ليلًا",
 "Slides": "شرائح",
 "Smileys e pessoas": "الوجوه والأشخاص",
 "Sobremesa": "حلوى",
 "Sobrou no mês": "المتبقي في الشهر",
 "Sociologia": "علم الاجتماع",
 "Sofá": "أريكة",
 "Sol": "شمس",
 "Sol pleno": "شمس كاملة",
 "Solo ou substrato": "التربة أو الركيزة",
 "Solte numa matéria para mover a página para lá:": "أفلت الصفحة على مادة لنقلها إليها:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "يجمع الضمان القانوني وضمان الشركة المصنّعة. تحقّق من شهادة الضمان. ينبّهك قبل 15 و3 أيام.",
 "Sombra": "ظل",
 "Somente esta tarefa": "هذه المهمة فقط",
 "Sono": "نوم",
 "Sono da noite": "نوم الليلة",
 "Sopa": "شوربة",
 "Sou MEI": "أنا MEI",
 "Status": "الحالة",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "انتهت صلاحية اتصالك بالسحابة (يحدث ذلك عندما يبقى التطبيق دون فتح لفترة طويلة أو عند تغيير كلمة المرور على جهاز آخر). لن يضيع شيء: سيُرسل ما هنا فور تأكيدك.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "فريقك في مكان واحد: محادثة ومستندات واجتماعات فيديو مع التسجيل ودعوة عبر الرابط.",
 "Sua rotina em um só lugar": "روتينك في مكان واحد",
 "Sua senha": "كلمة مرورك",
 "Suas abas": "تبويباتك",
 "Substituir": "استبدال",
 "Substrato usado": "الركيزة المستخدمة",
 "Subtarefa {n}": "مهمة فرعية {n}",
 "Suco": "عصير",
 "Sugerir nome": "اقتراح اسم",
 "Sugestão": "اقتراح",
 "Sugestões de {categoria}": "اقتراحات {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: يحفظ الحساب والبيانات المتزامنة بصفته معالجًا. قد تكون الخوادم خارج البرازيل، مع الضمانات المنصوص عليها في art. 33 من LGPD.",
 "Superiores": "العليا",
 "Supino reto": "ضغط البنش",
 "Suplemento": "مكمّل",
 "Suspense": "تشويق",
 "Suíte": "جناح",
 "Sábado": "السبت",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "هذا أكثر من 60 ملفًا. استخدم \"كل N صفحات\".",
 "Série": "مسلسل",
 "Série da DPS": "سلسلة DPS",
 "Série e turma": "الصف والشعبة",
 "Séries": "المجموعات",
 "Sérum": "سيروم",
 "Símbolos": "رموز",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "لا يراه إلا فريق المكتب. حتى 50 MB لكل ملف.",
 "Só acompanha": "متابعة فقط",
 "Só acompanha, sem valores": "متابعة فقط، دون مبالغ",
 "Só administradores": "للمشرفين فقط",
 "Só em {data}": "فقط في {data}",
 "Só leitura": "للقراءة فقط",
 "Só mandar para a aba Estudos (sem escolher página)": "الإرسال إلى تبويب الدراسة فقط (دون اختيار صفحة)",
 "Só neste dispositivo": "على هذا الجهاز فقط",
 "Só neste dispositivo: {n}": "على هذا الجهاز فقط: {n}",
 "Só o código": "الرمز فقط",
 "Só o dia {data}": "يوم {data} فقط",
 "Só os dados (texto)": "البيانات فقط (نص)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "تُرسَل إجماليات المالية فقط إلى ذكائك الاصطناعي. هذه ليست توصية استثمارية.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "لك وحدك: الدراسات والاستراتيجيات التعليمية وما نجح أو لم ينجح في كل درس. لا يراها الطلاب.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "يمكن لهاتف واحد فقط المزامنة مع التقويم. للانتقال إلى هذا الهاتف، اضغط أدناه.",
 "Só uma vez": "مرة واحدة",
 "Só uma vez (abrir a ficha da tarefa)": "مرة واحدة فقط (فتح بطاقة المهمة)",
 "Só áudio": "صوت فقط",
 "Sótão": "العلّية",
 "TAREFAS DA CASA": "مهام المنزل",
 "TELEFONE (OPCIONAL)": "الهاتف (اختياري)",
 "TRAZER PARA O MY PLANNER": "استيراد إلى My Planner",
 "TV por assinatura": "التلفزيون المدفوع",
 "Tabela": "جدول",
 "Talvez": "ربما",
 "Tamanho": "الحجم",
 "Tamanho da foto": "حجم الصورة",
 "Tamanho da página": "حجم الصفحة",
 "Tamanho das páginas": "حجم الصفحات",
 "Tamanho do arquivo": "حجم الملف",
 "Tamanho do copo": "حجم الكوب",
 "Também procurar nos Diários Oficiais dos municípios": "البحث أيضًا في الجرائد الرسمية للبلديات",
 "Também serão excluídos {n} item(ns) dentro dele.": "سيُحذف أيضًا {n} عنصر/عناصر بداخله.",
 "Tapioca": "كريب التابيوكا",
 "Tarefa": "مهمة",
 "Tarefa da casa": "مهمة منزلية",
 "Tarefa de casa": "واجب منزلي",
 "Tarefa duplicada": "تم تكرار المهمة",
 "Tarefa ou entrega": "مهمة أو تسليم",
 "Tarefa para {nome}": "مهمة لـ {nome}",
 "Tarefas da casa": "مهام المنزل",
 "Tarefas e itens de todas as abas": "المهام والعناصر من جميع التبويبات",
 "Tarefas novas do My Planner vão para: {agenda}": "تذهب مهام My Planner الجديدة إلى: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "المهام المتكررة التي تتجاوز الفترة تبقى في الأيام الأخرى؛ تُحذف الأيام المختارة فقط.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "أشرطة سوداء فوق CPF والمبالغ والأسماء. حذف فعلي.",
 "Tartaruga": "سلحفاة",
 "Taxa de limpeza": "رسوم التنظيف",
 "Taxa de limpeza cobrada do hóspede": "رسوم التنظيف المحصلة من الضيف",
 "Taxas e anúncios": "الرسوم والإعلانات",
 "Te amo": "أحبك",
 "Tecnologia": "التقنية",
 "Tela cheia": "ملء الشاشة",
 "Teleconsulta": "استشارة عن بُعد",
 "Telefone": "الهاتف",
 "Telefone da assistência": "هاتف مركز الصيانة",
 "Telefone da empresa": "هاتف الشركة",
 "Telefone da escola": "هاتف المدرسة",
 "Telefone da limpeza": "هاتف عامل التنظيف",
 "Telefone de emergência": "هاتف الطوارئ",
 "Telefone do veterinário": "هاتف الطبيب البيطري",
 "Telhado": "السقف",
 "Tem anexos": "يحتوي على مرفقات",
 "Tem certeza?": "هل أنت متأكد؟",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "لديك {n} دفعة متأخرة بإجمالي {v}. ادفع أولًا ذات الفوائد الأعلى، مثل البطاقة والسحب على المكشوف.",
 "Tema": "الموضوع",
 "Tempo de preparo": "وقت التحضير",
 "Temporada": "الموسم",
 "Temporizador (direita)": "المؤقت (يمين)",
 "Tenta consertar um PDF que não abre direito.": "يحاول إصلاح ملف PDF لا يُفتح بشكل صحيح.",
 "Tentar de novo": "إعادة المحاولة",
 "Tente uma foto mais nítida, com a página inteira.": "جرّب صورة أوضح للصفحة كاملة.",
 "Termina às {hora}": "ينتهي الساعة {hora}",
 "Terminar até": "الإنهاء قبل",
 "Terminei em": "تاريخ الانتهاء",
 "Terminou": "انتهت",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "انتهت في {data}. لم يُحذف شيء: يعود كل شيء كما كان عند الاشتراك.",
 "Termos de uso": "شروط الاستخدام",
 "Termos de uso e privacidade": "شروط الاستخدام والخصوصية",
 "Terror": "رعب",
 "Terça": "الثلاثاء",
 "Testando...": "جارٍ الاختبار...",
 "Testar alerta (1 minuto)": "اختبار التنبيه (دقيقة واحدة)",
 "Testar aviso": "اختبار الإشعار",
 "Teste de alerta do Planner": "اختبار تنبيه Planner",
 "Teste grátis até {data} ({n} dia(s))": "تجربة مجانية حتى {data} ({n} يوم)",
 "Teste grátis: {n} dia(s)": "تجربة مجانية: {n} يوم",
 "Teste terminado": "انتهت التجربة",
 "Teste terminou em {data}": "انتهت التجربة في {data}",
 "Teste: aviso feito pelo próprio celular.": "اختبار: إشعار أنشأه الهاتف نفسه.",
 "Texto": "نص",
 "Texto completo": "النص الكامل",
 "Texto copiado. Cole onde quiser enviar.": "تم نسخ النص. الصقه حيث تريد إرساله.",
 "Texto do documento": "نص المستند",
 "Texto extra do convite (traje, presentes...)": "نص إضافي للدعوة (اللباس، الهدايا...)",
 "Texto livre": "نص حر",
 "Texto ou recado": "نص أو إعلان",
 "Texto para PDF": "نص إلى PDF",
 "Texto {data}": "نص {data}",
 "Tipo": "النوع",
 "Tipo sanguíneo": "فصيلة الدم",
 "Tira as páginas que você não quer.": "يحذف الصفحات التي لا تريدها.",
 "Tira autor, programas, comandos escondidos e anexos.": "يزيل المؤلف والبرامج والأوامر المخفية والمرفقات.",
 "Tira comentários, destaques e desenhos de outros programas.": "يزيل التعليقات والتظليل والرسومات من برامج أخرى.",
 "Tira o texto do PDF (arquivo .txt).": "يستخرج النص من PDF (ملف .txt).",
 "Tiradentes": "Tiradentes",
 "Tirar": "إزالة",
 "Tirar a assinatura": "إزالة التوقيع",
 "Tirar a foto": "إزالة الصورة",
 "Tirar a foto agora": "التقط الصورة الآن",
 "Tirar admin": "إلغاء الإشراف",
 "Tirar alarmes do My Planner": "إزالة المنبّهات من My Planner",
 "Tirar arquivos anexados": "إزالة الملفات المرفقة",
 "Tirar comentários, destaques e links": "إزالة التعليقات والتظليل والروابط",
 "Tirar da agenda": "إزالة من الجدول",
 "Tirar da barra": "إزالة من الشريط",
 "Tirar daqui": "إزالة من هنا",
 "Tirar das minhas figurinhas?": "إزالة من ملصقاتي؟",
 "Tirar de administrador": "إزالة صلاحية المشرف",
 "Tirar do escritório": "إزالة من المكتب",
 "Tirar dos meus GIFs?": "إزالة من صور GIF الخاصة بي؟",
 "Tirar este copo": "إزالة هذا الكوب",
 "Tirar foto": "التقاط صورة",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "تصوير الفواتير والإيصالات والمستندات، واختيار الصور ومقاطع الفيديو من المعرض.",
 "Tirar o desenho padrão?": "إزالة نمط القفل؟",
 "Tirar o lixo": "إخراج القمامة",
 "Tire a foto e a sua IA preenche a ficha": "التقط الصورة ويملأ الذكاء الاصطناعي الخاص بك البطاقة",
 "Titular (de quem é o documento)": "صاحب المستند (لمن يعود المستند)",
 "Titular: {nome}": "صاحب المستند: {nome}",
 "Toalha de praia": "منشفة الشاطئ",
 "Tocar os pés": "لمس القدمين",
 "Toda a agenda": "الأجندة كلها",
 "Toda semana": "كل أسبوع",
 "Todas": "الكل",
 "Todas (passadas, esta e futuras)": "الكل (السابقة، وهذه، والقادمة)",
 "Todas ({n})": "الكل ({n})",
 "Todas as abas liberadas até {data}.": "جميع التبويبات مفتوحة حتى {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "جميع العواصم. حدّد مدينة واحدة أو أكثر.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "كل أدوات PDF: دمج، تقسيم، تنظيم، توقيع، ختم، حجب، أرقام الصفحات، نماذج، ضغط، تحويل، OCR وذكاء اصطناعي. يحفظ على الهاتف أو Google Drive أو OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "كل الأدوات موجودة في شاشة هذا التبويب.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "كل صور الرحلة هنا: ما تضيفه إلى الألبوم وصور البرنامج والأماكن والحجوزات.",
 "Todas as plantas estão regadas.": "كل النباتات مسقيّة.",
 "Todas as páginas, uma embaixo da outra.": "كل الصفحات، واحدة تحت الأخرى.",
 "Todo ano": "كل سنة",
 "Todo dia": "كل يوم",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "كل يوم في الوقت المختار: عدد مهام اليوم، وأولاها، والطاقة الإجمالية.",
 "Todo mês": "كل شهر",
 "Todo mês · dia {d}": "كل شهر · يوم {d}",
 "Todo o histórico": "السجل كله",
 "Todos": "الكل",
 "Todos ({n})": "الكل ({n})",
 "Todos do grupo": "كل أعضاء المجموعة",
 "Todos do grupo veem": "يراه كل أعضاء المجموعة",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "يرى جميع من في الاجتماع تنبيه \"جارٍ التسجيل\". يذهب الملف إلى مستندات المكتب، ولا يراه أحد غيرك حتى تتيحه للفريق.",
 "Todos os cuidados": "كل العناية",
 "Todos os dias": "كل الأيام",
 "Todos os suplementos": "كل المكملات",
 "Todos os treinos": "كل التمارين",
 "Todos os tribunais": "جميع المحاكم",
 "Todos presentes": "الجميع حاضرون",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "يغادر الجميع المجموعة. ما قبله كل شخص يبقى في جدوله.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "يعمل الجميع على البيانات نفسها، كلٌّ حسب دوره. اضغط على دور كل شخص في الأعضاء لتغييره.",
 "Tomador": "متلقّي الخدمة",
 "Tomador (quem contratou)": "متلقّي الخدمة (من طلبها)",
 "Tomadores": "متلقّو الخدمة",
 "Tomei": "اقترضتُ",
 "Toque aqui ou no + para criar uma tarefa": "اضغط هنا أو على + لإنشاء مهمة",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "المس \"حذف حسابي وكل البيانات\" وأكّد.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "اضغط + › بطاقة ائتمان جديدة وأدخل يومي الإغلاق والاستحقاق.",
 "Toque em Ajustes e depois em Segurança.": "المس الإعدادات ثم الأمان.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "اضغط على ربط، ثم في شاشة Apple فعّل العناصر التي يمكن لـ My Planner قراءتها.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "اضغط على ربط، ثم في شاشة Health Connect اسمح لـ My Planner بقراءة البيانات.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "اضغط على من يجب ألّا يرى هذه البطاقة (وما بداخلها). مثال: الهدية المفاجئة.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "اضغط على تبويب لفتحه. تعرض التبويبات المقفلة طريقة الاشتراك.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "اضغط على تبويب لفتحه. يمكن تجربة كل تبويب إضافي مجانًا لمدة 10 أيام.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "اضغط على تبويب لفتحه. اضغط على 📌 لوضع التبويب في الشريط السفلي أو إزالته منه. يمكن تجربة كل تبويب إضافي مجانًا لمدة 10 أيام.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "اضغط على قسم لفتحه. الأقسام المقفلة توضّح كيفية الاشتراك.",
 "Toque no desenho para continuar desenhando.": "اضغط على الرسم لمتابعة الرسم.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "اضغط على ما ستشاركه هذه المجموعة. كل ما بداخله (البرنامج، الصور، الحجوزات...) ينتقل معه ويشارك الجميع.",
 "Toque nos PDFs na ordem em que devem ficar.": "اضغط على ملفات PDF بالترتيب الذي يجب أن تكون عليه.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "اضغط على كوب لتغيير الحجم؛ اضغط مطولًا على + لإضافة كوب بحجم آخر.",
 "Toque num feriado para adicioná-lo ao Planner.": "اضغط على عطلة لإضافتها إلى Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "اضغط على حركة لتغيير الفئة أو حفظ الإيصال لـ IR أو حذفها.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "اضغط على قيد لتغيير فئته. اضغط مطولًا للحذف.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "اضغط على ملف شخصي لتعديله. اضغط مطولًا لإزالته.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "المس نصًا أو رسمًا أو قائمة تحقق واسحبه إلى أي مكان في الورقة.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "اضغط على صفحة لقصها أو تدويرها أو تغيير الفلتر. اضغط مطولًا واسحب لتغيير الترتيب.",
 "Toque numa tarefa para copiar ou mover para hoje.": "اضغط على مهمة لنسخها أو نقلها إلى اليوم.",
 "Toque onde quer a checklist.": "اضغط حيث تريد قائمة التحقق.",
 "Toque onde quer escrever.": "اضغط حيث تريد الكتابة.",
 "Toque para abrir": "اضغط للفتح",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "المس للفتح في تطبيق الهاتف. اسحب يمينًا لإزالته من القائمة.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "اضغط للفتح، واضغط مطولًا لإعادة التسمية. اسحب لليسار للأرشفة أو لليمين للحذف.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "اضغط للفتح. اسحب لليمين للإزالة من القائمة.",
 "Toque para aceitar ou recusar.": "اضغط للقبول أو الرفض.",
 "Toque para aceitar, editar ou recusar.": "اضغط للقبول أو التعديل أو الرفض.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "اضغط للتطبيق الآن، أو سيُطبَّق تلقائيًا عند إعادة فتح التطبيق.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "اضغط للتنزيل والتثبيت فوق النسخة الحالية. تبقى بياناتك كما هي.",
 "Toque para conversar": "اضغط للمحادثة",
 "Toque para enviar o emoji animado": "اضغط لإرسال الإيموجي المتحرك",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "اضغط للإرسال. اضغط مطولًا للحفظ أو الإزالة.",
 "Toque para escolher": "اضغط للاختيار",
 "Toque para fechar": "اضغط للإغلاق",
 "Toque para gerar um novo QR Code": "اضغط لإنشاء رمز QR جديد",
 "Tornar admin": "تعيين مسؤولًا",
 "Tornar administrador": "تعيين مشرفًا",
 "Tosa": "قص الشعر",
 "Totais por alimento": "الإجمالي حسب الطعام",
 "Total": "الإجمالي",
 "Total bruto": "الإجمالي",
 "Total das reservas: {v}": "إجمالي الحجوزات: {v}",
 "Total de aulas": "إجمالي الدروس",
 "Total de capítulos": "إجمالي الفصول",
 "Total de módulos": "إجمالي الوحدات",
 "Total de páginas": "إجمالي الصفحات",
 "Total de recibos: {v}": "إجمالي الإيصالات: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "الإجمالي: {n}. يمكن أن يحتوي كل تبويب على {lim} من النص كحد أقصى (الصور والملفات لا تُحتسب: تبقى على الجهاز أو في Drive الخاص بك).",
 "Total: {v}": "الإجمالي: {v}",
 "Trabalhando...": "جارٍ العمل...",
 "Trabalho": "العمل",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "اجلب مواعيد تقويم Google إلى My Planner وعدّلها من هنا: تعود التغييرات إلى التقويم.",
 "Trans": "ترانس",
 "Transferir: {s}": "نقل: {s}",
 "Transferência": "نقل خدمة",
 "Transferências": "نقل الخدمات",
 "Transporte": "المواصلات",
 "Tratamento": "علاج",
 "Travar depois de preencher": "القفل بعد الملء",
 "Trazer todas para hoje": "نقل الكل إلى اليوم",
 "Trazer tudo para hoje?": "نقل كل شيء إلى اليوم؟",
 "Trecho ou ideia": "اقتباس أو فكرة",
 "Treino": "تمرين",
 "Trem ou ônibus": "قطار أو حافلة",
 "Treme": "يرتجف",
 "Tribunais": "المحاكم",
 "Trilha": "المشي في المسارات",
 "Triste": "حزين",
 "Triângulo": "مثلث",
 "Troca de óleo": "تغيير الزيت",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "تغيير الزيت، وتدوير الإطارات، والصيانة حسب الكيلومترات، وIPVA، والترخيص، والتأمين.",
 "Trocador portátil": "مفرش تغيير حفاض محمول",
 "Trocar": "تغيير",
 "Trocar a categoria": "تغيير الفئة",
 "Trocar a foto": "تغيير الصورة",
 "Trocar a pasta": "تغيير المجلد",
 "Trocar a senha do cofre": "تغيير كلمة مرور الخزنة",
 "Trocar número": "تغيير الرقم",
 "Trocar o certificado": "تغيير الشهادة",
 "Trocar o código": "تغيير الرمز",
 "Trocar o código?": "تغيير الرمز؟",
 "Trocar o desenho": "تغيير النمط",
 "Trocar o emoji": "تغيير الإيموجي",
 "Trocar o modelo": "تغيير النموذج",
 "Trocar o número": "تغيير الرقم",
 "Trocar o número do celular": "تغيير رقم الهاتف",
 "Trocar por:": "استبدال بـ:",
 "Trocar roupa de cama e toalhas": "تغيير أغطية السرير والمناشف",
 "Tríceps na polia": "تمديد الترايسبس بالكابل",
 "Tubo de ensaio": "أنبوب اختبار",
 "Tudo": "الكل",
 "Tudo certo": "كل شيء على ما يرام",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "كل شيء على ما يرام هنا. سجّل مصروفاتك اليومية لأرى أين يذهب المال.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "كل شيء محفوظ بالفعل في حسابك. الملف نسخة إضافية تحتفظ بها أينما شئت.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "كل ما بداخل \"{nome}\" سيصبح مرئيًا للمجموعة، كل شخص حسب الدور الذي تختاره (يبدأ المنضمون الجدد بأكثر الأدوار محدودية).",
 "Tudo! Já comprei os ingressos.": "كل شيء جاهز! اشتريت التذاكر بالفعل.",
 "Turma": "الفصل",
 "Turma (opcional)": "الفصل (اختياري)",
 "Turmas": "الفصول",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "الفصول والمجموعات (دروس، إرشاد، تدريب): الطلاب والحضور والدرجات والخطط والمواد والمطالبات ودفترك.",
 "Turmas, alunos, chamada, notas e planos de aula.": "الفصول، الطلاب، الحضور، الدرجات وخطط الدروس.",
 "Turmas, pacientes, equipes e convidados": "فصول ومرضى وفرق وضيوف",
 "Técnico": "تقني",
 "Título": "العنوان",
 "Título (ex.: Capítulo 3)": "العنوان (مثال: الفصل 3)",
 "Título (opcional)": "العنوان (اختياري)",
 "Título da caixa": "عنوان الصندوق",
 "Título de eleitor": "بطاقة الناخب",
 "Título, autor, assunto e palavras-chave.": "العنوان والمؤلف والموضوع والكلمات المفتاحية.",
 "Tô chegando": "في الطريق",
 "Tônico": "تونر",
 "UF": "UF",
 "Uau": "واو",
 "Uhuul!": "ياااي!",
 "Um PDF novo só com as páginas escolhidas.": "ملف PDF جديد بالصفحات المختارة فقط.",
 "Um texto clarinho na diagonal de todas as páginas.": "نص فاتح بشكل مائل على كل الصفحات.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "مجلد لكل عميل: تتبادلون المستندات في الاتجاهين، وكل عميل يرى مجلده فقط.",
 "Uma página por arquivo": "صفحة واحدة لكل ملف",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "صفحة واحدة لكل ملف، أو كل N صفحات، أو حسب النطاقات.",
 "Unicórnio": "وحيد القرن",
 "Unidade": "الوحدة",
 "Universal": "عامة",
 "União": "اتحاد",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "يستخدم حساب Google الموجود على الهاتف. لا يطلب My Planner أبدًا كلمة مرور Google.",
 "Usado: {u} · livre: {v} · limite {l}": "المستخدم: {u} · المتاح: {v} · الحد {l}",
 "Usar": "استخدام",
 "Usar \"{nome}\"": "استخدام \"{nome}\"",
 "Usar biometria": "استخدام البصمة",
 "Usar desenho padrão": "استخدام نمط القفل",
 "Usar este celular": "استخدام هذا الهاتف",
 "Usar este nome": "استخدام هذا الاسم",
 "Usar modelo: {m}": "استخدام القالب: {m}",
 "Usar no navegador (My Planner Web)": "الاستخدام في المتصفح (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "استخدام الملف المرفق مسبقًا ({nome})",
 "Usar o código": "استخدام الرمز",
 "Usar senha": "استخدام كلمة المرور",
 "Usar {ia}": "استخدام {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "استخدم كلمة المرور الجديدة في المرة القادمة التي تسجل فيها الدخول، هنا وفي My Planner Web.",
 "Use a senha para desbloquear.": "استخدم كلمة المرور لفتح القفل.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "استخدم الذكاء الاصطناعي الخاص بك لقراءة النشرات القضائية والمستندات والملاحظات واقتراح المواعيد. أنت تؤكد دائمًا قبل أن يدخل أي شيء إلى Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "استخدم هذا الرمز عند إنشاء حسابك واحصل على 10 أيام مع فتح جميع التبويبات.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "استخدم كشف الحساب بصيغة OFX (الأفضل) أو CSV، بعد تنزيله من تطبيق البنك أو موقعه.",
 "Use o seu planner no computador, sincronizado com o celular.": "استخدم مخططك على الكمبيوتر، متزامنًا مع الهاتف.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "استخدم رابط https من Google Drive أو Google Docs أو OneDrive أو SharePoint.",
 "Uso": "الاستخدام",
 "Uso próprio": "استخدام شخصي",
 "VRBO": "VRBO",
 "Vacina": "لقاح",
 "Vacina {nome}: {pet}": "لقاح {nome}: {pet}",
 "Vacina: {nome}": "لقاح: {nome}",
 "Vacinas": "اللقاحات",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "لقاحات وأدوية الحيوانات الأليفة، ومتجر الحيوانات، وروتين المدرسة وصحة الأطفال.",
 "Vai na viagem": "مسافر في الرحلة",
 "Vale até {d}": "صالحة حتى {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "ينطبق على الدراسة والمستندات. في السحابة، يُفتح الملف على أي جهاز وفي My Planner Web (حتى 15 ميغابايت لكل ملف).",
 "Vale quantos pontos": "الدرجة القصوى",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "ينطبق عليك وحدك. تنبيه واحد على الأكثر كل 3 دقائق لكل شخص، حتى لو أضاف عدة أشياء.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "صالح مرة واحدة، خلال أول 30 يومًا من حسابك.",
 "Validade": "تاريخ الانتهاء",
 "Validade do certificado A1": "صلاحية شهادة A1",
 "Validade: {data}": "ينتهي في: {data}",
 "Valor": "المبلغ",
 "Valor ({m})": "المبلغ ({m})",
 "Valor a pagar": "المبلغ المستحق",
 "Valor combinado": "المبلغ المتفق عليه",
 "Valor combinado por atendimento": "المبلغ المتفق عليه لكل زيارة",
 "Valor da hora": "سعر الساعة",
 "Valor da parcela (1ª)": "قيمة القسط (الأول)",
 "Valor da venda": "سعر البيع",
 "Valor de costume": "القيمة المعتادة",
 "Valor do atendimento: {v}{pago}.": "قيمة الزيارة: {v}{pago}.",
 "Valor emprestado ou financiado": "مبلغ القرض أو التمويل",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "السعر النهائي يحدده Google Play أو App Store، بعملة بلدك.",
 "Valor maior que o guardado nesta meta.": "المبلغ أكبر من المدّخر في هذا الهدف.",
 "Valor padrão da consulta ou sessão": "السعر الافتراضي للاستشارة أو الجلسة",
 "Valor pago": "المبلغ المدفوع",
 "Valor pago (com multa ou desconto)": "المبلغ المدفوع (مع غرامة أو خصم)",
 "Valor pago (opcional)": "المبلغ المدفوع (اختياري)",
 "Valor pago: {v}": "المبلغ المدفوع: {v}",
 "Valor que este aluno paga (se for diferente)": "المبلغ الذي يدفعه هذا الطالب (إن كان مختلفًا)",
 "Valor recebido": "المبلغ المستلم",
 "Valor recebido: {v}": "المبلغ المستلم: {v}",
 "Valor total da compra": "إجمالي قيمة الشراء",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "لا تظهر المبالغ والبيانات السريرية إلا لمن يسمح دوره بذلك. يمكنك الإيقاف متى شئت: تبقى البيانات لديك.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "مبالغ للمراجعة مع محاسبك. قواعد الخصم تتغير كل عام.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "هل نتحدث عبر My Planner؟ أضفني كصديق بالرمز {codigo} (تبويب الرسائل > الأصدقاء).",
 "Vaso": "أصيص",
 "Veja os planos em Ajustes › Compras.": "اطّلع على الخطط في الإعدادات › المشتريات.",
 "Vem da aba Empréstimos & Financiamentos": "من تبويب القروض والتمويلات",
 "Vence em {data}.": "ينتهي في {data}.",
 "Vence em {fim} (data informada na publicação).": "تنتهي في {fim} (التاريخ المذكور في النشرة).",
 "Vence em {n} dia(s)": "ينتهي بعد {n} يوم/أيام",
 "Vence hoje": "ينتهي اليوم",
 "Vence {data}": "تستحق {data}",
 "Vencendo": "قارب على الانتهاء",
 "Venceu há {n} dia(s)": "انتهى منذ {n} يوم/أيام",
 "Vencidas": "المنتهية",
 "Vencidos": "منتهية",
 "Vencimento": "تاريخ الاستحقاق",
 "Vencimento (guias e boletos)": "الاستحقاق (قسائم الدفع وboletos)",
 "Vencimento da 1ª parcela": "استحقاق القسط الأول",
 "Vencimentos": "الاستحقاقات",
 "Venda": "بيع",
 "Venda/serviço do MEI": "بيع/خدمة MEI",
 "Vendidos": "المُباعة",
 "Ver": "عرض",
 "Ver a lista de membros": "رؤية قائمة الأعضاء",
 "Ver a rota": "عرض المسار",
 "Ver arquivos": "عرض الملفات",
 "Ver detalhes do erro": "عرض تفاصيل الخطأ",
 "Ver e editar": "عرض وتعديل",
 "Ver em Compras": "عرض في المشتريات",
 "Ver mais": "عرض المزيد",
 "Ver mais páginas": "عرض مزيد من الصفحات",
 "Ver no My Planner": "عرض في My Planner",
 "Ver o dia": "عرض اليوم",
 "Ver os feriados do ano": "عرض عطلات العام",
 "Ver participantes": "عرض المشاركين",
 "Ver páginas": "عرض الصفحات",
 "Ver todos": "عرض الكل",
 "Ver todos ({n})": "عرض الكل ({n})",
 "Ver {nome}": "عرض {nome}",
 "Verificar agora": "تحقّق الآن",
 "Vermífugo": "مضاد الديدان",
 "Vermífugo ou remédio": "مضاد الديدان أو دواء",
 "Vermífugos e remédios": "مضادات الديدان والأدوية",
 "Verso": "الوجه الخلفي",
 "Verso do documento": "الوجه الخلفي للمستند",
 "Versão do PDF": "إصدار PDF",
 "Versão instalada": "الإصدار المثبّت",
 "Versão {versao} disponível": "الإصدار {versao} متاح",
 "Versão {v}": "الإصدار {v}",
 "Veterinário": "الطبيب البيطري",
 "Veterinário ou clínica": "الطبيب البيطري أو العيادة",
 "Veículo": "مركبة",
 "Veículo e acessórios": "المركبة والإكسسوارات",
 "Veículos": "المركبات",
 "Veículos & Manutenção": "المركبات والصيانة",
 "Vi mais um episódio": "شاهدت حلقة أخرى",
 "Viagem": "رحلة",
 "Viagens": "الرحلات",
 "Viagens & Lazer": "السفر والترفيه",
 "Viagens e lugares": "السفر والأماكن",
 "Vida noturna": "الحياة الليلية",
 "Vidros e esquadrias": "الزجاج والإطارات",
 "Vigente": "سارٍ",
 "Vigentes": "السارية",
 "Virar": "تبديل",
 "Virar a câmera": "تبديل الكاميرا",
 "Virar tarefa (levar à assistência)": "تحويل إلى مهمة (أخذه إلى الصيانة)",
 "Visita domiciliar": "زيارة منزلية",
 "Visitados": "تمت زيارتها",
 "Visto": "شوهد",
 "Vistoria": "معاينة",
 "Vistoria: {i}": "معاينة: {i}",
 "Vistorias": "المعاينات",
 "Visualizar feriados": "عرض العطلات",
 "Vitamina": "فيتامين",
 "Vitamina D": "فيتامين د",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "فيتامينات، واي بروتين، كرياتين... مع تكرار كل منها. ما يخص اليوم يظهر في \"اليوم\" لتعليمه.",
 "Você": "أنت",
 "Você aceitou os termos em {data}.": "وافقت على الشروط في {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "ليس لديك أصدقاء في التطبيق بعد. أضفهم عبر الرمز.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "ليس لديك مجلدات بعد. أنشئ واحدًا في تبويب الدراسة.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "لن تعود ترى المحادثة والمستندات والاجتماعات.",
 "Você deve: {v}": "عليك: {v}",
 "Você entrou no grupo": "انضممت إلى المجموعة",
 "Você entrou no grupo \"{nome}\".": "انضممت إلى المجموعة \"{nome}\".",
 "Você está convidado(a) para: {evento}": "أنت مدعو/مدعوة إلى: {evento}",
 "Você foi convidado para o My Planner": "تمت دعوتك إلى My Planner",
 "Você foi convidado para o grupo": "تمت دعوتك إلى المجموعة",
 "Você juntou {v} para \"{m}\".": "جمعت {v} لـ \"{m}\".",
 "Você já tem todas as abas.": "لديك جميع التبويبات بالفعل.",
 "Você já usou um código de indicação nesta conta.": "لقد استخدمت بالفعل رمز إحالة في هذا الحساب.",
 "Você ligou": "اتصلتَ",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "يمكنك حذف حسابك في أي وقت من تطبيق الهاتف أو من الموقع:",
 "Você não tem permissão para isso neste grupo.": "ليس لديك إذن لذلك في هذه المجموعة.",
 "Você não vê os outros membros deste grupo.": "لا يمكنك رؤية باقي أعضاء هذه المجموعة.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "يمكنك حذف الحساب في أي وقت من الإعدادات > الأمان. يؤدي ذلك إلى حذف البيانات نهائيًا من السحابة ومن الجهاز.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "يمكنك: التأكد مما إذا كنا نعالج بياناتك، والوصول إليها، وتصحيحها، وطلب نقلها (بتصدير الملف من الإعدادات > الإعدادات العامة)، وطلب حذفها، ومعرفة مع من نشاركها، وسحب الموافقة، وتقديم شكوى إلى ANPD.",
 "Você recebe (líquido)": "تستلم (صافي)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "أنت مسؤول عن كلمة مرورك وعمّا يتم في حسابك. استخدم بيانات صحيحة عند التسجيل.",
 "Volta": "العودة",
 "Volta ou check-out": "العودة أو تسجيل المغادرة",
 "Volta às {hora}": "العودة الساعة {hora}",
 "Voltar": "رجوع",
 "Voltar ao cardápio da semana neste dia": "إرجاع قائمة الأسبوع في هذا اليوم",
 "Voltar ao cálculo": "العودة إلى الحساب",
 "Voltar ao foco": "العودة إلى التركيز",
 "Voltar ao padrão": "استعادة الافتراضي",
 "Voltar ao planejado": "العودة إلى المخطط",
 "Voltar para Anotações": "العودة إلى الملاحظات",
 "Voltar para as cores do My Planner": "العودة إلى ألوان My Planner",
 "Voltar para novas": "العودة إلى الجديدة",
 "Voltar para o QR Code": "العودة إلى رمز QR",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "عد إلى تطبيق My Planner على الهاتف. ستتحدث شاشة الإعدادات تلقائيًا.",
 "Voo": "رحلة طيران",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "الرحلات الجوية والفنادق والسيارة والجولات في مكان واحد، مع الرمز والإثبات.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "اذهب إلى الإعدادات واضغط على \"ربط المتصفح\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "اذهب إلى الإعدادات › الإعدادات العامة واضغط على \"ربط المتصفح\".",
 "Várias páginas por folha": "عدة صفحات في الورقة",
 "Vários PDFs num só, na ordem que você escolher.": "عدة ملفات PDF في ملف واحد، بالترتيب الذي تختاره.",
 "Vê as aulas e os materiais liberados.": "يرى الدروس والمواد المتاحة.",
 "Vê as etapas e registra o diário.": "يرى المراحل ويسجّل في اليوميات.",
 "Vê e altera tudo, inclusive os valores.": "يرى كل شيء ويعدّله، بما في ذلك المبالغ.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "يرى ويرسل مستندات مجلده ويرد على الطلبات.",
 "Vê o andamento, sem os valores e sem alterar.": "يرى سير العمل، دون المبالغ ودون تعديل.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "يرى مواعيد الوصول والمغادرة ويحدد التنظيف المنجز، دون مبالغ.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "يرى كل شيء ويسجّل المصروفات والأماكن وخط السير والأمتعة.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "يرى كل شيء ويضيف ويعدّل ويعلّق ويرفع الصور. لكنه لا يضيف أشخاصًا إلى المجموعة ولا يزيلهم.",
 "Vê tudo, inclusive os valores, sem alterar.": "يرى كل شيء، بما في ذلك المبالغ، دون تعديل.",
 "Vídeo": "فيديو",
 "Vínculo": "الربط",
 "Vínculo perdido": "رابط مفقود",
 "WhatsApp da assistência": "WhatsApp الصيانة",
 "Whey": "واي بروتين",
 "Wi-Fi (rede e senha)": "Wi-Fi (الشبكة وكلمة المرور)",
 "Yoga": "يوغا",
 "Zumbi e Consciência Negra": "Zumbi ويوم الوعي الأسود",
 "Zzz": "Zzz",
 "a cada {n} dias": "كل {n} يوم/أيام",
 "a pagar": "مستحق الدفع",
 "a receber": "مستحق القبض",
 "a receber {v}": "مستحق {v}",
 "a reserva": "الحجز",
 "a última execução falhou; avise o suporte": "فشل التشغيل الأخير؛ أبلِغ الدعم",
 "abr": "أبريل",
 "abril": "أبريل",
 "acabou": "نفد",
 "achatado": "مسطّح",
 "administra": "مشرف",
 "ago": "أغسطس",
 "agosto": "أغسطس",
 "ajustado": "معدَّل",
 "algo novo": "شيئًا جديدًا",
 "alterou": "عدّل",
 "amanhã": "غدًا",
 "anual": "سنوي",
 "apagou": "حذف",
 "aplicada em {d}": "أُعطي في {d}",
 "app {v} · atualização {p} de {data}": "التطبيق {v} · التحديث {p} بتاريخ {data}",
 "assinado": "موقّع",
 "atrasada": "متأخرة",
 "atrasada há {n} dia(s)": "متأخرة منذ {n} يوم/أيام",
 "até": "حتى",
 "até {data}": "حتى {data}",
 "até {d}": "حتى {d}",
 "aula {a} de {n}": "الدرس {a} من {n}",
 "avisos silenciados": "الإشعارات مكتومة",
 "caixa": "صندوق",
 "colher(es)": "ملعقة/ملاعق",
 "coluna": "عمود",
 "com anexos": "مع مرفقات",
 "com imagem": "مع صورة",
 "com tarjas": "محجوب",
 "com texto": "مع نص",
 "com {p}": "مع {p}",
 "como planejado": "كما هو مخطط",
 "comprado em {data}": "اشتُري في {data}",
 "comprado em {d} por {v}": "اشتُري في {d} بمبلغ {v}",
 "comprimido": "مضغوط",
 "comprovante": "إثبات الدفع",
 "concha(s)": "مغرفة/مغارف",
 "confirmados": "مؤكَّدون",
 "consulta recusada": "تم رفض الاستعلام",
 "contratado": "متعاقد",
 "contínuo": "مستمر",
 "copo(s)": "كوب/أكواب",
 "corridos": "تقويمي",
 "criou o grupo": "أنشأ المجموعة",
 "de": "من",
 "de Anotações": "من الملاحظات",
 "de {meta} passos": "من {meta} خطوة",
 "de {n}": "من {n}",
 "de {p}": "من {p}",
 "dentro / fora do planejado": "ضمن الخطة / خارجها",
 "desconto {v}": "خصم {v}",
 "desfazer": "تراجع",
 "destino": "الوجهة",
 "deve {v}": "عليه {v}",
 "devolvido em {d}": "أُرجع في {d}",
 "dez": "ديسمبر",
 "dezembro": "ديسمبر",
 "dia": "يوم",
 "dias": "أيام",
 "dias com a meta batida": "أيام تحقيق الهدف",
 "dias com a meta de passos": "أيام تحقيق هدف الخطوات",
 "digital": "البصمة",
 "diária média": "متوسط سعر الليلة",
 "do cliente": "من العميل",
 "do escritório": "من المكتب",
 "dom": "أحد",
 "domingo": "الأحد",
 "e mais {n}": "و{n} أخرى",
 "em aberto": "مفتوح",
 "em atraso": "متأخر",
 "em {n} dias": "بعد {n} يوم/أيام",
 "emitida": "صادرة",
 "entregue": "تم التسليم",
 "entrou no escritório": "انضم إلى المكتب",
 "enviado": "أُرسل",
 "escaneado": "ممسوح",
 "escolha": "اختر",
 "este": "هذا",
 "este dispositivo": "هذا الجهاز",
 "este item": "هذا العنصر",
 "exercícios concluídos": "تمارين مكتملة",
 "falta {v}": "متبقٍ {v}",
 "faltam {km}": "متبقٍّ {km}",
 "fatia(s)": "شريحة/شرائح",
 "faturamento": "الإيرادات",
 "feita em {d}": "أُنجزت في {d}",
 "feito {dur}": "تم {dur}",
 "fev": "فبراير",
 "fevereiro": "فبراير",
 "frequência {p}%": "نسبة الحضور {p}%",
 "gasto {v}": "المصروف {v}",
 "girado": "مدوّر",
 "guardado": "محفوظ",
 "higienizado": "منظّف",
 "hoje": "اليوم",
 "hora fixa no dia": "وقت ثابت في اليوم",
 "há {n} dias": "منذ {n} يوم/أيام",
 "iPhone ou computador: {link}": "آيفون أو الكمبيوتر: {link}",
 "incluiu": "أضاف",
 "jan": "يناير",
 "janeiro": "يناير",
 "jul": "يوليو",
 "julho": "يوليو",
 "jun": "يونيو",
 "junho": "يونيو",
 "já importado": "مستورد مسبقًا",
 "liberar em {d}": "إتاحة في {d}",
 "ligou o compartilhamento": "فعّل المشاركة",
 "linha": "صف",
 "lucro líquido": "صافي الربح",
 "mai": "مايو",
 "maio": "مايو",
 "mar": "مارس",
 "marca d'água": "علامة مائية",
 "marcada por {nome}": "حدّده {nome}",
 "março": "مارس",
 "menos de 1 ano": "أقل من سنة",
 "mensalidade": "الرسوم الشهرية",
 "meta batida!": "تم تحقيق الهدف!",
 "metadados": "بيانات وصفية",
 "min": "د",
 "min antes": "د قبل",
 "min antes do início": "دقيقة قبل البدء",
 "min · {de} às {ate}": "د · من {de} إلى {ate}",
 "multa e juros {v}": "غرامة وفوائد {v}",
 "média {m}": "المعدل {m}",
 "mês(es)": "شهر/أشهر",
 "na nuvem": "في السحابة",
 "na pasta \"{pasta}\"": "في المجلد \"{pasta}\"",
 "na pasta escolhida": "في المجلد المختار",
 "neste dispositivo": "على هذا الجهاز",
 "neste celular": "على هذا الهاتف",
 "no Planner": "في المخطط",
 "no {nome}": "في {nome}",
 "nos próximos dias": "في الأيام القادمة",
 "nov": "نوفمبر",
 "novembro": "نوفمبر",
 "numerado": "مرقّم",
 "nunca verificado": "لم يتم التحقق قط",
 "não vão": "لن يحضروا",
 "o documento mudou depois disso: guarde de novo": "تغيّر المستند بعد ذلك: احفظه مرة أخرى",
 "ocupação": "الإشغال",
 "ontem": "أمس",
 "organizado": "منظّم",
 "orçando": "قيد التسعير",
 "out": "أكتوبر",
 "outubro": "أكتوبر",
 "paga": "مدفوع",
 "paga em {d}": "دُفع في {d}",
 "pago": "مدفوع",
 "pago em {d}": "دُفع في {d}",
 "pago por {p}": "دفعه {p}",
 "pagou {v}": "دفع {v}",
 "parcela {a} de {n}": "القسط {a} من {n}",
 "parece já lançado": "يبدو مسجّلًا مسبقًا",
 "parte {n}": "الجزء {n}",
 "passos por dia (média)": "خطوات يوميًا (متوسط)",
 "passou {km}": "تجاوز بـ{km}",
 "pausa {p}": "راحة {p}",
 "pausado": "متوقف مؤقتًا",
 "peso {n}": "الوزن {n}",
 "pesquisável": "قابل للبحث",
 "por dia": "يوميًا",
 "por dia (média)": "يوميًا (متوسط)",
 "por dia disponível": "لكل يوم متاح",
 "por semana": "أسبوعيًا",
 "por {p}": "بواسطة {p}",
 "porção(ões)": "حصة/حصص",
 "preenchido": "مملوء",
 "primeira às {hora}: {tarefa}": "الأولى الساعة {hora}: {tarefa}",
 "produção": "الإنتاج",
 "próxima em {data}": "التالية في {data}",
 "próxima rega {d}": "الري التالي {d}",
 "publicação": "نشرة قضائية",
 "página de estudo": "صفحة دراسة",
 "página única": "صفحة واحدة",
 "páginas": "صفحات",
 "páginas {p}": "الصفحات {p}",
 "qua": "أربعاء",
 "quarta": "الأربعاء",
 "quarta-feira": "الأربعاء",
 "qui": "خميس",
 "quinta": "الخميس",
 "quinta-feira": "الخميس",
 "quitada": "مسدَّد",
 "recebe {v}": "يستلم {v}",
 "recebida": "واردة",
 "reconhecimento facial": "التعرف على الوجه",
 "recortado": "مقصوص",
 "refeições feitas": "وجبات تم تناولها",
 "rega a cada {n} dias": "الري كل {n} يوم/أيام",
 "regar hoje": "اسقِها اليوم",
 "reparado": "مُصلح",
 "retorno {d}": "المتابعة {d}",
 "saldo {v}": "الرصيد {v}",
 "seg": "اثنين",
 "segunda": "الإثنين",
 "segunda-feira": "الإثنين",
 "sem anotações": "بلا تعليقات",
 "sem as páginas {p}": "بدون الصفحات {p}",
 "sem cliente": "بدون عميل",
 "sem dias previstos": "لا توجد أيام مقررة",
 "sem horário": "بلا وقت",
 "sem meta": "بلا هدف",
 "sem resposta": "بلا رد",
 "sem tempo": "بلا وقت",
 "semana(s)": "أسبوع/أسابيع",
 "set": "سبتمبر",
 "setembro": "سبتمبر",
 "seu@email.com": "you@email.com",
 "sex": "جمعة",
 "sexta": "الجمعة",
 "sexta-feira": "الجمعة",
 "sáb": "سبت",
 "sábado": "السبت",
 "talvez": "ربما",
 "tarefa da casa": "مهمة منزلية",
 "tarefa: {t}": "الواجب: {t}",
 "taxas e despesas": "الرسوم والمصروفات",
 "ter": "ثلاثاء",
 "termina em {d}": "ينتهي في {d}",
 "terça": "الثلاثاء",
 "terça-feira": "الثلاثاء",
 "teste": "اختبار",
 "todas": "الكل",
 "todo ano em {d}": "كل سنة في {d}",
 "todo dia {d}": "شهريًا يوم {d}",
 "todos": "الجميع",
 "toque para abrir": "اضغط للفتح",
 "toque para pausar": "اضغط للإيقاف المؤقت",
 "toque para ver o contato": "اضغط لعرض جهة الاتصال",
 "toque para voltar a hoje": "اضغط للعودة إلى اليوم",
 "treinos concluídos": "حصص تدريب مكتملة",
 "uma vez em {d}": "مرة واحدة في {d}",
 "unidade(s)": "وحدة/وحدات",
 "vale {n}": "من {n}",
 "vence em {n} dias": "يستحق خلال {n} يوم",
 "vence {d}": "يستحق {d}",
 "venceu em {data}": "انتهى في {data}",
 "vencido": "متأخر",
 "vendido com ganho de {v}": "بيع بربح {v}",
 "vendido com perda de {v}": "بيع بخسارة {v}",
 "verificado {quando}": "تم التحقق {quando}",
 "você": "أنت",
 "você administra": "أنت المسؤول",
 "xícara(s)": "فنجان/فناجين",
 "{aba} bloqueada": "{aba} مقفل",
 "{aba} está bloqueada": "{aba} مقفل",
 "{aba}, em \"Anotações recebidas\"": "{aba}، في \"الملاحظات المستلمة\"",
 "{a} aula(s) feita(s)": "{a} درس مكتمل",
 "{a} de {n} aulas": "{a} من {n} دروس",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "بلغت {c} {p}% من الميزانية ({g} من {l}).",
 "{c} confirmados de {n} convidados": "{c} مؤكَّدون من {n} ضيف/ضيوف",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} عند {p}% من ميزانية الشهر. باقٍ {dias} يوم على نهاية الشهر.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} أعلى بـ {v} من الشهر الماضي بأكمله. تحقّق إن كان هناك شيء غير معتاد.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "تجاوزت {c} الميزانية بالفعل: {g} من {l}. أوقف هذا الإنفاق حتى يبدأ الشهر الجديد.",
 "{c} passou do orçamento: {g} de {l}.": "تجاوزت {c} الميزانية: {g} من {l}.",
 "{de} paga {v} para {para}": "{de} يدفع {v} إلى {para}",
 "{de} às {ate}": "من {de} إلى {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}، {d} {mes} {a}",
 "{dia}, {d} {mes}": "{dia}، {d} {mes}",
 "{dia}, {d}/{m}": "{dia}، {d}/{m}",
 "{dur} na semana": "{dur} هذا الأسبوع",
 "{dur} registrados": "{dur} مسجّلة",
 "{d}/{n} notas": "{d}/{n} درجات",
 "{feito} de {meta}": "{feito} من {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} من {n} منجزة",
 "{f}/{n} transferências feitas": "{f}/{n} عمليات نقل منجزة",
 "{hora} em {fuso}": "{hora} في {fuso}",
 "{h} este mês": "{h} هذا الشهر",
 "{h} h": "{h} س",
 "{h} h {m} min": "{h} س {m} د",
 "{h} no seu relógio": "{h} حسب ساعتك",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "تم الاتصال بـ {ia}. يتوفر {n} نموذج في حسابك.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: مفتاح API غير صالح أو بلا صلاحية.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: تم بلوغ حد الاستخدام. تحقق من الرصيد أو الحد في حساب API الخاص بك.",
 "{item}: em {n} dias ({data}).": "{item}: بعد {n} يوم/أيام ({data}).",
 "{item}: hoje ({data}).": "{item}: اليوم ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: ينتهي خلال {n} يومًا ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: ينتهي خلال {n} يوم ({data}).",
 "{item}: vence hoje ({data}).": "{item}: ينتهي اليوم ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: استحق في {data} ولم يُحدَّد كمنجز بعد.",
 "{livre} livres de {total}": "{livre} متاحة من {total}",
 "{m} min": "{m} د",
 "{nome} agora é seu amigo. Já podem conversar.": "أصبح {nome} صديقك الآن. يمكنكما التحدث.",
 "{nome} conectado!": "تم ربط {nome}!",
 "{nome} ligou": "اتصل {nome}",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "جديدة: {novas}، محدّثة: {atualizadas}، مُرسلة: {enviadas}، محذوفة: {removidas}",
 "{n} ITEM(NS)": "{n} عنصر",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} تبويب في خطتك · ألوان وخيارات كل منها",
 "{n} aba(s) para comprar": "{n} تبويب للشراء",
 "{n} adicionada(s)": "تمت إضافة {n}",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} تنبيه/تنبيهات مجدولة على هذا الهاتف للأيام القادمة.",
 "{n} aluno(s)": "{n} طالب/طلاب",
 "{n} anexo(s)": "{n} مرفق/مرفقات",
 "{n} ano(s)": "{n} سنة",
 "{n} arquivo(s)": "{n} ملف",
 "{n} atendimento(s)": "الزيارات: {n}",
 "{n} atrasada(s)": "{n} متأخرة",
 "{n} atrasado(s)": "{n} متأخر/متأخرة",
 "{n} caixa(s)": "{n} صندوق/صناديق",
 "{n} caixa(s) frágil(eis)": "{n} صندوق/صناديق قابلة للكسر",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} صندوق/صناديق · {a} فُتح بالفعل في المنزل الجديد",
 "{n} cancelada(s).": "تم إلغاء {n}.",
 "{n} cartão(ões) abertos": "{n} بطاقة/بطاقات مفتوحة",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "تم إنشاء {n} مطالبة/مطالبات تستحق في {d}.",
 "{n} com vencimento": "{n} بتاريخ استحقاق",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} عملية شراء بالبطاقة {c}. الأقساط المستقبلية تظهر بالفعل في الكشوف القادمة.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "تم تأشير {n} من الفواتير كمدفوعة تلقائيًا.",
 "{n} copo(s), {ml} de {meta}": "{n} كوب/أكواب، {ml} من {meta}",
 "{n} de {meta} copos": "{n} من {meta} أكواب",
 "{n} de {total}": "{n} من {total}",
 "{n} de {total} dias": "{n} من {total} يوم",
 "{n} de {total} hoje": "{n} من {total} اليوم",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} من {t} عنصر بسعر، من الإيصالات المقروءة في المالية.",
 "{n} dia(s)": "{n} يوم",
 "{n} dia(s) seguido(s) lendo": "{n} يوم متتالٍ من القراءة",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "تمت إزالة {n} يوم/أيام من المهام المتكررة",
 "{n} dias": "{n} أيام",
 "{n} dias grátis": "{n} يومًا مجانًا",
 "{n} dias grátis para testar": "{n} يومًا مجانًا للتجربة",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} يوم {tipo}: نُشرت في {pub}، ويبدأ العدّ من {ini}، وتنتهي في {fim}.",
 "{n} documento(s)": "{n} مستند",
 "{n} em atraso": "متأخرة: {n}",
 "{n} etapa(s) atrasada(s)": "{n} مرحلة/مراحل متأخرة",
 "{n} exclusão(ões) esperando o celular sincronizar.": "عمليات حذف تنتظر مزامنة الهاتف: {n}.",
 "{n} falta(s)": "{n} غياب",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "عدد السجلات في المجموعة: {n}. اختر دور كل شخص في الأعضاء.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} صورة وفيديو من الرحلة، من جميع أعضاء المجموعة. تظهر هنا أيضًا صور البرنامج والأماكن والحجوزات.",
 "{n} item(ns) adicionado(s).": "تمت إضافة {n} عنصر/عناصر.",
 "{n} item(ns) com outras pessoas": "{n} غرض/أغراض مع أشخاص آخرين",
 "{n} item(ns) no Planner.": "{n} عنصر/عناصر في Planner.",
 "{n} lançamento(s) encontrado(s)": "تم العثور على {n} من القيود",
 "{n} lançamento(s) novo(s).": "{n} من القيود الجديدة.",
 "{n} lembrete(s) colocado(s) no My Planner.": "تمت إضافة {n} تذكير/تذكيرات إلى My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} كتاب/كتب مقروءة هذا العام",
 "{n} marcado(s)": "{n} محدد",
 "{n} matéria(s)": "{n} مادة/مواد",
 "{n} membro(s) · abrir a conversa do grupo": "{n} عضو · فتح محادثة المجموعة",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} أشهر مجانًا من تاريخ إنشاء الحساب؛ ثم {preco} سنويًا.",
 "{n} min": "{n} د",
 "{n} min antes": "قبل {n} دقيقة",
 "{n} módulo(s)": "{n} وحدة",
 "{n} noite(s)": "الليالي: {n}",
 "{n} nota(s) nova(s).": "{n} فاتورة جديدة.",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "تم استبعاد {n} فاتورة بدون XML على هذا الجهاز.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} فاتورة · الصادرة {e} · الواردة {r}",
 "{n} nova(s)": "{n} جديدة",
 "{n} novo(s) do cliente": "{n} جديد من العميل",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} جديد للقبول أو التعديل أو الرفض.",
 "{n} parcela(s) colocada(s) no My Planner.": "تمت إضافة {n} قسط/أقساط إلى My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "أُعيد حساب {n} قسط/أقساط غير مدفوعة. بقيت المدفوعة كما هي.",
 "{n} parcela(s) em atraso": "أقساط متأخرة: {n}",
 "{n} parcela(s) em atraso: {v}": "أقساط متأخرة: {n} · {v}",
 "{n} participantes · toque para ver": "{n} مشارك · اضغط للعرض",
 "{n} passo(s)": "{n} خطوة/خطوات",
 "{n} pausa(s)": "{n} استراحة/استراحات",
 "{n} pedido(s) de amizade": "{n} طلب صداقة",
 "{n} pedido(s) em aberto": "{n} طلب مفتوح",
 "{n} pessoa(s)": "{n} شخص",
 "{n} pessoa(s) já entraram com o seu código.": "انضم {n} شخص/أشخاص برمزك.",
 "{n} pessoas": "{n} أشخاص",
 "{n} por folha": "{n} في الورقة",
 "{n} porções": "{n} حصة/حصص",
 "{n} publicação(ões) nova(s).": "{n} نشرة/نشرات جديدة.",
 "{n} publicações novas": "{n} نشرات جديدة",
 "{n} página(s)": "{n} صفحة",
 "{n} página(s) · {r} revisada(s)": "{n} صفحة/صفحات · {r} تمت مراجعتها",
 "{n} páginas": "عدد الصفحات: {n}",
 "{n} recebido(s) dos seus grupos": "{n} وارد من مجموعاتك",
 "{n} recebido(s) para responder": "{n} وارد بانتظار الرد",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} وجبة/وجبات، بقائمة ذلك اليوم",
 "{n} reserva(s) nova(s) ou alterada(s).": "حجوزات جديدة أو معدّلة: {n}.",
 "{n} resultado(s) em todas as publicações": "{n} نتيجة في جميع النشرات",
 "{n} selecionado(s): {lista}": "تم تحديد {n}: {lista}",
 "{n} tarefa(s)": "{n} مهمة/مهام",
 "{n} tarefa(s) apagada(s) por inteiro": "تم حذف {n} مهمة/مهام بالكامل",
 "{n} tarefa(s) criada(s)": "تم إنشاء {n} مهمة",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "خرجت {n} مهمة منزلية من My Planner وأصبحت الآن في منزلي فقط. لنقل إحداها إلى Planner، افتح المهمة واضغط \"إرسال إلى My Planner\".",
 "{n} tarefa(s) de ontem sem concluir": "مهام الأمس غير المكتملة: {n}",
 "{n} tarefa(s) dos últimos dias sem concluir": "مهام الأيام الأخيرة غير المكتملة: {n}",
 "{n} tarefa(s) hoje": "{n} مهمة/مهام اليوم",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "ستنتقل {n} مهمة/مهام معلّقة إلى قائمة اليوم.",
 "{n} tarjas no documento": "{n} أشرطة سوداء في المستند",
 "{n} treino(s), cada um nos dias dele": "{n} تمرين/تمارين، كلٌّ في أيامه",
 "{n} tribunais": "{n} محاكم",
 "{n}x de {v}": "{n} × {v}",
 "{n}º alerta": "التنبيه رقم {n}",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "تم إرسال {ok}، و{falhas} بها خطأ. حاول مرة أخرى لاحقًا.",
 "{ok} enviado(s).": "تم إرسال {ok}.",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} من {d} ليلة مشغولة. الحجوزات الممتدة بين شهرين تُقسَّم حسب الليالي.",
 "{preco} por ano": "{preco} سنويًا",
 "{p} de {t} parcelas pagas ({pct}%)": "تم دفع {p} من {t} قسط ({pct}%)",
 "{p} presentes · {f} faltas": "{p} حاضر · {f} غياب",
 "{p}% da meta de {m} páginas": "{p}% من هدف {m} صفحة",
 "{p}% feito": "{p}% منجز",
 "{p}% ocupado no mês": "إشغال {p}% هذا الشهر",
 "{p}% pronta": "{p}% جاهز",
 "{p}/{t} pagas": "{p}/{t} مدفوعة",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "دعاك {quem} إلى المجموعة \"{grupo}\" في My Planner. اضغط الرابط للانضمام (التطبيق مجاني للبدء): {link}\nرمز الدعوة: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "أضاف {quem} وآخرون {n} عناصر إلى المجموعة.",
 "{quem} incluiu {item} no grupo.": "أضاف {quem} {item} إلى المجموعة.",
 "{servico} do veículo": "{servico} للمركبة",
 "{s} de {a}": "{s} من {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: عُد الساعة {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (نسخة)",
 "{uso} usados de {total} reservados para o site": "تم استخدام {uso} من {total} المحجوزة للموقع",
 "{v} · atualização de {data}": "{v} · تحديث {data}",
 "{v}/hora": "{v}/ساعة",
 "À direita": "على اليمين",
 "À vista": "دفعة واحدة",
 "Às": "الساعة",
 "Às {hora}": "الساعة {hora}",
 "ÁGUA": "الماء",
 "Ácido": "حمضية",
 "Água": "الماء",
 "Água hoje": "الماء اليوم",
 "Área externa": "المساحة الخارجية",
 "Áreas": "الأقسام",
 "Áudio": "صوت",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "هذه أداة مساعدة ولا تغني عن متابعة الإخطارات القضائية عبر القنوات الرسمية. يجب التحقق من المهل في النظام الرسمي.",
 "Ética Profissional": "أخلاقيات المهنة",
 "Ícone e aba": "الرمز والتبويب",
 "Óculos de sol": "نظارة شمسية",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "جهة الإصدار (مثال: DETRAN-MS، الشرطة الفيدرالية)",
 "Órgão emissor: {nome}": "جهة الإصدار: {nome}",
 "Ômega 3": "أوميغا 3",
 "Última": "الأخيرة",
 "Última adubação": "آخر تسميد",
 "Última aplicação": "آخر جرعة",
 "Última busca do servidor para você: {quando}": "آخر بحث للخادم لك: {quando}",
 "Última cópia de segurança: {data}": "آخر نسخة احتياطية: {data}",
 "Última rega": "آخر ري",
 "Última sincronização: {quando}": "آخر مزامنة: {quando}",
 "Última: {data}": "الأخيرة: {data}",
 "Último dia para entregar a declaração do IR": "آخر يوم لتقديم إقرار IR",
 "Último erro: {m}": "آخر خطأ: {m}",
 "Últimos 30 dias": "آخر 30 يومًا",
 "Últimos 7 dias": "آخر 7 أيام",
 "íris": "قزحية العين",
 "última vez em {data}": "آخر مرة في {data}",
 "último em {d}": "آخرها في {d}",
 "úteis": "عمل",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ هو لون My Planner. ينطبق اختيارك على جميع المحادثات في هذا الجهاز وفي حسابك.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} يتصل بك (فيديو)",
 "📆 Conectar a agenda deste celular": "📆 ربط تقويم هذا الهاتف",
 "📞 {nome} está ligando (áudio)": "📞 {nome} يتصل بك (صوتي)",
 "Link bloqueado por segurança.": "تم حظر الرابط لأسباب أمنية.",
 "Este arquivo não é uma imagem válida.": "هذا الملف ليس صورة صالحة.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "البحث التلقائي في الخادم يتابع أول 5 ملفات تعريف. يتم فحص الباقي عند الضغط على \"تحقق الآن\".",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "تعرض هذه الشاشة الخط الزمني للرحلة، مع الأنشطة والأماكن التي لها يوم محدد. لإضافة المعلومات الكاملة لمكان أو تعديلها، استخدم تبويب الأماكن.",
 "Para a viagem {d}": "لرحلة {d}",
 "sem nome": "بلا اسم",
 "Foi para a viagem {d}.": "نُقل إلى رحلة {d}.",
 "Orçamento total (se não for detalhar)": "الميزانية الإجمالية (إن لم تُفصّلها)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "خطّط البرنامج يومًا بيوم. الأماكن التي لها يوم محدد تظهر هنا تلقائيًا. خلال فترة الرحلة، يظهر البرنامج في الخط الزمني لـ My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "حدّد اليوم والوقت في المكان ليظهر تلقائيًا في البرنامج.",
 "No roteiro": "في البرنامج",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" موجود في برنامج {data}. لتغيير اليوم أو الوقت، عدّل المكان.",
 "Para o roteiro desta viagem": "لبرنامج هذه الرحلة",
 "Orçamento e gastos": "الميزانية والمصروفات",
 "Parada (cidade)": "المحطة (المدينة)",
 "Item da categoria": "بند الفئة",
 "Orçamento da viagem inteira": "ميزانية الرحلة كاملة",
 "Orçamento geral da viagem": "الميزانية العامة للرحلة",
 "Previsto {p} · gasto {g}": "المتوقع {p} · المصروف {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "هنا تكاليف الرحلة التي لا تخص محطة معينة (مثال: التذاكر، التأمين). لكل محطة ميزانيتها الخاصة.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "أدخل المبلغ الذي تنوي إنفاقه في كل فئة. عند تسجيل المصروفات، يعرض التطبيق المبلغ المستخدم.",
 "Orçamento por parada": "الميزانية لكل محطة",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "هل ستمر بأكثر من مدينة؟ أضف المحطات (تبويب المحطات): لكل محطة ميزانيتها، وتدخل مصروفات تلك التواريخ فيها تلقائيًا.",
 "Coloque o valor do gasto.": "أدخل مبلغ المصروف.",
 "Orçamento de {c}": "ميزانية {c}",
 "Lançar um gasto nesta parada": "تسجيل مصروف في هذه المحطة",
 "Lançar gasto": "تسجيل مصروف",
 "Orçamento e gastos da parada": "ميزانية المحطة ومصروفاتها",
 "Gastos lançados ({n})": "المصروفات المسجلة ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "لتصحيح مصروف أو حذفه، استخدم تبويب الميزانية والمصروفات في الرحلة.",
 "Paradas": "المحطات",
 "Cidade ou lugar": "المدينة أو المكان",
 "Ex.: Porto": "مثال: بورتو",
 "Chegada": "الوصول",
 "Saída": "المغادرة",
 "Onde vai ficar": "مكان الإقامة",
 "gasto {g} de {p}": "صُرف {g} من {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "هل ستمر بأكثر من مدينة؟ أضف كل محطة مع تواريخها. لكل محطة ميزانيتها (الإقامة، الوجبات، المواصلات...) وتدخل مصروفات تلك التواريخ فيها تلقائيًا.",
 "Café da tarde": "قهوة العصر",
 "Outros / Lanches": "أخرى / وجبات خفيفة",
 "Gasto {v}": "المصروف {v}",
 "Gasto {g} de {p} · {a} acima": "صُرف {g} من {p} · تجاوز بـ {a}",
 "Gasto {g} de {p}": "صُرف {g} من {p}",
 "Tirar \"{nome}\" do orçamento?": "هل تريد إزالة \"{nome}\" من الميزانية؟",
 "Os gastos já lançados nela continuam na lista de gastos.": "تبقى المصروفات المسجلة فيها في قائمة المصروفات.",
 "Previsto para {nome}": "المتوقع لـ {nome}",
 "Tirar {nome}": "إزالة {nome}",
 "Nome do item (ex.: Jantar especial)": "اسم البند (مثال: عشاء خاص)",
 "Adicionar item": "إضافة بند",
 "Detalhar em itens": "التفصيل في بنود",
 "Nova categoria (ex.: Seguro, Presentes)": "فئة جديدة (مثال: التأمين، الهدايا)",
 "Voltar às categorias sugeridas?": "هل تريد العودة إلى الفئات المقترحة؟",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "ستُحذف المبالغ المتوقعة في هذه القائمة. تبقى المصروفات المسجلة.",
 "Voltar às categorias sugeridas": "العودة إلى الفئات المقترحة",
 "Previsto": "المتوقع",
 "Ainda pode gastar": "المتبقي للإنفاق",
 "Passou do previsto": "تجاوز المتوقع",
 "Não foi possível buscar o câmbio": "تعذر الحصول على سعر الصرف",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "لا يوجد إنترنت أو العملة {m} غير موجودة في الجدول. عدّل الرحلة وأدخل السعر يدويًا.",
 "Câmbio de {m} ainda não definido": "سعر صرف {m} غير محدد بعد",
 "Câmbio de hoje": "سعر اليوم",
 "Atualizado em {d}": "تم التحديث في {d}",
 "Valor em {m}": "المبلغ بـ {m}",
 "Moeda do destino": "عملة الوجهة",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "سعر الصرف: كم تساوي وحدة واحدة من عملة الوجهة بعملتك",
 "Sem dia marcado": "بدون يوم محدد",
 "Valor na moeda do destino": "المبلغ بعملة الوجهة",
 "Tirar só desta lista ou excluir de vez?": "إزالة من هذه القائمة فقط أم الحذف نهائيًا؟",
 "Excluir de vez": "حذف نهائيًا",
 "Relatório da viagem (PDF)": "تقرير الرحلة (PDF)",
 "Planilha da viagem (Excel)": "جدول الرحلة (Excel)",
 "Geral da viagem": "الرحلة كاملة",
 "Viagem {d}": "رحلة {d}",
 "Quem vai: {p}": "المسافرون: {p}",
 "Outros gastos": "مصروفات أخرى",
 "Orçamento · {n}": "الميزانية · {n}",
 "Código": "الرمز",
 "Pagou": "دفع",
 "Permissão internacional para dirigir": "رخصة القيادة الدولية",
 "Vacina (certificado)": "لقاح (شهادة)",
 "Autorização de viagem de menor": "إذن سفر قاصر",
 "Vence antes da volta": "تنتهي قبل العودة",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "تنتهي بعد أقل من 6 أشهر من العودة (كثير من الدول لا تقبل ذلك)",
 "A lista básica já está aqui.": "القائمة الأساسية موجودة بالفعل.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} مستند(ات) قد تعيق صلاحيتها الرحلة",
 "Lista básica: passaporte de cada um e seguro viagem": "القائمة الأساسية: جواز سفر لكل شخص وتأمين سفر",
 "Lista básica: identidade de cada um": "القائمة الأساسية: بطاقة هوية لكل شخص",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "أدخل تاريخ صلاحية كل مستند: ينبهك التطبيق قبل انتهائه ويتحقق من أن جواز السفر صالح لمدة 6 أشهر بعد العودة. تبقى صور المستندات محمية في الخزنة.",
 "De quem": "لمن",
 "Número (protegido no cofre)": "الرقم (محمي في الخزنة)",
 "Está em mãos": "في حوزتي",
 "Válido até {d}": "صالح حتى {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "جواز السفر، التأشيرة، تأمين السفر، اللقاح، إذن القاصر... مع تاريخ الصلاحية والصورة. ضع علامة عندما يكون في حوزتك.",
 "acerto entre os viajantes (não entra no orçamento)": "تسوية بين المسافرين (لا تدخل في الميزانية)",
 "Só gastos": "المصروفات فقط",
 "Acertos": "التسويات",
 "Marcar como pago?": "وضع علامة مدفوع؟",
 "{de} já pagou {v} para {para}?": "هل دفع {de} مبلغ {v} إلى {para}؟",
 "Já pagou": "تم الدفع",
 "Acerto: {de} pagou {para}": "تسوية: {de} دفع إلى {para}",
 "Conferir minhas assinaturas": "تحقق من اشتراكاتي",
 "Gerenciar ou cancelar assinaturas na loja": "إدارة الاشتراكات أو إلغاؤها في المتجر",
 "Restaurar compras": "استعادة المشتريات",
 "Procurando...": "جارٍ البحث...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "تم العثور على {n} اشتراك وتفعيله.",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "اشتراك سنوي يتجدد تلقائيًا. يمكنك الإلغاء متى شئت من اشتراكات المتجر قبل 24 ساعة من التجديد.",
 "Assinaturas da loja": "اشتراكات المتجر",
 "Gerenciar assinaturas (App Store)": "إدارة الاشتراكات (App Store)",
 "Gerenciar assinaturas (Google Play)": "إدارة الاشتراكات (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "يتم الاشتراك من تطبيق الهاتف (Google Play أو App Store) ويعمل أيضًا هنا على الموقع.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "هذا الاشتراك غير متاح في المتجر بعد. حاول لاحقًا.",
 "Assinatura feita": "تم الاشتراك",
 "Já assinei no celular: conferir": "اشتركت بالفعل من الهاتف: تحقق",
 "Nenhuma assinatura encontrada nesta conta da loja.": "لم يتم العثور على أي اشتراك في حساب المتجر هذا.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "تحقق من الإنترنت وحاول مرة أخرى. لم يتم خصم أي مبلغ.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "تم فتح {aba}. يعمل أيضًا على أجهزتك الأخرى وعلى الموقع.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "للاشتراك، حدّث My Planner من Google Play أو App Store.",
 "Assinada, renova em {data}": "مشترك، يتجدد في {data}",
 "Não deu para assinar agora": "تعذر الاشتراك الآن",
 "Assinar por {preco} por ano": "اشترك مقابل {preco} سنويًا",
 "\"{nome}\" foi para o Mural, em Conquistas.": "انتقل \"{nome}\" إلى لوحة الإعلانات، ضمن الإنجازات.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "أصبح \"{nome}\" جزءًا من روتينك. انتقل إلى لوحة الإعلانات، ضمن الإنجازات.",
 "\"{nome}\" voltou para o lugar.": "عاد \"{nome}\" إلى مكانه.",
 "1 ano": "سنة واحدة",
 "1 mês": "شهر واحد",
 "A IA não achou o valor no comprovante.": "لم يعثر الذكاء الاصطناعي على المبلغ في الإيصال.",
 "A cada {n} dias": "كل {n} أيام",
 "A carta está vazia": "الرسالة فارغة",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "تبقى الرسالة مقفلة حتى {d}. حتى ذلك الحين لا يمكن إعادة قراءتها أو تعديلها. لتغيير شيء، اكتب رسالة أخرى.",
 "A lixeira está vazia.": "سلة المهملات فارغة.",
 "A mesma do app e do celular": "نفس قفل التطبيق والهاتف",
 "A mesma forma de desbloqueio do app e do celular": "نفس طريقة فتح القفل في التطبيق والهاتف",
 "A senha do diário precisa ter 6 caracteres ou mais.": "يجب أن تتكون كلمة مرور اليوميات من 6 أحرف أو أكثر.",
 "A senha precisa ter 6 caracteres ou mais.": "يجب أن تتكون كلمة المرور من 6 أحرف أو أكثر.",
 "A turma ainda não tem grupo": "ليس للفصل مجموعة بعد",
 "AS 4 BOLINHAS DE COR": "النقاط الملونة الأربع",
 "Aberta em {d}": "فُتحت في {d}",
 "Abra a aba para poder restaurar": "افتح التبويب لتتمكن من الاستعادة",
 "Abra o diário primeiro": "افتح اليوميات أولًا",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "تُفتح بالقياسات الحيوية أو التعرف على الوجه أو كلمة مرور التطبيق. تُطلب كلمة مرور اليوميات مرة واحدة فقط على كل جهاز.",
 "Abre em {d}": "تُفتح في {d}",
 "Abrir carta para o futuro": "فتح رسالة إلى المستقبل",
 "Abrir em {aba}": "فتح في {aba}",
 "Abrir o Diário": "فتح اليوميات",
 "Abrir o diário": "فتح اليوميات",
 "Abrir {aba}": "فتح {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "يتابع العقار والحجوزات والإشغال والمصروفات والأرباح، دون تغيير أي شيء.",
 "Adicionar foto": "إضافة صورة",
 "Apaga tudo o que está no quadro desta página.": "يمسح كل ما في لوحة الرسم في هذه الصفحة.",
 "Apagar o desenho?": "حذف الرسم؟",
 "Apagar o diário": "حذف اليوميات",
 "Apagar para todos?": "حذف للجميع؟",
 "Aplicar a todas as páginas desta matéria": "تطبيق على جميع صفحات هذه المادة",
 "Aplicar a todas as páginas desta pasta": "تطبيق على جميع صفحات هذا المجلد",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "ملازم وقوائم وشرائح وفيديوهات وروابط ورسائل. من ⋮ › إرسال إلى الفصل، يستلمها كل طالب في تطبيقه.",
 "Aquarela": "ألوان مائية",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "هنا يظهر مجانًا ما شاركته المجموعات معك. لاستخدام التبويب ببياناتك الخاصة، اشترك في التبويب.",
 "Arquivados": "المؤرشفة",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "اسحب لليمين للحذف، أو لليسار للأرشفة.",
 "As cobranças desta aula extra já existem.": "مطالبات هذا الدرس الإضافي موجودة بالفعل.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "تُرسل الدرجات لكل طالب على حدة. لذلك يجب أن يكون اسم الشخص في المجموعة مطابقًا لاسم الطالب أو ولي الأمر في السجل.",
 "Atestado": "شهادة طبية",
 "Atestados": "الشهادات الطبية",
 "Até quando (opcional)": "حتى متى (اختياري)",
 "Até {d}": "حتى {d}",
 "Aula extra": "درس إضافي",
 "Aula extra (fora dos dias de aula)": "درس إضافي (خارج أيام الدروس)",
 "Aula extra de {d}": "درس إضافي بتاريخ {d}",
 "Avaliação de {d}": "تقييم {d}",
 "Avaliação salva": "تم حفظ التقييم",
 "Avançar": "التالي",
 "Aviso da revisão do mês": "تنبيه مراجعة الشهر",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "تنبيه في آخر يوم من الشهر: \"ما رأيك أن تراجع شهرك؟ ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "تنبيه بلا أي محتوى من اليوميات: \"كيف كان يومك؟ ✍️\"",
 "Avulsa": "منفردة",
 "Avulsas": "منفردة",
 "Azul": "أزرق",
 "Baixar na App Store": "التنزيل من App Store",
 "Baixar na Google Play": "التنزيل من Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "نزّل My Planner من المتجر: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "القياسات الحيوية أو التعرف على الوجه أو كلمة مرور التطبيق. تُحفظ كلمة مرور اليوميات بعد أول مرة على كل جهاز.",
 "Branco": "أبيض",
 "Buscando o clima…": "جارٍ جلب الطقس…",
 "Básicas": "أساسية",
 "COMO ESTOU": "كيف حالي",
 "COMO O DIÁRIO ABRE": "كيف تُفتح اليوميات",
 "COR DA FOLHA": "لون الورقة",
 "Caixinha no My Planner": "صندوق في My Planner",
 "Caixinha {m}": "صندوق {m}",
 "Carta de {d}": "رسالة بتاريخ {d}",
 "Carta guardada": "تم حفظ الرسالة",
 "Carta para o futuro": "رسالة إلى المستقبل",
 "Carta trancada": "رسالة مقفلة",
 "Cartas abertas podem ser lidas, mas não editadas.": "يمكن قراءة الرسائل المفتوحة، لكن لا يمكن تعديلها.",
 "Cartas para o Futuro": "رسائل إلى المستقبل",
 "Cartões arquivados": "البطاقات المؤرشفة",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "وصلت رسالة من {nome} قبل {tempo} 💌",
 "Chegou! Toque para abrir 💌": "وصلت! المس لفتحها 💌",
 "Cinza-escuro": "رمادي داكن",
 "Clara (segue o tema)": "فاتح (يتبع السمة)",
 "Claras e pastel (boas para folha escura)": "فاتحة وباستيل (مناسبة للورقة الداكنة)",
 "Clima (toque para preencher)": "الطقس (المس للتعبئة)",
 "Clima automático": "الطقس التلقائي",
 "Clima do dia": "طقس اليوم",
 "Cobrar a aula extra": "المطالبة بالدرس الإضافي",
 "Cobrar a aula extra dos presentes": "مطالبة الحاضرين بالدرس الإضافي",
 "Cobrar a turma toda": "مطالبة الفصل كله",
 "Cole um link que comece com https://": "الصق رابطًا يبدأ بـ https://",
 "Coloque o valor da aula extra na turma (Editar).": "ضع قيمة الدرس الإضافي في الفصل (تعديل).",
 "Coloque o valor.": "ضع القيمة.",
 "Colunas": "أعمدة",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "عند تفعيل الذكاء الاصطناعي الخاص بك (الإعدادات › الذكاء الاصطناعي)، يقرأ التطبيق المبلغ والتاريخ والوصف من الصورة.",
 "Como cuidei de mim hoje?": "كيف اعتنيت بنفسي اليوم؟",
 "Como foi o seu dia? ✍️": "كيف كان يومك؟ ✍️",
 "Compartilhar este projeto (convidar)": "مشاركة هذا المشروع (دعوة)",
 "Compartilhar o texto": "مشاركة النص",
 "Completa": "كاملة",
 "Comprovante (foto, PDF ou print)": "إيصال (صورة أو PDF أو لقطة شاشة)",
 "Comprovante anexado": "تم إرفاق الإيصال",
 "Comprovante de pagamento (foto ou PDF)": "إيصال الدفع (صورة أو PDF)",
 "Concluído: hábito formado": "مكتمل: تكوّنت العادة",
 "Concluídos": "المكتملة",
 "Configurar o Diário": "إعداد اليوميات",
 "Confirmar pagamento": "تأكيد الدفع",
 "Confirmar recebimento": "تأكيد الاستلام",
 "Conquistas": "الإنجازات",
 "Contas arquivadas": "الحسابات المؤرشفة",
 "Continuar escrevendo": "متابعة الكتابة",
 "Copiado ✓": "تم النسخ ✓",
 "Copiar código": "نسخ الرمز",
 "Copiar link": "نسخ الرابط",
 "Cor atual": "اللون الحالي",
 "Cor {n}": "اللون {n}",
 "Creme": "كريمي",
 "Criada em {d}": "أُنشئت في {d}",
 "Criar as cobranças": "إنشاء المطالبات",
 "Criar o grupo da turma": "إنشاء مجموعة الفصل",
 "Criar o meu diário": "إنشاء يومياتي",
 "Crie a senha do diário (6 ou mais)": "أنشئ كلمة مرور اليوميات (6 أحرف أو أكثر)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "أنشئ مجموعة الفصل وأرسل الدعوة إلى الطلاب. بعد ذلك يصل الإرسال إليهم مباشرة.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "أنشئ أول هدف أو غاية أو حلم لك بالزر + أدناه.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "أنشئ مشروعًا، وادعُ المشاركين، وقسّم الخطوات. كل شخص يحدد ما أنجزه.",
 "Crie uma senha nova para começar.": "أنشئ كلمة مرور جديدة للبدء.",
 "Cuidados arquivados": "العناية المؤرشفة",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "العناية الشخصية لليوم مكتملة (العافية)",
 "Curto prazo": "قصير المدى",
 "Custos": "التكاليف",
 "Céu estrelado": "سماء مرصّعة بالنجوم",
 "Círculo": "دائرة",
 "Cômodos arquivados": "الغرف المؤرشفة",
 "DIAS CUMPRIDOS": "الأيام المنجزة",
 "Data (opcional)": "التاريخ (اختياري)",
 "De {d}": "من {d}",
 "Desafixar do topo": "إلغاء التثبيت في الأعلى",
 "Desenho mais fraco ou mais forte": "رسم أخف أو أقوى",
 "Desfazer \"Concluído\" ({d})": "التراجع عن \"مكتمل\" ({d})",
 "Desligado": "متوقف",
 "Desmarcar": "إلغاء التحديد",
 "Desmarcar como paga?": "إلغاء تحديدها كمدفوعة؟",
 "Desmarcar como recebida?": "إلغاء تحديدها كمستلمة؟",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "ألغِ تحديد ما لا تستخدمه: يختفي من الشاشة ويصبح التبويب أبسط. يمكنك التغيير لاحقًا من الإعدادات › التبويبات › {aba} › أجزاء هذا التبويب.",
 "Dias da semana": "أيام الأسبوع",
 "Dias de aula": "أيام الدروس",
 "Dias de aula: {d}": "أيام الدروس: {d}",
 "Dias escritos": "الأيام المكتوبة",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "نصيحة: ارسم الشكل بيدك واضغط بإصبعك مطولًا في نهاية الخط ليصبح مثاليًا.",
 "Ditado": "إملاء",
 "Ditar (falar para escrever)": "إملاء (تحدّث لتكتب)",
 "Diário apagado": "تم حذف اليوميات",
 "Diário protegido": "يوميات محمية",
 "Dom": "أحد",
 "Dê um nome a ele na pasta Hábitos.": "أعطه اسمًا في مجلد العادات.",
 "EVOLUÇÃO": "التطور",
 "Editada em {d}": "عُدّلت في {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "تُفتح في {d} (بعد {n} يومًا). حتى ذلك الحين لا يمكن إعادة قراءتها أو تعديلها.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "تُفتح في {d}. سيصلك تنبيه في ذلك اليوم.",
 "Ela fica guardada com a data de hoje para comparar depois.": "تُحفظ بتاريخ اليوم للمقارنة لاحقًا.",
 "Enorme": "ضخم",
 "Enviado ao paciente": "أُرسل إلى المريض",
 "Enviado em": "أُرسل في",
 "Enviar \"{t}\" para todos do grupo {g}?": "إرسال \"{t}\" إلى جميع أعضاء المجموعة {g}؟",
 "Enviar a nota para cada aluno": "إرسال الدرجة لكل طالب",
 "Enviar as notas": "إرسال الدرجات",
 "Enviar o arquivo: {nome}": "إرسال الملف: {nome}",
 "Enviar o recado para a turma": "إرسال الرسالة إلى الفصل",
 "Enviar o título para outra aba": "إرسال العنوان إلى تبويب آخر",
 "Enviar para a turma": "إرسال إلى الفصل",
 "Enviar para outra aba": "إرسال إلى تبويب آخر",
 "Escolha a cor desta bolinha": "اختر لون هذه النقطة",
 "Escolha uma data no futuro": "اختر تاريخًا في المستقبل",
 "Escolher qualquer cor": "اختيار أي لون",
 "Esconder a barra": "إخفاء الشريط",
 "Escreva a frase": "اكتب العبارة",
 "Escreva a que se refere a cobrança.": "اكتب ما تخص المطالبة.",
 "Escreva alguma coisa antes de guardar.": "اكتب شيئًا قبل الحفظ.",
 "Escreva alguma coisa antes de salvar.": "اكتب شيئًا قبل الحفظ.",
 "Escreva hoje, abra no futuro": "اكتب اليوم، وافتح في المستقبل",
 "Escreva o que você quer mudar a partir de hoje": "اكتب ما تريد تغييره بدءًا من اليوم",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "اكتب لنفسك في المستقبل. تبقى الرسالة مقفلة حتى يوم فتحها.",
 "Escrever uma carta": "كتابة رسالة",
 "Escrita em {e} · abre em {a}": "كُتبت في {e} · تُفتح في {a}",
 "Escuras (boas para folha clara)": "داكنة (مناسبة للورقة الفاتحة)",
 "Esperado": "المتوقع",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "المتوقع: {e} · المنجز: {f} · المتبقي: {fa}",
 "Esqueceu a senha do diário?": "نسيت كلمة مرور اليوميات؟",
 "Esqueci a senha do diário": "نسيت كلمة مرور اليوميات",
 "Esta semana": "هذا الأسبوع",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "هذا القيد يأتي من جزء آخر من التطبيق ولا يُحذف من هنا.",
 "Estudo: {h}": "الدراسة: {h}",
 "Esvaziar": "إفراغ",
 "Esvaziar a lixeira": "إفراغ سلة المهملات",
 "Esvaziar a lixeira?": "إفراغ سلة المهملات؟",
 "Ex.: Comer uma fruta por dia": "مثال: تناول فاكهة كل يوم",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "مثال: واجبات منزلية، شهادة طبية ليومين",
 "Ex.: Reservar a pousada": "مثال: حجز النُزل",
 "Ex.: Viagem em família, juntar para a festa": "مثال: رحلة عائلية، الادخار للحفلة",
 "Excluir de vez?": "حذف نهائيًا؟",
 "Excluir esta avaliação?": "حذف هذا التقييم؟",
 "Excluir este bloco?": "حذف هذه الكتلة؟",
 "Excluir este desenho?": "حذف هذا الرسم؟",
 "Excluir este item?": "حذف هذا العنصر؟",
 "Excluir {n} item(ns)?": "حذف {n} عنصر/عناصر؟",
 "Exportar como imagem": "تصدير كصورة",
 "Exportar em PDF": "تصدير بصيغة PDF",
 "FOTOS": "الصور",
 "FRASE DO DIA": "عبارة اليوم",
 "FREQUÊNCIA": "التكرار",
 "Falta o valor": "المبلغ ناقص",
 "Feriado": "عطلة رسمية",
 "Feriado: {f}": "عطلة رسمية: {f}",
 "Fica 30 dias na lixeira.": "يبقى 30 يومًا في سلة المهملات.",
 "Ficam 30 dias na lixeira.": "تبقى 30 يومًا في سلة المهملات.",
 "Fichários arquivados": "المجلدات المؤرشفة",
 "Fixar no topo": "تثبيت في الأعلى",
 "Floral": "زهري",
 "Folha": "الورقة",
 "Folha, tema e cores das páginas com escrita": "الورقة والسمة وألوان صفحات الكتابة",
 "Folhas e plantas": "أوراق ونباتات",
 "Foto adicionada": "تمت إضافة الصورة",
 "Foto do sonho": "صورة الحلم",
 "Fotos do dia": "صور اليوم",
 "Frase": "عبارة",
 "Frase do dia (aparece no topo do Meu Dia)": "عبارة اليوم (تظهر أعلى يومي)",
 "Frases, textos, vídeos e fotos que motivam": "عبارات ونصوص وفيديوهات وصور تحفّزك",
 "Geométrico": "هندسي",
 "Gerar": "إنشاء",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "تسجيل التذكيرات والملاحظات صوتيًا وإملاء النصوص (🎤) عندما تطلب ذلك. لا يعمل الميكروفون إلا بلمستك، ولا يُحفظ صوت الإملاء.",
 "Guardar e trancar": "حفظ وقفل",
 "Guardar e trancar?": "حفظ وقفل؟",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "احفظ هنا ما يحفّزك: عبارات ونصوصك وفيديوهات وصور.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "احتفظ بكلمة المرور هذه جيدًا: بدونها لا يمكن استرداد اليوميات.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "اليوم عطلة رسمية: {f}. هل تريد التسجيل رغم ذلك؟",
 "Humor do mês": "المزاج خلال الشهر",
 "Humor do período": "المزاج خلال الفترة",
 "HÁBITOS LIGADOS": "العادات المرتبطة",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "توجد عناصر كبيرة في التحديد. لا يمكن حذفها إلا واحدًا تلو الآخر، مع التأكيد وكلمة المرور.",
 "Há um ano": "قبل سنة",
 "Há um mês": "قبل شهر",
 "Hábito": "عادة",
 "Hábito criado": "تم إنشاء العادة",
 "Hábitos": "العادات",
 "Hábitos cumpridos": "العادات المنجزة",
 "Hábitos cumpridos: {f} de {n}": "العادات المنجزة: {f} من {n}",
 "Hábitos formados": "العادات المكتسبة",
 "INSPIRAÇÃO": "الإلهام",
 "Imagem adicionada": "تمت إضافة الصورة",
 "Imagem não encontrada": "لم يتم العثور على الصورة",
 "Incrível": "رائع",
 "Informação nutricional": "المعلومات الغذائية",
 "Inserir": "إدراج",
 "Inspiração": "الإلهام",
 "Item para o paciente": "عنصر للمريض",
 "Itens grandes só se excluem um por um.": "العناصر الكبيرة تُحذف واحدًا تلو الآخر فقط.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "اجمع صورًا لما تريد أن تعيشه. اضغط مطولًا واسحب للترتيب.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "الربط بحلم من مشروع الحياة (اختياري)",
 "LIGAR A UMA META (OPCIONAL)": "الربط بهدف (اختياري)",
 "LINKS DE VÍDEO": "روابط الفيديو",
 "Lance as notas antes de enviar.": "أدخل الدرجات قبل الإرسال.",
 "Lançamentos arquivados": "القيود المؤرشفة",
 "Legenda (opcional)": "التعليق (اختياري)",
 "Lembrete diário": "تذكير يومي",
 "Lendo o comprovante...": "جارٍ قراءة الإيصال...",
 "Ler o comprovante com a minha IA": "قراءة الإيصال بالذكاء الاصطناعي الخاص بي",
 "Ligado": "مفعّل",
 "Ligar um texto de motivação (Inspiração)": "ربط نص تحفيزي (الإلهام)",
 "Lilás": "بنفسجي فاتح",
 "Limpar a folha inteira?": "مسح الورقة بالكامل؟",
 "Linha reta": "خط مستقيم",
 "Linhas": "مسطرة",
 "Link do vídeo (YouTube, Instagram...)": "رابط الفيديو (YouTube، Instagram...)",
 "Lisa": "سادة",
 "Liste os passos do projeto e diga quem faz cada um.": "اكتب خطوات المشروع وحدد من يقوم بكل منها.",
 "Lixeira": "سلة المهملات",
 "Longo prazo": "طويل المدى",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "التحديد تلقائيًا عبر العافية (اختياري)",
 "META OU SONHO LIGADO (OPCIONAL)": "الهدف أو الحلم المرتبط (اختياري)",
 "Mais opções": "خيارات أخرى",
 "Mal": "سيئ",
 "Mandar ao paciente pelo WhatsApp": "إرسال إلى المريض عبر WhatsApp",
 "Marque o que fez em cada dia": "حدد ما أنجزته في كل يوم",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "حدد أيام الدروس في الفصل (تعديل) ليعرض الحضور تلك الأيام فقط.",
 "Matérias arquivadas": "المواد المؤرشفة",
 "Mensalidade": "الرسوم الشهرية",
 "Meta de água do Bem-Estar": "هدف الماء في العافية",
 "Metas arquivadas": "الأهداف المؤرشفة",
 "Metas e sonhos concluídos": "الأهداف والأحلام المكتملة",
 "Metas em andamento": "الأهداف الجارية",
 "Metas que avançaram": "الأهداف التي تقدّمت",
 "Metas, objetivos e sonhos, com passos e prazos": "أهداف وغايات وأحلام، بخطوات ومواعيد",
 "Meu Dia": "يومي",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "يومي بصفحة حرة، ومشروع الحياة، والعادات، ولوحة الأحلام، وعجلة الحياة، ورسائل إلى المستقبل، والإنجازات. محمي بكلمة مرور.",
 "Minimalista": "بسيط",
 "Mostrar as contas antes do vencimento": "عرض الحسابات قبل الاستحقاق",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "عرض التواريخ والأوقات والعملة والعطل الرسمية الصحيحة لمكانك. لا يُستخدم الموقع التقريبي للهاتف إلا عندما تطلب طقس اليوم في اليوميات، ولا يُحفظ.",
 "Muito bem": "جيد جدًا",
 "Muito mal": "سيئ جدًا",
 "Mural de fotos dos seus sonhos": "لوحة صور أحلامك",
 "Mural, relatório e revisão do mês": "لوحة الإعلانات والتقرير ومراجعة الشهر",
 "Médio prazo": "متوسط المدى",
 "N dias cumpridos no mês": "N يومًا منجزًا في الشهر",
 "N dias seguidos": "N يومًا متتاليًا",
 "NESTE DIA": "في هذا اليوم",
 "Nada a enviar": "لا شيء لإرساله",
 "Nenhum estudo registrado nesta semana.": "لا توجد دراسة مسجّلة هذا الأسبوع.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "لا توجد عادات بعد. مثال: \"تناول فاكهة كل يوم\"، \"شرب 2 لتر من الماء\"، \"عدم تفويت الفطور\".",
 "Nenhum no período.": "لا شيء في هذه الفترة.",
 "Nenhuma": "لا شيء",
 "Nenhuma carta ainda.": "لا توجد رسائل بعد.",
 "Nenhuma foto ainda.": "لا توجد صور بعد.",
 "Neutras e opacas": "محايدة وباهتة",
 "Ninguém encontrado no grupo": "لم يُعثر على أحد في المجموعة",
 "No computador: {link}": "على الكمبيوتر: {link}",
 "No navegador, a senha do diário é pedida sempre.": "في المتصفح، تُطلب كلمة مرور اليوميات دائمًا.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "في آخر يوم من الشهر: \"ما رأيك أن تراجع شهرك؟ ✨\"",
 "Nome da página (opcional)": "اسم الصفحة (اختياري)",
 "Nome de quem faz este passo": "اسم من يقوم بهذه الخطوة",
 "Nome do vídeo (opcional)": "اسم الفيديو (اختياري)",
 "Normal": "عادي",
 "Nota de 0 a 10 para cada área da vida": "درجة من 0 إلى 10 لكل مجال من مجالات الحياة",
 "Nota: {a}": "الدرجة: {a}",
 "Nova caixa": "صندوق جديد",
 "Nova carta": "رسالة جديدة",
 "Nova meta, objetivo ou sonho": "هدف أو غاية أو حلم جديد",
 "Nova senha (6 caracteres ou mais)": "كلمة مرور جديدة (6 أحرف أو أكثر)",
 "Nova área (ex.: Espiritualidade)": "مجال جديد (مثال: الروحانية)",
 "Novo cômodo": "غرفة جديدة",
 "Novo hábito": "عادة جديدة",
 "Não dá para excluir em grupo": "لا يمكن الحذف دفعة واحدة",
 "Não enviados": "غير المرسلة",
 "Não estão no grupo (ou com outro nome): {l}": "ليسوا في المجموعة (أو باسم مختلف): {l}",
 "Não foi possível exportar": "تعذّر التصدير",
 "Não foi possível ouvir agora ({erro}).": "تعذّر الاستماع الآن ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "لا تطلب كلمة مرور اليوميات. إنه الجزء الوحيد الذي يمكن مشاركته.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "ليس يوم درس لهذا الفصل. يُسجَّل الحضور كتعويض أو درس إضافي.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "ينبّهك التطبيق قبل {n} يوم/أيام وفي يوم الاستحقاق، الساعة 9 صباحًا. يمكنك التغيير من الإعدادات › التبويبات › المالية.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "يستخدم الطقس التلقائي موقع الهاتف. بدون إذن، يبقى للتعبئة هنا.",
 "O conteúdo desta carta não foi encontrado.": "لم يتم العثور على محتوى هذه الرسالة.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "يأتي الإملاء مع الإصدار الجديد من التطبيق. حدّث My Planner من المتجر (أو ثبّت ملف APK الجديد) لاستخدام الميكروفون.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "تطلب اليوميات كلمة المرور في كل مرة تدخلها، حتى مع فتح قفل التطبيق.",
 "O diário só abre com essa senha, sempre.": "لا تُفتح اليوميات إلا بكلمة المرور هذه، دائمًا.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "اليوميات مشفّرة: بدون كلمة المرور لا يستطيع أحد فتحها، ولا حتى الدعم. إن أردت، يمكنك حذف اليوميات والبدء بيوميات جديدة (تبقى المشاريع الجماعية).",
 "O que aprendi hoje?": "ماذا تعلّمت اليوم؟",
 "O que este mês te ensinou? O que quer levar para o próximo?": "ماذا علّمك هذا الشهر؟ وماذا تريد أن تأخذ معك إلى الشهر القادم؟",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "ما يبقى غير محدد يختفي من الشاشة. تبقى البيانات محفوظة.",
 "O que foi bom hoje?": "ما الشيء الجيد اليوم؟",
 "O que foi excluído nos últimos 30 dias": "ما حُذف خلال آخر 30 يومًا",
 "O que quero melhorar amanhã?": "ماذا أريد أن أحسّن غدًا؟",
 "O que quero mudar agora": "ما أريد تغييره الآن",
 "O que você escreveu nesta carta vai se perder.": "سيضيع ما كتبته في هذه الرسالة.",
 "O que você quer fazer com o arquivo?": "ماذا تريد أن تفعل بالملف؟",
 "Objetivo": "غاية",
 "Oculta": "مخفية",
 "Orientação": "إرشادات",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "إرشادات ووصفات وشهادات طبية ومواد لتسليمها إلى المريض، مع ملفات. لا يُرسل إلا ما هو هنا: الملف الطبي لا يخرج أبدًا من هذا المجلد.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "الأيام التي فيها صفحة مكتوبة تكون مميّزة. المس يومًا لفتحه.",
 "Os itens saem de vez e não podem mais ser restaurados.": "تُحذف العناصر نهائيًا ولا يمكن استعادتها بعد ذلك.",
 "Outra data": "تاريخ آخر",
 "Outras moedas": "عملات أخرى",
 "Ouvindo…": "جارٍ الاستماع…",
 "PASSOS": "الخطوات",
 "PDF com seus dados e assinatura": "PDF ببياناتك وتوقيعك",
 "POR DIA": "حسب اليوم",
 "POR MATÉRIA": "حسب المادة",
 "PROGRESSO": "التقدّم",
 "Paciente: {nome}": "المريض: {nome}",
 "Para o paciente": "للمريض",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "لتغيير طريقة الفتح، ادخل إلى اليوميات بكلمة مرورها ثم عد إلى هنا.",
 "Para {nome} de {tempo} depois": "إلى {nome} بعد {tempo}",
 "Parar o ditado": "إيقاف الإملاء",
 "Parcelado": "بالتقسيط",
 "Partes desta aba": "أجزاء هذا التبويب",
 "Passo": "خطوة",
 "Pastas arquivadas": "المجلدات المؤرشفة",
 "Pastas arquivadas ({n})": "المجلدات المؤرشفة ({n})",
 "Pautada": "مسطّرة",
 "Pautada com margem": "مسطّرة بهامش",
 "Pedido de exame": "طلب فحص",
 "Pelo que sou grata hoje?": "على ماذا أنا ممتنّة اليوم؟",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "اسمح بالميكروفون والتعرف على الكلام لـ My Planner في إعدادات الهاتف.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "تخصيص: نوع الورقة ولونها وسمتها وألوان النقاط، لهذا التبويب فقط",
 "Pontilhada": "منقّطة",
 "Posto": "محطة الوقود",
 "Preenche o clima do Meu Dia pela localização do celular.": "يملأ طقس يومي حسب موقع الهاتف.",
 "Preencher pela foto do comprovante": "التعبئة من صورة الإيصال",
 "Primeira vez neste aparelho: digite a senha do diário.": "أول مرة على هذا الجهاز: أدخل كلمة مرور اليوميات.",
 "Projeto": "مشروع",
 "Projeto de Vida": "مشروع الحياة",
 "Projetos com amigos e família (compartilhados)": "مشاريع مع الأصدقاء والعائلة (مشتركة)",
 "Projetos em Grupo": "المشاريع الجماعية",
 "Proprietário / Locador": "المالك / المؤجِّر",
 "Páginas arquivadas": "الصفحات المؤرشفة",
 "Páginas desta aba": "صفحات هذا التبويب",
 "QUANDO ELA ABRE": "متى تُفتح",
 "Qua": "أربعاء",
 "Quadriculada": "مربّعات",
 "Quadro dos Sonhos": "لوحة الأحلام",
 "Quais partes você vai usar?": "ما الأجزاء التي ستستخدمها؟",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "عندما تُكمل هدفًا أو تكتسب عادة، يظهر هنا للاحتفال. 🎉",
 "Quanto você pagou?": "كم دفعت؟",
 "Quanto você recebeu?": "كم استلمت؟",
 "Que tal revisar o seu mês? ✨": "ما رأيك أن تراجع شهرك؟ ✨",
 "Quem faz": "من يقوم بها",
 "Quem fez o meu dia melhor?": "من جعل يومي أفضل؟",
 "Quer guardar o comprovante agora?": "هل تريد حفظ الإيصال الآن؟",
 "Qui": "خميس",
 "REFLEXÃO DO MÊS": "تأمّل الشهر",
 "Recebeu {v} a mais": "استلمت {v} زيادة",
 "Recebeu {v} a menos": "استلمت {v} أقل",
 "Receita médica": "وصفة طبية",
 "Receitas médicas": "الوصفات الطبية",
 "Recolher": "طيّ",
 "Refeições arquivadas": "الوجبات المؤرشفة",
 "Refeições do cronograma feitas (Bem-Estar)": "وجبات الجدول المنجزة (العافية)",
 "Referente a (ex.: material, passeio, inscrição)": "بخصوص (مثال: مواد، رحلة، تسجيل)",
 "Registrar": "تسجيل",
 "Relacionamentos": "العلاقات",
 "Relatório de estudos": "تقرير الدراسة",
 "Relatório de realizações": "تقرير الإنجازات",
 "Relatório em PDF": "تقرير PDF",
 "Renomear, adicionar ou tirar áreas": "إعادة تسمية المجالات أو إضافتها أو إزالتها",
 "Reposição": "تعويض",
 "Restaurado": "تمت الاستعادة",
 "Resumida": "مختصرة",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "مختصرة: سطر واحد فقط بالإجمالي. كاملة: تعرض عناصر اليوم. مخفية: لا تظهر. لا شيء من هذا التبويب يتحول إلى مهمة تلقائيًا.",
 "Resumo de {nome}": "ملخص {nome}",
 "Resumo do dia": "ملخص اليوم",
 "Retângulo": "مستطيل",
 "Revisar antes": "المراجعة أولًا",
 "Revisão do mês": "مراجعة الشهر",
 "Roda da Vida": "عجلة الحياة",
 "Rosa": "وردي",
 "Sair sem guardar?": "الخروج دون حفظ؟",
 "Salvar avaliação de hoje": "حفظ تقييم اليوم",
 "Salvar ou enviar": "حفظ أو إرسال",
 "Seg": "إثنين",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "اضغط مطولًا واسحب المجلدات لتغيير الترتيب. اسحب لليسار للأرشفة.",
 "Sem chamada neste dia: cobra todos os alunos.": "لا يوجد تسجيل حضور في هذا اليوم: تتم مطالبة جميع الطلاب.",
 "Sem ideia do que escrever? Toque numa pergunta:": "لا تعرف ماذا تكتب؟ المس سؤالًا:",
 "Sem registros de humor.": "لا توجد سجلات للمزاج.",
 "Sem tema": "بدون سمة",
 "Semana de {d}": "أسبوع {d}",
 "Senha atual do diário": "كلمة مرور اليوميات الحالية",
 "Senha do diário": "كلمة مرور اليوميات",
 "Senha do diário incorreta.": "كلمة مرور اليوميات غير صحيحة.",
 "Senha do diário trocada": "تم تغيير كلمة مرور اليوميات",
 "Senha própria só do diário": "كلمة مرور خاصة باليوميات فقط",
 "Sequência dos hábitos": "سلسلة العادات",
 "Seta": "سهم",
 "Seu diário, só seu": "يومياتك، لك وحدك",
 "Seu texto de motivação": "نصك التحفيزي",
 "Sex": "جمعة",
 "Sonho": "حلم",
 "Suplementos arquivados": "المكمّلات المؤرشفة",
 "Sáb": "سبت",
 "Só abre com a senha do diário.": "لا تُفتح إلا بكلمة مرور اليوميات.",
 "TEMA DECORATIVO": "سمة زخرفية",
 "TIPO DE FOLHA": "نوع الورقة",
 "Tarefas arquivadas": "المهام المؤرشفة",
 "Ter": "ثلاثاء",
 "Texto para o paciente": "نص للمريض",
 "Tipo, cor e tema da folha": "نوع الورقة ولونها وسمتها",
 "Tirar a área \"{a}\"?": "إزالة المجال \"{a}\"؟",
 "Tirar da frase do dia": "إزالة من عبارة اليوم",
 "Tirar do arquivo": "إخراج من الأرشيف",
 "Tirar esta foto do quadro?": "إزالة هذه الصورة من اللوحة؟",
 "Tirar esta pergunta?": "إزالة هذا السؤال؟",
 "Tirar este vídeo?": "إزالة هذا الفيديو؟",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "كل يوم الساعة {h}: \"كيف كان يومك؟ ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "لدى جميع الطلاب بالفعل مطالبة بهذا المرجع.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "المس مرة أخرى لـ \"أخرى\" (معفى، شهادة طبية...): لا يُحسب غيابًا ولا درسًا.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "المس الدائرة لتحديد ما أنجزته اليوم. لا تنتقل العادات إلى My Planner تلقائيًا: استخدم إرسال من القائمة ⋮.",
 "Toque num dia para marcar ou desmarcar.": "المس يومًا لتحديده أو إلغاء تحديده.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "المس نقطة لتغيير لونها. في الصفحة، الضغط المطوّل على النقطة يفعل الشيء نفسه.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "المس للفتح. اسحب لليسار للأرشفة أو التكرار، أو لليمين للحذف.",
 "Treino do dia feito (Bem-Estar)": "تمرين اليوم منجز (العافية)",
 "Treinos arquivados": "التمارين المؤرشفة",
 "Trocar a senha do diário": "تغيير كلمة مرور اليوميات",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "كل ما تكتبه في اليوميات يُشفَّر على هذا الجهاز قبل أن يصل إلى حسابك. لا يستطيع أحد غيرك قراءته، ولا حتى الدعم.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "كل ما تحذفه يبقى هنا لمدة 30 يومًا. بعد ذلك يُحذف نهائيًا.",
 "Título (ex.: Ter uma boa alimentação)": "العنوان (مثال: اتباع نظام غذائي جيد)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "مطالبة منفردة لكل واحد من الطلاب الـ {n}. لمطالبة طالب واحد فقط، المس +.",
 "Uma senha própria, só do diário": "كلمة مرور خاصة، لليوميات فقط",
 "Usar a senha do diário": "استخدام كلمة مرور اليوميات",
 "Usar como frase do dia": "استخدام كعبارة اليوم",
 "Usar este valor": "استخدام هذا المبلغ",
 "Usar o padrão do app": "استخدام الإعداد الافتراضي للتطبيق",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "ينطبق على مبالغ جميع التبويبات (المالية، الإيجار، الرسوم الشهرية...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "ينطبق على جميع صفحات الكتابة (الدراسة، الملاحظات، اليوميات، المستندات...). يمكن لكل تبويب أن يكون له إعداده الافتراضي في الإعدادات › التبويبات، ويمكن لكل صفحة تغيير الورقة من ⋮ › الورقة.",
 "Valor da aula extra (por aluno)": "قيمة الدرس الإضافي (لكل طالب)",
 "Valor por aluno": "القيمة لكل طالب",
 "Valor previsto: {v}": "القيمة المتوقعة: {v}",
 "Vencimento: {d}": "الاستحقاق: {d}",
 "Ver o comprovante": "عرض الإيصال",
 "Verde": "أخضر",
 "Visualizar": "معاينة",
 "Você está como convidado": "أنت مدعو",
 "Voltar a acompanhar este hábito": "العودة إلى متابعة هذه العادة",
 "Voltar ao início da folha": "العودة إلى بداية الورقة",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "العودة إلى الإعداد الأصلي (ورقة مسطّرة؛ أسود وأزرق وأحمر وأخضر)",
 "Voltar para a nova avaliação": "العودة إلى التقييم الجديد",
 "Vídeos": "الفيديوهات",
 "X vezes por semana": "X مرات في الأسبوع",
 "abre em {n} dias": "تُفتح بعد {n} يومًا",
 "agradável": "لطيف",
 "arquivo": "ملف",
 "aula extra": "درس إضافي",
 "calor": "حار",
 "chuva": "مطر",
 "concluído": "مكتمل",
 "céu limpo": "سماء صافية",
 "de {n} planejados": "من {n} مخطط لها",
 "dentro de {p}": "خلال {p}",
 "enviado em {d}": "أُرسل في {d}",
 "estudados na semana": "تمت دراستها هذا الأسبوع",
 "excluído em {d}": "حُذف في {d}",
 "falta 1 dia": "بقي يوم واحد",
 "faltam {n} dias": "بقي {n} يومًا",
 "feito {dur} na semana": "أُنجز {dur} هذا الأسبوع",
 "fresco": "منعش",
 "frio": "بارد",
 "garoa": "رذاذ",
 "hoje não está planejado": "غير مخطط لها اليوم",
 "hábito formado ✨": "تكوّنت العادة ✨",
 "incorreta": "غير صحيحة",
 "neblina": "ضباب",
 "neve": "ثلج",
 "nublado": "غائم",
 "não enviado": "لم يُرسل",
 "parcela {k}/{n}": "القسط {k}/{n}",
 "passou há {n} dias": "مضى {n} يومًا",
 "pelo Bem-Estar": "عبر العافية",
 "poucas nuvens": "غيوم قليلة",
 "reposição": "تعويض",
 "sai de vez em {n} dia(s)": "يُحذف نهائيًا بعد {n} يوم/أيام",
 "sem registros": "لا توجد سجلات",
 "tempestade": "عاصفة",
 "tracejado: {d}": "متقطع: {d}",
 "ver mais": "عرض المزيد",
 "ver menos": "عرض أقل",
 "{aluno}: {n} de {max}": "{aluno}: {n} من {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} عطلة رسمية: {f}. هل تريد التسجيل رغم ذلك؟",
 "{f} de {n} passos feitos": "{f} من {n} خطوات منجزة",
 "{f}/{n} passos": "{f}/{n} خطوات",
 "{nome} daqui a 1 ano": "{nome} بعد سنة",
 "{nome} daqui a 10 anos": "{nome} بعد 10 سنوات",
 "{nome} daqui a 6 meses": "{nome} بعد 6 أشهر",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} طالب/طلاب يستلمون درجتهم فقط في \"{a}\".",
 "{n} aluno(s) receberam a nota.": "استلم {n} طالب/طلاب الدرجة.",
 "{n} aluno(s) · {v} cada": "{n} طالب/طلاب · {v} لكل منهم",
 "{n} anos": "{n} سنوات",
 "{n} dia(s) antes": "قبل {n} يوم/أيام",
 "{n} dia(s) cumprido(s) no mês": "{n} يوم/أيام منجزة في الشهر",
 "{n} dia(s) registrado(s) · média {e}": "{n} يوم/أيام مسجّلة · المتوسط {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} يوم/أيام مسجّلة، المتوسط {m} من 6",
 "{n} dia(s) seguido(s)": "{n} يوم/أيام متتالية",
 "{n} dispensada(s) hoje": "{n} معفى اليوم",
 "{n} meses": "{n} أشهر",
 "{n} outro(s)": "{n} آخر/آخرون",
 "{n} selecionado(s)": "{n} محدد",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} مهمة/مهام مكتملة في My Planner",
 "{n} vez(es) por semana": "{n} مرة/مرات في الأسبوع",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "الماء: {a} من {m} مل",
 "ÚLTIMAS 8 SEMANAS": "آخر 8 أسابيع",
 "Última parcela em {d}": "آخر قسط في {d}",
 "é hoje!": "إنه اليوم!",
 "A mesma do app": "نفس كلمة مرور التطبيق",
 "Abrir com o código": "الفتح بالرمز",
 "Ainda não criado": "لم يُنشأ بعد",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "عند الإنشاء، يعرض التطبيق رمز استرداد لتحتفظ به.",
 "Apagar o diário e começar de novo": "حذف اليوميات والبدء من جديد",
 "Biometria ou código do dispositivo": "القياسات الحيوية أو رمز الجهاز",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "القياسات الحيوية أو رمز PIN للجهاز أو كلمة مرور التطبيق. لا حاجة لإنشاء كلمة مرور أخرى.",
 "Bloquear o app": "قفل التطبيق",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "سجّل بصمة أو وجهًا أو رمز قفل على الجهاز لاستخدام هذه الميزة.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "عند تفعيل القياسات الحيوية تظهر أولاً. إذا فشلت، تعرض النافذة نفسها رمز/PIN/نمط الجهاز؛ وتظل كلمة مرور التطبيق صالحة.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "يمكنك به استرداد اليوميات إذا نسيت كلمة المرور أو غيّرت الجهاز.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "بهذا الرمز يمكنك استرداد اليوميات إذا نسيت كلمة المرور أو غيّرت الجهاز. احفظه في مكان آمن ولا تُطلع عليه أحدًا.",
 "Como funciona a Roda da Vida": "كيف تعمل عجلة الحياة",
 "Como o diário abre": "طريقة فتح اليوميات",
 "Crie a senha que vai abrir o diário.": "أنشئ كلمة المرور التي ستفتح اليوميات.",
 "Crie o PIN do diário (4 a 6 números)": "أنشئ رمز PIN لليوميات (من 4 إلى 6 أرقام)",
 "Crie o diário de novo para começar.": "أنشئ اليوميات من جديد للبدء.",
 "Código aceito. Crie uma senha nova para o diário.": "تم قبول الرمز. أنشئ كلمة مرور جديدة لليوميات.",
 "Código de recuperação": "رمز الاسترداد",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "رمز الاسترداد (مثال: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "رمز الاسترداد غير صحيح.",
 "Cômodos": "الغرف",
 "Depois de 1 minuto": "بعد دقيقة واحدة",
 "Depois de {n} minutos": "بعد {n} دقائق",
 "Desenhe o padrão do diário": "ارسم نمط اليوميات",
 "Dias no mês": "أيام في الشهر",
 "Dias seguidos": "أيام متتالية",
 "Digite o seu PIN": "أدخل رمز PIN",
 "Diário ainda não criado": "لم تُنشأ اليوميات بعد",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "قيّم من 0 إلى 10 شعورك اليوم في كل مجال من مجالات الحياة. يوضح الرسم أين تتوازن حياتك وأين تحتاج إلى اهتمام. احفظ التقييم وكرّره من حين لآخر (مثلًا كل شهر) للمقارنة ومتابعة تطورك. يمكنك إعادة تسمية المجالات أو إضافتها أو إزالتها.",
 "Entre na aba Diário para criar o seu diário.": "انتقل إلى تبويب اليوميات لإنشاء يومياتك.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "ادخل إلى اليوميات (بكلمة مرورها أو بفتح قفل التطبيق) ثم عد إلى هنا.",
 "Esconder a senha": "إخفاء كلمة المرور",
 "Gerar novo código": "إنشاء رمز جديد",
 "Gerar um código de recuperação novo?": "إنشاء رمز استرداد جديد؟",
 "Guarde este código": "احتفظ بهذا الرمز",
 "Já guardei": "لقد حفظته",
 "Ligar um hábito que já existe": "ربط عادة موجودة",
 "Mostrar a senha": "إظهار كلمة المرور",
 "Mudar como o diário abre": "تغيير طريقة فتح اليوميات",
 "My Planner · Código de recuperação do Diário": "My Planner · رمز استرداد اليوميات",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "تعذّر الفتح بمفتاح هذا الجهاز. استخدم كلمة مرور اليوميات أو رمز الاسترداد.",
 "O Caps Lock parece estar ligado.": "يبدو أن Caps Lock مفعّل.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "يُحفظ رمز PIN على هذا الجهاز فقط بشكل محمي. تظل كلمة المرور صالحة إذا نسيت رمز PIN.",
 "O PIN precisa ter de 4 a 6 números.": "يجب أن يتكون رمز PIN من 4 إلى 6 أرقام.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "سيتوقف الرمز السابق عن العمل. لأسباب أمنية لا يُحفظ الرمز في التطبيق: يمكن رؤيته فقط لحظة إنشائه.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "لا يُحفظ الرمز في أي مكان يمكن لفريق الدعم رؤيته. بدون كلمة المرور والرمز لا يمكن استرداد اليوميات.",
 "O diário agora abre só com a senha dele.": "أصبحت اليوميات تُفتح بكلمة مرورها فقط.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "لا يمكن للتطبيقات استخدام التعرف على الوجه في هذا الجهاز. استخدم البصمة أو رمز/PIN الجهاز.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "يُحسب الوقت من لحظة خروج التطبيق من الشاشة (تطبيق آخر أو الشاشة الرئيسية أو إطفاء الشاشة). لا يُحتسب سحب الإشعارات أو نافذة القياسات الحيوية أو طلب إذن أو اختيار صورة أو ملف.",
 "Os PINs não conferem.": "رمزا PIN غير متطابقين.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (من 4 إلى 6 أرقام)",
 "PIN (só números, 4 a 6)": "PIN (أرقام فقط، من 4 إلى 6)",
 "PIN do diário": "رمز PIN لليوميات",
 "PIN incorreto": "رمز PIN غير صحيح",
 "PIN salvo.": "تم حفظ رمز PIN.",
 "Padrão do app": "الإعداد الافتراضي للتطبيق",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "للحذف، أكّد بكلمة مرور التطبيق أو القياسات الحيوية أو رمز PIN للجهاز. سيؤدي ذلك إلى حذف يومي والأهداف والعادات والرسائل وصور اليوميات. تبقى المشاريع الجماعية.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "للمتابعة، أدخل كلمة مرور التطبيق أو استخدم القياسات الحيوية/رمز الجهاز.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "لاسترداد اليوميات إذا نسيت كلمة المرور أو غيّرت الجهاز.",
 "Pastas": "المجلدات",
 "Pedir a senha de novo": "طلب كلمة المرور مجددًا",
 "Personalizada": "مخصص",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "أول مرة على هذا الجهاز: أدخل كلمة مرور اليوميات أو استخدم رمز الاسترداد.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "أول مرة على هذا الجهاز: أدخل رمز استرداد اليوميات.",
 "Reconhecimento de rosto": "التعرف على الوجه",
 "Repita o PIN": "أعد إدخال رمز PIN",
 "Salvar a senha nova": "حفظ كلمة المرور الجديدة",
 "Salvar em arquivo / no Drive": "الحفظ في ملف / في Drive",
 "Salvar o código de recuperação": "حفظ رمز الاسترداد",
 "Senha (letras e números)": "كلمة المرور (أحرف وأرقام)",
 "Senha do app": "كلمة مرور التطبيق",
 "Senha nova do diário": "كلمة مرور جديدة لليوميات",
 "Senha própria": "كلمة مرور خاصة",
 "Senha própria do diário": "كلمة مرور خاصة باليوميات",
 "Tarefas": "المهام",
 "Trocar o PIN": "تغيير رمز PIN",
 "Usar a senha": "استخدام كلمة المرور",
 "Usar o PIN": "استخدام رمز PIN",
 "Usar o código de recuperação": "استخدام رمز الاسترداد",
 "Usar o desbloqueio do app": "استخدام فتح قفل التطبيق",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "استخدم القياسات الحيوية أو رمز/PIN/نمط الجهاز.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "استخدم رمز الاسترداد الذي ظهر عند إنشاء اليوميات. بدون كلمة المرور والرمز لا يستطيع أحد فتح اليوميات، ولا حتى فريق الدعم.",
 "Voltar a usar só a senha?": "العودة إلى استخدام كلمة المرور فقط؟",
 "incorreto": "غير صحيح",
 "1 h": "1 س",
 "12 horas (2:30 PM)": "12 ساعة (2:30 PM)",
 "15 min": "15 د",
 "24 horas (14:30)": "24 ساعة (14:30)",
 "30 min": "30 د",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "تحتوي سلة المهملات على عناصر كبيرة. أكّد بكلمة مرور التطبيق أو البصمة أو رمز الجهاز.",
 "A semana começa na": "يبدأ الأسبوع يوم",
 "Abra o Diário primeiro": "افتح اليوميات أولًا",
 "Abrir configurações do celular": "فتح إعدادات الهاتف",
 "Agenda e mapas": "التقويم والخرائط",
 "Agora: {m}": "الآن: {m}",
 "Ajuda e sobre": "المساعدة وحول التطبيق",
 "Alarme (som)": "منبّه (صوت)",
 "Alarme ou vibração das pausas": "منبّه أو اهتزاز الاستراحات",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "يحذف الحساب وجميع البيانات في السحابة وعلى هذا الجهاز نهائيًا. يطلب كلمة مرورك أولًا.",
 "Apagar todas ({n})": "حذف الكل ({n})",
 "Apagar {n} selecionada(s)": "حذف المحدد ({n})",
 "Aparência": "المظهر",
 "App das rotas": "تطبيق المسارات",
 "Ardósia": "أردوازي",
 "Arrastar para a direita": "السحب إلى اليمين",
 "Arrastar para a esquerda": "السحب إلى اليسار",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "تظهر فواتير المالية في My Planner قبل موعدها بهذه المدة.",
 "Atualizações e sobre": "التحديثات وحول التطبيق",
 "Avisar antes do vencimento": "التنبيه قبل موعد الاستحقاق",
 "Aviso marcado": "تم ضبط التذكير",
 "Aviso no começo e no fim de cada pausa": "تنبيه في بداية كل استراحة ونهايتها",
 "Avisos desta aba": "تنبيهات هذا التبويب",
 "Avisos e alarmes": "التنبيهات والمنبّهات",
 "Avisos silenciosos": "تنبيهات صامتة",
 "Avisos: som e vibração": "التنبيهات: صوت واهتزاز",
 "Avisos: só som": "التنبيهات: صوت فقط",
 "Avisos: só vibração": "التنبيهات: اهتزاز فقط",
 "Azul elétrico": "أزرق كهربائي",
 "Azul-aço": "أزرق فولاذي",
 "Azul-bebê": "أزرق فاتح",
 "Azul-marinho": "كحلي",
 "Baixar meus dados": "تنزيل بياناتي",
 "Baixar todos os meus dados": "تنزيل جميع بياناتي",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "تنزيل جميع بياناتي وحذف الحساب (LGPD)",
 "Biometria": "البصمة الحيوية",
 "Bissexual": "ثنائي الميول",
 "Brilhante": "ساطع",
 "Buscar abas": "البحث في التبويبات",
 "Buscar nos ajustes": "البحث في الإعدادات",
 "Cancelar aviso": "إلغاء التذكير",
 "Cinza-chumbo": "رمادي فحمي",
 "Cofre": "الخزنة",
 "Coloque pelo menos uma matéria.": "أضف مادة واحدة على الأقل.",
 "Como usar": "طريقة الاستخدام",
 "Conexões": "الاتصالات",
 "Cor da aba": "لون التبويب",
 "Cor de destaque": "لون التمييز",
 "Crie uma matéria primeiro": "أنشئ مادة أولًا",
 "Cítrico": "حمضيات",
 "Cópia de segurança em arquivo": "نسخة احتياطية في ملف",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "بيانات المريض والسجل الطبي. أكّد بكلمة مرور التطبيق أو البصمة أو رمز الجهاز.",
 "Desligadas": "مُوقفة",
 "Digite a senha da sua conta para confirmar.": "أدخل كلمة مرور حسابك للتأكيد.",
 "Duração padrão de uma tarefa nova": "المدة الافتراضية للمهمة الجديدة",
 "Editar sessão": "تعديل الجلسة",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "تتكرر دون تاريخ انتهاء: تظهر المرات حتى {data}. إذا حددتها كلها، تُحذف المهمة بأكملها.",
 "Em atividade": "قيد النشاط",
 "Em pausa": "في استراحة",
 "Emoji da pausa": "رمز تعبيري للاستراحة",
 "Encerrar": "إنهاء",
 "Encerrar a sessão?": "إنهاء الجلسة؟",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "يدخل وضع التحديد لاختيار عدة عناصر دفعة واحدة.",
 "Escolha um horário no futuro.": "اختر وقتًا في المستقبل.",
 "Escolher a matéria": "اختيار المادة",
 "Esconde os valores em dinheiro (R$ •••)": "يخفي المبالغ المالية (R$ •••)",
 "Esconder o CPF": "إخفاء CPF",
 "Esconder os valores": "إخفاء المبالغ",
 "Esta e as próximas": "هذه والتالية",
 "Esta tarefa se repete. Onde aplicar a mudança?": "هذه المهمة متكررة. أين تريد تطبيق التغيير؟",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "يحتوي هذا العنصر على الكثير. أكّد بكلمة مرور التطبيق أو البصمة أو رمز الجهاز.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "يحذف العنصر (يطلب التأكيد). يمكنك التراجع لاحقًا أو الاستعادة من سلة المهملات.",
 "Excluir minha conta": "حذف حسابي",
 "Ficha protegida": "سجل محمي",
 "Formato da hora": "تنسيق الوقت",
 "Foto do Quadro dos Sonhos": "صورة لوحة الأحلام",
 "Geral": "عام",
 "Gestos": "الإيماءات",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive وOneDrive وملف النسخ الاحتياطي",
 "Grafite": "غرافيتي",
 "Guardar em": "الحفظ في",
 "Hábito do Diário": "عادة اليوميات",
 "Idioma e moeda": "اللغة والعملة",
 "Inspiração do Diário": "إلهام اليوميات",
 "Intenso": "مكثّف",
 "Item arquivado": "تمت أرشفة العنصر",
 "Item excluído": "تم حذف العنصر",
 "Lavanda": "لافندر",
 "Ligadas": "مُفعّلة",
 "Limite de energia": "حد الطاقة",
 "Lésbica": "مثلية",
 "Marque as vezes que vão ser apagadas.": "حدد المرات التي ستُحذف.",
 "Matéria": "المادة",
 "Me avise em…": "ذكّرني بعد…",
 "Menta": "نعناعي",
 "Menu ⋮": "القائمة ⋮",
 "Meta do Diário": "هدف اليوميات",
 "Modo discreto": "الوضع الخفي",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "جهّز الجلسة مرة واحدة (المواد ووقت كل منها والاستراحات) وكرّرها في الأيام الأخرى بالنقر على ابدأ. يُضاف وقت الدراسة تلقائيًا إلى الهدف.",
 "Mostra Arquivar e Duplicar.": "يعرض أرشفة وتكرار.",
 "Mostrar feriados no topo": "إظهار العطلات في الأعلى",
 "Mostrar os valores": "إظهار المبالغ",
 "Muda a ordem dos itens.": "يغيّر ترتيب العناصر.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "يغيّر لون My Planner فقط. لون التمييز للتطبيق في الإعدادات > المظهر. يمكن لكل مهمة أن يكون لها لونها الخاص في بطاقتها.",
 "Nada encontrado nos ajustes.": "لم يُعثر على شيء في الإعدادات.",
 "Nenhuma sessão salva ainda.": "لا توجد جلسات محفوظة بعد.",
 "Neon": "نيون",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "في هذا الوقت لا يرنّ التطبيق ولا يهتز. تستمر التنبيهات في الوصول بصمت.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "في القائمة ⋮ لأي عنصر: ينبّهك الهاتف في الوقت المختار، دون إنشاء مهمة في My Planner.",
 "Nome (ex.: Sessão do mestrado)": "الاسم (مثال: جلسة الماجستير)",
 "Nova sessão": "جلسة جديدة",
 "Nuvem e cópias de segurança": "السحابة والنسخ الاحتياطية",
 "Não perturbe": "عدم الإزعاج",
 "Não perturbe {de}–{ate}": "عدم الإزعاج {de}–{ate}",
 "Não-binário": "غير ثنائي",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "زر 🎉 العطلات في أعلى My Planner. الدولة وقائمة العطلات في الإعدادات > العطلات.",
 "O celular avisa às {h}.": "سينبّهك الهاتف الساعة {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "ما يُحذف من اليوميات يبقى مشفّرًا في سلة المهملات. ادخل إلى اليوميات ثم عُد إلى هنا للاستعادة.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "ما يُحذف يبقى في سلة المهملات 30 يومًا. أدخل كلمة مرور حسابك للتأكيد.",
 "O que saiu fica na Lixeira por 30 dias.": "ما حُذف يبقى في سلة المهملات 30 يومًا.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "يغيّر السمة ألوان التبويبات ولون التمييز ولمسة خفيفة على الخلفية، في الوضعين الفاتح والداكن. لتغيير لون تبويب واحد فقط، انتقل إلى الإعدادات > التبويبات.",
 "O tempo estudado até agora entra na meta.": "سيُضاف وقت الدراسة حتى الآن إلى الهدف.",
 "Oliva": "زيتوني",
 "Orgulho": "الفخر",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "تعمل التنبيهات في التطبيق المثبّت عند تفعيل الإشعارات.",
 "Os gestos do app": "إيماءات التطبيق",
 "Outro (escolher a hora)": "غير ذلك (اختيار الوقت)",
 "Pansexual": "شامل الميول",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "للتفعيل، استخدم التطبيق على الهاتف (الإعدادات › التقويم والخرائط › تقويم Google). بعدها سيظهر كل شيء هنا أيضًا.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "لكي لا نسألك مجددًا، اختر التطبيق في الإعدادات › التقويم والخرائط.",
 "Pausa": "استراحة",
 "Petróleo": "أزرق بترولي",
 "Pink elétrico": "وردي كهربائي",
 "Preto total": "أسود تام",
 "Progresso": "التقدم",
 "Pêssego": "خوخي",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "عدد الأيام التي تظهر فيها الفواتير مسبقًا موجود في الإعدادات > التنبيهات والمنبّهات.",
 "Rosa-chá": "وردي باهت",
 "Roxo-profundo": "بنفسجي داكن",
 "Segurança e dados": "الأمان والبيانات",
 "Segurar e arrastar": "اضغط مطولًا واسحب",
 "Segurar e soltar": "اضغط مطولًا ثم أفلت",
 "Selecionar todas": "تحديد الكل",
 "Semana começa na {dia}": "يبدأ الأسبوع يوم {dia}",
 "Sessão de estudo": "جلسة دراسة",
 "Sessão encerrada": "انتهت الجلسة",
 "Sessão pausada": "الجلسة متوقفة مؤقتًا",
 "Som e vibração": "الصوت والاهتزاز",
 "Suave": "هادئ",
 "Só esta semana": "هذا الأسبوع فقط",
 "Só hoje": "اليوم فقط",
 "Só neste dia ({data})": "في هذا اليوم فقط ({data})",
 "Tamanho das caixas": "حجم المربعات",
 "Tamanho do texto": "حجم النص",
 "Tarefa nova": "مهمة جديدة",
 "Tela inicial": "الشاشة الرئيسية",
 "Tema e cor de destaque": "السمة ولون التمييز",
 "Testar alerta": "اختبار التنبيه",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "اختبار التنبيه و\"عدم الإزعاج\" وإعدادات الهاتف موجودة في الإعدادات > التنبيهات والمنبّهات.",
 "Testar e conferir": "الاختبار والتحقق",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "كل خيارات العنصر: تعديل، نقل، مشاركة، أرشفة، حذف...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "انقر على لون من سمة {tema} لاستخدامه في الأزرار وزر + والعنصر المحدد.",
 "Total: {dur}": "الإجمالي: {dur}",
 "Tropical": "استوائي",
 "Turquesa": "فيروزي",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "ملف يضم جميع بياناتك في My Planner، لحفظه أو نقله إلى مكان آخر (قابلية النقل، LGPD).",
 "Usar no computador, pelo navegador": "الاستخدام على الكمبيوتر عبر المتصفح",
 "Usar o padrão": "استخدام الافتراضي",
 "Usar o padrão ({emoji})": "استخدام الافتراضي ({emoji})",
 "Use o app no celular para baixar o arquivo.": "استخدم التطبيق على الهاتف لتنزيل الملف.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "ينطبق على جميع التبويبات. يمكن لكل تبويب أن يكون له إعداده الخاص في الإعدادات > التبويبات.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "تنطبق على المهام ذات الاستراحات. يمكن لكل مهمة تغيير المنبّه والرمز التعبيري في بطاقتها.",
 "Ver lista": "عرض القائمة",
 "Ver o CPF inteiro": "عرض CPF كاملًا",
 "Verde-floresta": "أخضر غابي",
 "Verde-água": "أخضر مائي",
 "Vibração": "الاهتزاز",
 "Vinho": "خمري",
 "Você pediu para ser avisado agora.": "طلبت أن يتم تنبيهك الآن.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "يمكنك: التأكد مما إذا كنا نعالج بياناتك، والوصول إليها، وتصحيحها، وطلب نقلها (نزّل بياناتك من الإعدادات > بياناتي)، وطلب حذفها، ومعرفة مع من نشاركها، وسحب الموافقة، وتقديم شكوى إلى ANPD.",
 "Voltar ao filtro": "العودة إلى الفلتر",
 "Voltar à lista": "العودة إلى القائمة",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "انتقل إلى الإعدادات › My Planner Web وانقر على \"ربط المتصفح\".",
 "atividade {n} de {total}": "النشاط {n} من {total}",
 "matéria {n} de {t}": "المادة {n} من {t}",
 "padrão": "افتراضي",
 "pausa em {n} min": "استراحة بعد {n} د",
 "pausa {n} de {total}": "الاستراحة {n} من {total}",
 "termina em {n} min": "ينتهي بعد {n} د",
 "todas as vezes": "كل المرات",
 "troca em {n} min": "تبديل بعد {n} د",
 "volta em {n} min": "عودة بعد {n} د",
 "{nome} · {n} dia(s)": "{nome} · {n} يوم",
 "{n} de {total} vezes": "{n} من {total} مرة",
 "{n} itens arquivados": "تمت أرشفة {n} عنصر",
 "{n} itens excluídos": "تم حذف {n} عنصر",
 "{n} marcada(s)": "{n} محدد",
 "{n} vezes": "{n} مرة",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} د / {total}",
 "📔 Diário": "📔 اليوميات",
 "Agendados": "مجدولة",
 "Atrasado": "متأخر",
 "Atrasado: {v}": "متأخر: {v}",
 "Atualizar o a receber": "تحديث المستحقات",
 "Até (fim do contrato, se houver)": "حتى (نهاية العقد، إن وُجدت)",
 "Clínica": "عيادة",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "يحتسب كل يوم تم فيه تسجيل الحضور أو فيه خطة درس مُعلَّمة بـ \"تم تقديم الدرس\".",
 "Data do recebimento": "تاريخ الاستلام",
 "Data prevista do pagamento": "التاريخ المتوقع للدفع",
 "Desmarcar como recebido": "إلغاء تعليم الاستلام",
 "Dia do pagamento": "يوم الدفع",
 "Diferença: {v} (juros/multa)": "الفرق: {v} (فوائد/غرامة)",
 "Diferença: {v} (taxas/descontos)": "الفرق: {v} (رسوم/خصومات)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "المدارس والجامعات والدورات التي تدفع لك. مع الراتب الثابت، يُنشئ التطبيق المستحقات كل شهر؛ وبالساعة الدراسية، يجمع الدروس المقدَّمة في الفصول المرتبطة بالمؤسسة.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "اختر نوع الدفع (تعديل) ليحسب التطبيق ما تستحقه.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "هذا المبلغ مصدره قسم \"أين أعمل\" في تبويب {aba}. علِّمه هنا كمستلم أو افتح التبويب لعرض المؤسسة.",
 "Ex.: Colégio Estadual, Universidade Federal": "مثال: المدرسة الثانوية الحكومية، الجامعة الوطنية",
 "Ex.: Hospital Santa Casa, Clínica Vida": "مثال: المستشفى العام، عيادة الحياة",
 "Ex.: Salário de outubro, 13º, férias": "مثال: راتب أكتوبر، الراتب الثالث عشر، الإجازة",
 "Feitos": "المُنجَزة",
 "Horas-aula de cada aula": "عدد الساعات الدراسية لكل درس",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "المستشفيات والعيادات التي تدفع لك. مع الراتب الثابت، يُنشئ التطبيق المستحقات كل شهر؛ وبالمناوبة أو الموعد، علِّم ما أُنجز وسيحسب التطبيق.",
 "Hospital": "مستشفى",
 "Instituição": "المؤسسة",
 "Instituição (Onde trabalho)": "المؤسسة (أين أعمل)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "اربط الفصول بهذه المؤسسة (في الفصل: تعديل › المؤسسة) ليجمع التطبيق الدروس المقدَّمة.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "علِّم كل مناوبة أو موعد كمُنجَز: يجمع التطبيق ويحسب مبلغ الشهر.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "علِّم كل مناوبة أو موعد أُنجز في هذه المؤسسة. يجمع التطبيق ويحسب المبلغ المستحق للشهر.",
 "Nome da instituição": "اسم المؤسسة",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "ما على المؤسسة أن تدفعه لك، شهرًا بشهر. علِّمه كمستلم عند وصول المال: يُضاف أيضًا إلى تبويب المالية.",
 "Onde trabalho": "أين أعمل",
 "Plantão": "مناوبة",
 "Plantão ou atendimento": "مناوبة أو موعد",
 "Plantões e atendimentos": "المناوبات والمواعيد",
 "Por atendimento ou procedimento": "لكل موعد أو إجراء",
 "Por hora-aula": "بالساعة الدراسية",
 "Por plantão": "لكل مناوبة",
 "Previsto: {v}": "المتوقع: {v}",
 "Previsão do mês: {v}": "توقع الشهر: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "الكمية (دروس أو مناوبات أو مواعيد)",
 "Recebe no mês seguinte ao trabalhado": "يُدفع في الشهر التالي للعمل",
 "Receber: {t}": "استلام: {t}",
 "Recebimentos": "المقبوضات",
 "Salário": "الراتب",
 "Salário (valor do mês)": "الراتب (مبلغ الشهر)",
 "Salário fixo": "راتب ثابت",
 "Telefone (RH ou financeiro)": "الهاتف (الموارد البشرية أو المالية)",
 "Tipo de pagamento": "نوع الدفع",
 "Universidade": "جامعة",
 "Valor da hora-aula": "قيمة الساعة الدراسية",
 "Valor de cada um (se for diferente)": "قيمة كل واحد (إن كانت مختلفة)",
 "Valor do plantão": "قيمة المناوبة",
 "Valor por atendimento ou procedimento": "القيمة لكل موعد أو إجراء",
 "Valor previsto": "القيمة المتوقعة",
 "feito": "مُنجَز",
 "recebido em {d}": "استُلم في {d}",
 "{n} aula(s) dada(s)": "{n} درس/دروس مقدَّمة",
 "{n} hora(s)-aula": "{n} ساعة/ساعات دراسية",
 "{n} plantão(ões)": "{n} مناوبة/مناوبات",
 "Abas do My Planner Anne": "علامات تبويب My Planner Anne",
 "Acesso ao Não perturbe": "الوصول إلى وضع عدم الإزعاج",
 "Alarme dos remédios (mesmo no silencioso)": "منبّه الأدوية (حتى في الوضع الصامت)",
 "Algodão-doce": "غزل البنات",
 "Aplicar tema": "تطبيق السمة",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "الألوان الخاصة بكل سمة: زهور وردية، أوراق خضراء، سماء زرقاء...",
 "Assim ficam as letras no app.": "هكذا تبدو الحروف في التطبيق.",
 "Automática": "تلقائي",
 "Baht tailandês": "بات تايلاندي",
 "Boliviano": "بوليفيانو بوليفي",
 "Bolívar venezuelano": "بوليفار فنزويلي",
 "Botão": "زر",
 "Buscar moeda": "البحث عن عملة",
 "Cor do desenho": "لون الرسم",
 "Coroa dinamarquesa": "كرونة دنماركية",
 "Coroa norueguesa": "كرونة نرويجية",
 "Coroa sueca": "كرونة سويدية",
 "Coroa tcheca": "كرونة تشيكية",
 "Crepúsculo": "الشفق",
 "Crescente": "متصاعد",
 "Curta": "قصير",
 "Despesas em outra moeda (fora do lucro): {v}": "مصروفات بعملة أخرى (خارج الربح): {v}",
 "Dirham dos Emirados Árabes Unidos": "درهم إماراتي",
 "Dirham marroquino": "درهم مغربي",
 "Do seu país": "من بلدك",
 "Dong vietnamita": "دونغ فيتنامي",
 "Dupla": "مزدوج",
 "Dólar americano": "دولار أمريكي",
 "Dólar australiano": "دولار أسترالي",
 "Dólar canadense": "دولار كندي",
 "Dólar de Hong Kong": "دولار هونغ كونغ",
 "Dólar de Singapura": "دولار سنغافوري",
 "Dólar neozelandês": "دولار نيوزيلندي",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "يرسل جميع عناصر هذه القائمة، بما في ذلك العناصر الجديدة التي تُنشأ لاحقًا.",
 "Enviar todos para a equipe": "إرسال الكل إلى الفريق",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "اختر ما إذا كان منبّه هذا الدواء يرن حتى عندما يكون الهاتف في الوضع الصامت.",
 "Euro": "يورو",
 "Exemplo": "مثال",
 "Falta uma resposta": "ينقص جواب واحد",
 "Folha, tema e cores da caneta e das letras": "الورقة والسمة وألوان القلم والحروف",
 "Franco suíço": "فرنك سويسري",
 "Guarani paraguaio": "غواراني باراغواي",
 "Hryvnia ucraniana": "هريفنيا أوكرانية",
 "Iene japonês": "ين ياباني",
 "Kwanza angolano": "كوانزا أنغولية",
 "Libra egípcia": "جنيه مصري",
 "Libra esterlina": "جنيه إسترليني",
 "Lira turca": "ليرة تركية",
 "Longa": "طويل",
 "Mais usadas": "الأكثر استخدامًا",
 "Metical moçambicano": "متكال موزمبيقي",
 "Na página, segurar a bolinha faz o mesmo.": "في الصفحة، الضغط مطولًا على الدائرة يؤدي الأمر نفسه.",
 "Naira nigeriana": "نايرا نيجيرية",
 "Nenhuma moeda encontrada": "لم يتم العثور على أي عملة",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "على Android، لكي يرن منبّه الدواء أثناء تشغيل \"عدم الإزعاج\"، يجب أن يسمح الهاتف لتطبيق My Planner بالوصول إلى \"عدم الإزعاج\". اضغط على \"فتح الإعدادات\"، وابحث عن My Planner في القائمة وفعّل الإذن.",
 "No My Planner": "في My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "على iPhone، قد يمنع الوضع الصامت المنبّه. اترك الهاتف في الوضع العادي.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "على iPhone، يعرض ▶ فكرة عن كل نوع. التنبيهات الفعلية تستخدم الاهتزاز الافتراضي لـ iPhone.",
 "Novo dólar taiwanês": "دولار تايواني جديد",
 "Novo shekel israelense": "شيكل إسرائيلي جديد",
 "Ouvir/Sentir": "استماع/إحساس",
 "Peso argentino": "بيزو أرجنتيني",
 "Peso chileno": "بيزو تشيلي",
 "Peso colombiano": "بيزو كولومبي",
 "Peso filipino": "بيزو فلبيني",
 "Peso mexicano": "بيزو مكسيكي",
 "Peso uruguaio": "بيزو أوروغواي",
 "Política de privacidade": "سياسة الخصوصية",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "تم. اقفل الشاشة وانتظر دقيقة واحدة: يجب أن يظهر التنبيه بصمت.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "تم. اقفل الشاشة وانتظر دقيقة واحدة: يجب أن يظهر التنبيه مع اهتزاز، دون صوت.",
 "Páginas e canetas": "الصفحات والأقلام",
 "Pôr do sol": "غروب الشمس",
 "Rand sul-africano": "راند جنوب أفريقي",
 "Real brasileiro": "ريال برازيلي",
 "Ringgit malaio": "رينغيت ماليزي",
 "Riyal saudita": "ريال سعودي",
 "Rublo russo": "روبل روسي",
 "Rupia indiana": "روبية هندية",
 "Rupia indonésia": "روبية إندونيسية",
 "Rupia paquistanesa": "روبية باكستانية",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "إذا لم يظهر My Planner في القائمة، فسيتوفر هذا الإذن في الإصدار القادم من التطبيق (حدّثه من المتجر).",
 "Sentir": "إحساس",
 "Sol peruano": "سول بيروفي",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "هذه هي الألوان السريعة للقلم والحروف في الصفحات. اللون الأول هو اللون الافتراضي عند فتح صفحة. اضغط على دائرة لتغيير لونها.",
 "Taka bengali": "تاكا بنغلاديشية",
 "Teste grátis por {n} dias": "فترة تجريبية مجانية ({n} يوم)",
 "Tipo de vibração": "نوع الاهتزاز",
 "Tirar do My Planner": "إزالة من My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "الرنين حتى في الوضع الصامت ووضع عدم الإزعاج",
 "Tocar só se o celular estiver no normal": "الرنين فقط إذا كان الهاتف في الوضع العادي",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "تظهر جميع عناصر هذه القائمة في My Planner، بما في ذلك العناصر الجديدة.",
 "Vaga-lume": "اليراعة",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "ينطبق على جميع التنبيهات التي تهتز (اهتزاز، وصوت واهتزاز).",
 "Won sul-coreano": "وون كوري جنوبي",
 "Xelim queniano": "شلن كيني",
 "Yuan chinês": "يوان صيني",
 "Zloty polonês": "زلوتي بولندي",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 هل يجب أن يرن منبّه هذا الدواء حتى عندما يكون الهاتف في الوضع الصامت؟",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "معرض الصور سيتوفر في الإصدار القادم من التطبيق. حاليًا، استخدم «الملفات» أو «التقاط صورة».",
 "Abrir o fichário do grupo": "فتح مجلد المجموعة",
 "Arrastar a barra": "اسحب الشريط",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "بمجرد مشاركة المجلد، سيظهر هنا.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "ابحث عن أيقونة بالاسم (مثلًا: كتاب، منزل، قهوة)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "مع تبويب الدراسة تنشئ مجلداتك، وتستخدم المؤقت، وتتابع تقريرك، وأكثر من ذلك بكثير. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "مع تبويب {aba} تنشئ ما يخصك وتستخدم جميع الميزات. ✨",
 "Conhecer a aba": "تعرّف على التبويب",
 "Crie um fichário em Estudos e volte aqui.": "أنشئ مجلدًا في الدراسة ثم عد إلى هنا.",
 "Em sessão": "في جلسة",
 "Encerrar e salvar o cronômetro e começar a sessão?": "إيقاف المؤقت وحفظه وبدء الجلسة؟",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "إيقاف المؤقت وحفظه ومتابعة الجلسة؟",
 "Enquadre e toque no botão": "اضبط الإطار ثم اضغط الزر",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "اختر المجلد الذي سيراه الزملاء على الشاشة (للقراءة فقط).",
 "Esconder": "إخفاء",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "هذا الملف محفوظ فقط على جهاز من شاركه أو في Drive الخاص به، لذلك لا يظهر هنا.",
 "Fichário do grupo": "مجلد المجموعة",
 "Guia passo a passo do app e de cada aba": "دليل خطوة بخطوة للتطبيق ولكل تبويب",
 "Há um cronômetro em andamento.": "يوجد مؤقت قيد التشغيل.",
 "Há uma sessão em andamento.": "توجد جلسة قيد التقدم.",
 "Inserir imagem": "إدراج صورة",
 "Mais ícones": "المزيد من الأيقونات",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "لا توجد أيقونة بهذا الاسم. جرّب كلمة أخرى أو اختر من فئة.",
 "Nenhuma matéria neste fichário ainda.": "لا توجد مواد في هذا المجلد بعد.",
 "Nenhuma página nesta matéria ainda.": "لا توجد صفحات في هذه المادة بعد.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "في مجموعة الدراسة، تُفتح الصور وملفات PDF هنا على الشاشة. لا تتوفر معاينة لهذا النوع من الملفات داخل التطبيق.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "تعذّر العرض الآن. تحقق من اتصالك بالإنترنت وحاول مرة أخرى.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "ما زلنا نجهّز مشاركة المجلدات. عد بعد قليل.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "مجلد هذه المجموعة موجود على جهاز آخر لديك. ويظل مشاركًا من هناك.",
 "OK = Conhecer a aba · Cancelar = Agora não": "موافق = تعرّف على التبويب · إلغاء = ليس الآن",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "لن يرى الزملاء المجلد بعد الآن. يبقى كل شيء لديك.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "يرى الزملاء هذا المجلد على الشاشة للقراءة فقط: لا يمكنهم التعديل أو التنزيل أو الطباعة أو المشاركة. أهدافك والمؤقت والصفحات التي راجعتها تبقى خاصة بك.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "لعرض ملفات PDF هنا على الشاشة، ثبّت أحدث إصدار من التطبيق من المتجر.",
 "Parar de compartilhar": "إيقاف المشاركة",
 "Pausar a sessão": "إيقاف الجلسة مؤقتًا",
 "Pausar a sessão e estudar só esta?": "إيقاف الجلسة مؤقتًا ودراسة هذه فقط؟",
 "Página em branco.": "صفحة فارغة.",
 "Quer estudar com tudo isso?": "هل تريد الدراسة بكل هذه الميزات؟",
 "Quer usar tudo isso?": "هل تريد استخدام كل هذا؟",
 "Selecionar todos": "تحديد الكل",
 "Trocar fichário": "تغيير المجلد",
 "Você está participando do grupo de {nome}": "أنت مشارك في مجموعة {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "ترى على الشاشة ما تمت مشاركته في هذه المجموعة، لتقرأه وتتابعه.",
 "abacate, fruta": "أفوكادو، فاكهة",
 "academia, musculação, treino, peso": "صالة رياضية، كمال أجسام، تمرين، أثقال",
 "acampamento, camping": "تخييم، رحلة خلوية",
 "alfinete, fixar, importante": "دبوس، تثبيت، مهم",
 "almoço, arroz, prato": "غداء، أرز، طبق",
 "alvo, meta, objetivo, foco": "هدف، غاية، مقصد، تركيز",
 "aniversário, bolo": "عيد ميلاد، كعكة",
 "anotação, nota, lista, escrever": "ملاحظة، تدوين، قائمة، كتابة",
 "arco-íris": "قوس قزح",
 "avião, viagem, voo": "طائرة، سفر، رحلة جوية",
 "balança, direito, justiça, lei, processo": "ميزان، قانون، عدالة، تشريع، قضية",
 "balde, limpeza": "دلو، تنظيف",
 "banana, fruta": "موز، فاكهة",
 "banheira, banho, banheiro": "حوض استحمام، استحمام، حمّام",
 "barbear, barba, lâmina": "حلاقة، لحية، شفرة",
 "bicicleta, pedalar, bike": "دراجة، ركوب الدراجة، بسكليت",
 "bolo, doce, sobremesa": "كعكة، حلوى، تحلية",
 "brilho, mágica": "لمعان، سحر",
 "cabelo, cabeleireiro, corte": "شعر، حلاق، قص الشعر",
 "cachorro, cão, pet": "كلب، جرو، حيوان أليف",
 "caderno": "دفتر",
 "caderno, fichário, amarelo": "دفتر، مجلد، أصفر",
 "café, xícara, pausa": "قهوة، فنجان، استراحة",
 "caixa, pacote, mudança, entrega": "صندوق، طرد، انتقال، توصيل",
 "calendário, agenda, data": "تقويم، جدول مواعيد، تاريخ",
 "cama, quarto": "سرير، غرفة نوم",
 "caminhada, caminhar, andar": "مشي، المشي، تمشية",
 "camisa, gravata, roupa, trabalho": "قميص، ربطة عنق، ملابس، عمل",
 "carne, churrasco": "لحم، شواء",
 "carrinho, mercado, compras, supermercado": "عربة تسوق، سوق، مشتريات، سوبرماركت",
 "carro, dirigir, veículo": "سيارة، قيادة، مركبة",
 "certo, feito, visto": "صح، تم، علامة",
 "cesto, roupa, lavanderia, lavar roupa": "سلة، ملابس، مغسلة، غسيل الملابس",
 "chave de fenda, ferramenta, conserto": "مفك براغي، أداة، تصليح",
 "chave, senha": "مفتاح، كلمة مرور",
 "chocolate, doce": "شوكولاتة، حلوى",
 "chuveiro, banho": "دش، استحمام",
 "chá, xícara": "شاي، كوب",
 "compras, sacolas, shopping": "تسوق، أكياس، مول",
 "computador, monitor, tela": "كمبيوتر، شاشة، عرض",
 "computador, notebook, informática": "كمبيوتر، لابتوب، معلوماتية",
 "coração amarelo": "قلب أصفر",
 "coração azul": "قلب أزرق",
 "coração branco": "قلب أبيض",
 "coração laranja": "قلب برتقالي",
 "coração roxo": "قلب بنفسجي",
 "coração verde": "قلب أخضر",
 "coração, amor, saúde, vermelho": "قلب، حب، صحة، أحمر",
 "corrida, correr": "جري، ركض",
 "creme, hidratante, pele, skincare": "كريم، مرطب، بشرة، العناية بالبشرة",
 "croissant, pão, café da manhã": "كرواسون، خبز، فطور",
 "câmera, foto, fotografia": "كاميرا، صورة، تصوير",
 "cérebro, mente, memória, pensar": "دماغ، عقل، ذاكرة، تفكير",
 "dado, jogo de tabuleiro": "نرد، لعبة لوحية",
 "dente, dentista": "سن، طبيب أسنان",
 "despertador, relógio, alarme, acordar": "منبه، ساعة، تنبيه، استيقاظ",
 "diamante, joia": "ماس، مجوهرات",
 "dinheiro, pagar, conta, pagamento": "مال، دفع، فاتورة، سداد",
 "dormir, sono, descanso": "نوم، النوم، راحة",
 "e-mail, mensagem, carta": "بريد إلكتروني، رسالة، خطاب",
 "escada": "سلم، درج",
 "escova de dentes, dentes": "فرشاة أسنان، أسنان",
 "escrever, redação, caneta": "كتابة، إنشاء، قلم",
 "esponja, lavar louça": "إسفنجة، غسل الصحون",
 "esquadro, régua, geometria, desenho técnico": "مثلث رسم، مسطرة، هندسة، رسم هندسي",
 "estrela brilhante, destaque": "نجمة لامعة، تمييز",
 "estrela, favorito": "نجمة، مفضلة",
 "etiqueta, marcador": "ملصق، علامة",
 "extintor, segurança, incêndio": "طفاية حريق، سلامة، حريق",
 "falar, idioma, inglês, conversa": "تحدث، لغة، إنجليزية، محادثة",
 "feito, concluído, certo": "تم، مكتمل، صحيح",
 "ferramenta, conserto, manutenção": "أداة، تصليح، صيانة",
 "festa, comemoração": "حفلة، احتفال",
 "filme, cinema, série": "فيلم، سينما، مسلسل",
 "fogo, urgente, sequência": "نار، عاجل، سلسلة متتالية",
 "folha, natureza, erva, chá": "ورقة شجر، طبيعة، عشب، شاي",
 "fone de ouvido, áudio, música, podcast": "سماعات، صوت، موسيقى، بودكاست",
 "formatura, capelo, faculdade, diploma, universidade": "تخرج، قبعة التخرج، كلية، شهادة، جامعة",
 "força, braço, músculo": "قوة، ذراع، عضلات",
 "frango, coxa": "دجاج، فخذ",
 "frigideira, cozinhar, ovo, cozinha": "مقلاة، طبخ، بيض، مطبخ",
 "futebol, bola, esporte": "كرة القدم، كرة، رياضة",
 "gato, pet": "قطة، حيوان أليف",
 "gelo, geladeira, congelador": "ثلج، ثلاجة، فريزر",
 "gráfico, planilha, finanças, relatório": "رسم بياني، جدول بيانات، مالية، تقرير",
 "ingresso, show, evento": "تذكرة، حفل، فعالية",
 "jogo, videogame, game": "لعبة، ألعاب فيديو، جيمنج",
 "lancha, barco": "قارب سريع، قارب",
 "leite, copo": "حليب، كوب",
 "letras, alfabeto, português": "حروف، أبجدية، اللغة العربية",
 "link, corrente": "رابط، سلسلة",
 "livro aberto, leitura, ler": "كتاب مفتوح، قراءة، يقرأ",
 "livro azul, caderno": "كتاب أزرق، دفتر",
 "livro laranja, caderno": "كتاب برتقالي، دفتر",
 "livro verde, caderno": "كتاب أخضر، دفتر",
 "livro vermelho, caderno": "كتاب أحمر، دفتر",
 "livros, estudo, estudar, biblioteca": "كتب، دراسة، مذاكرة، مكتبة",
 "lixo, lixeira": "قمامة، سلة مهملات",
 "lua, noite": "قمر، ليل",
 "lâmpada, ideia, luz": "مصباح، فكرة، ضوء",
 "macarrão, massa": "معكرونة، باستا",
 "maleta, trabalho, escritório, negócios": "حقيبة عمل، عمل، مكتب، أعمال",
 "massagem, relaxar": "تدليك، استرخاء",
 "maçã, fruta": "تفاحة، فاكهة",
 "microfone, cantar, karaokê, palestra": "ميكروفون، غناء، كاريوكي، محاضرة",
 "microscópio, ciência, biologia": "مجهر، علوم، أحياء",
 "mochila, escola, filhos": "حقيبة ظهر، مدرسة، أطفال",
 "montanha, trilha": "جبل، مسار",
 "mundo, planeta, geografia": "عالم، كوكب، جغرافيا",
 "médico, consulta, exame, saúde": "طبيب، موعد، فحص، صحة",
 "música, nota musical": "موسيقى، نوتة موسيقية",
 "natação, nadar, piscina": "سباحة، يسبح، مسبح",
 "olho, visão, oftalmologista": "عين، نظر، طبيب عيون",
 "oração, orar, gratidão, igreja": "دعاء، صلاة، امتنان، كنيسة",
 "ovo": "بيضة",
 "pastas, arquivo, fichário, divisórias": "مجلدات، أرشيف، ملف، فواصل",
 "peixe": "سمك",
 "pescaria, pescar": "صيد السمك، صيد",
 "pessoas, reunião, equipe, grupo": "أشخاص، اجتماع، فريق، مجموعة",
 "piano, teclado musical": "بيانو، أورغ",
 "pintura, arte, desenho": "رسم، فن، لوحة",
 "pipa": "طائرة ورقية",
 "pipoca, cinema": "فشار، سينما",
 "pizza": "بيتزا",
 "planta, vaso, regar": "نبتة، أصيص، سقي",
 "porta, entrada": "باب، مدخل",
 "praia, férias": "شاطئ، إجازة",
 "prato, refeição, louça, jantar": "طبق، وجبة، أواني، عشاء",
 "prédio, história, governo, tribunal": "مبنى، تاريخ، حكومة، محكمة",
 "pão, padaria": "خبز، مخبز",
 "pé, podólogo": "قدم، طبيب أقدام",
 "pôr do sol, amanhecer": "غروب الشمس، شروق",
 "quebra-cabeça, peça": "أحجية، بازل، قطعة",
 "queijo": "جبن",
 "raio, energia, rápido": "برق، طاقة، سريع",
 "refrigerante, suco, bebida": "مشروب غازي، عصير، مشروب",
 "remédio, medicamento, vitamina, farmácia": "دواء، علاج، فيتامين، صيدلية",
 "sabão, sabonete, lavar": "صابون، غسل",
 "salada, dieta, verdura": "سلطة، حمية، خضار",
 "sanduíche, lanche": "ساندويتش، وجبة خفيفة",
 "sino, aviso, lembrete": "جرس، تنبيه، تذكير",
 "skate": "لوح تزلج، سكيت",
 "sofá, sala": "أريكة، غرفة المعيشة",
 "sol, manhã, dia": "شمس، صباح، نهار",
 "spa, sauna, autocuidado": "سبا، ساونا، العناية بالنفس",
 "teatro, máscaras": "مسرح، أقنعة",
 "telefone, ligação, ligar": "هاتف، مكالمة، اتصال",
 "tigela, cereal, sopa, mingau": "وعاء، حبوب الإفطار، شوربة، عصيدة",
 "trevo, sorte": "نفل، حظ",
 "troféu, conquista, prêmio": "كأس، إنجاز، جائزة",
 "tubo de ensaio, química, laboratório": "أنبوب اختبار، كيمياء، مختبر",
 "tênis, esporte": "تنس، رياضة",
 "unha, manicure": "ظفر، مانيكير",
 "vassoura, limpeza, faxina, varrer": "مكنسة، تنظيف، نظافة، كنس",
 "violão, guitarra": "جيتار، غيتار",
 "yoga, meditação, alongamento": "يوغا، تأمل، تمدد",
 "{n} selecionada": "تم تحديد {n}",
 "{n} selecionadas": "تم تحديد {n}",
 "{n} selecionado": "تم تحديد {n}",
 "{n} selecionados": "تم تحديد {n}",
 "ábaco, matemática, contas, cálculo, contabilidade": "عداد، رياضيات، حساب، عمليات حسابية، محاسبة",
 "água, gota, hidratar": "ماء، قطرة، ترطيب",
 "árvore, jardim, quintal": "شجرة، حديقة، فناء",
 "ônibus, transporte": "حافلة، مواصلات",
 "1 dia antes": "قبل يوم واحد",
 "1 dia depois": "بعد يوم واحد",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "يتم الاشتراك في تطبيق الهاتف عبر متجر التطبيقات، ويسري أيضًا هنا على الموقع.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "المفتاح غير مكتمل (قصير جدًا). انسخه مرة أخرى بزر النسخ في صفحة المفتاح.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "يحتوي المفتاح على أحرف ليست جزءًا من المفتاح. انسخ المفتاح وحده مرة أخرى، دون أي نص حوله.",
 "A galeria chega na próxima atualização do app.": "سيصل المعرض في التحديث القادم للتطبيق.",
 "ALERTAS": "التنبيهات",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "افتح تبويبًا مدفوعًا وابدأ الفترة التجريبية المجانية. ثم عد إلى هنا.",
 "Abrir a barra do editor": "فتح شريط المحرر",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "الآن وقت عدم الإزعاج في التطبيق: سيصل التنبيه خلال 5 ثوانٍ، دون صوت أو اهتزاز.",
 "Aguardando confirmação": "بانتظار التأكيد",
 "Aguardando envio ao My Planner": "بانتظار الإرسال إلى My Planner",
 "Alertas de cada fatura": "تنبيهات كل فاتورة",
 "Alertas do fim da garantia": "تنبيهات انتهاء الضمان",
 "Alertas do vencimento": "تنبيهات الاستحقاق",
 "Alertas: {campo}": "التنبيهات: {campo}",
 "Alvorada": "الفجر",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "عند فتح هذا التبويب، يطلب التطبيق فتح القفل نفسه المستخدم للتطبيق (كلمة المرور أو البصمة أو PIN). يمكنك تغيير ذلك من الإعدادات > التبويبات.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "عند لمس ملف مرفق، يُفتح في تطبيق الهاتف الذي تختاره (إذا سألك الهاتف، اختر \"مرة واحدة فقط\" أو \"دائمًا\"). ما تعدّله هناك يُحفظ في الملف نفسه.",
 "App instalado": "التطبيق مثبّت",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: يسجّل كل شيء بالفعل في تطبيق الصحة على الهاتف. لا داعي لفعل أي شيء.",
 "Arquivados e fixados": "المؤرشفة والمثبّتة",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "ملف للقراءة والحفظ، منظّم حسب التبويب. أُنشئ في {data}.",
 "As notificações do My Planner estão desligadas no celular.": "إشعارات My Planner متوقفة على الهاتف.",
 "Atualização automática disponível no app instalado.": "التحديث التلقائي متاح في التطبيق المثبّت.",
 "Aurora": "شفق",
 "Avisos: alarme (som)": "التنبيهات: منبّه (صوت)",
 "Baixar o app": "تنزيل التطبيق",
 "Baixar o arquivo técnico": "تنزيل الملف التقني",
 "Baixar para ler (PDF)": "تنزيل للقراءة (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "شريط المحرر (القلم، قلم التظليل، النص)",
 "Brisa": "نسيم",
 "Campainha": "جرس الباب",
 "Canal": "القناة",
 "Cole a chave antes de testar.": "الصق المفتاح قبل الاختبار.",
 "Começa em": "يبدأ في",
 "Como avisar": "طريقة التنبيه",
 "Confira a chave": "تحقّق من المفتاح",
 "Conta de teste de compras": "حساب اختبار المشتريات",
 "Conta vencida": "فاتورة متأخرة",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "انسخ المفتاح فورًا (يظهر مرة واحدة فقط). يبدأ بـ \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "انسخ المفتاح فورًا (يظهر مرة واحدة فقط). يبدأ بـ \"sk-ant-\".",
 "Cristal": "كريستال",
 "Daqui a 1 hora": "بعد ساعة",
 "Daqui a 1 semana": "بعد أسبوع",
 "Daqui a 3 dias": "بعد 3 أيام",
 "Depois de 5 min fora": "بعد 5 دقائق خارجه",
 "Depois de 5 minutos fora": "بعد 5 دقائق خارج التبويب",
 "Desligar a senha desta aba": "إيقاف كلمة مرور هذا التبويب",
 "Detalhes técnicos": "تفاصيل تقنية",
 "Dia {n} de {t}": "اليوم {n} من {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "نصيحة: المفتاح مثل كلمة المرور. لا ترسله في رسالة ولا تنشره. إذا تسرّب، احذفه من الموقع وأنشئ مفتاحًا آخر.",
 "Documento vencido": "مستند منتهي الصلاحية",
 "Ela abre em {d}.": "تُفتح في {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "تُفتح في {d}. ستتلقى تنبيهات: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "تُفتح في {d}. ستتلقى تنبيهًا: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "في \"API keys\"، المس \"Create key\" (إنشاء مفتاح) وأعطه اسمًا، مثل \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "في \"Billing\" (الفوترة)، أضف بطاقة وبضعة دولارات من الرصيد. اشتراك ChatGPT Plus لا يسري هنا.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "في \"Billing\" (الفوترة)، اشترِ رصيدًا. اشتراك Claude Pro لا يسري هنا.",
 "Em breve": "قريبًا",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "سجّل الدخول بحساب ChatGPT نفسه أو أنشئ حسابًا.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "سجّل الدخول بحساب Google الخاص بك (حساب Gmail نفسه يصلح).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "سجّل الدخول أو أنشئ حسابًا (يمكن استخدام البريد الإلكتروني نفسه المستخدم في Claude).",
 "Enviados para o My Planner": "المُرسلة إلى My Planner",
 "Enviar agora": "إرسال الآن",
 "Escolha hoje ou uma data futura.": "اختر اليوم أو تاريخًا مستقبليًا.",
 "Escolhas lembradas": "الاختيارات المحفوظة",
 "Escolher a data": "اختيار التاريخ",
 "Escolher células": "اختيار الخلايا",
 "Escolher quando": "اختيار الموعد",
 "Espessura": "السُّمك",
 "Esquecer": "نسيان",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "هذا المفتاح من خدمة أخرى ({servico}). هنا تعمل فقط مفاتيح Claude أو ChatGPT أو Gemini.",
 "Esta chave é do {ia}, não do {escolhida}.": "هذا المفتاح لـ {ia}، وليس لـ {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "يرى هذا الحساب التطبيق كحساب جديد، دون أي تبويب مفتوح، للتحقق من الأقفال والفترة التجريبية المجانية والشراء. الحسابات الأخرى لا تتغير.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "تحتاج هذه الأداة إلى رؤية صفحات PDF، وهذا يصل مع التطبيق الجديد (الإصدار 0.50). استخدم المتصفح أو حدّث My Planner من المتجر.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "لا يبدو هذا مفتاحًا لـ {ia}. مفاتيح {ia} تبدأ بـ {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "هذا التنبيه مضبوط على \"متوقف\": لن يرنّ شيء.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "لا يتلقى هذا الهاتف التنبيهات بعد والتطبيق مغلق. حدّث My Planner من المتجر (الإصدار {v} أو أحدث). والتطبيق مفتوح، تعمل التنبيهات بالفعل.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "هذا النوع من التنبيهات متوقف في إعدادات الإشعارات بالهاتف.",
 "Estudado": "تمت دراسته",
 "Estudado: {dur}": "تمت الدراسة: {dur}",
 "Faltou: {dur}": "المتبقي: {dur}",
 "Fazer os testes terminarem agora": "إنهاء الفترات التجريبية الآن",
 "Fechar a barra do editor": "إغلاق شريط المحرر",
 "Fichário": "مجلد",
 "Figurinhas e emojis": "الملصقات والرموز التعبيرية",
 "Garantia terminou": "انتهى الضمان",
 "Gerando…": "جارٍ الإنشاء…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "يحفظ المستندات والفحوصات والسجل الصحي بكلمة مرور خاصة به. حتى الدعم لا يستطيع قراءتها. إذا نسيت كلمة المرور، فلا سبيل لاستعادتها.",
 "Harpa": "قيثارة",
 "Horas por dia": "ساعات في اليوم",
 "Identificação": "التعريف",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "يبدو هذا رابطًا أو بريدًا إلكترونيًا، وليس مفتاحًا. انسخ المفتاح كاملًا من صفحة مفاتيح API.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "لن يظهر هذا في My Planner إلا إذا أرسلته. هل تريد الإرسال الآن؟",
 "Já dá para confirmar {titulo}?": "هل يمكن تأكيد {titulo} الآن؟",
 "Lembrar minha escolha nesta aba": "تذكّر اختياري في هذا التبويب",
 "Lembrete para confirmar: {data}": "تذكير بالتأكيد: {data}",
 "Marimba": "ماريمبا",
 "Marque pelo menos um dia da semana no plano.": "حدّد يومًا واحدًا على الأقل من أيام الأسبوع في الخطة.",
 "Me lembre de confirmar": "ذكّرني بالتأكيد",
 "Me lembre depois": "ذكّرني لاحقًا",
 "Menos": "أقل",
 "Meta somada": "الهدف الإجمالي",
 "Meta somada: {dur}": "الهدف الإجمالي: {dur}",
 "Meus dados - My Planner {data}": "بياناتي - My Planner {data}",
 "Meus dados do My Planner": "بياناتي في My Planner",
 "Mostrar a barra": "إظهار الشريط",
 "Mudar senha do diário": "تغيير كلمة مرور اليوميات",
 "Na primeira vez, aceite os termos de uso.": "في المرة الأولى، وافق على شروط الاستخدام.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "في إصدار المتاجر، سيتم الشراء عبر متجر تطبيقات الهاتف. حاليًا، يحاكي المفتاح الاشتراك لأغراض الاختبار.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "لا ينتقل شيء من التبويبات الأخرى تلقائيًا إلى My Planner. هذه العناصر لها تاريخ ولم تُرسل بعد.",
 "Nenhum estudo registrado neste mês.": "لا توجد دراسة مسجّلة هذا الشهر.",
 "Nenhum item aguardando envio.": "لا توجد عناصر بانتظار الإرسال.",
 "Nenhum teste começado": "لم تبدأ أي فترة تجريبية",
 "Nesta tela não há nada para adicionar.": "لا يوجد ما يُضاف في هذه الشاشة.",
 "No dia": "في اليوم نفسه",
 "Nova nota rápida": "ملاحظة سريعة جديدة",
 "Nova página do dia": "صفحة يوم جديدة",
 "Não deu certo": "لم ينجح ذلك",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "لا يشمل: محتوى اليوميات وحقول الخزنة (محمية بكلمة المرور)، والصور والملفات المرفقة. لاستعادة البيانات في التطبيق، استخدم الملف التقني.",
 "Não foi possível gerar o PDF.": "تعذّر إنشاء ملف PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "تعذّر الاختبار الآن. حاول مرة أخرى بعد بضع ثوانٍ.",
 "Não lembrar": "عدم التذكّر",
 "Não, obrigada": "لا، شكرًا",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "اليوميات محمية بكلمة مرورها الخاصة ولا تدخل في هذا الملف.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "يفتح التطبيق \"حفظ في الملفات\" لتختار المجلد (يمكن أن يكون iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "يحفظ التطبيق اختصار الملف المختار فقط: يبقى الملف في مكانه (Drive أو OneDrive أو التنزيلات) ويُفتح في تطبيق الهاتف. لا يُنسخ شيء. ينطبق هذا الخيار على الصور الملتقطة بالكاميرا.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "التطبيق المثبّت على هذا الجهاز هو الإصدار {v}. لإجراء مكالمات صوتية ومرئية، حدّث My Planner من المتجر (الإصدار 0.35 أو أحدث). الرسائل تعمل بالفعل.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "سيصل التنبيه بصمت، مباشرةً إلى قائمة الإشعارات: فعّل تنبيهات My Planner في إعدادات الهاتف.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "سيصل التنبيه دون صوت: تم إيقاف صوت هذا النوع من التنبيهات في إعدادات الهاتف.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "سيصل التنبيه، لكن صوت إشعارات My Planner متوقف على الهاتف.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "تحمل الدعوة رابط تنزيل التطبيق. من يدخل عبر الرابط ينتقل مباشرةً إلى المكتب.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "يصل الإملاء مع الإصدار الجديد من التطبيق. حدّث My Planner من المتجر لاستخدام الميكروفون.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "فتح القفل نفسه المستخدم للتطبيق: كلمة المرور أو البصمة أو PIN. يُطلب مرة واحدة عند الدخول؛ ولا يُطلب مجددًا داخل التبويب. فتح المعرض أو الكاميرا أو الملفات لا يُعدّ خروجًا. العناصر الكبيرة تظل تطلب كلمة المرور لحذفها.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "قد يمنع الوضع الصامت في الهاتف رنين المنبّه. اترك الهاتف في الوضع العادي.",
 "O plano fica só em Estudos (não vai para o My Planner).": "تبقى الخطة في الدراسة فقط (لا تنتقل إلى My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "اختياري: الموعد النهائي وعدد الساعات في اليوم وأيام الأسبوع.",
 "Os avisos do celular funcionam no app instalado.": "تنبيهات الهاتف تعمل في التطبيق المثبّت.",
 "Os avisos no celular funcionam no app instalado.": "التنبيهات على الهاتف تعمل في التطبيق المثبّت.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "انتهت الفترات التجريبية التي بدأت. افتح التبويب لترى \"انتهت الفترة التجريبية المجانية\".",
 "Outros dados": "بيانات أخرى",
 "Ouvir": "استماع",
 "Pacote em uso": "الحزمة المستخدمة",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "للاشتراك، حدّث My Planner من متجر تطبيقات الهاتف.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "للقراءة (PDF): منظّم حسب التبويب، مع العناوين والتواريخ. يُفتح على أي جهاز أو كمبيوتر.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "لكي يرنّ منبّه الدواء أثناء تفعيل \"عدم الإزعاج\"، يجب أن يسمح الهاتف لـ My Planner بالوصول إلى \"عدم الإزعاج\". المس \"فتح الإعدادات\"، وابحث عن My Planner في القائمة وفعّل الإذن.",
 "Passo a passo para criar a chave": "خطوات إنشاء المفتاح",
 "Pedir de novo": "الطلب مرة أخرى",
 "Pedir senha ao abrir esta aba": "طلب كلمة المرور عند فتح هذا التبويب",
 "Plano com período": "خطة بفترة محددة",
 "Plano começa em {d}": "تبدأ الخطة في {d}",
 "Por matéria": "حسب المادة",
 "Prolongar": "تمديد",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "تم: سيصل التنبيه خلال 5 ثوانٍ، مع صوت. إذا لم يرنّ، فتحقّق مما إذا كان الهاتف في الوضع الصامت.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "تم: سيصل التنبيه خلال 5 ثوانٍ، بالاهتزاز فقط.",
 "Publicado em": "نُشر في",
 "Pulso": "نبض",
 "Quando o app bloquear": "عند قفل التطبيق",
 "Quer proteger esta aba com senha?": "هل تريد حماية هذا التبويب بكلمة مرور؟",
 "Recolher ou arrastar a barra": "طيّ الشريط أو سحبه",
 "Recomeçar os testes grátis": "إعادة بدء الفترات التجريبية المجانية",
 "Recomeçar os testes grátis?": "إعادة بدء الفترات التجريبية المجانية؟",
 "Rolar a folha para os lados": "تمرير الورقة أفقيًا",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "إذا ربطت الساعة: الإجماليات اليومية للخطوات والمسافة والسعرات الحرارية والتمارين ونبضات القلب والنوم، تُقرأ من Health Connect أو من تطبيق الصحة على الهاتف. التطبيق يقرأ فقط ولا يغيّر هذه البيانات أبدًا.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "لا يوجد إنترنت أو انقطع الاتصال. تحقّق من Wi-Fi أو بيانات الجوال وحاول مرة أخرى.",
 "Senha desta aba": "كلمة مرور هذا التبويب",
 "Seu plano terminou": "انتهت خطتك",
 "Sino": "جرس",
 "Som do alarme": "صوت المنبّه",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "يجمع الضمان القانوني وضمان الشركة المصنّعة. تحقّق من شهادة الضمان.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "هذان ملفان يحتويان على بياناتك في My Planner (قابلية نقل البيانات، LGPD):",
 "Só quando o app bloquear": "فقط عند قفل التطبيق",
 "Tamanho da borracha": "حجم الممحاة",
 "Tamanho da letra": "حجم الخط",
 "Tempo": "الوقت",
 "Termina em": "ينتهي في",
 "Testar": "اختبار",
 "Texto de exemplo": "نص تجريبي",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "يرنّ للتنبيهات المضبوطة على \"منبّه (صوت)\". أما \"الصوت والاهتزاز\" فيستخدم صوت إشعارات الهاتف.",
 "Toda vez que sair": "في كل مرة تخرج فيها",
 "Toda vez que sair da aba": "في كل مرة تخرج فيها من التبويب",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "تعود جميع التبويبات إلى \"{n} أيام مجانية للتجربة\"، كما في حساب جديد. يتم إيقاف الاشتراكات المحاكاة.",
 "Todos os fichários": "جميع المجلدات",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "المس \"Create API key\" (إنشاء مفتاح API). إذا طُلب منك مشروع، فاختر الظاهر أو أنشئ مشروعًا جديدًا.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "المس \"إنشاء مفتاح API الخاص بي\" أعلاه. تُفتح منصة OpenAI (وليس موقع ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "المس \"إنشاء مفتاح API الخاص بي\" أعلاه. تُفتح Console من Anthropic (وليس موقع Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "المس \"إنشاء مفتاح API الخاص بي\" أعلاه. يُفتح Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "المس \"ربط\"، وفي شاشة تطبيق الصحة فعّل العناصر التي يمكن لـ My Planner قراءتها.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "المس أيقونة النسخ بجوار المفتاح. يبدأ المفتاح بـ \"AIza\" أو \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "المس خلية في الجدول (أو \"اختيار الخلايا\") لتغيير حجم خطها.",
 "Transparência": "الشفافية",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "تقني (للاستعادة): نسخة كاملة لا يقرؤها إلا My Planner. لاستخدامها، انتقل إلى الإعدادات › السحابة والنسخ الاحتياطية › استيراد ملف.",
 "Uma carta da {nome} abre em {n} dias 💌": "رسالة من {nome} تُفتح بعد {n} يوم 💌",
 "Usa a senha do app": "يستخدم كلمة مرور التطبيق",
 "Usar no {ia}": "استخدام في {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "استخدم التطبيق على الهاتف لتنزيل الملف التقني.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "السعر النهائي يحدده متجر التطبيقات، بعملة بلدك مباشرةً.",
 "Você ainda não enviou {titulo} para o My Planner.": "لم ترسل {titulo} إلى My Planner بعد.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "عد إلى هنا، والصق المفتاح في الحقل أدناه، ثم المس \"حفظ واختبار\".",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "عد إلى \"API keys\" والمس \"Create new secret key\" (إنشاء مفتاح).",
 "atualização automática": "تحديث تلقائي",
 "erro desconhecido": "خطأ غير معروف",
 "estudados no mês": "تمت دراستها هذا الشهر",
 "faltou {dur}": "المتبقي {dur}",
 "hoje {feito} de {meta}": "اليوم {feito} من {meta}",
 "hoje é folga": "اليوم عطلة",
 "login do Google (não é chave de API)": "تسجيل دخول Google (ليس مفتاح API)",
 "meta cumprida": "تحقق الهدف",
 "o que veio com a instalação": "ما جاء مع التثبيت",
 "outro": "أخرى",
 "provisório": "مؤقت",
 "superou {dur}": "تجاوز بـ {dur}",
 "token de login (não é chave de API)": "رمز تسجيل الدخول (ليس مفتاح API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "استغرق {ia} وقتًا طويلًا جدًا للرد. حاول مرة أخرى بعد لحظات.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} متوقف أو مثقل حاليًا. المشكلة ليست في مفتاحك: حاول مرة أخرى لاحقًا.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "ردّ {ia} على الاختبار بالنموذج {modelo}. يمكنك استخدامه الآن في التبويبات.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "رفض {ia} قراءة هذا المحتوى (فلتر الأمان الخاص بالشركة).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: المفتاح موجود، لكنه لا يملك إذنًا لاستخدام الذكاء الاصطناعي. أنشئ مفتاحًا جديدًا في الصفحة المذكورة في الخطوات.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: مفتاح غير صالح. تحقّق من أنك نسخت المفتاح كاملًا أو أنشئ مفتاحًا جديدًا.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: حظرت الشركة هذا المفتاح لأنه ظهر منشورًا على الإنترنت. احذفه وأنشئ مفتاحًا آخر.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: تم بلوغ حد الاستخدام. انتظر بضع دقائق (أو حتى الغد في الخطة المجانية) وحاول مرة أخرى.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: النموذج المختار غير متاح لحسابك. اختر نموذجًا آخر في \"النموذج\".",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: الخدمة غير متاحة في منطقتك أو لهذا النوع من الحسابات.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: حساب API الخاص بك بلا رصيد أو بلا وسيلة دفع. أضف رصيدًا في موقع الشركة.",
 "{item}: a garantia termina hoje ({data}).": "{item}: ينتهي الضمان اليوم ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: انتهى الضمان في {data}.",
 "{item}: venceu em {data}.": "{item}: استُحق في {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} محمي بكلمة مرور",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: إنهاء الخطة أم تمديدها بتاريخ انتهاء جديد؟ لن يُحذف شيء.",
 "{n} dias antes": "قبل {n} أيام",
 "{n} dias de estudo no plano · {dur} por dia": "{n} أيام دراسة في الخطة · {dur} يوميًا",
 "{n} dias de plano": "{n} أيام من الخطة",
 "{n} dias depois": "بعد {n} أيام",
 "{n} item(ns) aguardando envio ao My Planner": "{n} عنصر بانتظار الإرسال إلى My Planner",
 "{n} itens aguardando envio": "{n} عنصر بانتظار الإرسال",
 "{quando} às {hora}": "{quando} الساعة {hora}",
 "ÚLTIMOS 6 MESES": "آخر 6 أشهر",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "افتح My Planner Anne وسجّل الدخول باستخدام CPF أو البريد الإلكتروني وكلمة المرور.",
 "Anexo": "مرفق",
 "Assédio ou ameaça": "تحرش أو تهديد",
 "Bloquear {nome}": "حظر {nome}",
 "Conte mais (opcional)": "أخبرنا بالمزيد (اختياري)",
 "Conteúdo impróprio": "محتوى غير لائق",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "لا نتسامح مع المحتوى المسيء والمستخدمين المسيئين. يراجع فريقنا البلاغات خلال 24 ساعة.",
 "Denunciar": "إبلاغ",
 "Denunciar contato": "الإبلاغ عن جهة الاتصال",
 "Denunciar grupo": "الإبلاغ عن المجموعة",
 "Denunciar mensagem": "الإبلاغ عن الرسالة",
 "Denúncia enviada": "تم إرسال البلاغ",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "البلاغات التي تقدّمها في الرسائل: السبب، ومن تم الإبلاغ عنه، ومقتطف الرسالة المُبلَّغ عنها. لا يقرؤها إلا فريق My Planner، لمراجعة الحالة.",
 "Enviar denúncia": "إرسال البلاغ",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "أرسل بريدًا إلكترونيًا تطلب فيه الحذف، مع CPF أو البريد الإلكتروني للحساب. نرد خلال 15 يومًا.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "لا نتسامح مع المحتوى المسيء أو غير القانوني أو غير اللائق ولا مع المستخدمين المسيئين في الرسائل والمجموعات. يمكن لأي شخص الإبلاغ عن رسالة أو جهة اتصال أو مجموعة (اضغط مطولًا على الرسالة أو المس ⋮ > إبلاغ) وحظر من يشاء. يراجع فريقنا البلاغات خلال 24 ساعة: قد تتم إزالة المحتوى وقد يتعرض حساب مرسله للتعليق أو الإغلاق.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "شكرًا. سيراجع فريقنا البلاغ خلال 24 ساعة.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "للحسابات التي تسجّل الدخول باستخدام CPF، ينشئ فريق الدعم كلمة المرور الجديدة بعد التأكد من أن الحساب لك. راسلنا على {email} مع ذكر CPF أو البريد الإلكتروني المسجّل.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "لماذا تقوم بالإبلاغ؟ لن يعرف الشخص المُبلَّغ عنه من أبلغ عنه.",
 "Spam": "رسائل مزعجة",
 "{nome} não pode mais conversar com você.": "لم يعد بإمكان {nome} الدردشة معك.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nصالحة حتى {d}. تُحفظ مشفّرة في خزنتك، على هذا الجهاز فقط وفي نسختك على السحابة.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. على الكمبيوتر، افتح {url} واختر الدخول برمز QR.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. هنا، اضغط ربط المتصفح ووجّه الكاميرا إلى رمز QR على الكمبيوتر.",
 "Abandonados": "المتروكة",
 "Bloquear o computador": "قفل الكمبيوتر",
 "Cheguei na página...": "وصلت إلى الصفحة...",
 "Computador conectado": "الكمبيوتر المتصل",
 "Computador desconectado": "تم فصل الكمبيوتر",
 "Conectado em {d}": "متصل في {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "أنشئ المجموعة وأرسل الرابط: من ينضم يرى مواد الكتاب ويتابع القراءة. المشرف يضيف ويعدّل ويضع الصور، ويمكنه السماح بذلك لمن يستخدم التبويب أيضًا. المشرف وحده يضيف الأشخاص أو يزيلهم.",
 "Depois de {n} minutos parado": "بعد {n} دقائق من عدم النشاط",
 "Desconectar o computador?": "فصل الكمبيوتر؟",
 "Difícil demais": "صعب جدًا",
 "Editar livro": "تعديل الكتاب",
 "Entrar com o QR Code": "الدخول برمز QR",
 "Escreva (ex.: filosofia)": "اكتب (مثل: فلسفة)",
 "Este computador": "هذا الكمبيوتر",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "تم فصل هذا الكمبيوتر (من الهاتف أو لأن كمبيوترًا آخر دخل). للاستخدام مرة أخرى، ادخل برمز QR.",
 "Já existe um computador conectado": "يوجد كمبيوتر متصل بالفعل",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "يوجد كمبيوتر متصل بالفعل. التبديل إلى هذا؟ سيتم فصل الآخر.",
 "Navegador": "المتصفح",
 "Nenhum computador conectado": "لا يوجد كمبيوتر متصل",
 "Novo livro": "كتاب جديد",
 "Não gostei": "لم يعجبني",
 "Não, abandonei": "لا، تركته",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "سيُغلق My Planner على الكمبيوتر. للاستخدام مرة أخرى، اربط برمز QR فقط.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "يتغير رمز QR كل 3 دقائق ويصلح مرة واحدة. على كمبيوتر مشترك، استخدم الإعدادات › الخروج من هذا الكمبيوتر عند الانتهاء.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "تبقى بياناتك محفوظة في السحابة وعلى الهاتف. للدخول مرة أخرى، استخدم رمز QR.",
 "Parei em": "توقفت في",
 "Perdi o interesse": "فقدت الاهتمام",
 "Por que parei": "لماذا توقفت",
 "Páginas e meta": "الصفحات والهدف",
 "Quero voltar a ler?": "هل أريد العودة للقراءة؟",
 "Sair deste computador": "الخروج من هذا الكمبيوتر",
 "Sair deste computador?": "الخروج من هذا الكمبيوتر؟",
 "Se quiser, escreva com as suas palavras": "إن أردت، اكتب بكلماتك",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "إذا لم تُستخدم الفأرة أو لوحة المفاتيح طوال هذه المدة، يُقفل My Planner. للعودة، اكتب كلمة مرور الحساب (أو ادخل برمز QR مرة أخرى).",
 "Sem tempo": "لا وقت",
 "Sim, depois": "نعم، لاحقًا",
 "Só um computador pode ficar conectado por vez.": "يمكن ربط كمبيوتر واحد فقط في كل مرة.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "ضع صورة الشهادة أو ملف PDF في \"الصور والملفات والروابط\" وعلّمه كشهادة.",
 "ABNT copiada": "تم نسخ ABNT",
 "APA copiada": "تم نسخ APA",
 "Ano inválido": "سنة غير صالحة",
 "Ano ou data de publicação": "سنة أو تاريخ النشر",
 "Assisti em": "شاهدته في",
 "Buscando os dados...": "جارٍ البحث عن البيانات...",
 "Calculado pelos módulos": "محسوب من الوحدات",
 "Carga horária (horas)": "عدد الساعات",
 "Certificado": "الشهادة",
 "Certificado emitido em": "تاريخ إصدار الشهادة",
 "Cheguei na aula": "وصلت إلى الدرس",
 "Cheguei na aula...": "وصلت إلى الدرس...",
 "Cheguei na temporada": "وصلت إلى الموسم",
 "Cheguei no episódio": "وصلت إلى الحلقة",
 "Citação copiada": "تم نسخ الاقتباس",
 "Colocar em pasta": "وضع في مجلد",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "ضع كتبًا أو أفلامًا أو دورات في هذا المجلد لإنشاء القائمة.",
 "Comentário": "تعليق",
 "Copiar ABNT": "نسخ ABNT",
 "Copiar APA": "نسخ APA",
 "Copiar citação (ABNT)": "نسخ الاقتباس (ABNT)",
 "Copiar citação (APA)": "نسخ الاقتباس (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "أنشئ بطاقات بقائمة تحقق أو قائمة أو نص حر أو رسم لهذه المادة. اسحب لليمين للحذف ولليسار للأرشفة أو التكرار.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "أنشئ المجموعة وأرسل الرابط: من ينضم يرى القائمة ويتابعها. المشرف يضيف ويعدّل ويضع الصور، ويمكنه السماح بذلك لمن يستخدم التبويب أيضًا. المشرف وحده يضيف الأشخاص أو يزيلهم.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "أنشئ المجموعة وأرسل الرابط: من ينضم يرى مواد الدورة ويتابعها. المشرف يضيف ويعدّل ويضع الصور، ويمكنه السماح بذلك لمن يستخدم التبويب أيضًا. المشرف وحده يضيف الأشخاص أو يزيلهم.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "أنشئ مجلدًا أولًا في قسم 📁 المجلدات في هذا التبويب.",
 "DOI (artigos)": "DOI (مقالات)",
 "Data de acesso": "تاريخ الوصول",
 "Deixar avulsas": "إبقاؤها منفصلة",
 "Descrição (objetivo)": "الوصف (الهدف)",
 "Digite o ano com 4 números (ex.: {a}).": "اكتب السنة بأربعة أرقام (مثل: {a}).",
 "Direção": "الإخراج",
 "Editar pasta": "تعديل المجلد",
 "Editora": "الناشر",
 "Edição": "الطبعة",
 "Em 1 mês": "بعد شهر",
 "Em {n} meses": "بعد {n} أشهر",
 "Episódios por temporada (opcional)": "الحلقات في كل موسم (اختياري)",
 "Escreva o trecho na anotação para copiar a citação.": "اكتب المقطع في الملاحظة لنسخ الاقتباس.",
 "Este item já está em todas as pastas.": "هذا العنصر موجود بالفعل في كل المجلدات.",
 "Ex.: 10.1590/...": "مثل: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "مثل: رسالة — الأخلاق والقانون",
 "Ex.: {a}": "مثل: {a}",
 "Fazendo": "قيد التنفيذ",
 "Grupo de filmes e séries": "مجموعة الأفلام والمسلسلات",
 "Grupo de leitura": "مجموعة القراءة",
 "Grupo do curso": "مجموعة الدورة",
 "ISBN": "ISBN",
 "Ideia minha": "فكرتي",
 "Instrutor": "المدرب",
 "Itens da pasta": "عناصر المجلد",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "اجمع الكتب والأفلام والدورات في مجلد (مثل: \"رسالة\"، \"روايات فقط\"). يمكن أن يكون العنصر نفسه في عدة مجلدات.",
 "Link (material online)": "رابط (مادة على الإنترنت)",
 "Lista copiada": "تم نسخ القائمة",
 "Lista de referências": "قائمة المراجع",
 "Mais de um autor: separe com ponto e vírgula (;).": "أكثر من مؤلف: افصل بفاصلة منقوطة (;).",
 "Módulo": "الوحدة",
 "Nada novo": "لا جديد",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "من ⋮ لكتاب أو فيلم أو دورة، اضغط \"وضع في مجلد\".",
 "Nome da pasta": "اسم المجلد",
 "Não achei dados novos para completar a ficha.": "لم أجد بيانات جديدة لإكمال البطاقة.",
 "Não foi possível preencher": "تعذّر الملء",
 "O módulo não tem cards de anotações.": "لا توجد بطاقات ملاحظات في هذه الوحدة.",
 "Organizador": "المحرر",
 "Os dados vêm da ficha do livro (Editar › Referência).": "تأتي البيانات من بطاقة الكتاب (تعديل › المرجع).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "لا تُحذف كتب وأفلام ودورات المجلد: تبقى في التبويب.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "ستذهب أيضًا {n} من بطاقات ملاحظات هذه الوحدة إلى سلة المحذوفات.",
 "Pasta vazia": "مجلد فارغ",
 "Preencha o título (e o que mais tiver) na ficha.": "املأ العنوان (وما لديك غيره) في البطاقة.",
 "Preencher pelo DOI": "الملء من DOI",
 "Preencher pelo link": "الملء من الرابط",
 "Produtora ou país": "شركة الإنتاج أو البلد",
 "Quero fazer": "أريد الالتحاق",
 "Quero voltar?": "هل أريد العودة؟",
 "Referência vazia": "مرجع فارغ",
 "Referências": "المراجع",
 "Se deixar avulsas, elas continuam somando no total do curso.": "إن أبقيتها منفصلة، تظل محسوبة في إجمالي الدورة.",
 "Subtítulo": "العنوان الفرعي",
 "Tirar da pasta": "إزالة من المجلد",
 "Total de episódios (opcional)": "إجمالي الحلقات (اختياري)",
 "Total de temporadas (opcional)": "إجمالي المواسم (اختياري)",
 "Tradutor": "المترجم",
 "Trecho (citação)": "مقطع (اقتباس)",
 "Trecho vazio": "مقطع فارغ",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "شاهدت {n} من الدروس. في أي وحدة تضعها؟",
 "Volume": "المجلد",
 "{n} item(ns)": "{n} عنصر",
 "{n} referência(s) em ordem alfabética.": "{n} مرجع بالترتيب الأبجدي.",
 "Ícone": "الأيقونة",
 "ASSISTIDOS POR DIA": "المشاهَد يوميًا",
 "ASSISTIDOS POR MÊS": "المشاهَد شهريًا",
 "AULAS POR DIA": "الدروس يوميًا",
 "AULAS POR MÊS": "الدروس شهريًا",
 "Apagar a meta": "حذف الهدف",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "شاهدت {a} · أشاهد {b} · توقفت {c} · أريد مشاهدة {d}",
 "Aulas": "الدروس",
 "CURSOS": "الدورات",
 "Concluí {a} · Fazendo {b} · Parei {c}": "أكملت {a} · قيد التنفيذ {b} · توقفت {c}",
 "Datas": "التواريخ",
 "Datas escolhidas": "التواريخ المختارة",
 "Datas à escolha": "تواريخ مخصصة",
 "Definir meta de {ano}": "تحديد هدف {ano}",
 "Definir meta do ano": "تحديد هدف السنة",
 "FILMES E SÉRIES": "الأفلام والمسلسلات",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "باقٍ {f}: حوالي {m} في الشهر",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "باقٍ {f}: حوالي {m} في الشهر",
 "Faltam {f} título(s): dá cerca de {m} por mês": "باقٍ {f}: حوالي {m} في الشهر",
 "Gênero": "النوع",
 "Incluir lista de referências no PDF": "تضمين قائمة المراجع في PDF",
 "LIVROS": "الكتب",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "قرأت {a} · توقفت {b} · أقرأ {c}",
 "Meta de {ano}": "هدف {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "هدف {ano}: استخدام هدف {antes} ({n})؟",
 "Meta do ano cumprida": "تحقق هدف السنة",
 "Mudar": "تغيير",
 "Nada neste período.": "لا شيء في هذه الفترة.",
 "Nota": "التقييم",
 "O PDF não leva as suas anotações, resumos e comentários.": "لا يتضمن ملف PDF ملاحظاتك وملخصاتك وتعليقاتك.",
 "POR ITEM": "حسب العنصر",
 "Plataforma": "المنصة",
 "PÁGINAS POR DIA": "الصفحات يوميًا",
 "PÁGINAS POR MÊS": "الصفحات شهريًا",
 "Quantos no ano?": "كم في السنة؟",
 "Quero ler {a} · Abandonei {b}": "أريد قراءة {a} · تركت {b}",
 "Relatório de leitura e mídia": "تقرير القراءة والوسائط",
 "concluídos no período": "مكتمل في الفترة",
 "cursos concluídos no período": "دورات مكتملة في الفترة",
 "livros lidos no período": "كتب مقروءة في الفترة",
 "pág. {a} de {n}": "ص {a} من {n}",
 "títulos assistidos no período": "عناوين مشاهَدة في الفترة",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} من الدروس في الفترة · {h} ساعة من الدورات المكتملة",
 "{a} de {n} aulas ({p}%)": "{a} من {n} دروس ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} من {n} دورات مكتملة في {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} من {n} كتب في {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} من {n} عناوين مشاهَدة في {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} عنصر بلا تاريخ تغيير الحالة: استخدمت تاريخ الإنشاء.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} صفحة في {d} يوم · أطول سلسلة: {s} يوم",
 "{p}% lido · falta {f}%": "قُرئ {p}% · بقي {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "هذا التبويب يطلب كلمة مرور. افتحه أولًا ويستمر الدليل من هنا.",
 "Abrir esta aba": "فتح هذا التبويب",
 "Mostrar na tela": "عرض على الشاشة",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "لم أجد هذا الموضع على الشاشة الآن. تأكد من فتح الشاشة الصحيحة وحاول مجددًا.",
 "Primeiros passos": "الخطوات الأولى",
 "Buscar no guia": "البحث في الدليل",
 "Entendi": "فهمت",
 "{n} de {total} passos feitos": "{n} من {total} خطوات منجزة",
 "Já fiz": "تم",
 "Guia em construção": "الدليل قيد الإعداد",
 "Limpar marcações": "مسح العلامات",
 "Este ponto ainda não está marcado no app.": "هذا الموضع غير محدد في التطبيق بعد.",
 "Dicas e atalhos": "نصائح واختصارات",
 "Gestos do app": "إيماءات التطبيق",
 "Procurando na tela…": "جارٍ البحث على الشاشة…",
 "Guia das abas": "دليل التبويبات",
 "Voltar ao guia": "العودة إلى الدليل",
 "Para que serve": "الغرض منه",
 "Disponível no app do celular.": "متاح في تطبيق الهاتف.",
 "Nada encontrado no guia.": "لم يُعثر على شيء في الدليل.",
 "Recursos que valem para todas as abas": "ميزات لكل التبويبات",
 "Perguntas comuns": "أسئلة شائعة",
 "Ligar e desligar partes": "تشغيل الأجزاء وإيقافها",
 "Entrada cancelada. Este computador não foi conectado.": "تم إلغاء الدخول. لم يتم توصيل هذا الكمبيوتر.",
 "Alterações ainda não enviadas": "تغييرات لم تُرسل بعد",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "بعض التغييرات لم تُرسل إلى الخادم بعد (لا يوجد إنترنت؟). إذا خرجت الآن فستضيع. هل تريد الخروج على أي حال؟",
 "Sair mesmo assim": "الخروج على أي حال",
 "O seu papel no grupo não permite mudar aqui.": "دورك في المجموعة لا يسمح بالتغيير هنا.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "تعذر البحث عن DOI الآن (لا يوجد إنترنت؟). حاول مرة أخرى.",
 "DOI inválido.": "DOI غير صالح.",
 "DOI não encontrado.": "لم يتم العثور على DOI.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "لم يسمح الموقع بقراءة بياناته من هنا (أمر شائع في متصفح الكمبيوتر). جرّب التطبيق على الهاتف أو استخدم DOI أو اكتب الحقول.",
 "Atualizando...": "جارٍ التحديث...",
 "Banco de dados (Supabase, plano grátis)": "قاعدة البيانات (Supabase، الخطة المجانية)",
 "Cadeado (HTTPS) até": "قفل HTTPS حتى",
 "Dados das abas: {d}": "بيانات الأقسام: {d}",
 "Disco": "القرص",
 "Esta conta não tem acesso a estas informações.": "لا يملك هذا الحساب صلاحية الوصول إلى هذه المعلومات.",
 "Ligado há": "يعمل منذ",
 "Livre: {l} · site: {s}": "المتاح: {l} · الموقع: {s}",
 "Maiores tabelas": "أكبر الجداول",
 "Memória em uso": "الذاكرة المستخدمة",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "لم يرسل الخادم التقرير بعد. يرسله كل 10 دقائق بعد تشغيل 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "لا يملك الخادم هذه الوظيفة بعد. شغّل 53-SERVIDOR-0.78.bat على الكمبيوتر.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "يطلب نظام الخادم إعادة التشغيل (تم تثبيت تحديث أمني).",
 "Processador": "المعالج",
 "Relatório do servidor: {q}": "تقرير الخادم: {q}",
 "Servidor": "الخادم",
 "Servidor do site (Locaweb)": "خادم الموقع (Locaweb)",
 "Sistema": "النظام",
 "Só você vê este quadro.": "أنت وحدك ترى هذه اللوحة.",
 "Versão do site no ar": "إصدار الموقع المنشور",
 "atrasado: confira se o servidor está ligado": "متأخر: تحقّق من أن الخادم يعمل",
 "sem cadeado": "بلا قفل",
 "{a} ({n} guardadas)": "{a} ({n} محفوظة)",
 "{d} dia(s) e {h} h": "{d} يوم و{h} ساعة",
 "{n} núcleo(s) · carga {c}": "{n} نواة · الحمل {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} جديدة و{ativas} نشطة خلال 7 أيام",
 "{u} de {t} ({p}%)": "{u} من {t} ({p}%)",
 "Fechar teclado": "إغلاق لوحة المفاتيح",
 "Mostrar as ferramentas": "إظهار الأدوات",
 "Últimas cores usadas": "الألوان المستخدمة مؤخرًا",
 "Voltar ao topo": "العودة إلى الأعلى",
 "Topo": "الأعلى",
 "1 atividade do roteiro por fazer": "1 نشاط في خط الرحلة لم يُنجز",
 "1 dia": "1 يوم",
 "1 item por pôr na mala": "1 غرض لم يوضع في الحقيبة بعد",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "كانت 1 قائمة من الرحلات تُرسل كاملة إلى My Planner وأُزيلت من هناك. الآن يتم الإرسال عنصرًا بعنصر عبر ⋮ الخاص بكل عنصر.",
 "1 lugar não visitado": "1 مكان لم تتم زيارته",
 "1 reserva por confirmar": "1 حجز بانتظار التأكيد",
 "Abrir o bloco": "فتح القسم",
 "Adicionar pessoa": "إضافة شخص",
 "Ainda pode gastar {v}": "يمكنك إنفاق {v} أيضًا",
 "Ao ligar, o valor entra em Gastos como pago.": "عند التفعيل، يُضاف المبلغ إلى المصروفات كمدفوع.",
 "Até (dd/mm/aaaa)": "حتى (يوم/شهر/سنة)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "أضف الأشخاص في \"من سيذهب\" (عدّل الرحلة).",
 "Como foi?": "كيف كانت؟",
 "Concluído em {d}": "اكتمل في {d}",
 "Confirmada em {d}": "تم التأكيد في {d}",
 "Confirmadas": "مؤكدة",
 "Dia anterior": "اليوم السابق",
 "Dias": "الأيام",
 "Dias × valor por dia": "الأيام × المبلغ اليومي",
 "Documentos (só o tipo e a validade)": "المستندات (النوع والصلاحية فقط)",
 "EXIGÊNCIAS DO DESTINO": "متطلبات الوجهة",
 "Em mãos": "في اليد",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "اكتب ما تطلبه الوجهة (مثال: صفحتان فارغتان في جواز السفر، شهادة تطعيم). تحقق من الموقع الرسمي للبلد.",
 "Ex.: Lisboa (LIS)": "مثال: لشبونة (LIS)",
 "Ex.: São Paulo (GRU)": "مثال: ساو باولو (GRU)",
 "Falta confirmar": "بانتظار التأكيد",
 "Falta pôr": "لم يوضع بعد",
 "Faltou ({n}): {l}": "نُسي ({n}): {l}",
 "Foi ({n}): {l}": "أُخذ ({n}): {l}",
 "Fotos (lista das legendas)": "الصور (قائمة التعليقات)",
 "Gasto de {nome} em {d}": "مصروف {nome} في {d}",
 "Gastos do dia": "مصروفات اليوم",
 "Gastos em outras moedas (não convertidos): {v}": "مصروفات بعملات أخرى (غير محوّلة): {v}",
 "Gastos por dia": "المصروفات حسب اليوم",
 "Horário de chegada": "وقت الوصول",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "الأماكن (التي زرتها، المتبقية، التي لا تُفوَّت، والتقييم)",
 "Mala (o que foi e o que faltou)": "الحقيبة (ما أُخذ وما نُسي)",
 "Marcar como acertado": "تحديد كمسدَّد",
 "Marcar como acertado?": "تحديد كمسدَّد؟",
 "Na mala": "في الحقيبة",
 "Nenhuma parada ainda": "لا توجد محطات بعد",
 "Nova exigência": "متطلب جديد",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "لا تُدرج أرقام المستندات ومحتويات الخزنة في التقرير أبدًا. تظهر المبالغ بعملات مختلفة بشكل منفصل.",
 "O QUE AINDA FALTA": "ما زال متبقيًا",
 "O QUE INCLUIR": "ما الذي يُضمَّن",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "اختياري. ينبّهك التطبيق إذا انتهت صلاحية جواز السفر قبل ذلك، محسوبةً من تاريخ العودة. تحقق من متطلبات البلد.",
 "Orçamento previsto × gasto por categoria": "الميزانية المخططة × المصروف حسب الفئة",
 "Passou do previsto em {v}": "تجاوزت الميزانية بمقدار {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "أدخل تاريخ صلاحية كل مستند: ينبّهك التطبيق قبل انتهائها. تبقى صور المستندات محمية في الخزنة.",
 "Próximo dia": "اليوم التالي",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "ينضم أعضاء مجموعة الرحلة تلقائيًا. استخدم \"+ إضافة شخص\" لمن ليس لديه التطبيق.",
 "Recolher o bloco": "طي القسم",
 "Relatório da viagem": "تقرير الرحلة",
 "Reserva confirmada": "تم تأكيد الحجز",
 "Resumo da viagem": "ملخص الرحلة",
 "Resumo da viagem (datas, destino, pessoas)": "ملخص الرحلة (التواريخ، الوجهة، الأشخاص)",
 "Roteiro por dia (feito e falta)": "خط الرحلة حسب اليوم (المُنجز والمتبقي)",
 "Sem data": "بدون تاريخ",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "قد لا يُقبل جواز سفرك. تحقق من متطلبات البلد",
 "Subir": "نقل لأعلى",
 "Total do dia: {v}": "إجمالي اليوم: {v}",
 "Uma frase (opcional)": "جملة واحدة (اختياري)",
 "Validade mínima exigida (meses)": "الحد الأدنى المطلوب لصلاحية جواز السفر (بالأشهر)",
 "Validade: {d}": "الصلاحية: {d}",
 "Valor por dia": "المبلغ اليومي",
 "Viagens no My Planner": "الرحلات في My Planner",
 "Visitado": "تمت الزيارة",
 "Visitado em {d}": "تمت الزيارة في {d}",
 "Voltaria: {r}": "هل ستعود: {r}",
 "Voltaria?": "هل ستعود؟",
 "confirmada": "مؤكدة",
 "em mãos": "في اليد",
 "gasto na viagem {d}": "مصروف الرحلة {d}",
 "meses": "أشهر",
 "outro gasto": "مصروف آخر",
 "vence em {d}": "تنتهي في {d}",
 "{a} de {b} confirmadas": "{a} من {b} مؤكدة",
 "{a} de {b} em mãos": "{a} من {b} في اليد",
 "{a} de {b} feitos": "{a} من {b} مُنجزة",
 "{a} de {b} na mala": "{a} من {b} في الحقيبة",
 "{a} de {b} pagos": "{a} من {b} مدفوعة",
 "{a} de {b} visitados": "{a} من {b} تمت زيارتها",
 "{de} deve {v} a {para}": "{de} مدين لـ {para} بمبلغ {v}",
 "{g} de {p}": "{g} من {p}",
 "{n} atividades do roteiro por fazer": "{n} أنشطة في خط الرحلة لم تُنجز",
 "{n} item(ns) enviado(s).": "تم إرسال {n} عنصر.",
 "{n} itens por pôr na mala": "{n} أغراض لم توضع في الحقيبة بعد",
 "{n} já estava(m) no My Planner.": "{n} موجود مسبقًا في My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "كانت {n} قوائم من الرحلات تُرسل كاملة إلى My Planner وأُزيلت من هناك. الآن يتم الإرسال عنصرًا بعنصر عبر ⋮ الخاص بكل عنصر.",
 "{n} lugares não visitados": "{n} أماكن لم تتم زيارتها",
 "{n} reservas por confirmar": "{n} حجوزات بانتظار التأكيد",
 "{n} sem data (não foi).": "{n} بدون تاريخ (لم يُرسل).",
 "ARTIGOS E SITES": "المقالات والمواقع",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "أصبح الإرسال عنصرًا عنصرًا (من ⋮ الخاص بالعنصر أو باختيار عدة عناصر). هذه القوائم كانت تُرسل كاملة وأُزيلت من My Planner ({n} عنصر، لم يُحذف شيء):",
 "Artigo científico": "مقال علمي",
 "Artigo de site ou blog": "مقال موقع أو مدونة",
 "Artigo ou site": "مقال أو موقع",
 "Artigos e sites": "المقالات والمواقع",
 "Autor(es)": "المؤلف (المؤلفون)",
 "Cadastrar pela foto ou PDF": "الإضافة من صورة أو PDF",
 "Capítulo de livro": "فصل من كتاب",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "أنشئ المجموعة وأرسل الرابط: من ينضم يرى المقالات ويتابع القراءة. المسؤول يضيف ويعدّل ويضع الصور، ويمكنه السماح بذلك لمن يستخدم التبويب أيضًا. المسؤول وحده يضيف الأشخاص أو يزيلهم.",
 "DOI": "DOI",
 "Data ou ano de publicação": "تاريخ أو سنة النشر",
 "Editar artigo ou site": "تعديل المقال أو الموقع",
 "Enviar para o My Planner (lembrete de renovação)": "إرسال إلى My Planner (تذكير التجديد)",
 "Envio para o My Planner": "الإرسال إلى My Planner",
 "Ex.: 2024 ou 12/03/2024": "مثال: 2024 أو 12/03/2024",
 "Ex.: 45-60": "مثال: 45-60",
 "Grupo de artigos": "مجموعة المقالات",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "احفظ المقالات والأخبار وصفحات الويب مع المرجع جاهزًا (ABNT وAPA). املأه من DOI أو الرابط.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "قرأت {a} · أقرأ {b} · توقفت {c} · أريد قراءة {d}",
 "Minhas anotações do artigo": "ملاحظاتي على المقال",
 "Notícia": "خبر",
 "Novo artigo ou site": "مقال أو موقع جديد",
 "Os dados vêm da ficha do artigo (Editar).": "البيانات من بطاقة المقال (تعديل).",
 "Páginas (opcional)": "الصفحات (اختياري)",
 "Revista, site ou veículo": "مجلة أو موقع أو وسيلة",
 "artigos e sites lidos no período": "مقالات ومواقع مقروءة في الفترة",
 "1 confirmado": "1 مؤكد",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "انتقل ضيف واحد كان في \"معلّق\" إلى \"للدعوة\". عند إرسال الدعوة عبر التطبيق ينتقل تلقائيًا إلى \"مدعو، بلا رد\".",
 "1 extra": "1 إضافي",
 "1 talvez": "1 ربما",
 "A convidar": "للدعوة",
 "Agendar na igreja": "الحجز في الكنيسة",
 "Agora": "الآن",
 "Agradeci": "شكرتُ",
 "Agradeci em {d}": "شكرتُ في {d}",
 "Agradecidos": "تم شكرهم",
 "Alianças": "خواتم الزواج",
 "Aluguéis (mesas, cadeiras, louças)": "الإيجارات (طاولات، كراسٍ، أوانٍ)",
 "Avisar a data (save the date)": "الإعلان عن الموعد (save the date)",
 "Bebidas": "المشروبات",
 "Beca e cerimônia": "الرداء والحفل",
 "Bolo": "الكعكة",
 "Brincadeiras": "الألعاب",
 "Brincadeiras e amigo secreto": "الألعاب والصديق السري",
 "Brindes": "الهدايا الترويجية",
 "Buffet": "البوفيه",
 "Calculado sozinho: valor menos o sinal.": "يُحسب تلقائيًا: المبلغ ناقص العربون.",
 "Calcular quantidades": "حساب الكميات",
 "Categoria do orçamento": "فئة الميزانية",
 "Celebrante": "مُقيم المراسم",
 "Cerimônia": "المراسم",
 "Cerveja (adultos)": "بيرة (للبالغين)",
 "Checklist de preparação": "قائمة التحضير",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "حدّد تاريخ المناسبة (عدّل المناسبة) لترى موعد كل بند.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "أضف الأشخاص في \"أشخاص المناسبة\" (عدّل المناسبة).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "أدخل ما تنوي إنفاقه في كل فئة. استخدم ⊕ للحساب لكل ضيف. يُضاف المورّدون المتعاقد معهم تلقائيًا إلى الفئة المختارة.",
 "Combinado: {v}": "المتفق عليه: {v}",
 "Comprado": "تم الشراء",
 "Comprados": "تم شراؤها",
 "Comprar a decoração e as lembrancinhas": "شراء الزينة والتذكارات",
 "Comprar as alianças": "شراء الخواتم",
 "Comprar as lembrancinhas": "شراء التذكارات",
 "Comprar bebidas e gelo": "شراء المشروبات والثلج",
 "Comprar comida e bebidas": "شراء الطعام والمشروبات",
 "Comprar o que falta": "شراء ما ينقص",
 "Comprar ou alugar a roupa": "شراء الملابس أو استئجارها",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "المؤكَّدون مع مرافقيهم. يتغيّر تلقائيًا عندما يؤكد أحد أو يلغي.",
 "Confirmar a presença dos convidados": "تأكيد حضور الضيوف",
 "Confirmar os fornecedores": "تأكيد المورّدين",
 "Confirmar os fornecedores e os convidados": "تأكيد المورّدين والضيوف",
 "Contratar a comida": "التعاقد على الطعام",
 "Contratar a comida e o bolo": "التعاقد على الطعام والكعكة",
 "Contratar a decoração": "التعاقد على الزينة",
 "Contratar comida e bebidas": "التعاقد على الطعام والمشروبات",
 "Contratar foto e vídeo": "التعاقد على التصوير والفيديو",
 "Contratar o buffet": "التعاقد على البوفيه",
 "Convidado, sem resposta": "مدعو، بلا رد",
 "Convidados (por situação, com acompanhantes)": "الضيوف (حسب الحالة، مع المرافقين)",
 "Convidados que contam no ⊕": "الضيوف المحسوبون في ⊕",
 "Convites": "الدعوات",
 "Cronograma do dia (com responsáveis e situação)": "جدول اليوم (مع المسؤولين والحالة)",
 "Data do restante": "تاريخ المبلغ المتبقي",
 "Data do sinal": "تاريخ العربون",
 "Decoração": "الزينة",
 "Definir a data e o orçamento": "تحديد الموعد والميزانية",
 "Definir a lista de convidados": "تحديد قائمة الضيوف",
 "Doces": "الحلويات",
 "Dá para mudar, tirar e incluir itens depois.": "يمكنك تعديل البنود وحذفها وإضافتها لاحقًا.",
 "Enviar os convites": "إرسال الدعوات",
 "Equipamentos (projetor, som)": "المعدات (جهاز عرض، صوت)",
 "Equipe (garçons, limpeza)": "الطاقم (نُدُل، تنظيف)",
 "Escolha \"Outro\" para escrever o nome.": "اختر \"أخرى\" لكتابة الاسم.",
 "Escolher a roupa": "اختيار الملابس",
 "Escolher a roupa dos noivos": "اختيار ملابس العروسين",
 "Escolher os padrinhos": "اختيار الإشبينين",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "تقدير لـ {n} ضيوف. غيّر ما تشاء قبل نقله.",
 "Eu faço": "سأقوم بها",
 "Ex.: 200 un.": "مثال: 200 قطعة",
 "Ex.: Copos descartáveis": "مثال: أكواب للاستعمال مرة واحدة",
 "Ex.: Jogo de panelas": "مثال: طقم أوانٍ",
 "Ex.: Reservar o local": "مثال: حجز المكان",
 "Ex.: em negociação": "مثال: قيد التفاوض",
 "Extras de margem (quem aparece sem avisar)": "هامش إضافي (من يحضر دون إخبار)",
 "Falta 1 dia": "بقي يوم واحد",
 "Falta agradecer": "لم يُشكر بعد",
 "Falta comprar": "لم يُشترَ بعد",
 "Falta pagar": "لم يُدفع بعد",
 "Fazer a lista de presentes": "إعداد قائمة الهدايا",
 "Fazer o curso de batismo": "حضور دورة المعمودية",
 "Fornecedores (contratado, pago, falta)": "المورّدون (المتعاقد، المدفوع، المتبقي)",
 "Foto e vídeo": "التصوير والفيديو",
 "Fraldas": "الحفاضات",
 "Frase curta (opcional)": "عبارة قصيرة (اختياري)",
 "Hoje é o dia do evento!": "اليوم هو يوم المناسبة!",
 "Igreja e celebrante": "الكنيسة ومُقيم المراسم",
 "Incluir os Talvez": "تضمين \"ربما\"",
 "Incluir telefones": "تضمين أرقام الهواتف",
 "Item da lista de compras": "بند قائمة المشتريات",
 "Item da preparação": "بند التحضير",
 "Já deram: {d} · Falta: {f}": "دُفع: {d} · المتبقي: {f}",
 "Já deu": "دفع",
 "L": "لتر",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "سجّل هنا ما أُنفق. تُضاف مدفوعات المورّدين والمشتريات المحددة تلقائيًا.",
 "Lançar o gasto": "تسجيل المصروف",
 "Lembrancinhas": "التذكارات",
 "Levar para os itens": "نقل إلى البنود",
 "Local / espaço": "المكان / القاعة",
 "Mais um extra": "إضافي واحد آخر",
 "Menos um extra": "إضافي واحد أقل",
 "Música / som / DJ": "الموسيقى / الصوت / دي جي",
 "No dia do evento": "في يوم المناسبة",
 "O que comprar": "ما يجب شراؤه",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "يتغيّر الإجمالي تلقائيًا عندما يؤكد أحد أو يلغي.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "يُضاف مبلغ العقد تلقائيًا كمبلغ مخطط في هذه الفئة، وما يُدفع يدخل في المصروفات.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "يدخل المبلغ في مصروفات المناسبة ضمن فئة البند. يمكنك التخطي إن شئت.",
 "Onde comprar": "أين تشتري",
 "Orçamento do evento": "ميزانية المناسبة",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "تدخل البنود المحددة في الفئة مع ⊕ لكل ضيف. بعدها اضغط ⊕ وأدخل سعر الوحدة.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "لا تظهر أرقام هواتف الضيوف في PDF إلا إذا حددت \"تضمين أرقام الهواتف\". تظهر المبالغ بعملات مختلفة منفصلة.",
 "Pago em {d}": "دُفع في {d}",
 "Parte da vaquinha": "حصة من الصندوق المشترك",
 "Pessoas do evento": "أشخاص المناسبة",
 "Pessoas do evento: {p}": "أشخاص المناسبة: {p}",
 "Preparar as brincadeiras": "تحضير الألعاب",
 "Preparação": "التحضير",
 "Presente recebido": "هدية مستلمة",
 "Presentes": "الهدايا",
 "Prova final da roupa": "البروفة النهائية للملابس",
 "Pular": "تخطٍّ",
 "Quantidade por convidado": "الكمية لكل ضيف",
 "Quantidade por convidado × valor unitário": "الكمية لكل ضيف × سعر الوحدة",
 "Quanto custou?": "كم كلّف؟",
 "Quanto já deu": "المبلغ المدفوع",
 "Quanto vai contribuir": "مبلغ المساهمة",
 "Quantos dias antes do evento": "كم يومًا قبل المناسبة",
 "Quem deu": "من أهداها",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "يُضاف أعضاء مجموعة المناسبة تلقائيًا. استخدم \"+ إضافة شخص\" لمن ليس لديه التطبيق. تُستخدم هذه القائمة في الجدول والمصروفات والصندوق المشترك.",
 "Recreação e brinquedos": "الترفيه والألعاب",
 "Refrigerante": "المشروبات الغازية",
 "Relatório do evento": "تقرير المناسبة",
 "Relatório do evento (PDF)": "تقرير المناسبة (PDF)",
 "Reservar o local": "حجز المكان",
 "Reservar o local da cerimônia e da festa": "حجز مكان المراسم والحفل",
 "Reservar o local ou a mesa da festa": "حجز مكان الحفل أو الطاولة",
 "Restante": "المتبقي",
 "Restante pago": "تم دفع المتبقي",
 "Resumo do evento": "ملخص المناسبة",
 "Roupa e beleza": "الملابس والتجميل",
 "Salgados": "المقبلات المالحة",
 "Separar a roupa e o que levar": "تجهيز الملابس وما يجب أخذه",
 "Separar os documentos e as alianças": "تجهيز المستندات والخواتم",
 "Separar os documentos e os ingressos": "تجهيز المستندات والتذاكر",
 "Sinal": "العربون",
 "Sinal pago": "تم دفع العربون",
 "Sinal {v} pago": "تم دفع العربون {v}",
 "Usar a lista pronta para {tipo}": "استخدام القائمة الجاهزة لـ {tipo}",
 "Vai contribuir": "سيساهم",
 "Valor unitário": "سعر الوحدة",
 "Vaquinha": "الصندوق المشترك",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "تتابع كل ما تمت مشاركته، محدّثًا دائمًا. للإضافة والتعديل وتولّي المهام، اشترك في هذا القسم.",
 "agradeci": "شكرتُ",
 "atrasado": "متأخر",
 "completo": "مكتمل",
 "deu {d} de {v}": "دفع {d} من {v}",
 "em {l}": "في {l}",
 "falta o valor": "المبلغ غير محدد",
 "falta {v} até {d}": "متبقٍ {v} حتى {d}",
 "gasto em {e}": "أُنفق على {e}",
 "kg": "كغ",
 "o evento": "المناسبة",
 "restante": "المتبقي",
 "sinal": "العربون",
 "total": "الإجمالي",
 "un.": "قطعة",
 "{n} confirmados": "{n} مؤكدون",
 "{n} convidados contam no ⊕ por convidado.": "يُحسب {n} ضيوف في ⊕ لكل ضيف.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "انتقل {n} ضيوف كانوا في \"معلّق\" إلى \"للدعوة\". عند إرسال الدعوة عبر التطبيق ينتقلون تلقائيًا إلى \"مدعو، بلا رد\".",
 "{n} extras": "{n} إضافيون",
 "{n} talvez": "{n} ربما",
 "{q} por convidado": "{q} لكل ضيف",
 "{v} por convidado": "{v} لكل ضيف",
 "Item completo": "عنصر كامل",
 "Nota rápida": "ملاحظة سريعة",
 "📝 Nota rápida": "📝 ملاحظة سريعة",
 "Conteúdo da nota": "محتوى الملاحظة",
 "{c} confirmado(s) de {n} convidado(s)": "{c} مؤكد من أصل {n} ضيف",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "سيتم الحذف للجميع: مستندات المكتب \"{nome}\" والاجتماعات المجدولة والتسجيلات. تبقى المحادثة في الرسائل.",
 "Confirme para apagar o escritório": "أكّد لحذف المكتب",
 "Escreva o assunto da reunião para poder marcar.": "اكتب موضوع الاجتماع لتتمكن من تحديده.",
 "{n} min (marcada para {m} min)": "{n} دقيقة (محددة لـ {m} دقيقة)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "تعذّر تنزيل الملف الآن. تحقق من الإنترنت وحاول مجددًا.",
 "Meus clientes": "عملائي",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "قائمة عملاء واحدة تستخدمها كل علامات تبويب العمل: جهة الاتصال والعنوان والوسوم والملاحظات والملفات.",
 "Copiar para Meus clientes": "نسخ إلى عملائي",
 "Ver ou mudar": "عرض أو تغيير",
 "Ver o documento completo": "عرض المستند كاملًا",
 "CEP incompleto": "CEP غير مكتمل",
 "O CEP tem 8 números.": "يتكون CEP من 8 أرقام.",
 "CEP não encontrado": "لم يتم العثور على CEP",
 "Confira os números ou preencha o endereço à mão.": "تحقق من الأرقام أو أدخل العنوان يدويًا.",
 "Não foi possível buscar o CEP": "تعذر البحث عن CEP",
 "Confira a internet ou preencha o endereço à mão.": "تحقق من اتصال الإنترنت أو أدخل العنوان يدويًا.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "يبدو أن هناك شيئًا ناقصًا في هذا البريد (مثال: name@site.com).",
 "opcional": "اختياري",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "أصبح عملاؤك الآن في قائمة واحدة تستخدمها كل علامات تبويب العمل.",
 "Portal do Cliente: {n} cliente(s).": "بوابة العميل: {n} عميل.",
 "Freelancer & Projetos: {n} cliente(s).": "العمل الحر والمشاريع: {n} عميل.",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} كانوا العميل نفسه في أكثر من علامة تبويب وأصبحوا سجلًا واحدًا.",
 "Nenhum cliente repetido.": "لا يوجد عملاء مكررون.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "لم يُحذف شيء: المستندات والطلبات والبطاقات والساعات باقية في مكانها.",
 "Já está em Meus clientes": "موجود بالفعل في عملائي",
 "{nome} já está na lista.": "{nome} موجود بالفعل في القائمة.",
 "Copiado para Meus clientes": "تم النسخ إلى عملائي",
 "Só o nome e o contato foram copiados.": "تم نسخ الاسم وجهة الاتصال فقط.",
 "Aniversário hoje!": "عيد ميلاد اليوم!",
 "Fechar tudo": "طي الكل",
 "Abrir tudo": "توسيع الكل",
 "Quem é": "من هو",
 "Razão social": "الاسم القانوني",
 "Nome fantasia": "الاسم التجاري",
 "Data de abertura": "تاريخ التأسيس",
 "Inscrição estadual / municipal": "التسجيل الولائي / البلدي",
 "Outras pessoas de contato": "جهات اتصال أخرى",
 "Como chamar": "كيف تناديه",
 "Cliente desde": "عميل منذ",
 "Outro telefone": "هاتف آخر",
 "Site": "الموقع الإلكتروني",
 "Melhor jeito de falar": "أفضل وسيلة للتواصل",
 "Autorizou receber mensagens": "وافق على تلقي الرسائل",
 "Outros endereços": "عناوين أخرى",
 "Relacionamento": "العلاقة",
 "Como me conheceu": "كيف تعرّف عليّ",
 "Etiquetas": "الوسوم",
 "Nada anotado ainda.": "لا توجد ملاحظات بعد.",
 "Bloco da aba {aba}": "قسم علامة التبويب {aba}",
 "Abrir na aba {aba}": "فتح في علامة التبويب {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "قائمة واحدة تستخدمها كل علامات تبويب العمل.",
 "Escreva o nome do cliente.": "اكتب اسم العميل.",
 "Telefone / WhatsApp": "الهاتف / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "الاسم وحده إلزامي. افتح الأقسام التي تريد تعبئتها.",
 "Como chamar (apelido)": "كيف تناديه (اللقب)",
 "Inscrição estadual / municipal (opcional)": "التسجيل الولائي / البلدي (اختياري)",
 "Cargo": "المنصب",
 "Telefone da pessoa de contato": "هاتف جهة الاتصال",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "جهات اتصال أخرى (واحدة في كل سطر: الاسم، المنصب، الهاتف)",
 "O telefone principal é WhatsApp": "الهاتف الرئيسي على WhatsApp",
 "O outro telefone é WhatsApp": "الهاتف الآخر على WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "مثال: @name",
 "Ex.: WhatsApp, à tarde": "مثال: WhatsApp، بعد الظهر",
 "Estado (UF)": "الولاية (UF)",
 "Endereço (como estava escrito)": "العنوان (كما كان مكتوبًا)",
 "Outros endereços (trabalho, entrega...)": "عناوين أخرى (العمل، التوصيل...)",
 "Google": "Google",
 "Passou na frente": "مرّ من أمام المتجر",
 "Indicado por": "بترشيح من",
 "Criar etiqueta": "إنشاء وسم",
 "Ex.: VIP, Mensal, Atacado": "مثال: VIP، شهري، جملة",
 "Ativo": "نشط",
 "Inativo": "غير نشط",
 "Em negociação": "قيد التفاوض",
 "O cliente autorizou receber mensagens?": "هل وافق العميل على تلقي الرسائل؟",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "بدون موافقة، لا رسائل عيد ميلاد ولا تذكيرات دفع تلقائية ولا عروض لهذا العميل.",
 "aniversário hoje": "عيد ميلاد اليوم",
 "contato: {n}": "جهة الاتصال: {n}",
 "com esse telefone": "بهذا الهاتف",
 "com esse e-mail": "بهذا البريد الإلكتروني",
 "com esse documento": "بهذا المستند",
 "com esse nome": "بهذا الاسم",
 "Cliente parecido": "عميل مشابه",
 "Já existe {nome} {por}. Abrir?": "{nome} موجود بالفعل {por}. فتح؟",
 "Cadastrar mesmo assim": "إضافة على أي حال",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "سيتم حذف: سجل هذا العميل وملاحظاته وملفاته.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "وأيضًا في علامات التبويب: {abas} (مع المستندات والطلبات والبطاقات والساعات فيها).",
 "Juntar com outra ficha": "دمج مع سجل آخر",
 "Juntar fichas": "دمج السجلات",
 "Não há outra ficha para juntar.": "لا يوجد سجل آخر للدمج.",
 "Juntar \"{nome}\" com:": "دمج \"{nome}\" مع:",
 "Juntar as duas fichas?": "دمج السجلين؟",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "سيحصل \"{a}\" على كل ما في \"{b}\" (البيانات والملاحظات والملفات والروابط مع علامات التبويب). لن يعود السجل \"{b}\" موجودًا.",
 "Juntar": "دمج",
 "Confirme para juntar as fichas": "أكّد لدمج السجلات",
 "Aniversariantes do mês": "أعياد ميلاد هذا الشهر",
 "Ativos": "النشطون",
 "Inativos": "غير النشطين",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "أضف كل عميل مرة واحدة: سيظهر في كل علامات تبويب العمل التي تستخدمها.",
 "Novo cliente": "عميل جديد",
 "Editar cliente": "تعديل العميل",
 "Linha do tempo": "الخط الزمني",
 "{n} registro(s)": "{n} سجل",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "لا شيء بعد. ستظهر هنا المبيعات والمدفوعات والمستندات والساعات.",
 "Me deve": "مدين لي",
 "Total pago": "إجمالي المدفوع",
 "Última compra ou atendimento": "آخر شراء أو خدمة",
 "Próximo compromisso": "الموعد التالي",
 "na entrega": "عند التسليم",
 "Passou do limite de fiado ({v}).": "تجاوز حد الدين ({v}).",
 "Recebeu {v} ({p})": "تم استلام {v} ({p})",
 "Hoje é aniversário de {n}.": "اليوم عيد ميلاد {n}.",
 "Mandar parabéns": "أرسل تهنئة",
 "{n}: parcela de {v} atrasada.": "{n}: قسط بقيمة {v} متأخر.",
 "Cobrar": "طالب بالدفع",
 "{n} não compra há {d} dias.": "لم يشترِ {n} منذ {d} يومًا.",
 "Chamar de volta": "تواصل مجددًا",
 "🟢 em dia · 🟡 sumido": "🟢 منتظم · 🟡 غائب",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 منتظم · 🟡 شيء يقترب موعده أو عميل غائب · 🔴 متأخر",
 "Limite de fiado (opcional)": "حد الدين (اختياري)",
 "Avisa quando o que ele deve passar deste valor.": "ينبهك عندما يتجاوز دينه هذا المبلغ.",
 "A prazo": "بالتقسيط",
 "parcela atrasada": "قسط متأخر",
 "falta na entrega": "الباقي عند التسليم",
 "Sumidos": "الغائبون",
 "Sinal pago, falta o resto": "العربون مدفوع، والباقي مستحق",
 "Pagou {a} de {b}": "دفع {a} من {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "هذا القسط من «عملائي». علِّمه هنا كمستلم أو افتح العميل للمطالبة بالدفع وإنشاء الإيصال.",
 "Sinal + restante": "عربون + الباقي",
 "Pix": "Pix",
 "Cartão de crédito à vista": "بطاقة ائتمان، دفعة واحدة",
 "Cartão de crédito parcelado": "بطاقة ائتمان، بالتقسيط",
 "Fiado / a prazo": "بالدين / بالتقسيط",
 "Parcela única": "دفعة واحدة",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "مرحبًا {nome}! عيد ميلاد سعيد! 🎉 أتمنى لك يومًا جميلًا. مع خالص المحبة!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "مرحبًا {nome}! مضى وقت طويل منذ آخر حديث بيننا. هل يمكنني مساعدتك في شيء؟ سيسعدني خدمتك من جديد!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "مرحبًا {nome}! أودّ تذكيرك بالقسط بقيمة {v} الذي استحق في {d}. إن احتجت أي شيء، راسلني. شكرًا!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "مرحبًا {nome}! أودّ تذكيرك بالقسط بقيمة {v}{d}. إن احتجت أي شيء، راسلني. شكرًا!",
 "que vence dia {d}": "المستحق في {d}",
 "Quanto recebeu?": "كم استلمت؟",
 "Falta {v}. Pode ser só uma parte.": "المتبقي {v}. يمكن أن يكون جزءًا فقط.",
 "(seu nome ou sua marca, em Como você recebe?)": "(اسمك أو علامتك التجارية، في «كيف تستلم المدفوعات؟»)",
 "Recibo {c}": "إيصال {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "استلمتُ من {c} مبلغ {v} مقابل {o}.",
 "{v} no {f} → recebe {l}": "{v} عبر {f} ← تستلم {l}",
 "Pagou {a} de {b}, faltam {c}": "دفع {a} من {b}، والمتبقي {c}",
 "Recebido em {d}": "تم الاستلام في {d}",
 "Cobrar pelo WhatsApp": "طالب بالدفع عبر WhatsApp",
 "Sem autorização": "بدون إذن",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "لم يوافق هذا العميل على تلقي الرسائل (ملف العميل › العلاقة).",
 "Sem telefone": "لا يوجد رقم هاتف",
 "Coloque o telefone na ficha do cliente.": "أضف رقم الهاتف في ملف العميل.",
 "Gerar recibo": "إنشاء إيصال",
 "Como você recebe?": "كيف تستلم المدفوعات؟",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "فقط «دفعة فورية»: شاشة نظيفة بلا تقسيط ولا أقساط ولا لون أحمر.",
 "Taxa da maquininha (%)": "رسوم جهاز البطاقات (%)",
 "Taxa {k}": "رسوم {k}",
 "Cliente sumido depois de (dias sem comprar)": "يُعدّ العميل غائبًا بعد (أيام بلا شراء)",
 "Dias para considerar sumido": "عدد الأيام لاعتباره غائبًا",
 "Lembretes de cobrança por parcela atrasada": "تذكيرات الدفع للأقساط المتأخرة",
 "Nome ou marca no recibo": "الاسم أو العلامة على الإيصال",
 "Ex.: Ana Beatriz Doces": "مثال: Ana Beatriz للحلويات",
 "Venda ou serviço": "بيع أو خدمة",
 "O que foi vendido ou feito": "ما الذي بيع أو أُنجز",
 "Ex.: Bolo de aniversário": "مثال: كعكة عيد ميلاد",
 "Como paga": "طريقة الدفع",
 "Sinal (%)": "العربون (%)",
 "Ou escreva o valor do sinal logo abaixo.": "أو اكتب مبلغ العربون أدناه مباشرة.",
 "Sinal (valor)": "العربون (المبلغ)",
 "Restante na entrega": "الباقي عند التسليم",
 "Próximo vencimento": "الاستحقاق التالي",
 "Sinal a receber": "عربون مستحق",
 "falta {v}{q}": "متبقٍّ {v}{q}",
 "quitado": "مسدَّد",
 "Parcelas mantidas": "تم الإبقاء على الأقساط",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "يوجد دفع مسجَّل بالفعل: لم تُعَد الأقساط. لتغييرها، ألغِ المدفوعات أولًا.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "سجِّل ما اشتراه العميل أو الخدمة التي قدمتها، وطريقة دفعه.",
 "Débito": "بطاقة خصم",
 "Crédito à vista": "ائتمان، دفعة واحدة",
 "Crédito 2x": "ائتمان، قسطان",
 "Crédito 3x": "ائتمان، 3 أقساط",
 "Crédito 4x": "ائتمان، 4 أقساط",
 "Crédito 5x": "ائتمان، 5 أقساط",
 "Crédito 6x": "ائتمان، 6 أقساط",
 "Crédito 7x": "ائتمان، 7 أقساط",
 "Crédito 8x": "ائتمان، 8 أقساط",
 "Crédito 9x": "ائتمان، 9 أقساط",
 "Crédito 10x": "ائتمان، 10 أقساط",
 "Crédito 11x": "ائتمان، 11 قسطًا",
 "Crédito 12x": "ائتمان، 12 قسطًا",
 "ATRASADOS": "متأخرة",
 "Atrasado (hoje): {v}": "متأخر (حتى اليوم): {v}",
 "Buscar um cliente": "ابحث عن عميل",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ كامل والعنوان كاملًا وتاريخ الميلاد. يطلب كلمة مرور التطبيق.",
 "Cliente cadastrado": "تمت إضافة العميل",
 "Com documentos: guarde o arquivo em lugar seguro.": "مع المستندات: احفظ الملف في مكان آمن.",
 "Como pagou": "طريقة الدفع",
 "Esse contato não tem nome.": "جهة الاتصال هذه ليس لها اسم.",
 "Exportar planilha": "تصدير جدول البيانات",
 "Falta receber": "متبقٍ للتحصيل",
 "Falta receber (hoje): {v}": "متبقٍ للتحصيل (حتى اليوم): {v}",
 "Importar dos contatos": "استيراد من جهات الاتصال",
 "Importar dos contatos do celular": "استيراد من جهات اتصال الهاتف",
 "Incluir documentos": "تضمين المستندات",
 "Incluir documentos no relatório": "تضمين المستندات في التقرير",
 "MELHORES CLIENTES": "أفضل العملاء",
 "Melhores clientes": "أفضل العملاء",
 "Não foi possível gerar a planilha.": "تعذّر إنشاء جدول البيانات.",
 "O que foi": "ماذا كان",
 "Pago em": "تاريخ الدفع",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "لإضافة عملاء من جهات اتصال الهاتف، حدّث My Planner من متجر التطبيقات.",
 "RECEBIDO POR DIA": "المستلم يوميًا",
 "RECEBIDO POR MÊS": "المستلم شهريًا",
 "Recebeu": "المستلم",
 "Recebeu no período": "المستلم خلال الفترة",
 "Recebeu no período: {v}": "المستلم خلال الفترة: {v}",
 "Recebido no período": "المستلم خلال الفترة",
 "Relatório de clientes": "تقرير العملاء",
 "Relatório deste cliente": "تقرير هذا العميل",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "بدون إذن جهات الاتصال لا يمكن اختيار جهة اتصال. يمكنك السماح به من إعدادات الهاتف.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "بدون المستندات: يظهر CPF/CNPJ بآخر رقمين فقط. لا تُضمَّن الملاحظات أبدًا.",
 "Todos os clientes": "جميع العملاء",
 "Trabalha em: {e}": "يعمل في: {e}",
 "Trazer outro": "إضافة آخر",
 "VENDAS E ATENDIMENTOS": "المبيعات والخدمات",
 "Vence": "الاستحقاق",
 "Venceu": "انتهى الاستحقاق",
 "Vendas e atendimentos": "المبيعات والخدمات",
 "Vendeu": "المبيعات",
 "Vendeu no período": "المبيعات خلال الفترة",
 "Vendeu no período: {v}": "المبيعات خلال الفترة: {v}",
 "venceu {d}": "استحق في {d}",
 "vendido no período": "المبيعات خلال الفترة",
 "{nome} comprou no período": "مشتريات {nome} خلال الفترة",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "تمت إضافة {nome} إلى «عملائي». راجع البطاقة وحدّد ما إذا كان قد وافق على تلقي الرسائل.",
 "{n} compra(s)": "{n} عملية شراء",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "اسحب الصندوق إلى اليسار للأرشفة أو إلى اليمين للحذف. اضغط مطولًا على جزء فارغ من الصندوق واسحب لتغيير الترتيب.",
 "Bloco": "كتلة",
 "Confirme para apagar o grupo": "أكّد لحذف المجموعة",
 "Descer": "إلى الأسفل",
 "Opções do bloco": "خيارات الكتلة",
 "Exigências do destino": "متطلبات الوجهة",
 "{n} para acertar": "{n} للتسوية",
 "{n} parada(s)": "{n} محطة",
 "Cor do item selecionado": "لون العنصر المحدد",
 "Abrir o grupo": "فتح المجموعة",
 "Recolher o grupo": "طي المجموعة",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "اسحب الصندوق إلى اليمين للحذف أو إلى اليسار للأرشفة. اضغط مطولًا واسحب لتغيير الترتيب.",
 "Editar subtítulo": "تعديل العنوان الفرعي",
 "Início da caixa": "بداية الصندوق",
 "Mover para…": "نقل إلى…",
 "Mover {n} item(ns) para": "نقل {n} عنصر إلى",
 "Opções do item": "خيارات العنصر",
 "Transformar em subtítulo": "تحويل إلى عنوان فرعي",
 "Transformar em texto": "تحويل إلى نص",
 "esta caixa": "هذا الصندوق",
 "{a} de {n} feitos": "{a} من {n} منجز",
 "1 documento pedido atrasado": "مستند مطلوب واحد متأخر",
 "1 pedido vence logo": "طلب واحد يستحق قريبًا",
 "A lista vem de \"Meus clientes\".": "تأتي القائمة من \"عملائي\".",
 "Abrir Meus clientes": "افتح عملائي",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "أصبح تبويبا المكتب وبوابة العميل تبويبًا واحدًا الآن.",
 "Clientes com pendência": "عملاء لديهم أمور معلّقة",
 "Com pendência ({n})": "معلّقة ({n})",
 "Conversa da equipe": "محادثة الفريق",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "أنشئ المكتب وادعُ فريقك (أصدقاء التطبيق أو دعوة عبر رابط): محادثة واجتماعات فيديو ومستندات داخلية. تعمل وحدك؟ استخدم العملاء فقط.",
 "Documentos internos": "مستندات داخلية",
 "Entrar com um código de convite": "انضم برمز دعوة",
 "Escritório & Clientes": "المكتب والعملاء",
 "Escritórios: {n}": "المكاتب: {n}",
 "Esta parte é para quem trabalha com equipe": "هذا القسم لمن يعمل مع فريق",
 "Guias vencendo": "قسائم ضريبية مستحقة",
 "Minhas tarefas": "مهامي",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "لم يُحذف شيء: الفريق والمحادثة والاجتماعات والمستندات والعملاء المدعوون كما هم.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "لا يوجد عملاء بعد. أضف عميلًا في \"عملائي\" وسيظهر هنا فورًا.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "لمن يعمل مع العملاء، وحده أو مع فريق: مجلد لكل عميل (مستندات وطلبات وقسائم ضريبية)، والفريق والمحادثة والاجتماعات والمستندات الداخلية.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "مجلدات عملاء البوابة: {c} (فيها {d} مستند و{p} طلب)",
 "Pessoa física": "شخص طبيعي",
 "Procurar por nome, CNPJ ou CPF": "ابحث بالاسم أو CNPJ أو CPF",
 "Reuniões hoje": "اجتماعات اليوم",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "لا يوجد مكتب (فريق). انقر لإنشاء مكتب أو الانضمام برمز.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "يراه الفريق فقط. لا يرى العملاء هذا القسم أبدًا.",
 "Tudo em dia": "كل شيء محدّث",
 "Vencendo ({n})": "تستحق قريبًا ({n})",
 "chega na próxima versão": "قادم في الإصدار التالي",
 "nos próximos 7 dias": "خلال الأيام السبعة القادمة",
 "vence amanhã": "يستحق غدًا",
 "vence hoje": "يستحق اليوم",
 "{doc} venceu em {d}": "انتهت مهلة {doc} في {d}",
 "{n} documentos pedidos atrasados": "{n} مستندات مطلوبة متأخرة",
 "{n} pedidos vencem logo": "{n} طلبات تستحق قريبًا",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 محدّث · 🟡 شيء يستحق قريبًا · 🔴 طلب متأخر أو قسيمة ضريبية منتهية",
 "Acesso ao gov.br": "الدخول إلى gov.br",
 "Alvará": "رخصة مزاولة النشاط",
 "Até o dia (do mês)": "حتى يوم (من الشهر)",
 "CCMEI (certificado do MEI)": "CCMEI (شهادة MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "أضف هاتف العميل لتذكيره عبر WhatsApp.",
 "Cartão CNPJ": "بطاقة CNPJ",
 "Checklist criado": "تم إنشاء قائمة التحقق",
 "Checklist de cliente novo": "قائمة تحقق العميل الجديد",
 "Cliente viu {doc}": "شاهد العميل {doc}",
 "Cole no app do banco, em Pix copia e cola.": "الصقه في تطبيق البنك ضمن Pix نسخ ولصق.",
 "Cole no app do banco.": "الصقه في تطبيق البنك.",
 "Comprovante de endereço": "إثبات العنوان",
 "Contrato social e alterações": "عقد التأسيس وتعديلاته",
 "Copiado": "تم النسخ",
 "Copiar Pix": "نسخ Pix",
 "Copiar código de barras": "نسخ الرمز الشريطي",
 "Código de barras (linha digitável)": "الرمز الشريطي (السطر الرقمي)",
 "Dados bancários": "البيانات المصرفية",
 "Escreva o recado.": "اكتب الرسالة.",
 "Escritório enviou {doc}": "أرسل المكتب {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "لم يوافق هذا العميل على تلقي الرسائل (الملف في عملائي).",
 "Extratos bancários": "كشوف الحساب البنكية",
 "Ficha completa": "الملف الكامل",
 "Guia": "قسيمة الضريبة",
 "Guias a pagar": "قسائم ضريبية مستحقة الدفع",
 "Honorário": "الأتعاب",
 "Honorário por": "الأتعاب لكل",
 "Informes de rendimentos": "بيانات الدخل",
 "Lembrar pelo WhatsApp": "تذكير عبر WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "قراءة القسيمة أو الـ boleto بالذكاء الاصطناعي الخاص بي",
 "Lucro presumido": "الربح المفترض",
 "Lucro real": "الربح الفعلي",
 "Nada ainda.": "لا شيء بعد.",
 "Nenhum pedido em aberto.": "لا توجد طلبات مفتوحة.",
 "Notas fiscais emitidas": "الفواتير الصادرة",
 "O cliente": "العميل",
 "O pedido entrou em Pedidos de documentos.": "أُضيف الطلب إلى طلبات المستندات.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "مرحبًا {nome}! ينقص: {itens}. هل يمكنك إرساله هنا؟",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "مرحبًا {nome}! ينقص: {itens}. هل يمكنك إرسالها هنا؟",
 "Oi, {nome}! Tudo certo por aí?": "مرحبًا {nome}! هل كل شيء على ما يرام؟",
 "Pedido criado": "تم إنشاء الطلب",
 "Pedido feito: {o}": "تم إرسال الطلب: {o}",
 "Pedido recebido: {o}": "تم استلام الطلب: {o}",
 "Pedidos pendentes": "طلبات معلقة",
 "Pedir de novo todo mês": "الطلب مجددًا كل شهر",
 "Pedir nova ({c})": "طلب جديدة ({c})",
 "Pendentes": "معلقة",
 "Que tipo de cliente?": "ما نوع العميل؟",
 "RG e CPF": "RG وCPF",
 "RG e CPF do titular": "RG وCPF للمالك",
 "RG e CPF dos sócios": "RG وCPF للشركاء",
 "Recados": "الرسائل",
 "Recados entre você e o cliente, presos à pasta dele.": "الرسائل بينك وبين العميل، محفوظة في مجلده.",
 "Responde ao pedido": "يرد على الطلب",
 "Tipo / regime": "النوع / النظام الضريبي",
 "Visto pelo cliente em {d}": "شاهده العميل في {d}",
 "Válido até": "صالح حتى",
 "ano": "سنة",
 "código Pix copia e cola, se houver": "رمز Pix للنسخ واللصق، إن وُجد",
 "data de vencimento": "تاريخ الاستحقاق",
 "documento": "مستند",
 "linha digitável do boleto ou da guia, só números": "السطر الرقمي للـ boleto أو القسيمة، أرقام فقط",
 "mês": "شهر",
 "novo": "جديد",
 "todo mês, até o dia {n}": "كل شهر، حتى يوم {n}",
 "valor a pagar": "المبلغ المستحق",
 "válido até {d}": "صالح حتى {d}",
 "{c} nova": "{c} جديد",
 "{doc} pago": "تم دفع {doc}",
 "{n} a pagar": "{n} مستحق الدفع",
 "{n} enviou {doc}": "أرسل {n} {doc}",
 "{n} novo(s)": "{n} جديد",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "تم إنشاء {n} طلب مستندات، بمهلة 7 أيام.",
 "{n} vencida(s)": "{n} متأخرة",
 "Última declaração do Imposto de Renda": "آخر إقرار لضريبة الدخل",
 "Últimas guias pagas": "آخر القسائم المدفوعة",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "لم يتم ربط هذا الجزء من المكتب بالخادم بعد. على الكمبيوتر، شغّل الملف 56-SERVIDOR-0.96.bat (مرة واحدة فقط).",
 "Só vê": "للعرض فقط",
 "Nova versão": "إصدار جديد",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "كان هناك ملف بهذا الاسم من قبل: تم حفظ السابق كإصدار {n}.",
 "Visto por e comentários": "المشاهدون والتعليقات",
 "Arquivar (só neste aparelho)": "أرشفة (على هذا الجهاز فقط)",
 "Tirar do topo": "إزالة من الأعلى",
 "Fixar no topo (para todos)": "تثبيت في الأعلى (للجميع)",
 "Mover para a pasta…": "نقل إلى مجلد…",
 "versão {n}": "الإصدار {n}",
 "visto por {n}": "شاهده {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "حتى 50 ميغابايت لكل ملف. رفع ملف بالاسم نفسه يحفظ السابق كإصدار.",
 "Procurar documento ou pasta": "البحث عن مستند أو مجلد",
 "Fixados": "المثبّتة",
 "Abrir o documento": "فتح المستند",
 "enviado por {nome}": "رفعه {nome}",
 "Versões ({n})": "الإصدارات ({n})",
 "Versão {n} (atual)": "الإصدار {n} (الحالي)",
 "Versão {n}": "الإصدار {n}",
 "Visto por ({n})": "المشاهدون ({n})",
 "Ninguém da equipe abriu ainda.": "لم يفتحه أحد من الفريق بعد.",
 "{nome} em {d}": "{nome} في {d}",
 "Comentários ({n})": "التعليقات ({n})",
 "Escreva um comentário": "اكتب تعليقًا",
 "Contratos": "العقود",
 "Financeiro do escritório": "مالية المكتب",
 "RH": "الموارد البشرية",
 "Mover para a pasta": "نقل إلى مجلد",
 "Ou escreva o nome de uma pasta nova": "أو اكتب اسم مجلد جديد",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "تتكرر كل أسبوع: عند إلغائها ستُحذف من جميع الأسابيع ومن القائمة ومن وارد الفريق.",
 "a equipe toda": "الفريق بأكمله",
 "Com {quem}": "مع {quem}",
 "toda semana": "كل أسبوع",
 "Vão: {n}": "الحاضرون: {n}",
 "Não vão: {n}": "غير الحاضرين: {n}",
 "Vou": "سأحضر",
 "Não vou": "لن أحضر",
 "Pauta": "جدول الأعمال",
 "Ata": "محضر الاجتماع",
 "Escrever a ata": "كتابة المحضر",
 "Abrir o link": "فتح الرابط",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "يتلقى كل شخص مدعو الاجتماع في الوارد ويضيفه إلى Planner بلمسة واحدة مع التنبيه.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "اكتب أولًا ملاحظات الاجتماع (ما قيل وما تقرر)؛ يقوم الذكاء الاصطناعي بتنظيمها في محضر.",
 "Ata: {nome}": "محضر: {nome}",
 "Gerando...": "جارٍ الإنشاء...",
 "Gerar ata com a minha IA": "إنشاء محضر بالذكاء الاصطناعي الخاص بي",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "يقوم الذكاء الاصطناعي بتنظيم جدول الأعمال وملاحظاتك في محضر. راجعه قبل الحفظ.",
 "Ainda sem ata.": "لا يوجد محضر بعد.",
 "Tarefas da reunião ({n})": "مهام الاجتماع ({n})",
 "Tarefa da reunião": "مهمة الاجتماع",
 "Salvar a ata": "حفظ المحضر",
 "Repetir toda semana ({dia})": "تكرار كل أسبوع ({dia})",
 "Quem participa": "المشاركون",
 "A equipe toda": "الفريق بأكمله",
 "Link externo (opcional: Meet, Zoom, Teams)": "رابط خارجي (اختياري: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "يجب أن يبدأ الرابط بـ https://",
 "Marcar e avisar quem participa": "جدولة الاجتماع وإبلاغ المشاركين",
 "Cargo e papel": "المنصب والدور",
 "Passar o Admin": "نقل صلاحية المسؤول",
 "Passar o Admin para {nome}?": "هل تريد نقل صلاحية المسؤول إلى {nome}؟",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "سيصبح {nome} المسؤول عن المكتب (ويمكنه حذفه). ستبقى في الفريق كمسؤول (ويمكن لمن يتسلّم الصلاحية تغيير ذلك لاحقًا).",
 "Passar": "نقل",
 "{nome} agora cuida do escritório.": "{nome} هو الآن المسؤول عن المكتب.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "دورك هنا هو \"للعرض فقط\": تتابع الإعلانات والمهام والاجتماعات والمستندات.",
 "Edita": "يحرّر",
 "Incluir": "إضافة",
 "Novo aviso no mural": "إعلان جديد على اللوحة",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "يمكنك فقط عرض هذا المكتب: اختار المسؤول لك دور \"للعرض فقط\". اطلب من المسؤول تغييره إن احتجت.",
 "Quem viu": "من شاهده",
 "Apagar aviso": "حذف الإعلان",
 "Mural de avisos": "لوحة الإعلانات",
 "Novo aviso": "إعلان جديد",
 "Ex.: Feriado na sexta: escritório fechado": "مثال: إجازة يوم الجمعة: المكتب مغلق",
 "Fixar no mural": "تثبيت على اللوحة",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "لا توجد إعلانات. تُثبَّت الإعلانات هنا للفريق بأكمله.",
 "visto por {n} de {m}": "شاهده {n} من {m}",
 "sem responsável": "بدون مسؤول",
 "atrasada desde {d}": "متأخرة منذ {d}",
 "prazo {d}": "الموعد النهائي {d}",
 "Comecei": "بدأت",
 "Terminei": "أنهيت",
 "Reabrir": "إعادة فتح",
 "Tarefas da equipe": "مهام الفريق",
 "1 aberta": "1 مفتوحة",
 "{n} abertas": "{n} مفتوحة",
 "Minhas tarefas ({n})": "مهامي ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "لا توجد مهام مفتوحة لك. المس \"سأنفذها\" في إحدى مهام الفريق.",
 "Nenhuma tarefa aberta.": "لا توجد مهام مفتوحة.",
 "Feitas ({n})": "المنجزة ({n})",
 "Apagar a tarefa?": "هل تريد حذف المهمة؟",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "ما المطلوب إنجازه؟ (مثال: احتساب DAS لشهر مارس)",
 "Cliente (opcional)": "العميل (اختياري)",
 "Prazo (opcional)": "الموعد النهائي (اختياري)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "المسؤول (اختياري؛ وإلا فسيلمس أحدهم \"سأنفذها\")",
 "Escreva a tarefa para poder salvar.": "اكتب المهمة لتتمكن من الحفظ.",
 "Membro": "عضو",
 "Cargo (livre)": "المنصب (حر)",
 "Ex.: Advogada, Assistente, Estagiário": "مثال: محامية، مساعد، متدرب",
 "Papel": "الدور",
 "Admin: pode tudo no escritório.": "المسؤول: يمكنه فعل كل شيء في المكتب.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "يحرّر: يضيف مهام وإعلانات ومستندات واجتماعات",
 "Só vê: acompanha tudo, sem incluir nem mudar": "للعرض فقط: يتابع كل شيء دون إضافة أو تغيير",
 "Proposta": "عرض",
 "Documento sensível (pede a senha do app para abrir)": "مستند حساس (يطلب كلمة مرور التطبيق لفتحه)",
 "Li e concordo: {d}": "قرأت وأوافق: {d}",
 "Li e concordo": "قرأت وأوافق",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "عند الضغط على «أوافق»، يحفظ التطبيق تاريخ ووقت قراءتك وموافقتك على «{doc}». إنها موافقة بسيطة: لا تحل محل التوقيع الرقمي الرسمي.",
 "Concordo": "أوافق",
 "Fotos (escolha quais entram)": "الصور (اختر ما يدخل)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "تعذّرت قراءة صورة واحدة على هذا الجهاز فلم تُضَف.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "تعذّرت قراءة {n} صور على هذا الجهاز فلم تُضَف.",
 "Nenhuma foto no álbum desta viagem.": "لا توجد صور في ألبوم هذه الرحلة.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "اضغط على الصور لتحديدها أو إلغاء تحديدها. تُضاف مصغّرة ليبقى ملف PDF خفيفًا.",
 "Sugerir até 12": "اقترح حتى 12",
 "1 foto marcada": "تم تحديد صورة واحدة",
 "{n} fotos marcadas": "تم تحديد {n} صور",
 "Com mais de 12 fotos o PDF fica mais pesado.": "مع أكثر من 12 صورة يصبح ملف PDF أثقل.",
 "Confirme para abrir este documento": "أكّد لفتح هذا المستند",
 "Como usar esta aba": "كيفية استخدام هذا القسم",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "كان عميل واحد في أكثر من قسم وأصبح سجلًا واحدًا.",
 "Juntar {n} fotos num PDF?": "دمج {n} صور في ملف PDF واحد؟",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "تصبح الصور صفحات في ملف PDF واحد بترتيب القائمة، وتُحذف الصور المنفردة من هذه البطاقة.",
 "Não foi possível ler as fotos neste dispositivo.": "تعذّرت قراءة الصور على هذا الجهاز.",
 "PDF criado": "تم إنشاء PDF",
 "Montando o PDF...": "جارٍ إنشاء PDF...",
 "Juntar as {n} fotos num PDF": "دمج الصور الـ {n} في ملف PDF واحد",
 "Baixar o mês": "تنزيل الشهر",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "ملفات هذا الشهر موجودة على جهاز آخر وتعذّرت قراءتها هنا.",
 "Os documentos deste mês não têm arquivos.": "لا تحتوي مستندات هذا الشهر على ملفات.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "ملف واحد موجود على جهاز آخر وتم استبعاده.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} ملفات موجودة على جهاز آخر وتم استبعادها.",
 "Conversa sobre este documento": "محادثة حول هذا المستند",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "اسأل أو أجب عن هذا المستند. يراه المكتب والعميل.",
 "Escreva a mensagem": "اكتب الرسالة",
 "Usar um modelo de pedido ({n})": "استخدام قالب طلب ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "تذكير {nome} عبر واتساب: {o}",
 "Sem honorário": "بدون أتعاب",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "سجّل قيمة الأتعاب في خانة \"المكتب\" ببطاقة العميل، ضمن \"عملائي\".",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "استلمتُ من {c} مبلغ {v} عن أتعاب الفترة {m}.",
 "Recibo honorário {m} {c}": "إيصال أتعاب {m} {c}",
 "Recibo do honorário {m}": "إيصال الأتعاب {m}",
 "Recibo criado": "تم إنشاء الإيصال",
 "O recibo entrou em Documentos, na competência {m}.": "تمت إضافة الإيصال إلى المستندات ضمن الفترة {m}.",
 "Vendo como o cliente": "العرض كما يراه العميل",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "هكذا يرى العميل مجلده: بدون الملاحظات الداخلية وبدون ما هو للفريق فقط. لا يمكن تغيير أي شيء في هذا الوضع.",
 "Voltar a ver como escritório": "العودة إلى عرض المكتب",
 "Ver como o cliente": "عرض كما يراه العميل",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 ملاحظات داخلية (لا يراها العميل أبدًا)",
 "Recibo do honorário…": "إيصال الأتعاب…",
 "Competência do recibo": "فترة الإيصال",
 "⬇️ Baixar o mês": "⬇️ تنزيل الشهر",
 "Me avisar para lembrar o cliente": "نبّهني لتذكير العميل",
 "Guardar como modelo": "حفظ كقالب",
 "Modelo guardado": "تم حفظ القالب",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "عند إنشاء طلب لأي عميل، اضغط على \"استخدام قالب طلب\".",
 "Relatório do mês": "تقرير الشهر",
 "Notas rápidas": "ملاحظات سريعة",
 "Item completo: {o}": "العنصر كاملًا: {o}",
 "Reuniões do mês": "اجتماعات الشهر",
 "Tarefas feitas e pendentes": "المهام المنجزة والمعلّقة",
 "Documentos internos enviados": "المستندات الداخلية المرسلة",
 "Documentos enviados e recebidos dos clientes": "المستندات المرسلة إلى العملاء والمستلمة منهم",
 "Documentos da competência": "مستندات الفترة",
 "Guias pagas e vencidas": "قسائم الضرائب المدفوعة والمتأخرة",
 "Honorários": "الأتعاب",
 "Relatório do mês · {m}": "تقرير الشهر · {m}",
 "Reuniões ({n})": "الاجتماعات ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "المهام: {f} منجزة في الشهر · {p} معلّقة",
 "Quem fez": "من أنجزها",
 "Feita em": "أُنجزت في",
 "Documentos internos enviados ({n})": "المستندات الداخلية المرسلة ({n})",
 "Documentos trocados com os clientes": "المستندات المتبادلة مع العملاء",
 "Enviados pelo escritório": "أرسلها المكتب",
 "Recebidos do cliente": "المستلمة من العميل",
 "Nenhum documento trocado neste mês.": "لم تُتبادل أي مستندات هذا الشهر.",
 "Clientes com pendência ({n})": "العملاء الذين لديهم أمور معلّقة ({n})",
 "Pendência": "أمر معلّق",
 "Nenhum cliente com pendência.": "لا يوجد عملاء لديهم أمور معلّقة.",
 "Documentos da competência {m} ({n})": "مستندات الفترة {m} ({n})",
 "Pedidos de documentos ({n})": "طلبات المستندات ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "قسائم الشهر: {p} مدفوعة · {v} متأخرة",
 "Vencida": "متأخرة",
 "Recebido no mês": "المستلم في الشهر",
 "Relatório {m} {q}": "تقرير {m} {q}",
 "MÊS": "الشهر",
 "DE QUEM": "لمن",
 "O escritório": "المكتب",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "تُضاف الاجتماعات والمهام والمستندات الداخلية عند وجود مكتب (فريق).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "لا يدخل CPF وCNPJ والملاحظات الداخلية والمحادثات في التقرير أبداً.",
 "Anotações recebidas": "الملاحظات المستلمة",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "تظهر المبالغ المستحقة من هذه القائمة في My Planner، بما فيها الجديدة.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "يرسل فقط المبالغ المستحقة من هذه القائمة (المواعيد تُضاف تلقائيًا)، بما فيها الجديدة.",
 "Acrescentar": "إضافة",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "الصناديق الـ {n} موجودة في {aba}، في \"الملاحظات المستلمة\".",
 "Enviadas": "تم الإرسال",
 "Enviar para": "إرسال إلى",
 "Excluir 1 item?": "حذف عنصر واحد؟",
 "Excluir {n} itens?": "حذف {n} عناصر؟",
 "Inserir abaixo": "إدراج أسفل",
 "Mover para": "نقل إلى",
 "Mover {n} selecionados para": "نقل {n} من العناصر المحددة إلى",
 "adicionar aqui": "أضف هنا",
 "continue segurando para selecionar": "استمر في الضغط للتحديد"
}
